/* 09048d0f2a0ca3496b9c903b46f3cf5c53a0b5f2
 * This file is automatically generated by graphql-let. */

import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum AccountDeletionStatus {
  /** Đã xử lý */
  Completed = 'COMPLETED',
  /** Chờ xử lý */
  Pending = 'PENDING'
}

export type Achievement = {
  __typename?: 'Achievement';
  /** Background color of the Achievement */
  background_color?: Maybe<Scalars['String']['output']>;
  /** Border color of the Achievement */
  border_color?: Maybe<Scalars['String']['output']>;
  /** Description of the Achievement */
  description?: Maybe<Scalars['String']['output']>;
  /** Image URL of the Achievement */
  image?: Maybe<Scalars['String']['output']>;
  /** Label of the Configuration */
  label?: Maybe<Scalars['String']['output']>;
  /** Name of the Achievement */
  name?: Maybe<Scalars['String']['output']>;
  /** The target link of product achievement. */
  target_link?: Maybe<Scalars['String']['output']>;
  /** Text color of the Achievement */
  text_color?: Maybe<Scalars['String']['output']>;
};

export enum ActionType {
  Discount = 'DISCOUNT',
  FreeGift = 'FREE_GIFT',
  FreeShip = 'FREE_SHIP',
  Other = 'OTHER',
  Point = 'POINT',
  Voucher = 'VOUCHER'
}

export type AddBundleProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>;
};

export type AddBundleProductsToCartOutput = {
  __typename?: 'AddBundleProductsToCartOutput';
  cart: Cart;
};

export type AddCartLevelGiftsInput = {
  /** Masked cart ID */
  cart_id: Scalars['String']['input'];
  /** Gifts to select */
  gifts: Array<CartLevelGiftInput>;
  /** Rule ID */
  rule_id: Scalars['Int']['input'];
};

export type AddCartLevelGiftsOutput = {
  __typename?: 'AddCartLevelGiftsOutput';
  /** Updated cart */
  cart?: Maybe<Cart>;
  /** Validation errors */
  errors: Array<GiftError>;
  /** Selected gifts */
  selected_gifts: Array<SelectedCartLevelGift>;
};

export type AddConfigurableProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>;
};

export type AddConfigurableProductsToCartOutput = {
  __typename?: 'AddConfigurableProductsToCartOutput';
  cart: Cart;
};

export type AddDownloadableProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<DownloadableProductCartItemInput>>;
};

export type AddDownloadableProductsToCartOutput = {
  __typename?: 'AddDownloadableProductsToCartOutput';
  cart: Cart;
};

export type AddGiftsToCartInput = {
  /** The mask id of cart. */
  cart_id: Scalars['String']['input'];
  /** The id of quote item. */
  cart_item_id: Scalars['Int']['input'];
  /** The picked gift input. */
  picked_gifts?: InputMaybe<Array<InputMaybe<PickedGiftInput>>>;
};

export type AddGiftsToCartOutput = {
  __typename?: 'AddGiftsToCartOutput';
  cart: Cart;
};

export type AddProductToWishlistInput = {
  product_id: Scalars['Int']['input'];
};

export type AddSimpleProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>;
};

export type AddSimpleProductsToCartOutput = {
  __typename?: 'AddSimpleProductsToCartOutput';
  cart: Cart;
};

export type AddToCartContentInput = {
  product_id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddToCartErrorInternalEventInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type AddToCartErrorInternalEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<AddToCartErrorInternalEventInput>;
};

export type AddToCartEventInput = {
  cart_info?: InputMaybe<CartInfoInput>;
  user: UserDataInput;
};

export type AddToCartTrackingEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<AddToCartEventInput>;
};

export type AddVirtualProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>;
};

export type AddVirtualProductsToCartOutput = {
  __typename?: 'AddVirtualProductsToCartOutput';
  cart: Cart;
};

export type AdditionalDataAttribute = {
  __typename?: 'AdditionalDataAttribute';
  /** The attribute code. */
  code?: Maybe<Scalars['String']['output']>;
  /** The attribute label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The attribute value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The list of address types */
export enum AddressTypeEnum {
  Home = 'home',
  Office = 'office'
}

export type AdminAnswered = {
  __typename?: 'AdminAnswered';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  like_count?: Maybe<Scalars['Int']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  total_satisfied?: Maybe<Scalars['Int']['output']>;
};

/** A bucket that contains information for each filterable option (such as price, category ID, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String']['output'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']['output']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>;
};

export type AggregationOption = AggregationOptionInterface & {
  __typename?: 'AggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The id of aggregation option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Aggregation option display label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The id of aggregation option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Aggregation option display label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

export type AllocationFilterInput = {
  campaign_id?: InputMaybe<Scalars['String']['input']>;
  created_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AllocationStatus>;
  sync_status?: InputMaybe<SyncStatus>;
};

export enum AllocationStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export type Answer = {
  __typename?: 'Answer';
  adminId: Scalars['Int']['output'];
  adminName: Scalars['String']['output'];
  answer: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceId?: Maybe<Scalars['Int']['output']>;
};

export type AnswerRequest = {
  content: Scalars['String']['input'];
  parent_id: Scalars['Int']['input'];
  question_id: Scalars['Int']['input'];
};

export type ApiErrorInternalEventInput = {
  api_path?: InputMaybe<Scalars['String']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  error_name?: InputMaybe<Scalars['String']['input']>;
  http_code?: InputMaybe<Scalars['Int']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type ApiErrorInternalEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<ApiErrorInternalEventInput>;
};

export type AppBannerConfig = {
  __typename?: 'AppBannerConfig';
  content: Scalars['String']['output'];
  image_url: Scalars['String']['output'];
};

export type AppConfiguration = {
  __typename?: 'AppConfiguration';
  banner_config?: Maybe<AppBannerConfig>;
  footer_config?: Maybe<FooterConfig>;
  share_channel_configs?: Maybe<ShareChannelGroupResponse>;
};

export type AppliedCodeData = {
  __typename?: 'AppliedCodeData';
  allocation_name?: Maybe<Scalars['String']['output']>;
  applied_amount?: Maybe<Scalars['Float']['output']>;
  coupon_code?: Maybe<Scalars['String']['output']>;
  discount_label?: Maybe<Scalars['String']['output']>;
  masked_code?: Maybe<Scalars['String']['output']>;
  type: MarketingCodeType;
  voucher_id?: Maybe<Scalars['String']['output']>;
};

export enum AppliedCodeType {
  /** @deprecated  */
  Discount = 'DISCOUNT',
  /** @deprecated  */
  PaymentVoucher = 'PAYMENT_VOUCHER'
}

export type AppliedCodesResponse = {
  __typename?: 'AppliedCodesResponse';
  coupons: Array<MarketingAppliedCoupon>;
  vouchers: Array<AppliedVoucher>;
};

export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  code: Scalars['String']['output'];
};

export type AppliedUniversalCode = {
  __typename?: 'AppliedUniversalCode';
  code: Scalars['String']['output'];
};

export type AppliedVoucher = {
  __typename?: 'AppliedVoucher';
  allocation?: Maybe<StorefrontAllocation>;
  allocation_name?: Maybe<Scalars['String']['output']>;
  applied_amount: Scalars['Float']['output'];
  display_name: Scalars['String']['output'];
  display_type: VoucherDisplayType;
  voucher_id: Scalars['String']['output'];
};

export type ApplyCodeResponse = {
  __typename?: 'ApplyCodeResponse';
  data?: Maybe<AppliedCodeData>;
  error_message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ApplyCouponToCartInput = {
  cart_id: Scalars['String']['input'];
  coupon_code: Scalars['String']['input'];
};

export type ApplyCouponToCartOutput = {
  __typename?: 'ApplyCouponToCartOutput';
  cart: Cart;
};

export type ApplyKicoinsInput = {
  cart_id: Scalars['String']['input'];
};

export type ApplyKicoinsOutput = {
  __typename?: 'ApplyKicoinsOutput';
  cart: Cart;
};

export type ApplyUniversalCodeInput = {
  cart_id: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type ApplyUniversalCodePayload = {
  __typename?: 'ApplyUniversalCodePayload';
  applied_code_type?: Maybe<AppliedCodeType>;
  cart: Cart;
  user_message?: Maybe<Scalars['String']['output']>;
};

export type ApplyVoucherResponse = {
  __typename?: 'ApplyVoucherResponse';
  error_message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  voucher_id?: Maybe<Scalars['String']['output']>;
};

export type AssignVouchersInput = {
  allocation_id: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  strategy: SelectionStrategy;
};

export type AssignVouchersResult = {
  __typename?: 'AssignVouchersResult';
  allocation: VoucherAllocation;
  assigned_count: Scalars['Int']['output'];
};

/** Attribute contains the attribute_type of the specified attribute_code and entity_type */
export type Attribute = {
  __typename?: 'Attribute';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<AttributeOption>>>;
  /** The data type of the attribute */
  attribute_type?: Maybe<Scalars['String']['output']>;
  /** The type of entity that defines the attribute */
  entity_type?: Maybe<Scalars['String']['output']>;
  /** The frontend input type of the attribute */
  input_type?: Maybe<Scalars['String']['output']>;
};

/** AttributeInput specifies the attribute_code and entity_type to search */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']['input']>;
  /** The type of entity that defines the attribute */
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

/** Attribute option. */
export type AttributeOption = {
  __typename?: 'AttributeOption';
  /** Attribute option label. */
  label?: Maybe<Scalars['String']['output']>;
  /** Swatch data for Attribute option */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** Attribute option value. */
  value?: Maybe<Scalars['String']['output']>;
};

export type AuthErrorInternalEventInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type AuthErrorInternalEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<AuthErrorInternalEventInput>;
};

export type AvailableGifts = {
  __typename?: 'AvailableGifts';
  cart_item_id?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The rule info. */
  rule?: Maybe<Rule>;
  rule_id?: Maybe<Scalars['Int']['output']>;
};

export type AvailableGiftsCart = {
  __typename?: 'AvailableGiftsCart';
  items?: Maybe<Array<Maybe<AvailableGifts>>>;
};

/** Available next statuses and sorting direction. */
export type AvailableOrderHistoryStatuses = {
  __typename?: 'AvailableOrderHistoryStatuses';
  direction: SortDirection;
  items: Array<OrderStatus>;
};

export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod';
  /** The payment method code */
  code: Scalars['String']['output'];
  /** The payment method title. */
  title: Scalars['String']['output'];
};

/** Available cart price rules with discount data for local-first calculation */
export type AvailableRules = {
  __typename?: 'AvailableRules';
  /** An array of available rules */
  items?: Maybe<Array<Maybe<Rule>>>;
  /** The total count of available rules */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AvailableShippingMethod = {
  __typename?: 'AvailableShippingMethod';
  amount: Money;
  available: Scalars['Boolean']['output'];
  /** @deprecated The field should not be used on the storefront */
  base_amount?: Maybe<Money>;
  carrier_code: Scalars['String']['output'];
  carrier_title: Scalars['String']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  /** Could be null if method is not available */
  method_code?: Maybe<Scalars['String']['output']>;
  /** Could be null if method is not available */
  method_title?: Maybe<Scalars['String']['output']>;
  price_excl_tax: Money;
  price_incl_tax: Money;
};

/** Banners information for homepage */
export type Banner = {
  __typename?: 'Banner';
  /** App image url */
  app_image_url?: Maybe<Scalars['String']['output']>;
  /** background color */
  background_color?: Maybe<Scalars['String']['output']>;
  /** Banner ID */
  banner_id?: Maybe<Scalars['Int']['output']>;
  /** Image */
  image?: Maybe<Scalars['String']['output']>;
  /** Image app */
  image_app?: Maybe<Scalars['String']['output']>;
  /** Image Mobile */
  image_mobile?: Maybe<Scalars['String']['output']>;
  /** Banner name */
  name?: Maybe<Scalars['String']['output']>;
  /** Allow open new tab after click */
  newtab?: Maybe<Scalars['Int']['output']>;
  /** Position */
  position?: Maybe<Scalars['String']['output']>;
  /** URL banner */
  url_banner?: Maybe<Scalars['String']['output']>;
};

export type BannerConfig = {
  __typename?: 'BannerConfig';
  /** The content of page. */
  content?: Maybe<Scalars['String']['output']>;
  /** The banner image. */
  image?: Maybe<Scalars['String']['output']>;
};

/** Main banner information */
export type BannerItems = {
  __typename?: 'BannerItems';
  /** An array of banners */
  items?: Maybe<Array<Maybe<Banner>>>;
  /** The layout of banners. */
  layout?: Maybe<BannerLayoutData>;
};

/** The layout data. */
export type BannerLayoutData = {
  __typename?: 'BannerLayoutData';
  /** The label of layout. */
  label?: Maybe<Scalars['String']['output']>;
  /** The value of layout. */
  value?: Maybe<Scalars['String']['output']>;
};

export enum BannerPageType {
  EmptyCart = 'EMPTY_CART',
  OrderFailure = 'ORDER_FAILURE',
  OrderSuccess = 'ORDER_SUCCESS',
  ReferralFriend = 'REFERRAL_FRIEND'
}

/** Banners information */
export type Banners = {
  __typename?: 'Banners';
  /** An array of banners. */
  items?: Maybe<Array<Maybe<Banner>>>;
  /** The layout of banners. */
  layout?: Maybe<LayoutData>;
};

export type BeginAddToCartInternalEventInput = {
  product_id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type BeginAddToCartInternalEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<BeginAddToCartInternalEventInput>;
};

export type BillingAddressInput = {
  address?: InputMaybe<CartAddressInput>;
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  /** The invoice company address of customer. */
  invoice_company_address?: InputMaybe<Scalars['String']['input']>;
  /** The invoice company name of customer. */
  invoice_company_name?: InputMaybe<Scalars['String']['input']>;
  /** The invoice vat id of customer. */
  invoice_vat_id?: InputMaybe<Scalars['String']['input']>;
  /** Set billing address same as shipping */
  same_as_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use `same_as_shipping` field instead */
  use_for_shipping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingCartAddress = CartAddressInterface & {
  __typename?: 'BillingCartAddress';
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: CartAddressCountry;
  /** @deprecated The field is used only in shipping address */
  customer_notes?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  /** The invoice company address of customer. */
  invoice_company_address?: Maybe<Scalars['String']['output']>;
  /** The invoice company name of customer. */
  invoice_company_name?: Maybe<Scalars['String']['output']>;
  /** The invoice vat id of customer. */
  invoice_vat_id?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  street: Array<Maybe<Scalars['String']['output']>>;
  telephone: Scalars['String']['output'];
};

/** The Products object is the top-level object returned in a product list. */
export type BlockProducts = {
  __typename?: 'BlockProducts';
  /** An array of products that match the specified query data */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

/** The block types of the highlight product block. */
export enum BlockTypeEnum {
  Bestseller = 'BESTSELLER',
  Highlight = 'HIGHLIGHT',
  Interested = 'INTERESTED',
  NewArrival = 'NEW_ARRIVAL'
}

export type BraintreeCcVaultInput = {
  device_data?: InputMaybe<Scalars['String']['input']>;
  public_hash: Scalars['String']['input'];
};

export type BraintreeInput = {
  /** Contains a fingerprint provided by Braintree JS SDK and should be sent with sale transaction details to the Braintree payment gateway. Should be specified only in a case if Kount (advanced fraud protection) is enabled for Braintree payment integration. */
  device_data?: InputMaybe<Scalars['String']['input']>;
  /** States whether an entered by a customer credit/debit card should be tokenized for later usage. Required only if Vault is enabled for Braintree payment integration. */
  is_active_payment_token_enabler: Scalars['Boolean']['input'];
  /** The one-time payment token generated by Braintree payment gateway based on card details. Required field to make sale transaction. */
  payment_method_nonce: Scalars['String']['input'];
};

export type BrandLayout = {
  __typename?: 'BrandLayout';
  /** The banner image. */
  banner_image?: Maybe<Scalars['String']['output']>;
  /** The banner link. */
  banner_link?: Maybe<Scalars['String']['output']>;
  /** The border type for each brand. */
  border_type?: Maybe<Scalars['String']['output']>;
  /** The layout of brand. */
  layout?: Maybe<LayoutData>;
  /** The limit quantity display on block. */
  limit_qty?: Maybe<Scalars['Int']['output']>;
  /** The row qty display on block. */
  row_qty?: Maybe<Scalars['Int']['output']>;
};

export type BrandListFilter = {
  /** The list of brand ids to filter by. */
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The list of brand labels to filter by. */
  label?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The list of brand urls to filter by. */
  url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BrandListInput = {
  /** The current page of brands */
  current_page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter options for brands */
  filter?: InputMaybe<BrandListFilter>;
  /** The page size of brands */
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

/** The brands for category. */
export type Brands = {
  __typename?: 'Brands';
  /** The list of brands. */
  items?: Maybe<Array<Maybe<HighlightBrand>>>;
  /** The page size of brands. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of brands. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Breadcrumb item. */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  /** Category ID. */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** Category level. */
  category_level?: Maybe<Scalars['Int']['output']>;
  /** Category name. */
  category_name?: Maybe<Scalars['String']['output']>;
  /** Category URL key. */
  category_url_key?: Maybe<Scalars['String']['output']>;
  /** Category URL path. */
  category_url_path?: Maybe<Scalars['String']['output']>;
};

export type BssPopup = {
  __typename?: 'BssPopup';
  /** Time to show popup after page load. The value of X equals (seconds) corresponds to event_display = 1 - After customer spend X seconds on page. */
  after_load?: Maybe<Scalars['Int']['output']>;
  /** The value of X equals (%) corresponds to event_display = 2 - After customers scroll page by X percent. */
  after_scroll?: Maybe<Scalars['Int']['output']>;
  close_outside?: Maybe<Scalars['Int']['output']>;
  /** The cookie expires (minutes) of popup. */
  cookie_expires?: Maybe<Scalars['Int']['output']>;
  /** The customer group of popup. */
  customer_group?: Maybe<Scalars['String']['output']>;
  /** The start date to show popup. */
  display_from?: Maybe<Scalars['String']['output']>;
  /** The end date to show popup. */
  display_to?: Maybe<Scalars['String']['output']>;
  /** The Display Animation of popup. */
  effect_display?: Maybe<Scalars['Int']['output']>;
  /** The rule to show popup. */
  event_display?: Maybe<Scalars['Int']['output']>;
  exclude_category?: Maybe<Scalars['String']['output']>;
  exclude_product?: Maybe<Scalars['String']['output']>;
  /** The display frequency of popup. */
  frequently?: Maybe<Scalars['Int']['output']>;
  /** Auto close popup after X seconds. */
  hide_after?: Maybe<Scalars['Int']['output']>;
  /** The id of popup. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Return an array layouts page to show popup. */
  layouts?: Maybe<Array<Maybe<Layout>>>;
  page_display?: Maybe<Scalars['String']['output']>;
  /** The value of X equals corresponds to event_display = 3 - After customer view X pages. */
  page_view?: Maybe<Scalars['Int']['output']>;
  /** The display frequency of popup. */
  popup_content?: Maybe<Scalars['String']['output']>;
  /** The css of popup. */
  popup_css?: Maybe<Scalars['String']['output']>;
  /** The name of popup. */
  popup_name?: Maybe<Scalars['String']['output']>;
  /** The url of popup. */
  popup_url?: Maybe<Scalars['String']['output']>;
  /** The position of popup. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The priority of popup. */
  priority?: Maybe<Scalars['Int']['output']>;
  /** The status of popup. */
  status?: Maybe<Scalars['Int']['output']>;
  /** The store view of popup. */
  storeview?: Maybe<Scalars['String']['output']>;
};

export type BssPopups = {
  __typename?: 'BssPopups';
  items?: Maybe<Array<Maybe<BssPopup>>>;
};

export type BundleCartItem = CartItemInterface & {
  __typename?: 'BundleCartItem';
  bundle_options: Array<Maybe<SelectedBundleOption>>;
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** BundleItem defines an individual item in a bundle product. */
export type BundleItem = {
  __typename?: 'BundleItem';
  /** An ID assigned to each type of item in a bundle product. */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>;
  /** he relative position of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The display name of the item. */
  title?: Maybe<Scalars['String']['output']>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']['output']>;
};

/** BundleItemOption defines characteristics and options for a specific bundle item. */
export type BundleItemOption = {
  __typename?: 'BundleItemOption';
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars['Boolean']['output']>;
  /** The ID assigned to the bundled item option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']['output']>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated The `qty` is deprecated. Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']['output']>;
  /** Indicates the quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type BundleOptionInput = {
  id: Scalars['Int']['input'];
  quantity: Scalars['Float']['input'];
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

/** BundleProduct defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & {
  __typename?: 'BundleProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the bundle product has a dynamic price. */
  dynamic_price?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the bundle product has a dynamic SK. */
  dynamic_sku?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the bundle product has a dynamically calculated weight. */
  dynamic_weight?: Maybe<Scalars['Boolean']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  /** An array containing information about individual bundle items. */
  items?: Maybe<Array<Maybe<BundleItem>>>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** One of PRICE_RANGE or AS_LOW_AS. */
  price_view?: Maybe<PriceViewEnum>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether to ship bundle items together or individually. */
  ship_bundle_items?: Maybe<ShipBundleItemsEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type BundleProductCartItemInput = {
  bundle_options: Array<InputMaybe<BundleOptionInput>>;
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CampaignFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CancelOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  order_number: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Cart = {
  __typename?: 'Cart';
  /**
   * An array of coupons that have been applied to the cart
   * @deprecated Use applied_coupons instead
   */
  applied_coupon?: Maybe<AppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code */
  applied_coupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  /** An array of `AppliedUniversalCode` objects. Each object contains the `code` text attribute, which specifies the coupon or payment voucher */
  applied_universal_codes?: Maybe<Array<Maybe<AppliedUniversalCode>>>;
  /** Available payment methods */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  billing_address?: Maybe<BillingCartAddress>;
  /** Returns information about discount kicoins */
  discount_kicoins?: Maybe<DiscountKicoins>;
  email?: Maybe<Scalars['String']['output']>;
  /** The ID of the cart. */
  id: Scalars['ID']['output'];
  is_virtual: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  prices?: Maybe<CartPrices>;
  selected_payment_method?: Maybe<SelectedPaymentMethod>;
  shipping_addresses: Array<Maybe<ShippingCartAddress>>;
  total_quantity: Scalars['Float']['output'];
};

export type CartAddressCountry = {
  __typename?: 'CartAddressCountry';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CartAddressInput = {
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country_code: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['Int']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  save_in_address_book?: InputMaybe<Scalars['Boolean']['input']>;
  street: Array<InputMaybe<Scalars['String']['input']>>;
  telephone: Scalars['String']['input'];
  ward?: InputMaybe<Scalars['String']['input']>;
  ward_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CartAddressInterface = {
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: CartAddressCountry;
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  street: Array<Maybe<Scalars['String']['output']>>;
  telephone: Scalars['String']['output'];
};

export type CartAddressRegion = {
  __typename?: 'CartAddressRegion';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CartDiscount = {
  __typename?: 'CartDiscount';
  amount: Money;
  label: Array<Maybe<Scalars['String']['output']>>;
};

export type CartInfoInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<AddToCartContentInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CartItemInput = {
  quantity: Scalars['Float']['input'];
  sku: Scalars['String']['input'];
};

export type CartItemInterface = {
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

export type CartItemMeta = {
  __typename?: 'CartItemMeta';
  /** Serialized additional data or custom options associated with this item. */
  additional_data?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of applied sales rule IDs for discounts. */
  applied_rule_ids?: Maybe<Scalars['String']['output']>;
  /** The discount amount applied in the base currency. */
  base_discount_amount?: Maybe<Scalars['Float']['output']>;
  /** The price of the product in the base currency. */
  base_price?: Maybe<Scalars['Float']['output']>;
  /** The price including tax in base currency. */
  base_price_incl_tax?: Maybe<Scalars['Float']['output']>;
  /** The total (price × qty) excluding discounts and taxes in the base currency. */
  base_row_total?: Maybe<Scalars['Float']['output']>;
  /** The total row amount including tax in base currency. */
  base_row_total_incl_tax?: Maybe<Scalars['Float']['output']>;
  /** Custom price manually set for this item (e.g., via admin or promo rule). */
  custom_price?: Maybe<Scalars['Float']['output']>;
  /** The detailed description of the product at the time of adding to cart. */
  description?: Maybe<Scalars['String']['output']>;
  /** The discount amount applied in the quote currency. */
  discount_amount?: Maybe<Scalars['Float']['output']>;
  /** The discount percentage applied to this item. */
  discount_percent?: Maybe<Scalars['Float']['output']>;
  /** Cart item ID. */
  id?: Maybe<Scalars['String']['output']>;
  /** Indicates if the quantity for this product can be a decimal value (used for weight-based products). */
  is_qty_decimal?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether this item is virtual (non-shippable). */
  is_virtual?: Maybe<Scalars['Int']['output']>;
  /** The product name displayed in the cart. */
  name?: Maybe<Scalars['String']['output']>;
  /** Flag to indicate that discounts are disabled for this item. */
  no_discount?: Maybe<Scalars['Int']['output']>;
  /** Original custom price set before any recalculation or override. */
  original_custom_price?: Maybe<Scalars['Float']['output']>;
  /** Parent item ID for child items. */
  parent_item_id?: Maybe<Scalars['Int']['output']>;
  /** The price of the product in the quote currency. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The price including tax in quote currency. */
  price_incl_tax?: Maybe<Scalars['Float']['output']>;
  /** Product ID. */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The product type (e.g., simple, configurable, bundle). */
  product_type?: Maybe<Scalars['String']['output']>;
  /** Quantity of this product in the cart. */
  qty?: Maybe<Scalars['Float']['output']>;
  /** The total (price × qty) excluding discounts and taxes in the quote currency. */
  row_total?: Maybe<Scalars['Float']['output']>;
  /** The total row amount including tax in quote currency. */
  row_total_incl_tax?: Maybe<Scalars['Float']['output']>;
  /** The total after discount but before tax. */
  row_total_with_discount?: Maybe<Scalars['Float']['output']>;
  /** Total weight for this item row (weight × qty). */
  row_weight?: Maybe<Scalars['Float']['output']>;
  /** The SKU of the product. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Weight of a single unit of this product. */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CartItemPrices = {
  __typename?: 'CartItemPrices';
  /** An array of discounts to be applied to the cart item */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  price: Money;
  row_total: Money;
  row_total_including_tax: Money;
  /** The total of all discounts applied to the item */
  total_item_discount?: Maybe<Money>;
};

/** Deprecated: `cart_items` field of `ShippingCartAddress` returns now  `CartItemInterface` instead of `CartItemQuantity` */
export type CartItemQuantity = {
  __typename?: 'CartItemQuantity';
  /** @deprecated `cart_items` field of `ShippingCartAddress` returns now `CartItemInterface` instead of `CartItemQuantity` */
  cart_item_id: Scalars['Int']['output'];
  /** @deprecated `cart_items` field of `ShippingCartAddress` returns now `CartItemInterface` instead of `CartItemQuantity` */
  quantity: Scalars['Float']['output'];
};

export type CartItemReference = {
  __typename?: 'CartItemReference';
  /** The masked cart ID */
  cart_id?: Maybe<Scalars['String']['output']>;
  /** Magento Quote Item ID */
  cart_item_id?: Maybe<Scalars['Int']['output']>;
  /** Cart Item Reference ID */
  cart_item_reference_id: Scalars['String']['output'];
  /** Return an array cart items data. */
  cart_items?: Maybe<Array<Maybe<LocalCartItemInterface>>>;
  /** Created at timestamp */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Is Selected flag */
  is_selected?: Maybe<Scalars['Boolean']['output']>;
  /** The local ID for the cart item reference */
  local_id?: Maybe<Scalars['String']['output']>;
  /** Logics applied to this reference */
  logics?: Maybe<Array<Maybe<CartItemReferenceLogic>>>;
  /** Parent product (for configurable products) */
  parent_product?: Maybe<ProductInterface>;
  /** Product ID */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** Quantity */
  qty: Scalars['Int']['output'];
  /** Product SKU */
  sku: Scalars['String']['output'];
};

export type CartItemReferenceAction = {
  __typename?: 'CartItemReferenceAction';
  /** Optional note for the action */
  action_note?: Maybe<Scalars['String']['output']>;
  /** The information about gift product. */
  action_product?: Maybe<ProductInterface>;
  /** Quantity for the action */
  action_qty?: Maybe<Scalars['Int']['output']>;
  /** Action type: free_gift, discount, free_ship, point, voucher, other */
  action_type?: Maybe<ActionType>;
  /** Value of the action (e.g., discount amount) */
  action_value?: Maybe<Scalars['Float']['output']>;
  /** Cart item reference logic ID */
  cart_item_reference_logic_id?: Maybe<Scalars['String']['output']>;
  /** Action ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Resulting Quote Item ID for gifts */
  result_quote_item_id?: Maybe<Scalars['Int']['output']>;
};

export type CartItemReferenceLogic = {
  __typename?: 'CartItemReferenceLogic';
  /** Actions for this logic */
  actions?: Maybe<Array<Maybe<CartItemReferenceAction>>>;
  /** Quantity of product allocated to this logic (for gift calculation) */
  allocated_qty?: Maybe<Scalars['Int']['output']>;
  /** Cart item reference ID. */
  cart_item_reference_id: Scalars['String']['output'];
  /** Unique identifier for the logic. */
  id?: Maybe<Scalars['String']['output']>;
  /** Magento Rule ID */
  logic_id: Scalars['String']['output'];
  /** Magento Rule Name */
  logic_name?: Maybe<Scalars['String']['output']>;
  /** Logic type: promotion, freeship, campaign, other */
  logic_type: Scalars['String']['output'];
  /** The session ID for the logic */
  session_id: Scalars['String']['output'];
};

export type CartItemSelectedOptionValuePrice = {
  __typename?: 'CartItemSelectedOptionValuePrice';
  type: PriceTypeEnum;
  units: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CartItemUpdateInput = {
  cart_item_id: Scalars['Int']['input'];
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

/** Lightweight cart items response without expensive calculations */
export type CartItemsOnly = {
  __typename?: 'CartItemsOnly';
  /** The masked cart ID */
  cart_id: Scalars['String']['output'];
  /** Cart items without triggering total calculations */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** Number of different items in cart */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** Total quantity of all items */
  items_qty?: Maybe<Scalars['Float']['output']>;
};

export type CartLevelGiftInput = {
  /** Quantity to select */
  quantity: Scalars['Int']['input'];
  /** Gift SKU */
  sku: Scalars['String']['input'];
};

export type CartLevelGiftRule = {
  __typename?: 'CartLevelGiftRule';
  /** Available gift products */
  available_gifts: Array<GiftProduct>;
  /** Human-readable conditions (e.g., 'Cart >= 300,000đ') */
  conditions_text?: Maybe<Scalars['String']['output']>;
  /** Rule description */
  description?: Maybe<Scalars['String']['output']>;
  /** Amasty gift type: 0 = customer can pick any/all SKUs, 1 = customer can pick only ONE SKU from the list */
  gift_selection_type: Scalars['Int']['output'];
  /** Whether this rule is usable after priority/exclusivity filtering. A rule may be eligible but not effective if a higher-priority exclusive rule takes precedence. */
  is_effective: Scalars['Boolean']['output'];
  /** Whether cart meets rule conditions */
  is_eligible: Scalars['Boolean']['output'];
  /** Maximum number of gifts customer can select */
  max_selections: Scalars['Int']['output'];
  /** Rule ID */
  rule_id: Scalars['Int']['output'];
  /** Display label for customer */
  rule_label?: Maybe<Scalars['String']['output']>;
  /** Rule name */
  rule_name?: Maybe<Scalars['String']['output']>;
  /** Currently selected gifts for this rule */
  selected_gifts: Array<SelectedGift>;
  /** Rule priority. Lower value = higher priority. Used for exclusivity resolution. */
  sort_order: Scalars['Int']['output'];
  /** If true, this rule is exclusive — no lower-priority rules can apply simultaneously. Magento SalesRule flag. */
  stop_rules_processing: Scalars['Boolean']['output'];
  /** Minimum cart subtotal to qualify for this rule. Extracted from rule conditions. Null if rule has no subtotal condition. */
  threshold_amount?: Maybe<Scalars['Float']['output']>;
};

export type CartLevelGiftsOutput = {
  __typename?: 'CartLevelGiftsOutput';
  /** Primary active exclusive rule (backward compat). The highest-priority exclusive rule with selections, or highest-priority exclusive rule if none have selections, or null if no exclusive rules exist. */
  active_rule_id?: Maybe<Scalars['Int']['output']>;
  /** All rule IDs that currently have gift selections applied. Multiple rules can be active simultaneously when no exclusive rule conflicts exist (TH1, TH3B). */
  active_rule_ids: Array<Scalars['Int']['output']>;
  /** All eligible rules available for customer to view and select gifts from. Customer can select from multiple rules simultaneously (TH1/TH3B) or only one rule at a time (TH2/TH3A/TH4) depending on stop_rules_processing and sort_order configuration. */
  effective_rules: Array<CartLevelGiftRule>;
  /** True when exclusive rules (stop_rules_processing=true) exist among eligible rules, indicating potential selection constraints. */
  has_exclusive_conflict: Scalars['Boolean']['output'];
  /** All cart-level gift rules with eligibility status */
  items: Array<CartLevelGiftRule>;
};

export type CartMeta = {
  __typename?: 'CartMeta';
  /** A comma-separated list of applied sales rule IDs for discounts and promotions. */
  applied_rule_ids?: Maybe<Scalars['String']['output']>;
  /** The base currency code used for the website. */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** The total amount payable for the cart in the base currency, including taxes and discounts. */
  base_grand_total?: Maybe<Scalars['Float']['output']>;
  /** The subtotal of the cart in the base currency, before taxes and discounts. */
  base_subtotal?: Maybe<Scalars['Float']['output']>;
  /** The subtotal of the cart in the base currency, including discounts but before taxes. */
  base_subtotal_with_discount?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether order confirmation should be made via phone (1 = yes, 0 = no). */
  confirm_by_phone?: Maybe<Scalars['Int']['output']>;
  /** The coupon code applied to the cart, if any. */
  coupon_code?: Maybe<Scalars['String']['output']>;
  /** The date of birth of the customer, if available. */
  customer_dob?: Maybe<Scalars['String']['output']>;
  /** The email address of the customer associated with the cart. */
  customer_email?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer. */
  customer_firstname?: Maybe<Scalars['String']['output']>;
  /** The gender of the customer, if provided. */
  customer_gender?: Maybe<Scalars['String']['output']>;
  /** The last name of the customer. */
  customer_lastname?: Maybe<Scalars['String']['output']>;
  /** The middle name of the customer. */
  customer_middlename?: Maybe<Scalars['String']['output']>;
  /** An optional note left by the customer for the order. */
  customer_note?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the customer should be notified about the note (1 = yes, 0 = no). */
  customer_note_notify?: Maybe<Scalars['Int']['output']>;
  /** The prefix (e.g., Mr., Ms.) of the customer name. */
  customer_prefix?: Maybe<Scalars['String']['output']>;
  /** The suffix (e.g., Jr., Sr.) of the customer name. */
  customer_suffix?: Maybe<Scalars['String']['output']>;
  /** The tax or VAT identification number of the customer. */
  customer_taxvat?: Maybe<Scalars['String']['output']>;
  /** The grand total of the cart. */
  grand_total?: Maybe<Scalars['Float']['output']>;
  /** The ID of the cart. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Indicates whether the cart has been modified since the last calculation (1 = yes, 0 = no). */
  is_changed?: Maybe<Scalars['Int']['output']>;
  /** Returns an array of cart items. */
  items?: Maybe<Array<Maybe<CartItemMeta>>>;
  /** The number of items in the cart. */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** The total quantity of items in the cart. */
  items_qty?: Maybe<Scalars['Int']['output']>;
  /** The currency code used for the current cart/quote. */
  quote_currency_code?: Maybe<Scalars['String']['output']>;
  /** An optional note or instruction related to shipping for this cart. */
  shipping_note?: Maybe<Scalars['String']['output']>;
  /** The currency code used by the store view. */
  store_currency_code?: Maybe<Scalars['String']['output']>;
  /** The conversion rate from store currency to base currency. */
  store_to_base_rate?: Maybe<Scalars['Float']['output']>;
  /** The conversion rate from store currency to quote currency. */
  store_to_quote_rate?: Maybe<Scalars['Float']['output']>;
  /** The subtotal of the cart in the quote currency, before taxes and discounts. */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** The subtotal of the cart in the quote currency, including discounts but before taxes. */
  subtotal_with_discount?: Maybe<Scalars['Float']['output']>;
};

export type CartPrices = {
  __typename?: 'CartPrices';
  applied_taxes?: Maybe<Array<Maybe<CartTaxItem>>>;
  /** @deprecated Use discounts instead  */
  discount?: Maybe<CartDiscount>;
  /** An array of applied discounts */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  grand_total?: Maybe<Money>;
  subtotal_excluding_tax?: Maybe<Money>;
  subtotal_including_tax?: Maybe<Money>;
  subtotal_with_discount_excluding_tax?: Maybe<Money>;
};

export type CartSyncActionInput = {
  /** Product information if action is a gift */
  actionProduct?: InputMaybe<CartSyncActionProductInput>;
  /** Quantity for the action */
  actionQty?: InputMaybe<Scalars['Int']['input']>;
  /** Action type: free_gift, discount, free_ship, point, voucher, other */
  actionType: Scalars['String']['input'];
  /** Value of the action (e.g., discount amount) */
  actionValue?: InputMaybe<Scalars['Float']['input']>;
  /** Unique identifier for the action (client-generated UUID) */
  id: Scalars['String']['input'];
};

export type CartSyncActionProductInput = {
  /** Product SKU for the action */
  sku: Scalars['String']['input'];
};

/** Per-item error returned from synchronizeCart when an individual item fails */
export type CartSyncItemError = {
  __typename?: 'CartSyncItemError';
  /** The reference ID of the item that failed — maps to cart line on screen */
  cart_item_reference_id: Scalars['String']['output'];
  /** Machine-readable error code for client logic */
  error_code: CartSyncItemErrorCode;
  /** Human-readable error message for display */
  message: Scalars['String']['output'];
  /** The SKU that caused the error */
  sku?: Maybe<Scalars['String']['output']>;
};

/** Machine-readable error codes for cart sync item failures */
export enum CartSyncItemErrorCode {
  /** Failed to add product to Magento cart */
  AddToCartFailed = 'ADD_TO_CART_FAILED',
  /** Failed to add gift product to cart */
  GiftAddFailed = 'GIFT_ADD_FAILED',
  /** Gift product requested quantity exceeds available salable quantity */
  GiftInsufficientStock = 'GIFT_INSUFFICIENT_STOCK',
  /** Gift product is not salable (out of stock or not assigned to warehouse) */
  GiftNotSalable = 'GIFT_NOT_SALABLE',
  /** Requested quantity exceeds available stock */
  InsufficientStock = 'INSUFFICIENT_STOCK',
  /** Child SKU is not a valid variant of the parent configurable product */
  InvalidConfigurable = 'INVALID_CONFIGURABLE',
  /** Product is out of stock */
  OutOfStock = 'OUT_OF_STOCK',
  /** Product is disabled/not visible */
  ProductDisabled = 'PRODUCT_DISABLED',
  /** Product SKU does not exist in catalog */
  SkuNotFound = 'SKU_NOT_FOUND',
  /** SKU equals parent_sku — configurable product data corruption */
  SkuParentCollision = 'SKU_PARENT_COLLISION',
  /** Unexpected error */
  Unknown = 'UNKNOWN'
}

export type CartSyncItemInput = {
  /** Unique identifier for this reference (client-generated UUID) */
  cartItemReferenceId: Scalars['String']['input'];
  /** The critical 'intent to purchase' flag. If true, the item will be added/updated in the Magento cart. If false, it will be removed from the Magento cart but its reference will be saved for audit. */
  isSelected: Scalars['Boolean']['input'];
  /** The cart item local ID */
  localId: Scalars['String']['input'];
  /** List of logics applied to this reference */
  logics: Array<CartSyncLogicInput>;
  /** Parent product SKU (for configurable products) */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  /** Quantity */
  quantity: Scalars['Int']['input'];
  /** Product SKU */
  sku: Scalars['String']['input'];
};

export type CartSyncLogicInput = {
  /** List of actions generated by this logic */
  actions: Array<CartSyncActionInput>;
  /** Quantity of product allocated to this logic (for gift calculation) */
  allocatedQty: Scalars['Int']['input'];
  /** Unique identifier for the logic (client-generated UUID) */
  id: Scalars['String']['input'];
  /** Magento Rule ID */
  logicId: Scalars['String']['input'];
  /** " type: promotion, freeship, campaign, other */
  logicType: Scalars['String']['input'];
  /** The session ID for the logic */
  sessionId: Scalars['String']['input'];
};

export type CartTaxItem = {
  __typename?: 'CartTaxItem';
  amount: Money;
  label: Scalars['String']['output'];
};

/** Data detect from magento catalog-products-list widget */
export type CatalogProductsListWidget = ContentFragmentDataInterface & {
  __typename?: 'CatalogProductsListWidget';
  /** Cache key for App view more button */
  cache_key?: Maybe<Scalars['String']['output']>;
  /** Config of widget */
  config?: Maybe<ProductListConfig>;
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Product skus list */
  skus: Array<Scalars['String']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type CatalogStatusMessageResponse = {
  __typename?: 'CatalogStatusMessageResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type CategoryBanners = {
  __typename?: 'CategoryBanners';
  /** An array of banners */
  items?: Maybe<Array<Maybe<Banner>>>;
  /** The layout of banners. */
  layout?: Maybe<BannerLayoutData>;
};

/** CategoryFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by category ID that uniquely identifies the category. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter by the part of the URL that identifies the category */
  url_key?: InputMaybe<FilterEqualTypeInput>;
};

/** The Products object is the top-level object returned in a product list. */
export type CategoryHighlightProducts = {
  __typename?: 'CategoryHighlightProducts';
  /** An array of products that match the specified query data */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

/** CategoryInterface contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  /** Achievement information of the Category */
  achievement?: Maybe<Achievement>;
  amtoolkit_robots?: Maybe<Scalars['String']['output']>;
  author_email?: Maybe<Scalars['String']['output']>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  background_app_icon?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  banner_active_from?: Maybe<Scalars['String']['output']>;
  banner_active_to?: Maybe<Scalars['String']['output']>;
  banner_from_date?: Maybe<Scalars['String']['output']>;
  banner_head?: Maybe<Scalars['String']['output']>;
  banner_menu_image?: Maybe<Scalars['String']['output']>;
  banner_mobile_image?: Maybe<Scalars['String']['output']>;
  banner_to_date?: Maybe<Scalars['String']['output']>;
  banner_url?: Maybe<Scalars['String']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  category_image_for_app?: Maybe<Scalars['String']['output']>;
  category_tags?: Maybe<Scalars['String']['output']>;
  child_tags?: Maybe<Scalars['String']['output']>;
  children_count?: Maybe<Scalars['String']['output']>;
  /** Category CMS Block. */
  cms_block?: Maybe<CmsBlock>;
  /** Timestamp indicating when the category was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  custom_layout_update_file?: Maybe<Scalars['String']['output']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']['output']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  display_mode?: Maybe<Scalars['String']['output']>;
  featured_app_icon?: Maybe<Scalars['String']['output']>;
  featured_icon?: Maybe<Scalars['String']['output']>;
  filter_price_range?: Maybe<Scalars['Float']['output']>;
  first_post?: Maybe<Scalars['String']['output']>;
  fourth_post?: Maybe<Scalars['String']['output']>;
  highlight_post?: Maybe<Scalars['String']['output']>;
  highlight_product_app_qty?: Maybe<Scalars['String']['output']>;
  highlight_product_app_sku?: Maybe<Scalars['String']['output']>;
  highlight_product_app_type?: Maybe<Scalars['String']['output']>;
  /** An ID that uniquely identifies the category. */
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image1?: Maybe<Scalars['String']['output']>;
  image_desktop_active_from?: Maybe<Scalars['String']['output']>;
  image_desktop_active_to?: Maybe<Scalars['String']['output']>;
  image_mobile_active_from?: Maybe<Scalars['String']['output']>;
  image_mobile_active_to?: Maybe<Scalars['String']['output']>;
  include_in_menu?: Maybe<Scalars['Int']['output']>;
  is_anchor?: Maybe<Scalars['Int']['output']>;
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  is_virtual_category?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<Scalars['Int']['output']>;
  /** Indicates the depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>;
  menu_icon?: Maybe<Scalars['String']['output']>;
  menu_icon_over?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  mobile_image?: Maybe<Scalars['String']['output']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** Category Path. */
  path?: Maybe<Scalars['String']['output']>;
  /** Category path in store. */
  path_in_store?: Maybe<Scalars['String']['output']>;
  /** The popular search keywords for category page. */
  popularSearchKeywords?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** The number of products in the category. */
  product_count?: Maybe<Scalars['Int']['output']>;
  product_deal?: Maybe<Scalars['String']['output']>;
  product_deal_time?: Maybe<Scalars['String']['output']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  searchindex_weight?: Maybe<Scalars['String']['output']>;
  second_post?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slider_params?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  third_post?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the category was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The url key assigned to the category. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** The url path assigned to the category. */
  url_path?: Maybe<Scalars['String']['output']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_name_in_product_search?: Maybe<Scalars['Int']['output']>;
  use_store_positions?: Maybe<Scalars['Int']['output']>;
  virtual_category_root?: Maybe<Scalars['Int']['output']>;
  virtual_rule?: Maybe<Scalars['String']['output']>;
};


/** CategoryInterface contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** An array posts in category. */
export type CategoryPosts = {
  __typename?: 'CategoryPosts';
  /** An array of posts that match the specified query data. */
  items?: Maybe<Array<Maybe<Post>>>;
};

/** The category products object returned in the Category query. */
export type CategoryProducts = {
  __typename?: 'CategoryProducts';
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Tag items for category. */
export type CategoryTags = {
  __typename?: 'CategoryTags';
  /** An array of tags */
  items?: Maybe<Array<Maybe<Tag>>>;
};

/** Category Tree implementation. */
export type CategoryTree = CategoryInterface & {
  __typename?: 'CategoryTree';
  /** Achievement information of the Category */
  achievement?: Maybe<Achievement>;
  amtoolkit_robots?: Maybe<Scalars['String']['output']>;
  author_email?: Maybe<Scalars['String']['output']>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  background_app_icon?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  banner_active_from?: Maybe<Scalars['String']['output']>;
  banner_active_to?: Maybe<Scalars['String']['output']>;
  banner_from_date?: Maybe<Scalars['String']['output']>;
  banner_head?: Maybe<Scalars['String']['output']>;
  banner_menu_image?: Maybe<Scalars['String']['output']>;
  banner_mobile_image?: Maybe<Scalars['String']['output']>;
  banner_to_date?: Maybe<Scalars['String']['output']>;
  banner_url?: Maybe<Scalars['String']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  category_image_for_app?: Maybe<Scalars['String']['output']>;
  category_tags?: Maybe<Scalars['String']['output']>;
  child_tags?: Maybe<Scalars['String']['output']>;
  /** Child categories tree. */
  children?: Maybe<Array<Maybe<CategoryTree>>>;
  children_count?: Maybe<Scalars['String']['output']>;
  /** Category CMS Block. */
  cms_block?: Maybe<CmsBlock>;
  /** Timestamp indicating when the category was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  custom_layout_update_file?: Maybe<Scalars['String']['output']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']['output']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  display_mode?: Maybe<Scalars['String']['output']>;
  featured_app_icon?: Maybe<Scalars['String']['output']>;
  featured_icon?: Maybe<Scalars['String']['output']>;
  filter_price_range?: Maybe<Scalars['Float']['output']>;
  first_post?: Maybe<Scalars['String']['output']>;
  fourth_post?: Maybe<Scalars['String']['output']>;
  highlight_post?: Maybe<Scalars['String']['output']>;
  highlight_product_app_qty?: Maybe<Scalars['String']['output']>;
  highlight_product_app_sku?: Maybe<Scalars['String']['output']>;
  highlight_product_app_type?: Maybe<Scalars['String']['output']>;
  /** An array attribute object. */
  highlight_product_attributes?: Maybe<Array<Maybe<Attribute>>>;
  /** An ID that uniquely identifies the category. */
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image1?: Maybe<Scalars['String']['output']>;
  image_desktop_active_from?: Maybe<Scalars['String']['output']>;
  image_desktop_active_to?: Maybe<Scalars['String']['output']>;
  image_mobile_active_from?: Maybe<Scalars['String']['output']>;
  image_mobile_active_to?: Maybe<Scalars['String']['output']>;
  include_in_menu?: Maybe<Scalars['Int']['output']>;
  is_anchor?: Maybe<Scalars['Int']['output']>;
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  is_virtual_category?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<Scalars['Int']['output']>;
  /** Indicates the depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>;
  menu_icon?: Maybe<Scalars['String']['output']>;
  menu_icon_over?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  mobile_image?: Maybe<Scalars['String']['output']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** Category Path. */
  path?: Maybe<Scalars['String']['output']>;
  /** Category path in store. */
  path_in_store?: Maybe<Scalars['String']['output']>;
  /** The popular search keywords for category page. */
  popularSearchKeywords?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** The number of products in the category. */
  product_count?: Maybe<Scalars['Int']['output']>;
  product_deal?: Maybe<Scalars['String']['output']>;
  product_deal_time?: Maybe<Scalars['String']['output']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  searchindex_weight?: Maybe<Scalars['String']['output']>;
  second_post?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slider_params?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  third_post?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the category was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The url key assigned to the category. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** The url path assigned to the category. */
  url_path?: Maybe<Scalars['String']['output']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_name_in_product_search?: Maybe<Scalars['Int']['output']>;
  use_store_positions?: Maybe<Scalars['Int']['output']>;
  virtual_category_root?: Maybe<Scalars['Int']['output']>;
  virtual_rule?: Maybe<Scalars['String']['output']>;
};


/** Category Tree implementation. */
export type CategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Defines all Checkout Agreement information */
export type CheckoutAgreement = {
  __typename?: 'CheckoutAgreement';
  /** Checkout Agreement identifier */
  agreement_id: Scalars['Int']['output'];
  /** Checkout Agreement checkbox text */
  checkbox_text: Scalars['String']['output'];
  /** Checkout Agreement content */
  content: Scalars['String']['output'];
  /** Checkout Agreement content height */
  content_height?: Maybe<Scalars['String']['output']>;
  /** Is Checkout Agreement content in HTML format */
  is_html: Scalars['Boolean']['output'];
  mode: CheckoutAgreementMode;
  /** Checkout Agreement name */
  name: Scalars['String']['output'];
};

export enum CheckoutAgreementMode {
  /** @deprecated  */
  Auto = 'AUTO',
  /** @deprecated  */
  Manual = 'MANUAL'
}

export type CheckoutInfoInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<InitiateCheckoutContentInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientCredentialInput = {
  client_id: Scalars['String']['input'];
  client_secret: Scalars['String']['input'];
};

/** CMS block defines all CMS block information */
export type CmsBlock = {
  __typename?: 'CmsBlock';
  /** CMS block content */
  content?: Maybe<Scalars['String']['output']>;
  /** CMS block identifier */
  identifier?: Maybe<Scalars['String']['output']>;
  /** CMS block title */
  title?: Maybe<Scalars['String']['output']>;
};

/** CMS blocks information */
export type CmsBlocks = {
  __typename?: 'CmsBlocks';
  /** An array of CMS blocks */
  items?: Maybe<Array<Maybe<CmsBlock>>>;
};

/** CMS page defines all CMS page information */
export type CmsPage = {
  __typename?: 'CmsPage';
  /** CMS page content */
  content?: Maybe<Scalars['String']['output']>;
  /** CMS page content heading */
  content_heading?: Maybe<Scalars['String']['output']>;
  /** Identifier of the CMS page */
  identifier?: Maybe<Scalars['String']['output']>;
  /** CMS page meta description */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** CMS page meta keywords */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** CMS page meta title */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** CMS page content heading */
  page_layout?: Maybe<Scalars['String']['output']>;
  /** CMS page title */
  title?: Maybe<Scalars['String']['output']>;
  /** URL key of CMS page */
  url_key?: Maybe<Scalars['String']['output']>;
};

/** CMS page configuration */
export type CmsPageConfig = {
  __typename?: 'CmsPageConfig';
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['String']['output'];
  url_key?: Maybe<Scalars['String']['output']>;
};

export type CmsPageResponse = {
  __typename?: 'CmsPageResponse';
  /** Cms html */
  content?: Maybe<Scalars['String']['output']>;
  /** Data extracted from html element used to render in frontend  */
  content_fragment: Array<ContentFragment>;
  /** Heading of cms page */
  content_heading?: Maybe<Scalars['String']['output']>;
  /** Identification key of page */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Mega description of cms page */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** Mega keywords of cms page */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** Mega title of cms page */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Layout name of page in magento */
  page_layout?: Maybe<Scalars['String']['output']>;
  /** Url of shared image */
  social_image?: Maybe<Scalars['String']['output']>;
  /** Title of cms page */
  title?: Maybe<Scalars['String']['output']>;
  /** Url key of cms page */
  url_key?: Maybe<Scalars['String']['output']>;
};

export type ColorSwatchData = SwatchDataInterface & {
  __typename?: 'ColorSwatchData';
  /** Value of swatch item (HEX color code, image link or textual value) */
  value?: Maybe<Scalars['String']['output']>;
};

export type CompleteRegistrationEventInput = {
  user: UserDataInput;
};

export type CompleteRegistrationTrackingEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<CompleteRegistrationEventInput>;
};

export type ComplexTextValue = {
  __typename?: 'ComplexTextValue';
  /** HTML format */
  html: Scalars['String']['output'];
};

/** Data return for image */
export type CompositeImageWidget = ContentFragmentDataInterface & {
  __typename?: 'CompositeImageWidget';
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Images in CompositeImageWidget */
  images?: Maybe<Array<Maybe<ImageItem>>>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type Condition = {
  __typename?: 'Condition';
  aggregator?: Maybe<Scalars['String']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  is_value_processed?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** ConfigurableAttributeOption contains the value_index (and other related information) assigned to a configurable product option */
export type ConfigurableAttributeOption = {
  __typename?: 'ConfigurableAttributeOption';
  /** The ID assigned to the attribute */
  code?: Maybe<Scalars['String']['output']>;
  /** A string that describes the configurable attribute option */
  label?: Maybe<Scalars['String']['output']>;
  /** A unique index number assigned to the configurable product option */
  value_index?: Maybe<Scalars['Int']['output']>;
};

export type ConfigurableCartItem = CartItemInterface & {
  __typename?: 'ConfigurableCartItem';
  configurable_options: Array<Maybe<SelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: ProductInterface;
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

export type ConfigurableLocalCartItem = LocalCartItemInterface & {
  __typename?: 'ConfigurableLocalCartItem';
  cart_item_reference_id: Scalars['String']['output'];
  configurable_options: Array<SelectedConfigurableOption>;
  /** Product details of the cart item. */
  configured_variant: ProductInterface;
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  id: Scalars['String']['output'];
  local_id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** ConfigurableProduct defines basic features of a configurable product and its simple product variants */
export type ConfigurableProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & {
  __typename?: 'ConfigurableProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** An array of linked simple product items */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOptions>>>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  sold_quantity?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /** An array of variants of products */
  variants?: Maybe<Array<Maybe<ConfigurableVariant>>>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type ConfigurableProductCartItemInput = {
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
  /** Configurable product SKU. */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  variant_sku?: InputMaybe<Scalars['String']['input']>;
};

/** ConfigurableProductOptions defines configurable attributes for the specified product */
export type ConfigurableProductOptions = {
  __typename?: 'ConfigurableProductOptions';
  /** A string that identifies the attribute */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the attribute */
  attribute_id?: Maybe<Scalars['String']['output']>;
  /** The configurable option ID number assigned by the system */
  id?: Maybe<Scalars['Int']['output']>;
  /** A string that describes the configurable product option, which is displayed on the UI */
  label?: Maybe<Scalars['String']['output']>;
  /** A number that indicates the order in which the attribute is displayed */
  position?: Maybe<Scalars['Int']['output']>;
  /** This is the same as a product's id field */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is the default */
  use_default?: Maybe<Scalars['Boolean']['output']>;
  /** An array that defines the value_index codes assigned to the configurable product */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>;
};

/** ConfigurableProductOptionsValues contains the index number assigned to a configurable product option */
export type ConfigurableProductOptionsValues = {
  __typename?: 'ConfigurableProductOptionsValues';
  /** The label of the product on the default store */
  default_label?: Maybe<Scalars['String']['output']>;
  /** The label of the product */
  label?: Maybe<Scalars['String']['output']>;
  /** The label of the product on the current store */
  store_label?: Maybe<Scalars['String']['output']>;
  /** Swatch data for configurable product option */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** Indicates whether to use the default_label */
  use_default_value?: Maybe<Scalars['Boolean']['output']>;
  /** A unique index number assigned to the configurable product option */
  value_index?: Maybe<Scalars['Int']['output']>;
};

/** An array containing all the simple product variants of a configurable product */
export type ConfigurableVariant = {
  __typename?: 'ConfigurableVariant';
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>;
  product?: Maybe<SimpleProduct>;
};

export type ConfirmRequestedValidationPhoneResponse = {
  __typename?: 'ConfirmRequestedValidationPhoneResponse';
  /** Error Code if any */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Secret to use for next request */
  secret?: Maybe<Scalars['String']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  contact?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  socials?: Maybe<Array<Maybe<SocialChannel>>>;
  website?: Maybe<Scalars['String']['output']>;
};

/** Data extracted from html element */
export type ContentFragment = {
  __typename?: 'ContentFragment';
  /** Additional data diffirent on each widget type */
  data?: Maybe<ContentFragmentDataInterface>;
  /** Html of widget */
  html: Scalars['String']['output'];
  /** Magento widget id */
  widget_id?: Maybe<Scalars['String']['output']>;
};

export type ContentFragmentDataInterface = {
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type CoreConfig = {
  __typename?: 'CoreConfig';
  image_upload_quantity_limit?: Maybe<Scalars['Int']['output']>;
  image_upload_size_limit?: Maybe<Scalars['Int']['output']>;
  video_upload_quantity_limit?: Maybe<Scalars['Int']['output']>;
  video_upload_size_limit?: Maybe<Scalars['Int']['output']>;
};

export type Country = {
  __typename?: 'Country';
  available_regions?: Maybe<Array<Maybe<Region>>>;
  full_name_english?: Maybe<Scalars['String']['output']>;
  full_name_locale?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  three_letter_abbreviation?: Maybe<Scalars['String']['output']>;
  two_letter_abbreviation?: Maybe<Scalars['String']['output']>;
};

/** The list of countries codes */
export enum CountryCodeEnum {
  /**
   * Andorra
   * @deprecated
   */
  Ad = 'AD',
  /**
   * United Arab Emirates
   * @deprecated
   */
  Ae = 'AE',
  /**
   * Afghanistan
   * @deprecated
   */
  Af = 'AF',
  /**
   * Antigua & Barbuda
   * @deprecated
   */
  Ag = 'AG',
  /**
   * Anguilla
   * @deprecated
   */
  Ai = 'AI',
  /**
   * Albania
   * @deprecated
   */
  Al = 'AL',
  /**
   * Armenia
   * @deprecated
   */
  Am = 'AM',
  /**
   * Netherlands Antilles
   * @deprecated
   */
  An = 'AN',
  /**
   * Angola
   * @deprecated
   */
  Ao = 'AO',
  /**
   * Antarctica
   * @deprecated
   */
  Aq = 'AQ',
  /**
   * Argentina
   * @deprecated
   */
  Ar = 'AR',
  /**
   * American Samoa
   * @deprecated
   */
  As = 'AS',
  /**
   * Austria
   * @deprecated
   */
  At = 'AT',
  /**
   * Australia
   * @deprecated
   */
  Au = 'AU',
  /**
   * Aruba
   * @deprecated
   */
  Aw = 'AW',
  /**
   * Åland Islands
   * @deprecated
   */
  Ax = 'AX',
  /**
   * Azerbaijan
   * @deprecated
   */
  Az = 'AZ',
  /**
   * Bosnia & Herzegovina
   * @deprecated
   */
  Ba = 'BA',
  /**
   * Barbados
   * @deprecated
   */
  Bb = 'BB',
  /**
   * Bangladesh
   * @deprecated
   */
  Bd = 'BD',
  /**
   * Belgium
   * @deprecated
   */
  Be = 'BE',
  /**
   * Burkina Faso
   * @deprecated
   */
  Bf = 'BF',
  /**
   * Bulgaria
   * @deprecated
   */
  Bg = 'BG',
  /**
   * Bahrain
   * @deprecated
   */
  Bh = 'BH',
  /**
   * Burundi
   * @deprecated
   */
  Bi = 'BI',
  /**
   * Benin
   * @deprecated
   */
  Bj = 'BJ',
  /**
   * St. Barthélemy
   * @deprecated
   */
  Bl = 'BL',
  /**
   * Bermuda
   * @deprecated
   */
  Bm = 'BM',
  /**
   * Brunei
   * @deprecated
   */
  Bn = 'BN',
  /**
   * Bolivia
   * @deprecated
   */
  Bo = 'BO',
  /**
   * Brazil
   * @deprecated
   */
  Br = 'BR',
  /**
   * Bahamas
   * @deprecated
   */
  Bs = 'BS',
  /**
   * Bhutan
   * @deprecated
   */
  Bt = 'BT',
  /**
   * Bouvet Island
   * @deprecated
   */
  Bv = 'BV',
  /**
   * Botswana
   * @deprecated
   */
  Bw = 'BW',
  /**
   * Belarus
   * @deprecated
   */
  By = 'BY',
  /**
   * Belize
   * @deprecated
   */
  Bz = 'BZ',
  /**
   * Canada
   * @deprecated
   */
  Ca = 'CA',
  /**
   * Cocos (Keeling) Islands
   * @deprecated
   */
  Cc = 'CC',
  /**
   * Congo-Kinshasa
   * @deprecated
   */
  Cd = 'CD',
  /**
   * Central African Republic
   * @deprecated
   */
  Cf = 'CF',
  /**
   * Congo-Brazzaville
   * @deprecated
   */
  Cg = 'CG',
  /**
   * Switzerland
   * @deprecated
   */
  Ch = 'CH',
  /**
   * Côte d’Ivoire
   * @deprecated
   */
  Ci = 'CI',
  /**
   * Cook Islands
   * @deprecated
   */
  Ck = 'CK',
  /**
   * Chile
   * @deprecated
   */
  Cl = 'CL',
  /**
   * Cameroon
   * @deprecated
   */
  Cm = 'CM',
  /**
   * China
   * @deprecated
   */
  Cn = 'CN',
  /**
   * Colombia
   * @deprecated
   */
  Co = 'CO',
  /**
   * Costa Rica
   * @deprecated
   */
  Cr = 'CR',
  /**
   * Cuba
   * @deprecated
   */
  Cu = 'CU',
  /**
   * Cape Verde
   * @deprecated
   */
  Cv = 'CV',
  /**
   * Christmas Island
   * @deprecated
   */
  Cx = 'CX',
  /**
   * Cyprus
   * @deprecated
   */
  Cy = 'CY',
  /**
   * Czech Republic
   * @deprecated
   */
  Cz = 'CZ',
  /**
   * Germany
   * @deprecated
   */
  De = 'DE',
  /**
   * Djibouti
   * @deprecated
   */
  Dj = 'DJ',
  /**
   * Denmark
   * @deprecated
   */
  Dk = 'DK',
  /**
   * Dominica
   * @deprecated
   */
  Dm = 'DM',
  /**
   * Dominican Republic
   * @deprecated
   */
  Do = 'DO',
  /**
   * Algeria
   * @deprecated
   */
  Dz = 'DZ',
  /**
   * Ecuador
   * @deprecated
   */
  Ec = 'EC',
  /**
   * Estonia
   * @deprecated
   */
  Ee = 'EE',
  /**
   * Egypt
   * @deprecated
   */
  Eg = 'EG',
  /**
   * Western Sahara
   * @deprecated
   */
  Eh = 'EH',
  /**
   * Eritrea
   * @deprecated
   */
  Er = 'ER',
  /**
   * Spain
   * @deprecated
   */
  Es = 'ES',
  /**
   * Ethiopia
   * @deprecated
   */
  Et = 'ET',
  /**
   * Finland
   * @deprecated
   */
  Fi = 'FI',
  /**
   * Fiji
   * @deprecated
   */
  Fj = 'FJ',
  /**
   * Falkland Islands
   * @deprecated
   */
  Fk = 'FK',
  /**
   * Micronesia
   * @deprecated
   */
  Fm = 'FM',
  /**
   * Faroe Islands
   * @deprecated
   */
  Fo = 'FO',
  /**
   * France
   * @deprecated
   */
  Fr = 'FR',
  /**
   * Gabon
   * @deprecated
   */
  Ga = 'GA',
  /**
   * United Kingdom
   * @deprecated
   */
  Gb = 'GB',
  /**
   * Grenada
   * @deprecated
   */
  Gd = 'GD',
  /**
   * Georgia
   * @deprecated
   */
  Ge = 'GE',
  /**
   * French Guiana
   * @deprecated
   */
  Gf = 'GF',
  /**
   * Guernsey
   * @deprecated
   */
  Gg = 'GG',
  /**
   * Ghana
   * @deprecated
   */
  Gh = 'GH',
  /**
   * Gibraltar
   * @deprecated
   */
  Gi = 'GI',
  /**
   * Greenland
   * @deprecated
   */
  Gl = 'GL',
  /**
   * Gambia
   * @deprecated
   */
  Gm = 'GM',
  /**
   * Guinea
   * @deprecated
   */
  Gn = 'GN',
  /**
   * Guadeloupe
   * @deprecated
   */
  Gp = 'GP',
  /**
   * Equatorial Guinea
   * @deprecated
   */
  Gq = 'GQ',
  /**
   * Greece
   * @deprecated
   */
  Gr = 'GR',
  /**
   * South Georgia & South Sandwich Islands
   * @deprecated
   */
  Gs = 'GS',
  /**
   * Guatemala
   * @deprecated
   */
  Gt = 'GT',
  /**
   * Guam
   * @deprecated
   */
  Gu = 'GU',
  /**
   * Guinea-Bissau
   * @deprecated
   */
  Gw = 'GW',
  /**
   * Guyana
   * @deprecated
   */
  Gy = 'GY',
  /**
   * Hong Kong SAR China
   * @deprecated
   */
  Hk = 'HK',
  /**
   * Heard &amp; McDonald Islands
   * @deprecated
   */
  Hm = 'HM',
  /**
   * Honduras
   * @deprecated
   */
  Hn = 'HN',
  /**
   * Croatia
   * @deprecated
   */
  Hr = 'HR',
  /**
   * Haiti
   * @deprecated
   */
  Ht = 'HT',
  /**
   * Hungary
   * @deprecated
   */
  Hu = 'HU',
  /**
   * Indonesia
   * @deprecated
   */
  Id = 'ID',
  /**
   * Ireland
   * @deprecated
   */
  Ie = 'IE',
  /**
   * Israel
   * @deprecated
   */
  Il = 'IL',
  /**
   * Isle of Man
   * @deprecated
   */
  Im = 'IM',
  /**
   * India
   * @deprecated
   */
  In = 'IN',
  /**
   * British Indian Ocean Territory
   * @deprecated
   */
  Io = 'IO',
  /**
   * Iraq
   * @deprecated
   */
  Iq = 'IQ',
  /**
   * Iran
   * @deprecated
   */
  Ir = 'IR',
  /**
   * Iceland
   * @deprecated
   */
  Is = 'IS',
  /**
   * Italy
   * @deprecated
   */
  It = 'IT',
  /**
   * Jersey
   * @deprecated
   */
  Je = 'JE',
  /**
   * Jamaica
   * @deprecated
   */
  Jm = 'JM',
  /**
   * Jordan
   * @deprecated
   */
  Jo = 'JO',
  /**
   * Japan
   * @deprecated
   */
  Jp = 'JP',
  /**
   * Kenya
   * @deprecated
   */
  Ke = 'KE',
  /**
   * Kyrgyzstan
   * @deprecated
   */
  Kg = 'KG',
  /**
   * Cambodia
   * @deprecated
   */
  Kh = 'KH',
  /**
   * Kiribati
   * @deprecated
   */
  Ki = 'KI',
  /**
   * Comoros
   * @deprecated
   */
  Km = 'KM',
  /**
   * St. Kitts & Nevis
   * @deprecated
   */
  Kn = 'KN',
  /**
   * North Korea
   * @deprecated
   */
  Kp = 'KP',
  /**
   * South Korea
   * @deprecated
   */
  Kr = 'KR',
  /**
   * Kuwait
   * @deprecated
   */
  Kw = 'KW',
  /**
   * Cayman Islands
   * @deprecated
   */
  Ky = 'KY',
  /**
   * Kazakhstan
   * @deprecated
   */
  Kz = 'KZ',
  /**
   * Laos
   * @deprecated
   */
  La = 'LA',
  /**
   * Lebanon
   * @deprecated
   */
  Lb = 'LB',
  /**
   * St. Lucia
   * @deprecated
   */
  Lc = 'LC',
  /**
   * Liechtenstein
   * @deprecated
   */
  Li = 'LI',
  /**
   * Sri Lanka
   * @deprecated
   */
  Lk = 'LK',
  /**
   * Liberia
   * @deprecated
   */
  Lr = 'LR',
  /**
   * Lesotho
   * @deprecated
   */
  Ls = 'LS',
  /**
   * Lithuania
   * @deprecated
   */
  Lt = 'LT',
  /**
   * Luxembourg
   * @deprecated
   */
  Lu = 'LU',
  /**
   * Latvia
   * @deprecated
   */
  Lv = 'LV',
  /**
   * Libya
   * @deprecated
   */
  Ly = 'LY',
  /**
   * Morocco
   * @deprecated
   */
  Ma = 'MA',
  /**
   * Monaco
   * @deprecated
   */
  Mc = 'MC',
  /**
   * Moldova
   * @deprecated
   */
  Md = 'MD',
  /**
   * Montenegro
   * @deprecated
   */
  Me = 'ME',
  /**
   * St. Martin
   * @deprecated
   */
  Mf = 'MF',
  /**
   * Madagascar
   * @deprecated
   */
  Mg = 'MG',
  /**
   * Marshall Islands
   * @deprecated
   */
  Mh = 'MH',
  /**
   * Macedonia
   * @deprecated
   */
  Mk = 'MK',
  /**
   * Mali
   * @deprecated
   */
  Ml = 'ML',
  /**
   * Myanmar (Burma)
   * @deprecated
   */
  Mm = 'MM',
  /**
   * Mongolia
   * @deprecated
   */
  Mn = 'MN',
  /**
   * Macau SAR China
   * @deprecated
   */
  Mo = 'MO',
  /**
   * Northern Mariana Islands
   * @deprecated
   */
  Mp = 'MP',
  /**
   * Martinique
   * @deprecated
   */
  Mq = 'MQ',
  /**
   * Mauritania
   * @deprecated
   */
  Mr = 'MR',
  /**
   * Montserrat
   * @deprecated
   */
  Ms = 'MS',
  /**
   * Malta
   * @deprecated
   */
  Mt = 'MT',
  /**
   * Mauritius
   * @deprecated
   */
  Mu = 'MU',
  /**
   * Maldives
   * @deprecated
   */
  Mv = 'MV',
  /**
   * Malawi
   * @deprecated
   */
  Mw = 'MW',
  /**
   * Mexico
   * @deprecated
   */
  Mx = 'MX',
  /**
   * Malaysia
   * @deprecated
   */
  My = 'MY',
  /**
   * Mozambique
   * @deprecated
   */
  Mz = 'MZ',
  /**
   * Namibia
   * @deprecated
   */
  Na = 'NA',
  /**
   * New Caledonia
   * @deprecated
   */
  Nc = 'NC',
  /**
   * Niger
   * @deprecated
   */
  Ne = 'NE',
  /**
   * Norfolk Island
   * @deprecated
   */
  Nf = 'NF',
  /**
   * Nigeria
   * @deprecated
   */
  Ng = 'NG',
  /**
   * Nicaragua
   * @deprecated
   */
  Ni = 'NI',
  /**
   * Netherlands
   * @deprecated
   */
  Nl = 'NL',
  /**
   * Norway
   * @deprecated
   */
  No = 'NO',
  /**
   * Nepal
   * @deprecated
   */
  Np = 'NP',
  /**
   * Nauru
   * @deprecated
   */
  Nr = 'NR',
  /**
   * Niue
   * @deprecated
   */
  Nu = 'NU',
  /**
   * New Zealand
   * @deprecated
   */
  Nz = 'NZ',
  /**
   * Oman
   * @deprecated
   */
  Om = 'OM',
  /**
   * Panama
   * @deprecated
   */
  Pa = 'PA',
  /**
   * Peru
   * @deprecated
   */
  Pe = 'PE',
  /**
   * French Polynesia
   * @deprecated
   */
  Pf = 'PF',
  /**
   * Papua New Guinea
   * @deprecated
   */
  Pg = 'PG',
  /**
   * Philippines
   * @deprecated
   */
  Ph = 'PH',
  /**
   * Pakistan
   * @deprecated
   */
  Pk = 'PK',
  /**
   * Poland
   * @deprecated
   */
  Pl = 'PL',
  /**
   * St. Pierre & Miquelon
   * @deprecated
   */
  Pm = 'PM',
  /**
   * Pitcairn Islands
   * @deprecated
   */
  Pn = 'PN',
  /**
   * Palestinian Territories
   * @deprecated
   */
  Ps = 'PS',
  /**
   * Portugal
   * @deprecated
   */
  Pt = 'PT',
  /**
   * Palau
   * @deprecated
   */
  Pw = 'PW',
  /**
   * Paraguay
   * @deprecated
   */
  Py = 'PY',
  /**
   * Qatar
   * @deprecated
   */
  Qa = 'QA',
  /**
   * Réunion
   * @deprecated
   */
  Re = 'RE',
  /**
   * Romania
   * @deprecated
   */
  Ro = 'RO',
  /**
   * Serbia
   * @deprecated
   */
  Rs = 'RS',
  /**
   * Russia
   * @deprecated
   */
  Ru = 'RU',
  /**
   * Rwanda
   * @deprecated
   */
  Rw = 'RW',
  /**
   * Saudi Arabia
   * @deprecated
   */
  Sa = 'SA',
  /**
   * Solomon Islands
   * @deprecated
   */
  Sb = 'SB',
  /**
   * Seychelles
   * @deprecated
   */
  Sc = 'SC',
  /**
   * Sudan
   * @deprecated
   */
  Sd = 'SD',
  /**
   * Sweden
   * @deprecated
   */
  Se = 'SE',
  /**
   * Singapore
   * @deprecated
   */
  Sg = 'SG',
  /**
   * St. Helena
   * @deprecated
   */
  Sh = 'SH',
  /**
   * Slovenia
   * @deprecated
   */
  Si = 'SI',
  /**
   * Svalbard & Jan Mayen
   * @deprecated
   */
  Sj = 'SJ',
  /**
   * Slovakia
   * @deprecated
   */
  Sk = 'SK',
  /**
   * Sierra Leone
   * @deprecated
   */
  Sl = 'SL',
  /**
   * San Marino
   * @deprecated
   */
  Sm = 'SM',
  /**
   * Senegal
   * @deprecated
   */
  Sn = 'SN',
  /**
   * Somalia
   * @deprecated
   */
  So = 'SO',
  /**
   * Suriname
   * @deprecated
   */
  Sr = 'SR',
  /**
   * São Tomé & Príncipe
   * @deprecated
   */
  St = 'ST',
  /**
   * El Salvador
   * @deprecated
   */
  Sv = 'SV',
  /**
   * Syria
   * @deprecated
   */
  Sy = 'SY',
  /**
   * Swaziland
   * @deprecated
   */
  Sz = 'SZ',
  /**
   * Turks & Caicos Islands
   * @deprecated
   */
  Tc = 'TC',
  /**
   * Chad
   * @deprecated
   */
  Td = 'TD',
  /**
   * French Southern Territories
   * @deprecated
   */
  Tf = 'TF',
  /**
   * Togo
   * @deprecated
   */
  Tg = 'TG',
  /**
   * Thailand
   * @deprecated
   */
  Th = 'TH',
  /**
   * Tajikistan
   * @deprecated
   */
  Tj = 'TJ',
  /**
   * Tokelau
   * @deprecated
   */
  Tk = 'TK',
  /**
   * Timor-Leste
   * @deprecated
   */
  Tl = 'TL',
  /**
   * Turkmenistan
   * @deprecated
   */
  Tm = 'TM',
  /**
   * Tunisia
   * @deprecated
   */
  Tn = 'TN',
  /**
   * Tonga
   * @deprecated
   */
  To = 'TO',
  /**
   * Turkey
   * @deprecated
   */
  Tr = 'TR',
  /**
   * Trinidad & Tobago
   * @deprecated
   */
  Tt = 'TT',
  /**
   * Tuvalu
   * @deprecated
   */
  Tv = 'TV',
  /**
   * Taiwan
   * @deprecated
   */
  Tw = 'TW',
  /**
   * Tanzania
   * @deprecated
   */
  Tz = 'TZ',
  /**
   * Ukraine
   * @deprecated
   */
  Ua = 'UA',
  /**
   * Uganda
   * @deprecated
   */
  Ug = 'UG',
  /**
   * U.S. Outlying Islands
   * @deprecated
   */
  Um = 'UM',
  /**
   * United States
   * @deprecated
   */
  Us = 'US',
  /**
   * Uruguay
   * @deprecated
   */
  Uy = 'UY',
  /**
   * Uzbekistan
   * @deprecated
   */
  Uz = 'UZ',
  /**
   * Vatican City
   * @deprecated
   */
  Va = 'VA',
  /**
   * St. Vincent & Grenadines
   * @deprecated
   */
  Vc = 'VC',
  /**
   * Venezuela
   * @deprecated
   */
  Ve = 'VE',
  /**
   * British Virgin Islands
   * @deprecated
   */
  Vg = 'VG',
  /**
   * U.S. Virgin Islands
   * @deprecated
   */
  Vi = 'VI',
  /**
   * Vietnam
   * @deprecated
   */
  Vn = 'VN',
  /**
   * Vanuatu
   * @deprecated
   */
  Vu = 'VU',
  /**
   * Wallis & Futuna
   * @deprecated
   */
  Wf = 'WF',
  /**
   * Samoa
   * @deprecated
   */
  Ws = 'WS',
  /**
   * Yemen
   * @deprecated
   */
  Ye = 'YE',
  /**
   * Mayotte
   * @deprecated
   */
  Yt = 'YT',
  /**
   * South Africa
   * @deprecated
   */
  Za = 'ZA',
  /**
   * Zambia
   * @deprecated
   */
  Zm = 'ZM',
  /**
   * Zimbabwe
   * @deprecated
   */
  Zw = 'ZW'
}

export type CouponContentResponse = {
  __typename?: 'CouponContentResponse';
  background_color?: Maybe<Scalars['String']['output']>;
  border_color?: Maybe<Scalars['String']['output']>;
  /** Brand logo image */
  brand_image?: Maybe<Scalars['String']['output']>;
  /** Html to show condition of coupon */
  condition?: Maybe<Scalars['String']['output']>;
  coupon_config_id?: Maybe<Scalars['String']['output']>;
  /** Text to show description of coupon */
  description?: Maybe<Scalars['String']['output']>;
  /** text show devices */
  device?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  /** Html to show instruction of coupon */
  instruction?: Maybe<Scalars['String']['output']>;
  /** Coupon is stored in the customer wallet */
  is_in_wallet?: Maybe<Scalars['Boolean']['output']>;
  /** Name of coupon */
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Array<Maybe<CouponPartner>>>;
  /** payment image url */
  payment_image?: Maybe<Scalars['String']['output']>;
  /** payment method in usage condition of the coupon */
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_method_text?: Maybe<Scalars['String']['output']>;
  /** Html to show restriction of coupon */
  restriction?: Maybe<Scalars['String']['output']>;
  salesrule?: Maybe<Salesrule>;
  shipping_method?: Maybe<Scalars['String']['output']>;
  /** tag of coupon */
  tag?: Maybe<Scalars['String']['output']>;
};

export type CouponPartner = {
  __typename?: 'CouponPartner';
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_key?: Maybe<Scalars['String']['output']>;
  partner_type?: Maybe<Scalars['String']['output']>;
};

/** Defines a filter that matches the input exactly. */
export type CouponWidgetFilterEqualTypeInput = {
  /** A string to filter on */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** An array of values to filter on */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CouponWidgetFilterInput = {
  brand?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  category?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  code?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  partner?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  payment?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  product?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
};

export type CreateAllocationInput = {
  allocation_code: Scalars['String']['input'];
  campaign_id: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  display_end_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_locations?: InputMaybe<Array<DisplayLocation>>;
  display_start_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_status?: InputMaybe<DisplayStatus>;
  expires_at: Scalars['DateTime']['input'];
  max_allocation_usages?: InputMaybe<Scalars['Int']['input']>;
  max_user_usages?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  start_at: Scalars['DateTime']['input'];
};

export type CreateAnswerRequest = {
  adminId: Scalars['Int']['input'];
  adminName: Scalars['String']['input'];
  answer: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAnswerResponse = {
  __typename?: 'CreateAnswerResponse';
  result: Scalars['Boolean']['output'];
};

export type CreateClientCredentialResult = {
  __typename?: 'CreateClientCredentialResult';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateEmptyCartInput = {
  cart_id?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating new event registration details */
export type CreateEventRegistrationDetailsInput = {
  /** Path to the birth certificate image */
  birth_certificate_image?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the registrant */
  birth_date?: InputMaybe<Scalars['String']['input']>;
  /** District ID of the registrant */
  district_id: Scalars['Int']['input'];
  /** District name of the registrant */
  district_name: Scalars['String']['input'];
  /** Due date for the registration */
  due_date?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the registrant */
  email: Scalars['String']['input'];
  /** Full name of the registrant */
  full_name: Scalars['String']['input'];
  /** Guardian's name */
  guardian_name?: InputMaybe<Scalars['String']['input']>;
  /** Guardian's phone number */
  guardian_phone_number?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the registrant */
  phone_number: Scalars['String']['input'];
  /** Path to the prenatal checkup image */
  prenatal_checkup_image?: InputMaybe<Scalars['String']['input']>;
  /** Region ID of the registrant */
  region_id: Scalars['Int']['input'];
  /** Region name of the registrant */
  region_name: Scalars['String']['input'];
  /** Specific address of the registrant */
  specific_address: Scalars['String']['input'];
  /** Store code where the registrant will exchange the event ticket */
  ticket_exchange_store_code?: InputMaybe<Scalars['String']['input']>;
  /** Store name where the registrant will exchange the event ticket */
  ticket_exchange_store_name?: InputMaybe<Scalars['String']['input']>;
  /** Ward ID of the registrant */
  ward_id: Scalars['Int']['input'];
  /** Ward name of the registrant */
  ward_name: Scalars['String']['input'];
};

/** Input type for creating a new event registration */
export type CreateEventRegistrationInput = {
  /** Activity ID for the registration */
  activity_id: Scalars['ID']['input'];
  /** Whether the user agreed to the terms */
  agreed_terms: Scalars['Boolean']['input'];
  /** Details of the registration */
  registration_details?: InputMaybe<Array<CreateEventRegistrationDetailsInput>>;
  /** The update secret to indicate that the action is performed by admin */
  update_secret?: InputMaybe<Scalars['String']['input']>;
  /** User ID for the registration - this is temporary user ID */
  user_temporary_id: Scalars['ID']['input'];
};

/** Input type for creating a new event user */
export type CreateEventUserInput = {
  /** Address of the user */
  address: Scalars['String']['input'];
  /** Birth date of the event user */
  birth_date?: InputMaybe<Scalars['String']['input']>;
  /** captcha token */
  captcha_token?: InputMaybe<Scalars['String']['input']>;
  /** District ID of the user */
  district_id: Scalars['Int']['input'];
  /** District name of the user */
  district_name: Scalars['String']['input'];
  /** Email address of the user */
  email: Scalars['String']['input'];
  /** Event ID for the registration */
  event_id: Scalars['ID']['input'];
  /** Full name of the user */
  full_name: Scalars['String']['input'];
  /** Participant type of the user */
  participant_type: ParticipantType;
  /** Phone number of the user */
  phone_number: Scalars['String']['input'];
  /** Referral code of the user */
  referral_code?: InputMaybe<Scalars['String']['input']>;
  /** referrer */
  referrer?: InputMaybe<Scalars['String']['input']>;
  /** Region ID of the user */
  region_id: Scalars['Int']['input'];
  /** Region name of the user */
  region_name: Scalars['String']['input'];
  /** Specific address of the user */
  specific_address: Scalars['String']['input'];
  /** update secret */
  update_secret?: InputMaybe<Scalars['String']['input']>;
  /** Id of temporary user */
  user_id?: InputMaybe<Scalars['String']['input']>;
  /** Id of temporary user */
  user_temporary_id?: InputMaybe<Scalars['String']['input']>;
  /** utm campaign */
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  /** utm content */
  utm_content?: InputMaybe<Scalars['String']['input']>;
  /** utm medium */
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  /** utm source where user navigate from */
  utm_source?: InputMaybe<Scalars['String']['input']>;
  /** utm term */
  utm_term?: InputMaybe<Scalars['String']['input']>;
  /** Ward ID of the user */
  ward_id: Scalars['Int']['input'];
  /** Ward name of the user */
  ward_name: Scalars['String']['input'];
};

export type CreateNotificationMessageInput = {
  /** message of notification */
  content: Scalars['String']['input'];
  /** icon of notification */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** url of notification */
  link: Scalars['String']['input'];
  /** title */
  title: Scalars['String']['input'];
  /** type of notification */
  type_notification: TypeNotificationEnum;
};

export type CreateQuestionRequest = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  question: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateQuestionResponse = {
  __typename?: 'CreateQuestionResponse';
  result: Scalars['Boolean']['output'];
};

export type CreateReviewRequest = {
  /** Detail */
  detail: Scalars['String']['input'];
  /** Did Customer order the product */
  is_ordered_customer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nick name */
  nickname: Scalars['String']['input'];
  /** Rating code */
  rating_code?: InputMaybe<Scalars['String']['input']>;
  /** Product SKU */
  sku: Scalars['String']['input'];
  /** Source id */
  source_id?: InputMaybe<Scalars['Int']['input']>;
  /** Store code */
  store_code: Scalars['String']['input'];
  /** Title */
  title: Scalars['String']['input'];
  /** Value */
  value: Scalars['Float']['input'];
};

/** Contains credit memo details. */
export type CreditMemo = {
  __typename?: 'CreditMemo';
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID']['output'];
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars['String']['output'];
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>;
};

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  __typename?: 'CreditMemoTotal';
  /** An adjustment manually applied to the order. */
  adjustment: Money;
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: Money;
  /** The amount of tax applied to the credit memo. */
  total_tax: Money;
};

export type Currency = {
  __typename?: 'Currency';
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  base_currency_code?: Maybe<Scalars['String']['output']>;
  base_currency_symbol?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_symbol`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']['output']>;
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  default_display_currency_symbol?: Maybe<Scalars['String']['output']>;
  exchange_rates?: Maybe<Array<Maybe<ExchangeRate>>>;
};

/** The list of available currency codes */
export enum CurrencyEnum {
  /** @deprecated  */
  Aed = 'AED',
  /** @deprecated  */
  Afn = 'AFN',
  /** @deprecated  */
  All = 'ALL',
  /** @deprecated  */
  Amd = 'AMD',
  /** @deprecated  */
  Ang = 'ANG',
  /** @deprecated  */
  Aoa = 'AOA',
  /** @deprecated  */
  Ars = 'ARS',
  /** @deprecated  */
  Aud = 'AUD',
  /** @deprecated  */
  Awg = 'AWG',
  /** @deprecated  */
  Azm = 'AZM',
  /** @deprecated  */
  Azn = 'AZN',
  /** @deprecated  */
  Bam = 'BAM',
  /** @deprecated  */
  Bbd = 'BBD',
  /** @deprecated  */
  Bdt = 'BDT',
  /** @deprecated  */
  Bgn = 'BGN',
  /** @deprecated  */
  Bhd = 'BHD',
  /** @deprecated  */
  Bif = 'BIF',
  /** @deprecated  */
  Bmd = 'BMD',
  /** @deprecated  */
  Bnd = 'BND',
  /** @deprecated  */
  Bob = 'BOB',
  /** @deprecated  */
  Brl = 'BRL',
  /** @deprecated  */
  Bsd = 'BSD',
  /** @deprecated  */
  Btn = 'BTN',
  /** @deprecated  */
  Buk = 'BUK',
  /** @deprecated  */
  Bwp = 'BWP',
  /** @deprecated  */
  Byr = 'BYR',
  /** @deprecated  */
  Bzd = 'BZD',
  /** @deprecated  */
  Cad = 'CAD',
  /** @deprecated  */
  Cdf = 'CDF',
  /** @deprecated  */
  Che = 'CHE',
  /** @deprecated  */
  Chf = 'CHF',
  /** @deprecated  */
  Chw = 'CHW',
  /** @deprecated  */
  Clp = 'CLP',
  /** @deprecated  */
  Cny = 'CNY',
  /** @deprecated  */
  Cop = 'COP',
  /** @deprecated  */
  Crc = 'CRC',
  /** @deprecated  */
  Cup = 'CUP',
  /** @deprecated  */
  Cve = 'CVE',
  /** @deprecated  */
  Czk = 'CZK',
  /** @deprecated  */
  Djf = 'DJF',
  /** @deprecated  */
  Dkk = 'DKK',
  /** @deprecated  */
  Dop = 'DOP',
  /** @deprecated  */
  Dzd = 'DZD',
  /** @deprecated  */
  Eek = 'EEK',
  /** @deprecated  */
  Egp = 'EGP',
  /** @deprecated  */
  Ern = 'ERN',
  /** @deprecated  */
  Etb = 'ETB',
  /** @deprecated  */
  Eur = 'EUR',
  /** @deprecated  */
  Fjd = 'FJD',
  /** @deprecated  */
  Fkp = 'FKP',
  /** @deprecated  */
  Gbp = 'GBP',
  /** @deprecated  */
  Gek = 'GEK',
  /** @deprecated  */
  Gel = 'GEL',
  /** @deprecated  */
  Ghs = 'GHS',
  /** @deprecated  */
  Gip = 'GIP',
  /** @deprecated  */
  Gmd = 'GMD',
  /** @deprecated  */
  Gnf = 'GNF',
  /** @deprecated  */
  Gqe = 'GQE',
  /** @deprecated  */
  Gtq = 'GTQ',
  /** @deprecated  */
  Gyd = 'GYD',
  /** @deprecated  */
  Hkd = 'HKD',
  /** @deprecated  */
  Hnl = 'HNL',
  /** @deprecated  */
  Hrk = 'HRK',
  /** @deprecated  */
  Htg = 'HTG',
  /** @deprecated  */
  Huf = 'HUF',
  /** @deprecated  */
  Idr = 'IDR',
  /** @deprecated  */
  Ils = 'ILS',
  /** @deprecated  */
  Inr = 'INR',
  /** @deprecated  */
  Iqd = 'IQD',
  /** @deprecated  */
  Irr = 'IRR',
  /** @deprecated  */
  Isk = 'ISK',
  /** @deprecated  */
  Jmd = 'JMD',
  /** @deprecated  */
  Jod = 'JOD',
  /** @deprecated  */
  Jpy = 'JPY',
  /** @deprecated  */
  Kes = 'KES',
  /** @deprecated  */
  Kgs = 'KGS',
  /** @deprecated  */
  Khr = 'KHR',
  /** @deprecated  */
  Kmf = 'KMF',
  /** @deprecated  */
  Kpw = 'KPW',
  /** @deprecated  */
  Krw = 'KRW',
  /** @deprecated  */
  Kwd = 'KWD',
  /** @deprecated  */
  Kyd = 'KYD',
  /** @deprecated  */
  Kzt = 'KZT',
  /** @deprecated  */
  Lak = 'LAK',
  /** @deprecated  */
  Lbp = 'LBP',
  /** @deprecated  */
  Lkr = 'LKR',
  /** @deprecated  */
  Lrd = 'LRD',
  /** @deprecated  */
  Lsl = 'LSL',
  /** @deprecated  */
  Lsm = 'LSM',
  /** @deprecated  */
  Ltl = 'LTL',
  /** @deprecated  */
  Lvl = 'LVL',
  /** @deprecated  */
  Lyd = 'LYD',
  /** @deprecated  */
  Mad = 'MAD',
  /** @deprecated  */
  Mdl = 'MDL',
  /** @deprecated  */
  Mga = 'MGA',
  /** @deprecated  */
  Mkd = 'MKD',
  /** @deprecated  */
  Mmk = 'MMK',
  /** @deprecated  */
  Mnt = 'MNT',
  /** @deprecated  */
  Mop = 'MOP',
  /** @deprecated  */
  Mro = 'MRO',
  /** @deprecated  */
  Mur = 'MUR',
  /** @deprecated  */
  Mvr = 'MVR',
  /** @deprecated  */
  Mwk = 'MWK',
  /** @deprecated  */
  Mxn = 'MXN',
  /** @deprecated  */
  Myr = 'MYR',
  /** @deprecated  */
  Mzn = 'MZN',
  /** @deprecated  */
  Nad = 'NAD',
  /** @deprecated  */
  Ngn = 'NGN',
  /** @deprecated  */
  Nic = 'NIC',
  /** @deprecated  */
  Nok = 'NOK',
  /** @deprecated  */
  Npr = 'NPR',
  /** @deprecated  */
  Nzd = 'NZD',
  /** @deprecated  */
  Omr = 'OMR',
  /** @deprecated  */
  Pab = 'PAB',
  /** @deprecated  */
  Pen = 'PEN',
  /** @deprecated  */
  Pgk = 'PGK',
  /** @deprecated  */
  Php = 'PHP',
  /** @deprecated  */
  Pkr = 'PKR',
  /** @deprecated  */
  Pln = 'PLN',
  /** @deprecated  */
  Pyg = 'PYG',
  /** @deprecated  */
  Qar = 'QAR',
  /** @deprecated  */
  Rhd = 'RHD',
  /** @deprecated  */
  Rol = 'ROL',
  /** @deprecated  */
  Ron = 'RON',
  /** @deprecated  */
  Rsd = 'RSD',
  /** @deprecated  */
  Rub = 'RUB',
  /** @deprecated  */
  Rwf = 'RWF',
  /** @deprecated  */
  Sar = 'SAR',
  /** @deprecated  */
  Sbd = 'SBD',
  /** @deprecated  */
  Scr = 'SCR',
  /** @deprecated  */
  Sdg = 'SDG',
  /** @deprecated  */
  Sek = 'SEK',
  /** @deprecated  */
  Sgd = 'SGD',
  /** @deprecated  */
  Shp = 'SHP',
  /** @deprecated  */
  Skk = 'SKK',
  /** @deprecated  */
  Sll = 'SLL',
  /** @deprecated  */
  Sos = 'SOS',
  /** @deprecated  */
  Srd = 'SRD',
  /** @deprecated  */
  Std = 'STD',
  /** @deprecated  */
  Svc = 'SVC',
  /** @deprecated  */
  Syp = 'SYP',
  /** @deprecated  */
  Szl = 'SZL',
  /** @deprecated  */
  Thb = 'THB',
  /** @deprecated  */
  Tjs = 'TJS',
  /** @deprecated  */
  Tmm = 'TMM',
  /** @deprecated  */
  Tnd = 'TND',
  /** @deprecated  */
  Top = 'TOP',
  /** @deprecated  */
  Trl = 'TRL',
  /** @deprecated  */
  Try = 'TRY',
  /** @deprecated  */
  Ttd = 'TTD',
  /** @deprecated  */
  Twd = 'TWD',
  /** @deprecated  */
  Tzs = 'TZS',
  /** @deprecated  */
  Uah = 'UAH',
  /** @deprecated  */
  Ugx = 'UGX',
  /** @deprecated  */
  Usd = 'USD',
  /** @deprecated  */
  Uyu = 'UYU',
  /** @deprecated  */
  Uzs = 'UZS',
  /** @deprecated  */
  Veb = 'VEB',
  /** @deprecated  */
  Vef = 'VEF',
  /** @deprecated  */
  Vnd = 'VND',
  /** @deprecated  */
  Vuv = 'VUV',
  /** @deprecated  */
  Wst = 'WST',
  /** @deprecated  */
  Xcd = 'XCD',
  /** @deprecated  */
  Xof = 'XOF',
  /** @deprecated  */
  Xpf = 'XPF',
  /** @deprecated  */
  Yer = 'YER',
  /** @deprecated  */
  Ytl = 'YTL',
  /** @deprecated  */
  Zar = 'ZAR',
  /** @deprecated  */
  Zmk = 'ZMK',
  /** @deprecated  */
  Zwd = 'ZWD'
}

/** CustomAttributeMetadata defines an array of attribute_codes and entity_types */
export type CustomAttributeMetadata = {
  __typename?: 'CustomAttributeMetadata';
  /** An array of attributes */
  items?: Maybe<Array<Maybe<Attribute>>>;
};

export type Customer = {
  __typename?: 'Customer';
  /** An array containing the customer's shipping and billing addresses */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** Timestamp indicating when the account was created */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The customer's date of birth */
  date_of_birth?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the billing address */
  default_billing?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the shipping address */
  default_shipping?: Maybe<Scalars['String']['output']>;
  /**
   * The customer's date of birth
   * @deprecated Use `date_of_birth` instead
   */
  dob?: Maybe<Scalars['String']['output']>;
  /** The customer's email address. Required */
  email?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<CustomerFaq>;
  /** The customer's first name */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The customer's gender (Male - 1, Female - 2) */
  gender?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios */
  group_id?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID assigned to the customer
   * @deprecated id is not needed as part of Customer because on server side it can be identified based on customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the customer is subscribed to the company's newsletter */
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  /** The customer's family name */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The customer's middle name */
  middlename?: Maybe<Scalars['String']['output']>;
  order_reviews?: Maybe<MyOrderReviews>;
  orders?: Maybe<CustomerOrders>;
  phone_number: Scalars['String']['output'];
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<CustomerQuestions>;
  /** The rank of customer. */
  rank?: Maybe<Scalars['String']['output']>;
  /** Referral Code */
  referral_code?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<CustomerReviewsResponse>;
  search_keywords_history?: Maybe<Array<SearchKeywordHistory>>;
  /** A value such as Sr., Jr., or III */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers) */
  taxvat?: Maybe<Scalars['String']['output']>;
  /** The wishlist query returns the contents of a customer's wish lists */
  wishlist: Wishlist;
};


export type CustomerFaqArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerOrder_ReviewsArgs = {
  filter?: InputMaybe<MyOrderReviewFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CustomerOrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<ScopeTypeEnum>;
  sort?: InputMaybe<CustomerOrderSortInput>;
};


export type CustomerQuestionsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerReviewsArgs = {
  filter: CustomerReviewFilterInput;
};

export type CustomerAccountDeletionFilters = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountDeletionStatus>;
};

export type CustomerAccountDeletionListResponse = {
  __typename?: 'CustomerAccountDeletionListResponse';
  /** List of deletion requests */
  items: Array<CustomerAccountDeletionResponse>;
  /** Pagination information */
  page_info: PageInfo;
};

export type CustomerAccountDeletionResponse = {
  __typename?: 'CustomerAccountDeletionResponse';
  /** Request creation date */
  created_at: Scalars['String']['output'];
  /** Customer email */
  email: Scalars['String']['output'];
  /** Customer first name */
  firstname: Scalars['String']['output'];
  /** Deletion request ID */
  id: Scalars['String']['output'];
  /** Customer last name */
  lastname: Scalars['String']['output'];
  /** Customer phone number */
  phone_number: Scalars['String']['output'];
  /** Deletion request status */
  status: AccountDeletionStatus;
  /** Request last update date */
  updated_at: Scalars['String']['output'];
  /** User who updated the request */
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** CustomerAddress contains detailed information about a customer's billing and shipping addresses */
export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  /** Address Type */
  address_type?: Maybe<Scalars['String']['output']>;
  /** The city or town */
  city?: Maybe<Scalars['String']['output']>;
  /** The customer's company */
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's country */
  country_code?: Maybe<CountryCodeEnum>;
  /**
   * The customer's country
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Custom attributes should not be put into container */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /**
   * The customer ID
   * @deprecated customer_id is not needed as part of CustomerAddress, address ID (id) is unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the address is the default billing address */
  default_billing?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the address is the default shipping address */
  default_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** District Name */
  district?: Maybe<Scalars['String']['output']>;
  /** District ID */
  district_id?: Maybe<Scalars['Int']['output']>;
  /** Address extension attributes */
  extension_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** The fax number */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the address object */
  id?: Maybe<Scalars['Int']['output']>;
  /** The invoice company address of customer. */
  invoice_company_address?: Maybe<Scalars['String']['output']>;
  /** The invoice company name of customer. */
  invoice_company_name?: Maybe<Scalars['String']['output']>;
  /** The invoice vat id of customer. */
  invoice_vat_id?: Maybe<Scalars['String']['output']>;
  /** The family name of the person associated with the shipping/billing address */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The middle name of the person associated with the shipping/billing address */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** An object containing the region name, region code, and region ID */
  region?: Maybe<CustomerAddressRegion>;
  /** @deprecated Region ID is excessive on storefront and region code should suffice for all scenarios */
  region_id?: Maybe<Scalars['Int']['output']>;
  /** An array of strings that define the street number and name */
  street?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A value such as Sr., Jr., or III */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers) */
  vat_id?: Maybe<Scalars['String']['output']>;
  /** Ward Name */
  ward?: Maybe<Scalars['String']['output']>;
  /** Ward ID */
  ward_id?: Maybe<Scalars['Int']['output']>;
};

export type CustomerAddressAttribute = {
  __typename?: 'CustomerAddressAttribute';
  /** Attribute code */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** Attribute value */
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressAttributeInput = {
  /** Attribute code */
  attribute_code: Scalars['String']['input'];
  /** Attribute value */
  value: Scalars['String']['input'];
};

export type CustomerAddressInput = {
  /** The address type. */
  address_type?: InputMaybe<AddressTypeEnum>;
  /** The city or town */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The customer's country */
  country_code?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: use `country_code` instead. */
  country_id?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: Custom attributes should not be put into container. */
  custom_attributes?: InputMaybe<Array<InputMaybe<CustomerAddressAttributeInput>>>;
  /** Indicates whether the address is the default billing address */
  default_billing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the address is the default shipping address */
  default_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** The district name. */
  district?: InputMaybe<Scalars['String']['input']>;
  /** The district id. */
  district_id?: InputMaybe<Scalars['Int']['input']>;
  /** The fax number */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** The invoice company address of customer. */
  invoice_company_address?: InputMaybe<Scalars['String']['input']>;
  /** The invoice company name of customer. */
  invoice_company_name?: InputMaybe<Scalars['String']['input']>;
  /** The invoice vat id of customer. */
  invoice_vat_id?: InputMaybe<Scalars['String']['input']>;
  /** The family name of the person associated with the shipping/billing address */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The middle name of the person associated with the shipping/billing address */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** The customer's ZIP or postal code */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** An object containing the region name, region code, and region ID */
  region?: InputMaybe<CustomerAddressRegionInput>;
  /** An array of strings that define the street number and name */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A value such as Sr., Jr., or III */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The telephone number */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers) */
  vat_id?: InputMaybe<Scalars['String']['input']>;
  /** The ward name. */
  ward?: InputMaybe<Scalars['String']['input']>;
  /** The ward id. */
  ward_id?: InputMaybe<Scalars['Int']['input']>;
};

/** CustomerAddressRegion defines the customer's state or province */
export type CustomerAddressRegion = {
  __typename?: 'CustomerAddressRegion';
  /** The state or province name */
  region?: Maybe<Scalars['String']['output']>;
  /** The address region code */
  region_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Region ID is excessive on storefront and region code should suffice for all scenarios */
  region_id?: Maybe<Scalars['Int']['output']>;
};

export type CustomerAddressRegionInput = {
  /** The state or province name */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The address region code */
  region_code?: InputMaybe<Scalars['String']['input']>;
  /** region_id is deprecated. Region ID is excessive on storefront and region code should suffice for all scenarios */
  region_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerDownloadableProduct = {
  __typename?: 'CustomerDownloadableProduct';
  date?: Maybe<Scalars['String']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  order_increment_id?: Maybe<Scalars['String']['output']>;
  remaining_downloads?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomerDownloadableProducts = {
  __typename?: 'CustomerDownloadableProducts';
  /** List of purchased downloadable items */
  items?: Maybe<Array<Maybe<CustomerDownloadableProduct>>>;
};

export type CustomerFaq = {
  __typename?: 'CustomerFaq';
  data?: Maybe<Array<Maybe<CustomerFaqData>>>;
  pagination_metadata?: Maybe<PaginationData>;
};

export type CustomerFaqData = {
  __typename?: 'CustomerFaqData';
  content?: Maybe<Scalars['String']['output']>;
  create_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<FaqItem>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['Int']['output']>;
};

export type CustomerInformation = {
  __typename?: 'CustomerInformation';
  profile?: Maybe<CustomerProfile>;
};

export type CustomerInput = {
  /** The customer's first name */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's family name */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's middle name */
  middlename?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerKicoin = {
  __typename?: 'CustomerKicoin';
  available?: Maybe<Scalars['Int']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
};

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  /** The billing address for the order. */
  billing_address?: Maybe<OrderAddress>;
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<CreditMemo>>>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars['Float']['output']>;
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID']['output'];
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars['String']['output']>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>;
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>;
  /** The order number. */
  number: Scalars['String']['output'];
  /** The date the order was placed. */
  order_date: Scalars['String']['output'];
  /**
   * The order number
   * @deprecated Use the `number` field instead.
   */
  order_number: Scalars['String']['output'];
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<OrderPaymentMethod>>>;
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address?: Maybe<OrderAddress>;
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars['String']['output']>;
  /** The current status of the order. */
  status: Scalars['String']['output'];
  /** The status code of the order. */
  status_code?: Maybe<Scalars['String']['output']>;
  /** The status history of this order, including timeline and available statuses. */
  status_history?: Maybe<OrderStatusHistory>;
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>;
};

export type CustomerOrderFilterV2 = {
  order_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type CustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: SortEnum;
  /** Specifies the field to use for sorting */
  sort_field: CustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export enum CustomerOrderSortableField {
  /**
   * Sorts customer orders by created_at field
   * @deprecated
   */
  CreatedAt = 'CREATED_AT',
  /**
   * Sorts customer orders by number
   * @deprecated
   */
  Number = 'NUMBER'
}

/** Customer order statistics summary (pre-indexed for O(1) lookup) */
export type CustomerOrderStats = {
  __typename?: 'CustomerOrderStats';
  /** Number of orders placed via app */
  app_order_count?: Maybe<Scalars['Int']['output']>;
  /** Number of completed orders */
  completed_order_count?: Maybe<Scalars['Int']['output']>;
  /** Date of the most recent completed order */
  last_order_date?: Maybe<Scalars['String']['output']>;
  /** Total sales amount of completed orders */
  total_sales_amount?: Maybe<Scalars['Float']['output']>;
  /** Number of orders placed via web */
  web_order_count?: Maybe<Scalars['Int']['output']>;
};

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  __typename?: 'CustomerOrders';
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters by order ID. */
  id?: InputMaybe<FilterEqualTypeInput>;
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>;
  /** Filters by order status. */
  status?: InputMaybe<FilterEqualTypeInput>;
};

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrdersV2 = {
  __typename?: 'CustomerOrdersV2';
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<PageInfo>;
};

export type CustomerOutput = {
  __typename?: 'CustomerOutput';
  customer: Customer;
};

export type CustomerPaymentTokens = {
  __typename?: 'CustomerPaymentTokens';
  /** An array of payment tokens */
  items: Array<Maybe<PaymentToken>>;
};

export type CustomerProfile = {
  __typename?: 'CustomerProfile';
  /** App avatar */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Customer email */
  email?: Maybe<Scalars['String']['output']>;
  /** The customer's first name */
  first_name?: Maybe<Scalars['String']['output']>;
  /** Profile id */
  id?: Maybe<Scalars['String']['output']>;
  /** The customer's family name */
  last_name?: Maybe<Scalars['String']['output']>;
  /** Customer phone number */
  phone_number?: Maybe<Scalars['String']['output']>;
};

export type CustomerProfileInput = {
  /** App avatar */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name */
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** The customer's family name */
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerProfileSign = {
  __typename?: 'CustomerProfileSign';
  id?: Maybe<Scalars['String']['output']>;
  sign?: Maybe<Scalars['String']['output']>;
};

export type CustomerQuestion = {
  __typename?: 'CustomerQuestion';
  product?: Maybe<ProductInterface>;
  question: FaqQuestion;
};

export type CustomerQuestions = {
  __typename?: 'CustomerQuestions';
  items: Array<Maybe<CustomerQuestion>>;
  page_info: PageInfo;
};

export type CustomerReferralCodeInput = {
  code: Scalars['String']['input'];
  salt: Scalars['String']['input'];
  sign: Scalars['String']['input'];
};

export type CustomerReferralCodeSignature = {
  __typename?: 'CustomerReferralCodeSignature';
  /** salt for security purpose */
  salt: Scalars['String']['output'];
  /** Sign for security purpose */
  sign: Scalars['String']['output'];
};

export type CustomerReviewFilterInput = {
  /** Current page */
  current_page?: InputMaybe<Scalars['Int']['input']>;
  /** Page size */
  page_size?: InputMaybe<Scalars['Int']['input']>;
  /** status of review */
  status_code?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerReviewsResponse = {
  __typename?: 'CustomerReviewsResponse';
  /** customer reviews */
  items?: Maybe<Array<Maybe<Review>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  page_info?: Maybe<PageInfo>;
  /** The number of reviews returned that match specified filter criteria */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CustomerToken = {
  __typename?: 'CustomerToken';
  /** The customer token */
  access_token?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['Int']['output']>;
  id_token?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

export type CustomizableOptionInput = {
  id: Scalars['Int']['input'];
  value_string: Scalars['String']['input'];
};

/** The CustomizableOptionInterface contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /** Option ID. */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
};

/** CustomizableProductInterface contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
};

export type DeletePaymentTokenOutput = {
  __typename?: 'DeletePaymentTokenOutput';
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  result: Scalars['Boolean']['output'];
};

export type DeliveryTime = {
  __typename?: 'DeliveryTime';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DeviceRequestInput = {
  /** Device App Version */
  device_app_version: Scalars['String']['input'];
  /** Device ID */
  device_id: Scalars['String']['input'];
  /** Device Name */
  device_name: Scalars['String']['input'];
  /** Device OS */
  device_os: Scalars['String']['input'];
  /** Device OS Version */
  device_os_version: Scalars['String']['input'];
  /** Device Type ios | android */
  device_type: Scalars['String']['input'];
  /** Device Push Token */
  push_token: Scalars['String']['input'];
  /** Device Push User ID */
  user_id: Scalars['String']['input'];
};

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item. */
export type Discount = {
  __typename?: 'Discount';
  /** The amount of the discount */
  amount: Money;
  /** A description of the discount */
  label: Scalars['String']['output'];
};

export type DiscountKicoins = {
  __typename?: 'DiscountKicoins';
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** Represents a single label-value pair, designed for easy display in a UI. */
export type DisplayInfoItem = {
  __typename?: 'DisplayInfoItem';
  /** The label or title for the piece of information (e.g., 'Ngày hết hạn') */
  label: Scalars['String']['output'];
  /** The value to be displayed (e.g., '20/12/2024') */
  value: Scalars['String']['output'];
};

export enum DisplayLocation {
  Cart = 'CART',
  Checkout = 'CHECKOUT',
  Wallet = 'WALLET'
}

export enum DisplayStatus {
  Active = 'ACTIVE',
  Hidden = 'HIDDEN',
  Scheduled = 'SCHEDULED'
}

export type District = {
  __typename?: 'District';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region_code: Scalars['String']['output'];
  region_id: Scalars['Int']['output'];
};

/** Downloadable Cart Item */
export type DownloadableCartItem = CartItemInterface & {
  __typename?: 'DownloadableCartItem';
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  /** An array containing information about the links for the added to cart downloadable product */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
  /** DownloadableProductSamples defines characteristics of a downloadable product */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
};

export enum DownloadableFileTypeEnum {
  /** @deprecated `sample_url` serves to get the downloadable sample */
  File = 'FILE',
  /** @deprecated `sample_url` serves to get the downloadable sample */
  Url = 'URL'
}

/** Downloadable Cart Item */
export type DownloadableLocalCartItem = LocalCartItemInterface & {
  __typename?: 'DownloadableLocalCartItem';
  cart_item_reference_id: Scalars['String']['output'];
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  /** An array containing information about the links for the added to cart downloadable product */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  local_id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
  /** DownloadableProductSamples defines characteristics of a downloadable product */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
};

/** DownloadableProduct defines a product that the customer downloads */
export type DownloadableProduct = CustomizableProductInterface & ProductInterface & {
  __typename?: 'DownloadableProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** An array containing information about the links for this downloadable product */
  downloadable_product_links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** An array containing information about samples of this downloadable product. */
  downloadable_product_samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  /** A value of 1 indicates that each link in the array must be purchased separately */
  links_purchased_separately?: Maybe<Scalars['Int']['output']>;
  /** The heading above the list of downloadable products */
  links_title?: Maybe<Scalars['String']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type DownloadableProductCartItemInput = {
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
  downloadable_product_links?: InputMaybe<Array<InputMaybe<DownloadableProductLinksInput>>>;
};

/** DownloadableProductLinks defines characteristics of a downloadable product */
export type DownloadableProductLinks = {
  __typename?: 'DownloadableProductLinks';
  /** @deprecated This information should not be exposed on frontend */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This information should not be exposed on frontend */
  is_shareable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type?: Maybe<DownloadableFileTypeEnum>;
  /** @deprecated This information should not be exposed on frontend */
  number_of_downloads?: Maybe<Scalars['Int']['output']>;
  /** The price of the downloadable product */
  price?: Maybe<Scalars['Float']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** URL to the downloadable sample */
  sample_url?: Maybe<Scalars['String']['output']>;
  /** A number indicating the sort order */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the link */
  title?: Maybe<Scalars['String']['output']>;
};

export type DownloadableProductLinksInput = {
  link_id: Scalars['Int']['input'];
};

/** DownloadableProductSamples defines characteristics of a downloadable product */
export type DownloadableProductSamples = {
  __typename?: 'DownloadableProductSamples';
  /** @deprecated This information should not be exposed on frontend */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** URL to the downloadable sample */
  sample_url?: Maybe<Scalars['String']['output']>;
  /** A number indicating the sort order */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the sample */
  title?: Maybe<Scalars['String']['output']>;
};

export type EnabledPaymentMethod = {
  __typename?: 'EnabledPaymentMethod';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** EntityUrl is an output object containing the `id`, `relative_url`, and `type` attributes */
export type EntityUrl = {
  __typename?: 'EntityUrl';
  /** @deprecated The canonical_url field is deprecated, use relative_url instead. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID. */
  id?: Maybe<Scalars['Int']['output']>;
  /** 301 or 302 HTTP code for url permanent or temporary redirect or 0 for the 200 no redirect */
  redirectCode?: Maybe<Scalars['Int']['output']>;
  /** The internal relative URL. If the specified  url is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The ID is encoded. */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ErpVoucherSyncInput = {
  campaign_code: Scalars['String']['input'];
  customer_contact_no?: InputMaybe<Scalars['String']['input']>;
  erp_created_by_receipt_no?: InputMaybe<Scalars['String']['input']>;
  erp_created_in_store_no?: InputMaybe<Scalars['String']['input']>;
  erp_replication_counter?: InputMaybe<Scalars['Int']['input']>;
  erp_reserved_by_pos_no?: InputMaybe<Scalars['String']['input']>;
  expires_at: Scalars['String']['input'];
  initial_amount: Scalars['Float']['input'];
  start_at: Scalars['String']['input'];
  voucher_code: Scalars['String']['input'];
};

/** Unique identifier for the activity */
export type EventActivity = {
  __typename?: 'EventActivity';
  /** Code of the activity */
  code: Scalars['String']['output'];
  /** Description of the activity */
  description?: Maybe<Scalars['String']['output']>;
  /** End time of the activity */
  end_time: Scalars['String']['output'];
  /** Unique identifier for the activity */
  id: Scalars['ID']['output'];
  /** Is the activity is open for register */
  is_open_for_register: Scalars['Boolean']['output'];
  /** Name of the activity */
  name: Scalars['String']['output'];
  /** Region ID of the activity */
  region_id: Scalars['Int']['output'];
  /** Position in activity group */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** Start time of the activity */
  start_time: Scalars['String']['output'];
};

export type EventActivityGroup = {
  __typename?: 'EventActivityGroup';
  activities?: Maybe<Array<Maybe<EventActivity>>>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order: Scalars['Int']['output'];
};

/** Unique identifier for the attribute */
export type EventAttribute = {
  __typename?: 'EventAttribute';
  /** Code of the attribute */
  code: Scalars['String']['output'];
  /** Unique identifier for the attribute */
  id: Scalars['ID']['output'];
  /** Name of the attribute */
  name: Scalars['String']['output'];
  /** Type of the attribute */
  type: Scalars['String']['output'];
};

export type EventDataInput = {
  /** device information */
  deviceRequest?: InputMaybe<DeviceRequestInput>;
  nonce: Scalars['String']['input'];
  sign: Scalars['String']['input'];
};

/** Unique identifier for the event */
export type EventEntity = {
  __typename?: 'EventEntity';
  /** Description of the event */
  description?: Maybe<Scalars['String']['output']>;
  /** End time of the event */
  end_time: Scalars['String']['output'];
  /** Unique identifier for the event */
  id: Scalars['ID']['output'];
  /** Name of the event */
  name: Scalars['String']['output'];
  /** Region ID of the event */
  region_id: Scalars['Int']['output'];
  /** Start time of the event */
  start_time: Scalars['String']['output'];
  /** total number of users of the event */
  users_count: Scalars['Int']['output'];
};

/** Unique identifier for the registration */
export type EventRegistration = {
  __typename?: 'EventRegistration';
  /** Activities associated with the registration */
  activity: EventActivity;
  /** Whether the user agreed to the terms */
  agreed_terms: Scalars['Boolean']['output'];
  /** Creation timestamp */
  created_at: Scalars['String']['output'];
  /** Event associated with the registration */
  event: EventEntity;
  /** Unique identifier for the registration */
  id: Scalars['ID']['output'];
  registration_details?: Maybe<Array<EventRegistrationDetails>>;
  /** Last update timestamp */
  updated_at: Scalars['String']['output'];
  /** User associated with the registration */
  user: EventUser;
};

/** Unique identifier for the registration details */
export type EventRegistrationDetails = {
  __typename?: 'EventRegistrationDetails';
  /** Path to the birth certificate image */
  birth_certificate_image?: Maybe<Scalars['String']['output']>;
  /** Birth date of the registrant */
  birth_date?: Maybe<Scalars['String']['output']>;
  /** District ID of the registrant */
  district_id: Scalars['Int']['output'];
  /** District name of the user */
  district_name: Scalars['String']['output'];
  /** Due date for the registration */
  due_date?: Maybe<Scalars['String']['output']>;
  /** Email address of the registrant */
  email: Scalars['String']['output'];
  /** Full name of the registrant */
  full_name: Scalars['String']['output'];
  /** Guardian's name */
  guardian_name?: Maybe<Scalars['String']['output']>;
  /** Guardian's phone number */
  guardian_phone_number?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the registration details */
  id: Scalars['ID']['output'];
  /** Phone number of the registrant */
  phone_number: Scalars['String']['output'];
  /** Path to the prenatal checkup image */
  prenatal_checkup_image?: Maybe<Scalars['String']['output']>;
  /** Region ID of the registrant */
  region_id: Scalars['Int']['output'];
  /** Region name of the user */
  region_name: Scalars['String']['output'];
  /** Registration associated with the details */
  registration: EventRegistration;
  /** Specific address of the registrant */
  specific_address: Scalars['String']['output'];
  /** Store code where the registrant will exchange the event ticket */
  ticket_exchange_store_code?: Maybe<Scalars['String']['output']>;
  /** Store name where the registrant will exchange the event ticket */
  ticket_exchange_store_name?: Maybe<Scalars['String']['output']>;
  /** Ward ID of the registrant */
  ward_id: Scalars['Int']['output'];
  /** Ward name of the user */
  ward_name: Scalars['String']['output'];
};

export enum EventTypeEnum {
  ActiveApp = 'ACTIVE_APP',
  Login = 'LOGIN',
  Register = 'REGISTER'
}

/** Unique identifier for the user */
export type EventUser = {
  __typename?: 'EventUser';
  /** Address of the user */
  address: Scalars['String']['output'];
  /** Birth date of the event user */
  birth_date?: Maybe<Scalars['String']['output']>;
  contacted_status?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  created_at: Scalars['String']['output'];
  /** District ID of the user */
  district_id: Scalars['Int']['output'];
  /** District name of the user */
  district_name: Scalars['String']['output'];
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** Full name of the user */
  full_name: Scalars['String']['output'];
  /** Unique identifier for the user */
  id?: Maybe<Scalars['ID']['output']>;
  /** Participant type of the user */
  participant_type: ParticipantType;
  /** Phone number of the user */
  phone_number: Scalars['String']['output'];
  /** Referral code of the user */
  referral_code?: Maybe<Scalars['String']['output']>;
  /** Region ID of the user */
  region_id: Scalars['Int']['output'];
  /** Region name of the user */
  region_name: Scalars['String']['output'];
  /** Signature */
  signature?: Maybe<Scalars['String']['output']>;
  /** Specific address of the user */
  specific_address: Scalars['String']['output'];
  /** Last update timestamp */
  updated_at: Scalars['String']['output'];
  /** Unique identifier for the temporary user (before registration - initial user) */
  user_temporary_id: Scalars['ID']['output'];
  /** Ward ID of the user */
  ward_id: Scalars['Int']['output'];
  /** Ward name of the user */
  ward_name: Scalars['String']['output'];
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  currency_to?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type ExecutePaymentInput = {
  /** MOMO payment specific input */
  momo?: InputMaybe<MomoExecutePaymentInput>;
  /** Order identifier */
  order_id: Scalars['ID']['input'];
  /** Payment provider */
  provider: PaymentProvider;
};

export type ExecutePaymentResult = {
  __typename?: 'ExecutePaymentResult';
  /** Payment amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Error information */
  error?: Maybe<Scalars['String']['output']>;
  /** Status message */
  message?: Maybe<Scalars['String']['output']>;
  /** Signature */
  signature?: Maybe<Scalars['String']['output']>;
  /** Payment status code (0 = success, <> 0 = failure) */
  status: Scalars['Int']['output'];
  /** Provider transaction ID */
  transaction_id?: Maybe<Scalars['String']['output']>;
};

export type FaqAnswer = {
  __typename?: 'FaqAnswer';
  admin_answered?: Maybe<Array<Maybe<AdminAnswered>>>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type FaqArticle = {
  __typename?: 'FaqArticle';
  /** created at timestamp for the article FAQ */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Description of the article FAQ */
  description?: Maybe<Scalars['String']['output']>;
  /** Article Id of the category FAQ */
  id?: Maybe<Scalars['Int']['output']>;
  /** URL Image of the article FAQ */
  image?: Maybe<Scalars['String']['output']>;
  /** Short description of the article FAQ */
  short_description?: Maybe<Scalars['String']['output']>;
  /** Title of the article FAQ */
  title?: Maybe<Scalars['String']['output']>;
};

export type FaqArticles = {
  __typename?: 'FaqArticles';
  /** List of article FAQ */
  data?: Maybe<Array<Maybe<FaqArticle>>>;
  /** Pagination information */
  pagination?: Maybe<PageInfo>;
};

export type FaqCategories = {
  __typename?: 'FaqCategories';
  /** List of category FAQ */
  faq_categories?: Maybe<Array<Maybe<FaqCategory>>>;
  /** Pagination information */
  pagination?: Maybe<PageInfo>;
};

export type FaqCategory = {
  __typename?: 'FaqCategory';
  articles?: Maybe<FaqArticles>;
  /** Category Id of the category FAQ */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** Icon of the category FAQ */
  icon?: Maybe<Scalars['String']['output']>;
  /** Name of the customer */
  questions?: Maybe<FaqCategoryQuestions>;
  /** Title of the category FAQ */
  title: Scalars['String']['output'];
  /** URL key of the category FAQ */
  url_key: Scalars['String']['output'];
};


export type FaqCategoryArticlesArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqCategoryQuestionsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqCategoryAnswer = {
  __typename?: 'FaqCategoryAnswer';
  /** Answer content of the category FAQ */
  content?: Maybe<Scalars['String']['output']>;
  /** Created at timestamp for the category FAQ */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Answer Id of the category FAQ */
  id?: Maybe<Scalars['String']['output']>;
  /** Interactive action of the category FAQ */
  interactive_action?: Maybe<Scalars['String']['output']>;
  /** Is Admin of the category FAQ */
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the customer */
  name?: Maybe<Scalars['String']['output']>;
  /** Total number of answers for the category FAQ */
  total_satisfied?: Maybe<Scalars['Int']['output']>;
  /** Total number of unsatisfied answers for the category FAQ */
  total_unsatisfied?: Maybe<Scalars['Int']['output']>;
};

export type FaqCategoryFilters = {
  /** URL key of the category FAQ */
  url_key?: InputMaybe<Scalars['String']['input']>;
};

export type FaqCategoryQuestion = {
  __typename?: 'FaqCategoryQuestion';
  /** Answer content of Question FAQ */
  answers?: Maybe<Array<Maybe<FaqCategoryAnswer>>>;
  /** Created at timestamp for the category FAQ */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Name of the customer */
  customer_name?: Maybe<Scalars['String']['output']>;
  /** Question Id of the category FAQ */
  question_id?: Maybe<Scalars['Int']['output']>;
  /** Title of the question category FAQ */
  title: Scalars['String']['output'];
  /** URL key of the Question FAQ */
  url_key: Scalars['String']['output'];
};

export type FaqCategoryQuestions = {
  __typename?: 'FaqCategoryQuestions';
  /** List of category FAQ */
  data?: Maybe<Array<Maybe<FaqCategoryQuestion>>>;
  /** Pagination information */
  pagination?: Maybe<PageInfo>;
};

export type FaqFilterInput = {
  /** Filter FAQs by brand_id. */
  brand?: InputMaybe<FilterEqualTypeInput>;
  /** Filter FAQs by category_id. */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter FAQs by sku. */
  sku?: InputMaybe<FilterEqualTypeInput>;
};

export type FaqItem = {
  __typename?: 'FaqItem';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url_key?: Maybe<Scalars['String']['output']>;
};

export type FaqListBySku = {
  __typename?: 'FaqListBySku';
  /** List of FAQ answers */
  data?: Maybe<Array<Maybe<FaqAnswer>>>;
  /** Pagination information */
  pagination?: Maybe<PageInfo>;
};

/** A product FAQ question. */
export type FaqQuestion = {
  __typename?: 'FaqQuestion';
  admin_answered?: Maybe<Array<Maybe<AdminAnswered>>>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is_purchased?: Maybe<Scalars['Boolean']['output']>;
  like_count?: Maybe<Scalars['Int']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  total_satisfied?: Maybe<Scalars['Int']['output']>;
};

export type FaqReaction = {
  __typename?: 'FaqReaction';
  entity_id?: Maybe<Scalars['Int']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
};

export type FaqSuggestionTag = {
  __typename?: 'FaqSuggestionTag';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

/** Fast cart totals without full price calculation */
export type FastCartTotals = {
  __typename?: 'FastCartTotals';
  /** The masked cart ID */
  cart_id?: Maybe<Scalars['String']['output']>;
  /** Applied coupon code */
  coupon_code?: Maybe<Scalars['String']['output']>;
  /** Currency code */
  currency_code?: Maybe<Scalars['String']['output']>;
  /** Total discount amount */
  discount_amount?: Maybe<Scalars['Float']['output']>;
  /** Cart grand total */
  grand_total?: Maybe<Scalars['Float']['output']>;
  /** Whether cart contains only virtual items */
  is_virtual?: Maybe<Scalars['Boolean']['output']>;
  /** Number of different items in cart */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** Total quantity of all items */
  items_qty?: Maybe<Scalars['Float']['output']>;
  /** Shipping amount */
  shipping_amount?: Maybe<Scalars['Float']['output']>;
  /** Cart subtotal */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** Subtotal after discount */
  subtotal_with_discount?: Maybe<Scalars['Float']['output']>;
  /** Total tax amount */
  tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type FavoriteBrandFilter = {
  /** The id of the brand. */
  brand_id?: InputMaybe<Scalars['Int']['input']>;
};

/** The featured image info. */
export type FeaturedImageData = {
  __typename?: 'FeaturedImageData';
  /** The link of featured image. */
  link?: Maybe<Scalars['String']['output']>;
  /** The URL of featured image. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** A string to filter on */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** An array of values to filter on */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** One or more words to filter on */
  match?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** The beginning of the range */
  from?: InputMaybe<Scalars['String']['input']>;
  /** The end of the range */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']['input']>;
};

/** FilterTypeInput specifies which action will be performed in a query  */
export type FilterTypeInput = {
  /** Equals */
  eq?: InputMaybe<Scalars['String']['input']>;
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** From. Must be used with 'to' */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** In. The value can contain a set of comma-separated values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** More than or equal to */
  moreq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Not in. The value can contain a set of comma-separated values */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not null */
  notnull?: InputMaybe<Scalars['String']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['String']['input']>;
  /** To. Must be used with 'from' */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  __typename?: 'FixedProductTax';
  /** Amount of the FPT as a money object. */
  amount?: Maybe<Money>;
  /** The label assigned to the FPT to be displayed on the frontend. */
  label?: Maybe<Scalars['String']['output']>;
};

/** This enumeration display settings for the fixed product tax */
export enum FixedProductTaxDisplaySetting {
  /**
   * The displayed price does not include the FPT amount. The values of ProductPrice.fixed_product_taxes and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price'
   * @deprecated
   */
  ExcludeFptAndIncludeWithDetails = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values from ProductPrice.fixed_product_taxes are not displayed. This value corresponds to 'Excluding FPT'
   * @deprecated
   */
  ExcludeFptWithoutDetails = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The FPT feature is not enabled. You can omit  ProductPrice.fixed_product_taxes from your query
   * @deprecated
   */
  FptDisabled = 'FPT_DISABLED',
  /**
   * The displayed price includes the FPT amount without displaying the ProductPrice.fixed_product_taxes values. This value corresponds to 'Including FPT only'
   * @deprecated
   */
  IncludeFptWithoutDetails = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The displayed price includes the FPT amount while displaying the values of ProductPrice.fixed_product_taxes separately. This value corresponds to 'Including FPT and FPT description'
   * @deprecated
   */
  IncludeFptWithDetails = 'INCLUDE_FPT_WITH_DETAILS'
}

/** This enumeration display settings for the fixed product tax */
export enum FixedProductTaxDisplaySettings {
  /**
   * The displayed price does not include the FPT amount. The values of ProductPrice.fixed_product_taxes and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price'
   * @deprecated
   */
  ExcludeFptAndIncludeWithDetails = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values from ProductPrice.fixed_product_taxes are not displayed. This value corresponds to 'Excluding FPT'
   * @deprecated
   */
  ExcludeFptWithoutDetails = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The FPT feature is not enabled. You can omit  ProductPrice.fixed_product_taxes from your query
   * @deprecated
   */
  FptDisabled = 'FPT_DISABLED',
  /**
   * The displayed price includes the FPT amount without displaying the ProductPrice.fixed_product_taxes values. This value corresponds to 'Including FPT only'
   * @deprecated
   */
  IncludeFptWithoutDetails = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The displayed price includes the FPT amount while displaying the values of ProductPrice.fixed_product_taxes separately. This value corresponds to 'Including FPT and FPT description'
   * @deprecated
   */
  IncludeFptWithDetails = 'INCLUDE_FPT_WITH_DETAILS'
}

/** Flash sale information */
export type FlashSale = {
  __typename?: 'FlashSale';
  /** The created at of the flash sale */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The date from of the flash sale */
  date_from?: Maybe<Scalars['String']['output']>;
  /** The date to of the flash sale */
  date_to?: Maybe<Scalars['String']['output']>;
  /** The deal qty of the flash sale */
  deal_qty?: Maybe<Scalars['Int']['output']>;
  /** The deal type of the flash sale */
  deal_type?: Maybe<Scalars['String']['output']>;
  /** The ID of the flash sale */
  flashsale_id?: Maybe<Scalars['Int']['output']>;
  /** The type of the flash sale */
  flashsale_type?: Maybe<Scalars['String']['output']>;
  /** The image of the flash sale */
  image?: Maybe<Scalars['String']['output']>;
  /** The is featured of the flash sale */
  is_featured?: Maybe<Scalars['Int']['output']>;
  /** The name of the flash sale */
  name?: Maybe<Scalars['String']['output']>;
  /** The out of stock of the flash sale */
  out_of_stock?: Maybe<Scalars['Int']['output']>;
  /** The sold out of the flash sale */
  sold_out?: Maybe<Scalars['Int']['output']>;
  /** The status of the flash sale */
  status?: Maybe<Scalars['Int']['output']>;
  /** The store ids of the flash sale */
  store_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** The updated at of the flash sale */
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** The flash sale products. */
export type FlashSaleItems = {
  __typename?: 'FlashSaleItems';
  /** Flash sale information of product */
  items?: Maybe<Array<Maybe<FlashSaleProduct>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of flash sale products returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Flash sale information of product */
export type FlashSaleProduct = {
  __typename?: 'FlashSaleProduct';
  /** The product information. */
  product?: Maybe<ProductInterface>;
  /** The flash sale information of a product */
  sales_data?: Maybe<FlashSaleProductData>;
};

/** The flash sale information of a product */
export type FlashSaleProductData = {
  __typename?: 'FlashSaleProductData';
  /** The created at of flash sale product. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The date from of the flash sale. */
  date_from?: Maybe<Scalars['String']['output']>;
  /** The date to of the flash sale. */
  date_to?: Maybe<Scalars['String']['output']>;
  /**
   * The deal id of product.
   * @deprecated Use the `id` field instead.
   */
  deal_id?: Maybe<Scalars['Int']['output']>;
  /** The deal price of product. */
  deal_price?: Maybe<Scalars['Float']['output']>;
  /** The deal qty of product. */
  deal_qty?: Maybe<Scalars['Int']['output']>;
  /** The deal value of product. */
  deal_value?: Maybe<Scalars['Int']['output']>;
  /** The ID of the flash sale. */
  flashsale_id?: Maybe<Scalars['Int']['output']>;
  /** The deal id of product */
  id?: Maybe<Scalars['Int']['output']>;
  /** The flash sale product limit for each order. */
  limit_per_order?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale price for product. */
  price?: Maybe<ProductPrice>;
  /** The ID of product. */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The name of product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sku of product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** The sale qty of product. */
  sale_qty?: Maybe<Scalars['Int']['output']>;
  /** The flash sale status of product. */
  status?: Maybe<Scalars['Int']['output']>;
  /** The store ids of the flash sale. */
  store_ids?: Maybe<Scalars['Int']['output']>;
  /** The updated at of flash sale product. */
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** The Products object is the top-level object returned in a product list. */
export type FlashSaleProducts = {
  __typename?: 'FlashSaleProducts';
  /** Flash sale information */
  flash_sale?: Maybe<FlashSale>;
  /** An array of products that match the specified query data */
  items?: Maybe<Array<Maybe<FlashSaleProduct>>>;
};

/** The Products object is the top-level object returned in a product list. */
export type FlashSaleProductsV2 = {
  __typename?: 'FlashSaleProductsV2';
  /** An array banners of flash sale. */
  banner_items?: Maybe<BannerItems>;
  /** Flash sale information */
  flash_sale?: Maybe<FlashSale>;
  /** An array of flash sale products. */
  flash_sale_items?: Maybe<FlashSaleItems>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
};


/** The Products object is the top-level object returned in a product list. */
export type FlashSaleProductsV2Flash_Sale_ItemsArgs = {
  current_page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
};

export type FlashSaleWidget = ContentFragmentDataInterface & {
  __typename?: 'FlashSaleWidget';
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export enum FollowerActionEnum {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type FooterConfig = {
  __typename?: 'FooterConfig';
  html_content: Scalars['String']['output'];
  image_url: Scalars['String']['output'];
};

export type FormAttributeValue = {
  __typename?: 'FormAttributeValue';
  attribute_code: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FormConfig = {
  __typename?: 'FormConfig';
  configs: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FormDataInput = {
  attribute_code: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FormSubmissionInput = {
  form_data: Array<FormDataInput>;
  form_id: Scalars['String']['input'];
};

export type FormValue = {
  __typename?: 'FormValue';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<FormAttributeValue>>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type FreeGiftCart = {
  __typename?: 'FreeGiftCart';
  /** An array of the free gifts in a cart. */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
};

/** The free gifts of the product. */
export type FreeGifts = {
  __typename?: 'FreeGifts';
  /** An array of free gifts that match the specified available rule. */
  items?: Maybe<Array<Maybe<FreeGiftsData>>>;
};

/** The free gifts of the product. */
export type FreeGiftsData = {
  __typename?: 'FreeGiftsData';
  /** An array of products that match the specified query data. */
  products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The rule is applied for the product. */
  rule?: Maybe<Rule>;
};

export type GeneratedOtpTokenResponse = {
  __typename?: 'GeneratedOtpTokenResponse';
  /** Secret to verify OTP */
  secret: Scalars['String']['output'];
};

export type GetCmsPageSchemaByIdentifierResponse = {
  __typename?: 'GetCmsPageSchemaByIdentifierResponse';
  content?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

export type GetCustomerAccountDeletionRequest = {
  filters?: InputMaybe<CustomerAccountDeletionFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<Array<SortOptions>>;
};

/** Input type to get user entity */
export type GetEventUserEntityInput = {
  /** Id of user */
  id: Scalars['String']['input'];
  /** signature */
  signature: Scalars['String']['input'];
};

export type GetFaqListBySkuResponse = {
  __typename?: 'GetFaqListBySkuResponse';
  current_page?: Maybe<Scalars['Int']['output']>;
  /** List of FAQ answers */
  data?: Maybe<Array<Maybe<FaqAnswer>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

/** Returns information about an gift item in cart. */
export type GiftCartItem = {
  __typename?: 'GiftCartItem';
  /** The gift cart item info. */
  gift_item?: Maybe<CartItemInterface>;
  /** The rule info. */
  rule?: Maybe<Rule>;
};

export type GiftError = {
  __typename?: 'GiftError';
  /** Error code */
  code: Scalars['String']['output'];
  /** Error message */
  message: Scalars['String']['output'];
  /** Gift SKU (if applicable) */
  sku?: Maybe<Scalars['String']['output']>;
};

export type GiftIndexedInfo = {
  __typename?: 'GiftIndexedInfo';
  /** The rule id. */
  id?: Maybe<Scalars['Int']['output']>;
  /** An array image urls of list gift. */
  image_urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The rule name. */
  rule_name?: Maybe<Scalars['String']['output']>;
};

export type GiftProduct = {
  __typename?: 'GiftProduct';
  /** Maximum quantity customer can select */
  max_qty: Scalars['Int']['output'];
  /** The information of the product. */
  product?: Maybe<ProductInterface>;
};

export type GiftRuleThreshold = {
  __typename?: 'GiftRuleThreshold';
  /** Rule description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether current subtotal meets threshold */
  is_unlocked: Scalars['Boolean']['output'];
  /** Max gifts selectable for this rule */
  max_selections?: Maybe<Scalars['Int']['output']>;
  /** 0-100 progress towards this threshold */
  progress_percentage: Scalars['Float']['output'];
  /** Amount remaining to unlock, 0 if already unlocked */
  remaining_amount: Scalars['Float']['output'];
  /** SalesRule ID */
  rule_id: Scalars['Int']['output'];
  /** Display label for customer */
  rule_label?: Maybe<Scalars['String']['output']>;
  /** Rule name */
  rule_name?: Maybe<Scalars['String']['output']>;
  /** Display order */
  sort_order: Scalars['Int']['output'];
  /** Minimum subtotal to unlock this milestone */
  threshold_amount: Scalars['Float']['output'];
};

export type GiftRuleThresholdsOutput = {
  __typename?: 'GiftRuleThresholdsOutput';
  /** Cart grand total passed in */
  current_subtotal: Scalars['Float']['output'];
  /** Sorted threshold milestones */
  items: Array<GiftRuleThreshold>;
  /** Next unlockable milestone, null if all unlocked */
  next_milestone?: Maybe<GiftRuleThreshold>;
};

/** GroupedProduct defines a grouped product */
export type GroupedProduct = PhysicalProductInterface & ProductInterface & {
  __typename?: 'GroupedProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  /** An array containing grouped product items */
  items?: Maybe<Array<Maybe<GroupedProductItem>>>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

/** GroupedProductItem contains information about an individual grouped product item */
export type GroupedProductItem = {
  __typename?: 'GroupedProductItem';
  /** The relative position of this item compared to the other group items */
  position?: Maybe<Scalars['Int']['output']>;
  /** The ProductInterface object, which contains details about this product option */
  product?: Maybe<ProductInterface>;
  /** The quantity of this grouped product item */
  qty?: Maybe<Scalars['Float']['output']>;
};

/** The highlight brand */
export type HighlightBrand = {
  __typename?: 'HighlightBrand';
  /** Achievement information of the Brand */
  achievement?: Maybe<Achievement>;
  /** The alt of the brand. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The banner image of the brand. */
  banner_image?: Maybe<Scalars['String']['output']>;
  /** The description of the brand. */
  description?: Maybe<Scalars['String']['output']>;
  /** The highlight products of the brand. */
  highlight_products?: Maybe<Products>;
  /** The id of the brand. It is option_id of brand attribute */
  id?: Maybe<Scalars['Int']['output']>;
  /** The image of the brand. */
  img?: Maybe<Scalars['String']['output']>;
  /** The name of the brand. */
  label?: Maybe<Scalars['String']['output']>;
  /** The like count of the brand. */
  like_count?: Maybe<Scalars['BigInt']['output']>;
  /** The description of the brand. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** The description of the brand. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The position of the brand. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The review count of the brand. */
  review_count?: Maybe<Scalars['Int']['output']>;
  /** The sold count of the brand. */
  sold_count?: Maybe<Scalars['BigInt']['output']>;
  /** The title description of the brand. */
  title_description?: Maybe<Scalars['String']['output']>;
  /** The url of the brand. */
  url?: Maybe<Scalars['String']['output']>;
  /** The list posts of the brand. */
  wp_posts?: Maybe<Posts>;
};


/** The highlight brand */
export type HighlightBrandHighlight_ProductsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** The highlight brand */
export type HighlightBrandWp_PostsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

/** The highlight brand items. */
export type HighlightBrands = {
  __typename?: 'HighlightBrands';
  /** Returns highlight brand layout for Category. */
  category_layout?: Maybe<BrandLayout>;
  /** Returns highlight brand layout for Homepage. */
  homepage_layout?: Maybe<BrandLayout>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** The highlight brand information. */
  items?: Maybe<Array<Maybe<HighlightBrand>>>;
};

/** The information of highlight categories. */
export type HighlightCategories = {
  __typename?: 'HighlightCategories';
  /** The highlight category information. */
  items?: Maybe<Array<Maybe<HighlightCategory>>>;
};

export type HighlightCategory = {
  __typename?: 'HighlightCategory';
  /** The background app icon of category. */
  background_app_icon?: Maybe<Scalars['String']['output']>;
  /** The featured app icon of category. */
  featured_app_icon?: Maybe<Scalars['String']['output']>;
  /** The featured icon of category. */
  featured_icon?: Maybe<Scalars['String']['output']>;
  /** The featured icon solid of category. */
  featured_icon_solid?: Maybe<Scalars['String']['output']>;
  /** The ID of category. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The priority of category. */
  priority?: Maybe<Scalars['String']['output']>;
  /** The url of category. */
  url?: Maybe<Scalars['String']['output']>;
};

export type HighlightProductBlocks = {
  __typename?: 'HighlightProductBlocks';
  /** The identifier */
  id?: Maybe<Scalars['String']['output']>;
  /** An array highlight product block. */
  items?: Maybe<Array<Maybe<ProductBlock>>>;
};

/** Item of Highlight Products */
export type HighlightProductItem = {
  __typename?: 'HighlightProductItem';
  /** Icon of product */
  icon?: Maybe<Scalars['String']['output']>;
  /** The id of item. This ID will be product ID. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Label of product */
  label?: Maybe<Scalars['String']['output']>;
  /** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
  product?: Maybe<ProductInterface>;
};

/** The Products object is the top-level object returned in a product list. */
export type HighlightProducts = {
  __typename?: 'HighlightProducts';
  /** An array of highlight products that match the specified query data */
  highlight_items?: Maybe<Array<Maybe<HighlightProductItem>>>;
  /** An array of products that match the specified query data */
  hot_new_items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
};

export type HomePageFloatBanner = {
  __typename?: 'HomePageFloatBanner';
  left_banner_img?: Maybe<Scalars['String']['output']>;
  left_banner_url?: Maybe<Scalars['String']['output']>;
  right_banner_img?: Maybe<Scalars['String']['output']>;
  right_banner_url?: Maybe<Scalars['String']['output']>;
};

/** The HomepageFeaturedBlock object is the top-level object returned in featured block. */
export type HomepageFeaturedBlock = {
  __typename?: 'HomepageFeaturedBlock';
  /** An array of banners for App. */
  app_banner_images?: Maybe<BannerItems>;
  /** An array of category. */
  category_items?: Maybe<Array<Maybe<CategoryTree>>>;
  /** The featured image of block. */
  featured_images?: Maybe<Array<Maybe<FeaturedImageData>>>;
  /** Highlight product attribute of block. */
  highlight_attribute?: Maybe<Aggregation>;
  /** The first highlight product. */
  highlight_item?: Maybe<HighlightProductItem>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** The layout to show featured image. */
  layout?: Maybe<Scalars['String']['output']>;
  /** The layout of products App on Homepage. */
  layout_product_app?: Maybe<LayoutData>;
  /** The number of products to show on Homepage block. */
  limit_product_block?: Maybe<Scalars['Int']['output']>;
  /** The limit of products on Homepage App. */
  limit_product_homepage_app?: Maybe<Scalars['Int']['output']>;
  /** The limit of products for each page. */
  limit_product_page?: Maybe<Scalars['Int']['output']>;
  /** An array of banners. */
  mobile_banner_images?: Maybe<Array<Maybe<Banner>>>;
  /** The name of featured block. */
  name?: Maybe<Scalars['String']['output']>;
  /** An array of products app. */
  product_app_items?: Maybe<Products>;
  /** An array attributes of block. */
  product_attributes?: Maybe<Array<Maybe<Aggregation>>>;
  /** An array of products that match the specified query data */
  product_items?: Maybe<Array<Maybe<ProductInterface>>>;
};


/** The HomepageFeaturedBlock object is the top-level object returned in featured block. */
export type HomepageFeaturedBlockProduct_App_ItemsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type HomepagePopularSearchKeywords = {
  __typename?: 'HomepagePopularSearchKeywords';
  items?: Maybe<Array<Maybe<Keywords>>>;
};

/** An array posts in homepage. */
export type HomepagePosts = {
  __typename?: 'HomepagePosts';
  /** Background color code */
  background_color?: Maybe<Scalars['String']['output']>;
  /** An array posts in homepage. */
  items?: Maybe<Array<Maybe<Post>>>;
  /** URL of banner */
  post_banner?: Maybe<Scalars['String']['output']>;
};

/** Homepage product blocks read directly from Elasticsearch. Single query returns all 3 tabs. */
export type HomepageProductsLightweight = {
  __typename?: 'HomepageProductsLightweight';
  /** Bestseller products sorted by qty_ordered DESC */
  bestseller_items?: Maybe<Array<Maybe<LightweightProductItem>>>;
  /** Highlight hot/new products */
  hot_new_items?: Maybe<Array<Maybe<LightweightProductItem>>>;
  /** New arrival products with date range filter */
  new_arrival_items?: Maybe<Array<Maybe<LightweightProductItem>>>;
};

/** Data return for html or not supported magento widgets */
export type HtmlWidget = ContentFragmentDataInterface & {
  __typename?: 'HtmlWidget';
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

/** The object details of target path parameters */
export type HttpQueryParameter = {
  __typename?: 'HttpQueryParameter';
  /** Parameter name */
  name?: Maybe<Scalars['String']['output']>;
  /** Parameter value */
  value?: Maybe<Scalars['String']['output']>;
};

export type IdentityAuthResult = {
  __typename?: 'IdentityAuthResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idpAccessToken?: Maybe<Scalars['String']['output']>;
  idpIdToken?: Maybe<Scalars['String']['output']>;
  idpRefreshToken?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** New challenge session returned on wrong OTP — client uses it for retry */
  session?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tokenType?: Maybe<Scalars['String']['output']>;
};

export type IdentityMagentoToken = {
  __typename?: 'IdentityMagentoToken';
  accessToken: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
};

export type IdentityOtpChallengeResponse = {
  __typename?: 'IdentityOtpChallengeResponse';
  challengeName?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type IdentityRefreshResult = {
  __typename?: 'IdentityRefreshResult';
  accessToken?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type IdentitySignUpResult = {
  __typename?: 'IdentitySignUpResult';
  cognitoSub?: Maybe<Scalars['String']['output']>;
  /** Commerce tokens returned after auto-login (enables 1-OTP registration without passwords) */
  commerceAccessToken?: Maybe<Scalars['String']['output']>;
  commerceExpiresIn?: Maybe<Scalars['Int']['output']>;
  commerceRefreshToken?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type IframeWidget = ContentFragmentDataInterface & {
  __typename?: 'IframeWidget';
  /** Classes of iframe tag */
  class_name?: Maybe<Scalars['String']['output']>;
  /** Height of iframe content */
  height?: Maybe<Scalars['String']['output']>;
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Url of iframe */
  iframe_url: Scalars['String']['output'];
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Title of iframe tag */
  title?: Maybe<Scalars['String']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ImageItem = {
  __typename?: 'ImageItem';
  /** Image alt */
  alt?: Maybe<Scalars['String']['output']>;
  /** Image height */
  height?: Maybe<Scalars['String']['output']>;
  /** Url when clicking on image */
  href?: Maybe<Scalars['String']['output']>;
  /** Html id */
  html_id?: Maybe<Scalars['String']['output']>;
  /** Url link for image */
  image_url: Scalars['String']['output'];
  /** Image width */
  width?: Maybe<Scalars['String']['output']>;
};

export type ImageSwatchData = SwatchDataInterface & {
  __typename?: 'ImageSwatchData';
  /** Thumbnail swatch image URL */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Value of swatch item (HEX color code, image link or textual value) */
  value?: Maybe<Scalars['String']['output']>;
};

/** Data return for image */
export type ImageWidget = ContentFragmentDataInterface & {
  __typename?: 'ImageWidget';
  /** Image alt */
  alt?: Maybe<Scalars['String']['output']>;
  /** Image height */
  height?: Maybe<Scalars['String']['output']>;
  /** Url when clicking on image */
  href?: Maybe<Scalars['String']['output']>;
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Html id */
  html_id?: Maybe<Scalars['String']['output']>;
  /** Url link for image */
  image_url: Scalars['String']['output'];
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
  /** Image width */
  width?: Maybe<Scalars['String']['output']>;
};

export type InitiateCheckoutContentInput = {
  product_id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type InitiateCheckoutEventInput = {
  checkout_info?: InputMaybe<CheckoutInfoInput>;
  user: UserDataInput;
};

export type InitiateCheckoutTrackingEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<InitiateCheckoutEventInput>;
};

export type InteractiveRequestData = {
  answer_id: Scalars['Int']['input'];
  interactive_type: Scalars['Int']['input'];
};

/** The Products object is the top-level object returned in a product list. */
export type InterestedProducts = {
  __typename?: 'InterestedProducts';
  /** An array of products that match the specified query data. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

/** Contains invoice details. */
export type Invoice = {
  __typename?: 'Invoice';
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID']['output'];
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars['String']['output'];
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>;
};

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: Money;
  /** The amount of tax applied to the invoice. */
  total_tax: Money;
};

export type IsEmailAvailableOutput = {
  __typename?: 'IsEmailAvailableOutput';
  /** Is email availabel value */
  is_email_available?: Maybe<Scalars['Boolean']['output']>;
};

export type IssuedCoupon = {
  __typename?: 'IssuedCoupon';
  /** Code issued for users */
  code?: Maybe<Scalars['String']['output']>;
  /** The time coupon is issued */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Coupon description */
  description?: Maybe<Scalars['String']['output']>;
  /** The discount amount of coupon */
  discount_amount?: Maybe<Scalars['Int']['output']>;
  /** The starting date for coupon's validity period */
  from_date?: Maybe<Scalars['DateTime']['output']>;
  /** Masked phone number of user */
  masked_phone_number?: Maybe<Scalars['String']['output']>;
  /** Coupon name */
  name?: Maybe<Scalars['String']['output']>;
  /** Phone number of user */
  phone_number?: Maybe<Scalars['String']['output']>;
  /** The end date for coupon's validity period */
  to_date?: Maybe<Scalars['DateTime']['output']>;
  /** The usage limit of coupon per customer */
  uses_per_customer?: Maybe<Scalars['Int']['output']>;
};

export type ItemStatus = {
  __typename?: 'ItemStatus';
  sku: Scalars['String']['output'];
  stock_status: StockStatus;
};

/** Contains a key-value pair. */
export type KeyValue = {
  __typename?: 'KeyValue';
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']['output']>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']['output']>;
};

export type Keywords = {
  __typename?: 'Keywords';
  tag_name?: Maybe<Scalars['String']['output']>;
  tag_url?: Maybe<Scalars['String']['output']>;
};

export type LayerFilter = {
  __typename?: 'LayerFilter';
  /**
   * Array of filter items.
   * @deprecated Use Aggregation.options instead.
   */
  filter_items?: Maybe<Array<Maybe<LayerFilterItemInterface>>>;
  /**
   * Count of filter items in filter group.
   * @deprecated Use Aggregation.count instead.
   */
  filter_items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Layered navigation filter name.
   * @deprecated Use Aggregation.label instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Request variable name for filter query.
   * @deprecated Use Aggregation.attribute_code instead.
   */
  request_var?: Maybe<Scalars['String']['output']>;
};

export type LayerFilterItemInterface = {
  /**
   * Count of items by filter.
   * @deprecated Use AggregationOption.count instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Filter label.
   * @deprecated Use AggregationOption.label instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * Value for filter request variable to be used in query.
   * @deprecated Use AggregationOption.value instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

export type Layout = {
  __typename?: 'Layout';
  entities?: Maybe<Scalars['String']['output']>;
  layout_handle?: Maybe<Scalars['String']['output']>;
  layout_id?: Maybe<Scalars['Int']['output']>;
  page_for?: Maybe<Scalars['String']['output']>;
  page_group?: Maybe<Scalars['String']['output']>;
};

export type LayoutData = {
  __typename?: 'LayoutData';
  /** The label of layout. */
  label?: Maybe<Scalars['String']['output']>;
  /** The value of layout. */
  value?: Maybe<Scalars['Int']['output']>;
};

export type LightweightPageInfo = {
  __typename?: 'LightweightPageInfo';
  current_page?: Maybe<Scalars['Int']['output']>;
  page_size?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type LightweightPrice = {
  __typename?: 'LightweightPrice';
  discount?: Maybe<ProductDiscount>;
  final_price?: Maybe<Money>;
  regular_price?: Maybe<Money>;
};

export type LightweightPriceRange = {
  __typename?: 'LightweightPriceRange';
  /** Maximum price — relevant for configurable/bundle products with price range */
  maximum_price?: Maybe<LightweightPrice>;
  minimum_price?: Maybe<LightweightPrice>;
};

/** Flat product item from ES — all fields pre-computed at index time. */
export type LightweightProductItem = {
  __typename?: 'LightweightProductItem';
  /** Brand attribute value */
  brand?: Maybe<Scalars['String']['output']>;
  /** Whether product has gift — derived from gifts[] array in ES */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Whether product is hot (1=yes, 0=no) */
  hot_product?: Maybe<Scalars['Int']['output']>;
  /** Product entity ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Product name */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether product is new (1=yes, 0=no) */
  new_product?: Maybe<Scalars['Int']['output']>;
  /** Price range data */
  price_range?: Maybe<LightweightPriceRange>;
  /** Comma-separated matching badge IDs */
  product_badge_ids?: Maybe<Scalars['String']['output']>;
  /** Number of ratings */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** Rating summary percentage 0-100 */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Product SKU */
  sku?: Maybe<Scalars['String']['output']>;
  /** Small image URL */
  small_image_url?: Maybe<Scalars['String']['output']>;
  /** Special price start date */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** Special price if set */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** Special price end date */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** IN_STOCK or OUT_OF_STOCK */
  stock_status?: Maybe<Scalars['String']['output']>;
  /** Thumbnail image URL */
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  /** Product type: simple, configurable, bundle, grouped, virtual, downloadable */
  type_id?: Maybe<Scalars['String']['output']>;
  /** URL key */
  url_key?: Maybe<Scalars['String']['output']>;
  /** URL suffix */
  url_suffix?: Maybe<Scalars['String']['output']>;
};

/** Ultra-fast product list read directly from Elasticsearch. No MySQL EAV joins, no per-product sub-resolvers. */
export type LightweightProductList = {
  __typename?: 'LightweightProductList';
  /** Array of product items from ES */
  items?: Maybe<Array<Maybe<LightweightProductItem>>>;
  /** Pagination info */
  page_info?: Maybe<LightweightPageInfo>;
  /** Total number of matching products */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type LocalCartItemInterface = {
  /** Cart Item Reference ID */
  cart_item_reference_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** The local ID for the cart item reference. */
  local_id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

export enum Location {
  Account = 'ACCOUNT',
  Authentication = 'AUTHENTICATION'
}

export enum LogicType {
  Campaign = 'CAMPAIGN',
  Freeship = 'FREESHIP',
  Other = 'OTHER',
  Promotion = 'PROMOTION'
}

export type LoginDevice = {
  /** Device App Version */
  device_app_version: Scalars['String']['input'];
  /** Device ID */
  device_id: Scalars['String']['input'];
  /** Device Name */
  device_name: Scalars['String']['input'];
  /** Device OS */
  device_os: Scalars['String']['input'];
  /** Device OS Version */
  device_os_version: Scalars['String']['input'];
  /** Device Type ios | android */
  device_type: Scalars['String']['input'];
  /** Device Push Token */
  push_token: Scalars['String']['input'];
  /** Device Push User ID */
  user_id: Scalars['String']['input'];
};

export type LoginEventInput = {
  user: UserDataInput;
};

/** Login Success Response */
export type LoginSuccessResponse = {
  __typename?: 'LoginSuccessResponse';
  /** Session Cookies */
  cookies: Scalars['String']['output'];
  /** Message */
  message: Scalars['String']['output'];
  /** Success */
  success: Scalars['Boolean']['output'];
  /** Session Token */
  token?: Maybe<Scalars['String']['output']>;
};

export type LoginTrackingEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<LoginEventInput>;
};

export type LogoData = {
  __typename?: 'LogoData';
  id?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type LogoutInternalEventInput = {
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutInternalEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<LogoutInternalEventInput>;
};

/** Input type to get look up user */
export type LookUpEventUserInput = {
  /** Captcha token */
  captcha_token?: InputMaybe<Scalars['String']['input']>;
  /** Event id */
  event_id: Scalars['String']['input'];
  /** Phone number of user */
  searchString: Scalars['String']['input'];
  /** Update secret */
  update_secret?: InputMaybe<Scalars['String']['input']>;
};

export type LookupCustomerResponse = {
  __typename?: 'LookupCustomerResponse';
  is_existed_phone: Scalars['Boolean']['output'];
};

export type MarketingAppliedCoupon = {
  __typename?: 'MarketingAppliedCoupon';
  code: Scalars['String']['output'];
  discount_label?: Maybe<Scalars['String']['output']>;
};

export enum MarketingCodeType {
  Coupon = 'COUPON',
  Voucher = 'VOUCHER'
}

export type MarketingRequestLog = {
  __typename?: 'MarketingRequestLog';
  action_type?: Maybe<Scalars['String']['output']>;
  client_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  operation_name?: Maybe<Scalars['String']['output']>;
  raw_payload?: Maybe<Scalars['String']['output']>;
  request_id: Scalars['String']['output'];
  status?: Maybe<MarketingRequestLogStatus>;
  updated_at: Scalars['DateTime']['output'];
};

export enum MarketingRequestLogStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type MarketingRequestLogsFilterInput = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['String']['input']>;
  created_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  operation_name?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MarketingRequestLogStatus>;
};

/** MediaGalleryEntry defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  __typename?: 'MediaGalleryEntry';
  /** Contains a ProductMediaGalleryEntriesContent object. */
  content?: Maybe<ProductMediaGalleryEntriesContent>;
  /** Whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']['output']>;
  /** The identifier assigned to the object. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The alt text displayed on the UI when the user points to the image. */
  label?: Maybe<Scalars['String']['output']>;
  /** image or video. */
  media_type?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Contains a ProductMediaGalleryEntriesVideoContent object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
};

export type MomoExecutePaymentInput = {
  /** Token return from MOMO app */
  app_data: Scalars['String']['input'];
  /** Customer number */
  customer_number: Scalars['String']['input'];
};

/** A Money object defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money';
  /** A three-letter currency code, such as USD or EUR */
  currency?: Maybe<CurrencyEnum>;
  /** A number expressing a monetary value */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Mutation type for modifying data */
export type Mutation = {
  __typename?: 'Mutation';
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>;
  /** Add cart-level gift selections */
  addCartLevelGiftsToCart?: Maybe<AddCartLevelGiftsOutput>;
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>;
  addCouponToMyList?: Maybe<StatusMessageResponse>;
  addDeviceToUser: Scalars['Boolean']['output'];
  addDownloadableProductsToCart?: Maybe<AddDownloadableProductsToCartOutput>;
  /** Auto add free gift to cart. */
  addGiftsToCart?: Maybe<AddGiftsToCartOutput>;
  addNewIp: Result;
  /** Adds product to the specified wish list. */
  addProductToWishlist?: Maybe<ProductToWishlistOutput>;
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>;
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>;
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>;
  /** Apply kicoins to cart */
  applyKicoins?: Maybe<ApplyKicoinsOutput>;
  applyUniversalCode?: Maybe<ApplyUniversalCodePayload>;
  /** Assign a logged-in customer to the specified guest shopping cart */
  assignCustomerToGuestCart: Cart;
  /** Assign a provider to a client. */
  assignProviderToClient: Result;
  cancelCustomerOrder?: Maybe<StatusMessageResponse>;
  /** Changes the password for the logged-in customer */
  changeCustomerPassword?: Maybe<Customer>;
  /** Configure credential for a SMS service provider. */
  configureSmsServiceProvider: Result;
  confirmRequestedValidationPhone: ConfirmRequestedValidationPhoneResponse;
  createAnswer?: Maybe<CreateAnswerResponse>;
  /** Creates Client Token for Braintree Javascript SDK initialization. */
  createBraintreeClientToken: Scalars['String']['output'];
  /** Create a new client to access the SMS service. */
  createClient: CreateClientCredentialResult;
  createClientQuota: Result;
  /** Create customer address */
  createCustomerAddress?: Maybe<CustomerAddress>;
  /** Creates an empty shopping cart for a guest or logged in user */
  createEmptyCart?: Maybe<Scalars['String']['output']>;
  /** Create empty cart for web via GraphQL */
  createEmptyWebCart?: Maybe<Cart>;
  /** Create a new event registration */
  createEventRegistration?: Maybe<Array<EventRegistration>>;
  createQuestion?: Maybe<CreateQuestionResponse>;
  deleteAllIps: Result;
  /** Delete customer address */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a customer payment token */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>;
  /** Delete a single keyword from history */
  deleteSearchKeyword: StatusMessageResponse;
  /** Exchange Identity Provider tokens for Magento token */
  exchangeIdentityToken: IdentityMagentoToken;
  /** Execute payment transaction */
  executePayment: ExecutePaymentResult;
  generateCustomerProfileSign?: Maybe<CustomerProfileSign>;
  /** Generate the customer token */
  generateCustomerToken?: Maybe<CustomerToken>;
  /** Generate referral code */
  generateReferralCode: ReferralCodeResponse;
  /** Register new user: Magento register (auto-creates Cognito) → DB mapping → auto-login */
  identitySignUp: IdentitySignUpResult;
  /** Initiate OTP challenge via Identity Provider (Cognito Custom Auth) — Login only */
  initiateIdentityOtpChallenge: IdentityOtpChallengeResponse;
  /** Initiate password reset by phone number */
  initiatePasswordResetByPhone: GeneratedOtpTokenResponse;
  /** "like or dislike a brand */
  likeBrand: CatalogStatusMessageResponse;
  /** Login customer by username and password */
  loginCustomerByUsernameAndPassword: CustomerToken;
  /** Login user by phone number and OTP */
  loginWithPhoneAndOtp: CustomerToken;
  /** Mark all notifications as read */
  markAllNotificationAsRead: Scalars['Boolean']['output'];
  /** Mark a specific notification as read by its ID */
  markNotificationAsRead: Scalars['Boolean']['output'];
  marketingApplyCode: ApplyCodeResponse;
  marketingApplyVoucherFromAllocation: ApplyVoucherResponse;
  marketingRemoveAppliedVoucher: ApplyVoucherResponse;
  marketingRemoveCode: RemoveCodeResponse;
  /** Merges the source cart into the destination cart */
  mergeCarts: Cart;
  placeOrder?: Maybe<PlaceOrderOutput>;
  pushAddToCartErrorInternalEvent?: Maybe<TrackEventResult>;
  pushAddToCartTrackingEvent?: Maybe<TrackEventResult>;
  pushApiErrorInternalEvent?: Maybe<TrackEventResult>;
  pushAuthErrorInternalEvent?: Maybe<TrackEventResult>;
  pushBeginAddToCartInternalEvent?: Maybe<TrackEventResult>;
  pushCompleteRegistrationTrackingEvent?: Maybe<TrackEventResult>;
  pushInitiateCheckoutTrackingEvent?: Maybe<TrackEventResult>;
  pushLoginTrackingEvent?: Maybe<TrackEventResult>;
  pushLogoutInternalEvent?: Maybe<TrackEventResult>;
  pushPurchaseTrackingEvent?: Maybe<TrackEventResult>;
  pushScrollDepthInternalEvent?: Maybe<TrackEventResult>;
  /** Recalculates cart totals and marks cart as clean */
  recalculateCartTotals?: Maybe<RecalculateCartTotalsOutput>;
  /** Refresh Identity Provider session */
  refreshIdentitySession: IdentityRefreshResult;
  /** Refresh customer token */
  refreshToken: CustomerToken;
  registerNewAccountByOtp: RegisterResponse;
  /** Register a user to an event */
  registerUserToEvent: EventUser;
  /** Remove cart-level gift */
  removeCartLevelGiftFromCart?: Maybe<RemoveCartLevelGiftOutput>;
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>;
  removeIp: Result;
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>;
  /** Remove kicoins from cart */
  removeKicoins?: Maybe<RemoveKicoinsOutput>;
  removeUniversalCode?: Maybe<RemoveUniversalCodeOutput>;
  /** Request customer account deletion */
  requestCustomerAccountDeletion: StatusMessageResponse;
  requestValidatePhone: RequestValidatePhoneResponse;
  /** Reset password by OTP token */
  resetPasswordByOtp: ResetPasswordResponse;
  /** Revoke the customer token */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>;
  saveFaqAnswer?: Maybe<Scalars['Boolean']['output']>;
  saveFaqInteractive?: Maybe<Scalars['Boolean']['output']>;
  saveFaqQuestion?: Maybe<Scalars['Boolean']['output']>;
  saveFaqReaction?: Maybe<Scalars['Boolean']['output']>;
  /** Like/dislike action for a review */
  saveReviewReaction?: Maybe<ReviewReactionResponse>;
  sendOrderReview?: Maybe<StatusMessageResponse>;
  /** Send review request */
  sendReview?: Maybe<Review>;
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>;
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>;
  /** @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request. */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>;
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>;
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>;
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>;
  submitForm?: Maybe<FormValue>;
  /** Synchronize cart with client-driven state */
  synchronizeCart?: Maybe<SynchronizeCartPayload>;
  /** Api for saving active app event for non-logged in user */
  trackEvent?: Maybe<TrackEventResult>;
  /** Api for saving active app event for logged in user */
  trackEventSession?: Maybe<TrackEventResult>;
  updateCartItems?: Maybe<UpdateCartItemsOutput>;
  /** Update the customer's personal information */
  updateCustomer?: Maybe<CustomerOutput>;
  /** Update customer account deletion request status */
  updateCustomerAccountDeletionStatus: CustomerAccountDeletionResponse;
  /** Update customer address */
  updateCustomerAddress?: Maybe<CustomerAddress>;
  updateCustomerProfile?: Maybe<StatusMessageResponse>;
  updateQuotaAmount: Result;
  /** Returns an array coupon codes. */
  validateCoupons?: Maybe<Array<Maybe<SalesRule>>>;
  /** Validate password reset token */
  validateResetPasswordToken: ResetPasswordResponse;
  /** Verify OTP challenge and obtain Identity Provider tokens */
  verifyIdentityOtpChallenge: IdentityAuthResult;
};


/** Mutation type for modifying data */
export type MutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddCartLevelGiftsToCartArgs = {
  input: AddCartLevelGiftsInput;
};


/** Mutation type for modifying data */
export type MutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddCouponToMyListArgs = {
  coupon_code: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationAddDeviceToUserArgs = {
  push_id: Scalars['String']['input'];
  push_token: Scalars['String']['input'];
  type_device: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationAddDownloadableProductsToCartArgs = {
  input?: InputMaybe<AddDownloadableProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddGiftsToCartArgs = {
  input?: InputMaybe<AddGiftsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddNewIpArgs = {
  ip: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationAddProductToWishlistArgs = {
  input?: InputMaybe<AddProductToWishlistInput>;
};


/** Mutation type for modifying data */
export type MutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationApplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>;
};


/** Mutation type for modifying data */
export type MutationApplyKicoinsArgs = {
  input?: InputMaybe<ApplyKicoinsInput>;
};


/** Mutation type for modifying data */
export type MutationApplyUniversalCodeArgs = {
  input?: InputMaybe<ApplyUniversalCodeInput>;
};


/** Mutation type for modifying data */
export type MutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationAssignProviderToClientArgs = {
  clientId: Scalars['String']['input'];
  credentialProviderId: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationCancelCustomerOrderArgs = {
  input: CancelOrderInput;
};


/** Mutation type for modifying data */
export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationConfigureSmsServiceProviderArgs = {
  provider: ProviderEnum;
  providerId: Scalars['String']['input'];
  providerSecret: Scalars['String']['input'];
  serviceProviderName: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationConfirmRequestedValidationPhoneArgs = {
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationCreateAnswerArgs = {
  input?: InputMaybe<CreateAnswerRequest>;
};


/** Mutation type for modifying data */
export type MutationCreateClientArgs = {
  clientName: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationCreateClientQuotaArgs = {
  clientId: Scalars['String']['input'];
  quotaAmount: Scalars['Int']['input'];
  quotaLevel: QuotaLevelEnum;
};


/** Mutation type for modifying data */
export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput;
};


/** Mutation type for modifying data */
export type MutationCreateEmptyCartArgs = {
  input?: InputMaybe<CreateEmptyCartInput>;
};


/** Mutation type for modifying data */
export type MutationCreateEventRegistrationArgs = {
  input?: InputMaybe<Array<CreateEventRegistrationInput>>;
};


/** Mutation type for modifying data */
export type MutationCreateQuestionArgs = {
  input?: InputMaybe<CreateQuestionRequest>;
};


/** Mutation type for modifying data */
export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation type for modifying data */
export type MutationDeletePaymentTokenArgs = {
  public_hash: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationDeleteSearchKeywordArgs = {
  query: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationExchangeIdentityTokenArgs = {
  idpAccessToken: Scalars['String']['input'];
  idpIdToken: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationExecutePaymentArgs = {
  input: ExecutePaymentInput;
};


/** Mutation type for modifying data */
export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationIdentitySignUpArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation type for modifying data */
export type MutationInitiateIdentityOtpChallengeArgs = {
  notificationChannel?: InputMaybe<NotificationChannel>;
  phoneNumber: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationInitiatePasswordResetByPhoneArgs = {
  phone_number: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationLikeBrandArgs = {
  action: FollowerActionEnum;
  brand_id: Scalars['Int']['input'];
};


/** Mutation type for modifying data */
export type MutationLoginCustomerByUsernameAndPasswordArgs = {
  device?: InputMaybe<LoginDevice>;
  password: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  sign?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation type for modifying data */
export type MutationLoginWithPhoneAndOtpArgs = {
  device: LoginDevice;
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  sign: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationMarkNotificationAsReadArgs = {
  notification_id: Scalars['Int']['input'];
};


/** Mutation type for modifying data */
export type MutationMarketingApplyCodeArgs = {
  cart_id: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationMarketingApplyVoucherFromAllocationArgs = {
  allocation_id: Scalars['String']['input'];
  cart_id: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationMarketingRemoveAppliedVoucherArgs = {
  cart_id: Scalars['String']['input'];
  voucher_id: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationMarketingRemoveCodeArgs = {
  cart_id: Scalars['String']['input'];
  code_id: Scalars['String']['input'];
  type: MarketingCodeType;
};


/** Mutation type for modifying data */
export type MutationMergeCartsArgs = {
  destination_cart_id: Scalars['String']['input'];
  source_cart_id: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationPlaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>;
};


/** Mutation type for modifying data */
export type MutationPushAddToCartErrorInternalEventArgs = {
  input?: InputMaybe<AddToCartErrorInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushAddToCartTrackingEventArgs = {
  input?: InputMaybe<AddToCartTrackingEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushApiErrorInternalEventArgs = {
  input?: InputMaybe<ApiErrorInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushAuthErrorInternalEventArgs = {
  input?: InputMaybe<AuthErrorInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushBeginAddToCartInternalEventArgs = {
  input?: InputMaybe<BeginAddToCartInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushCompleteRegistrationTrackingEventArgs = {
  input?: InputMaybe<CompleteRegistrationTrackingEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushInitiateCheckoutTrackingEventArgs = {
  input?: InputMaybe<InitiateCheckoutTrackingEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushLoginTrackingEventArgs = {
  input?: InputMaybe<LoginTrackingEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushLogoutInternalEventArgs = {
  input?: InputMaybe<LogoutInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushPurchaseTrackingEventArgs = {
  input?: InputMaybe<PurchaseTrackingEventInput>;
};


/** Mutation type for modifying data */
export type MutationPushScrollDepthInternalEventArgs = {
  input?: InputMaybe<ScrollDepthInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationRecalculateCartTotalsArgs = {
  input: RecalculateCartTotalsInput;
};


/** Mutation type for modifying data */
export type MutationRefreshIdentitySessionArgs = {
  refreshToken: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationRefreshTokenArgs = {
  refresh_token: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationRegisterNewAccountByOtpArgs = {
  accountInfo: RegisterAccountInfo;
  deviceRequest?: InputMaybe<LoginDevice>;
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  referralCode?: InputMaybe<CustomerReferralCodeInput>;
  secret: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationRegisterUserToEventArgs = {
  input: CreateEventUserInput;
};


/** Mutation type for modifying data */
export type MutationRemoveCartLevelGiftFromCartArgs = {
  input: RemoveCartLevelGiftInput;
};


/** Mutation type for modifying data */
export type MutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>;
};


/** Mutation type for modifying data */
export type MutationRemoveIpArgs = {
  ip: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationRemoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>;
};


/** Mutation type for modifying data */
export type MutationRemoveKicoinsArgs = {
  input?: InputMaybe<RemoveKicoinsInput>;
};


/** Mutation type for modifying data */
export type MutationRemoveUniversalCodeArgs = {
  input?: InputMaybe<RemoveUniversalCodeInput>;
};


/** Mutation type for modifying data */
export type MutationRequestValidatePhoneArgs = {
  captchaResponseToken?: InputMaybe<Scalars['String']['input']>;
  notificationChannel: NotificationChannel;
  phone_number: Scalars['String']['input'];
  sign?: InputMaybe<Scalars['String']['input']>;
  validateType: ValidatePhoneType;
};


/** Mutation type for modifying data */
export type MutationResetPasswordByOtpArgs = {
  new_password: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationSaveFaqAnswerArgs = {
  answerRequest?: InputMaybe<AnswerRequest>;
};


/** Mutation type for modifying data */
export type MutationSaveFaqInteractiveArgs = {
  interactiveRequestData?: InputMaybe<InteractiveRequestData>;
};


/** Mutation type for modifying data */
export type MutationSaveFaqQuestionArgs = {
  questionRequest?: InputMaybe<QuestionRequest>;
};


/** Mutation type for modifying data */
export type MutationSaveFaqReactionArgs = {
  entity_id: Scalars['Int']['input'];
  entity_type: Scalars['String']['input'];
  reaction_type: Scalars['Int']['input'];
};


/** Mutation type for modifying data */
export type MutationSaveReviewReactionArgs = {
  input: ReviewReactionRequest;
};


/** Mutation type for modifying data */
export type MutationSendOrderReviewArgs = {
  captchaResponseToken: Scalars['String']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  order: OrderReviewInformation;
  reviewRequest: CreateReviewRequest;
  videos?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};


/** Mutation type for modifying data */
export type MutationSendReviewArgs = {
  captchaResponseToken: Scalars['String']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  reviewRequest: CreateReviewRequest;
  video?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};


/** Mutation type for modifying data */
export type MutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>;
};


/** Mutation type for modifying data */
export type MutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSubmitFormArgs = {
  input: FormSubmissionInput;
};


/** Mutation type for modifying data */
export type MutationSynchronizeCartArgs = {
  input: SynchronizeCartInput;
};


/** Mutation type for modifying data */
export type MutationTrackEventArgs = {
  event?: InputMaybe<TrackEventInput>;
};


/** Mutation type for modifying data */
export type MutationTrackEventSessionArgs = {
  event?: InputMaybe<TrackEventInput>;
};


/** Mutation type for modifying data */
export type MutationUpdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>;
};


/** Mutation type for modifying data */
export type MutationUpdateCustomerArgs = {
  input: CustomerInput;
};


/** Mutation type for modifying data */
export type MutationUpdateCustomerAccountDeletionStatusArgs = {
  id: Scalars['String']['input'];
  input: UpdateCustomerAccountDeletionStatusInput;
};


/** Mutation type for modifying data */
export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<CustomerAddressInput>;
};


/** Mutation type for modifying data */
export type MutationUpdateCustomerProfileArgs = {
  input: CustomerProfileInput;
};


/** Mutation type for modifying data */
export type MutationUpdateQuotaAmountArgs = {
  clientId: Scalars['String']['input'];
  quotaAmount: Scalars['Int']['input'];
  quotaLevel: QuotaLevelEnum;
};


/** Mutation type for modifying data */
export type MutationValidateCouponsArgs = {
  input?: InputMaybe<ValidateCouponsInput>;
};


/** Mutation type for modifying data */
export type MutationValidateResetPasswordTokenArgs = {
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationVerifyIdentityOtpChallengeArgs = {
  otp: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export type MyFavoriteBrands = {
  __typename?: 'MyFavoriteBrands';
  /** The list of brands. */
  brands?: Maybe<Array<Maybe<HighlightBrand>>>;
  /** The pagination information for the brands. */
  pagination?: Maybe<PageInfo>;
};

export type MyOrderReviewFilter = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MyOrderReviews = {
  __typename?: 'MyOrderReviews';
  page_info?: Maybe<PageInfo>;
  reviews?: Maybe<Array<Maybe<Review>>>;
};

export type MyQuestion = {
  __typename?: 'MyQuestion';
  answers?: Maybe<Array<Maybe<AdminAnswered>>>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type MyQuestions = {
  __typename?: 'MyQuestions';
  data?: Maybe<Array<Maybe<MyQuestion>>>;
  pagination?: Maybe<PageInfo>;
};

/** The Products object is the top-level object returned in a product list. */
export type NewArrivalProducts = {
  __typename?: 'NewArrivalProducts';
  /** An array of products that match the specified query data. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Limit product at Homepage for only App. */
  limit_product_for_app?: Maybe<Scalars['Int']['output']>;
  /** Limit product at Homepage for only Web. */
  limit_product_for_web?: Maybe<Scalars['Int']['output']>;
};

export enum NotificationChannel {
  /** Send OTP via SMS */
  Sms = 'SMS',
  /** Send OTP via ZALO */
  Zalo = 'ZALO'
}

export type NotificationCustomer = {
  __typename?: 'NotificationCustomer';
  messages?: Maybe<Array<Maybe<NotificationMessage>>>;
  paginationMetadata?: Maybe<NotificationPagination>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a generic notification item. */
export type NotificationData = {
  __typename?: 'NotificationData';
  /** The main content or message of the notification */
  content: Scalars['String']['output'];
  /** Timestamp when the notification was created */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Provides a list of label-value pairs for display in the UI.
   * e.g., [{label: "Ngày hết hạn", value: "20/12/2024"}]
   */
  displayInfo?: Maybe<Array<DisplayInfoItem>>;
  /** Unique identifier for the notification */
  id: Scalars['ID']['output'];
  /** Optional image URL for the notification */
  image?: Maybe<Scalars['String']['output']>;
  /** The data payload of the notification. It will be one of the types that implements the NotificationPayload interface. */
  payload?: Maybe<NotificationPayload>;
  /** Indicates whether the user has read the notification */
  read: Scalars['Boolean']['output'];
  route?: Maybe<Scalars['String']['output']>;
  /** The title of the notification */
  title: Scalars['String']['output'];
};

export type NotificationHistoryFilterInput = {
  type: Scalars['String']['input'];
};

export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  read?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  typeNotification?: Maybe<Scalars['String']['output']>;
};

/** Payload for notifications related to user orders. */
export type NotificationOrderData = NotificationPayload & {
  __typename?: 'NotificationOrderData';
  currentStatus?: Maybe<Scalars['String']['output']>;
  /** Implements NotificationPayload. The ID of the order. */
  entityId: Scalars['ID']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type NotificationPagination = {
  __typename?: 'NotificationPagination';
  currentPage?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/**
 * Defines a contract for all notification payloads.
 * Any type that implements this interface MUST have an `entityId`.
 * This allows clients to query the common `entityId` field without knowing the specific payload type.
 */
export type NotificationPayload = {
  /** The unique identifier of the core entity related to this payload (e.g., an order ID, a promotion ID). */
  entityId: Scalars['ID']['output'];
};

/** Payload for notifications related to promotions or marketing. */
export type NotificationPromotionData = NotificationPayload & {
  __typename?: 'NotificationPromotionData';
  discountCode?: Maybe<Scalars['String']['output']>;
  /** Implements NotificationPayload. The ID of the promotion. */
  entityId: Scalars['ID']['output'];
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type Notifications = {
  __typename?: 'Notifications';
  data?: Maybe<NotificationsData>;
  pagination?: Maybe<PageInfo>;
};

export type NotificationsData = {
  __typename?: 'NotificationsData';
  notification?: Maybe<Array<Maybe<NotificationData>>>;
  total_unread?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  /** @deprecated The order_id field is deprecated, use order_number instead. */
  order_id?: Maybe<Scalars['String']['output']>;
  order_number: Scalars['String']['output'];
};

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  __typename?: 'OrderAddress';
  /** The city or town. */
  city: Scalars['String']['output'];
  /** The customer's company. */
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /** The district name. */
  district?: Maybe<Scalars['String']['output']>;
  /** The district id. */
  district_id?: Maybe<Scalars['ID']['output']>;
  /** The fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String']['output'];
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String']['output'];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The state or province name. */
  region?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars['ID']['output']>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']['output']>;
  /** The ward name. */
  ward?: Maybe<Scalars['String']['output']>;
  /** The ward id. */
  ward_id?: Maybe<Scalars['ID']['output']>;
};

/** Basic order information */
export type OrderBasicInfo = {
  __typename?: 'OrderBasicInfo';
  /** The created at of the order. */
  created_at: Scalars['String']['output'];
  /** The grand total of the order. */
  grand_total: Scalars['Float']['output'];
  /** The increment id of the order. */
  increment_id: Scalars['String']['output'];
  /** The status of the order. */
  status: Scalars['String']['output'];
};

export type OrderItem = OrderItemInterface & {
  __typename?: 'OrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The image URL of the base product. */
  product_image?: Maybe<Scalars['String']['output']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** A Money object defines a monetary value, including a numeric value and a currency code. */
  product_original_price: Money;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** Detect if this item has a review yet */
  reviewed: Scalars['Boolean']['output'];
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Order item details. */
export type OrderItemInterface = {
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The image URL of the base product. */
  product_image?: Maybe<Scalars['String']['output']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** A Money object defines a monetary value, including a numeric value and a currency code. */
  product_original_price: Money;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  __typename?: 'OrderItemOption';
  /** The name of the option. */
  label: Scalars['String']['output'];
  /** The value of the option. */
  value: Scalars['String']['output'];
};

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod';
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<KeyValue>>>;
  /** The label that describes the payment method. */
  name: Scalars['String']['output'];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String']['output'];
};

export type OrderReviewInformation = {
  /** Order number */
  order_number: Scalars['String']['input'];
  /** SKU */
  sku: Scalars['String']['input'];
};

/** Contains order shipment details. */
export type OrderShipment = {
  __typename?: 'OrderShipment';
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID']['output'];
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars['String']['output'];
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>;
};

/** Represents an available status the order can transition to. */
export type OrderStatus = {
  __typename?: 'OrderStatus';
  label: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/** Status history and possible next statuses of an order. */
export type OrderStatusHistory = {
  __typename?: 'OrderStatusHistory';
  available_statuses: AvailableOrderHistoryStatuses;
  history: Array<OrderStatusHistoryItem>;
};

/** Describes an item in the order's status history timeline. */
export type OrderStatusHistoryItem = {
  __typename?: 'OrderStatusHistoryItem';
  created_at: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Gift item detail from order sync */
export type OrderSyncGiftDetail = {
  __typename?: 'OrderSyncGiftDetail';
  /** Gift product image URL */
  gift_image?: Maybe<Scalars['String']['output']>;
  /** Gift product name */
  gift_name: Scalars['String']['output'];
  /** Full gift product details */
  gift_product?: Maybe<ProductInterface>;
  /** Gift quantity */
  gift_qty: Scalars['Int']['output'];
  /** Gift SKU */
  gift_sku: Scalars['String']['output'];
  /** Customer-facing label for the rule */
  rule_label?: Maybe<Scalars['String']['output']>;
  /** Promotion rule name */
  rule_name?: Maybe<Scalars['String']['output']>;
  /** Name of the product that triggered this gift */
  source_product_name?: Maybe<Scalars['String']['output']>;
  /** SKU of the product that triggered this gift (for product-level) */
  source_product_sku?: Maybe<Scalars['String']['output']>;
  /** product-level or cart-level */
  source_type: Scalars['String']['output'];
  /** Whether the gift was actually in the order */
  was_applied: Scalars['Boolean']['output'];
};

/** Price information at time of order */
export type OrderSyncItemPrice = {
  __typename?: 'OrderSyncItemPrice';
  /** Discount percentage, e.g. 50 for -50% */
  discount_percent?: Maybe<Scalars['Float']['output']>;
  /** Final sale price */
  final_price: Money;
  /** Original regular price */
  original_price: Money;
  /** Row total (final_price x quantity) */
  row_total: Money;
};

/** Order item with full product data, mirroring CartItemReference */
export type OrderSyncItemReference = {
  __typename?: 'OrderSyncItemReference';
  /** Configurable options selected by customer */
  configurable_options?: Maybe<Array<Maybe<OrderSyncSelectedOption>>>;
  /** Selected variant product for configurable (child simple product) */
  configured_variant?: Maybe<ProductInterface>;
  /** Was selected for checkout */
  is_selected: Scalars['Boolean']['output'];
  /** Promotion logics with actions and gift product details */
  logics?: Maybe<Array<OrderSyncItemReferenceLogic>>;
  /** Magento Order Item ID */
  order_item_id?: Maybe<Scalars['Int']['output']>;
  /** Order Item Reference ID */
  order_item_reference_id: Scalars['String']['output'];
  /** Price information at time of order */
  order_price: OrderSyncItemPrice;
  /** Parent configurable product with options and variants */
  parent_product?: Maybe<ProductInterface>;
  /** Parent SKU for configurable products */
  parent_sku?: Maybe<Scalars['String']['output']>;
  /** Product details (parent for configurable, product for simple) */
  product?: Maybe<ProductInterface>;
  /** Quantity ordered */
  quantity: Scalars['Int']['output'];
  /** Product SKU (variant SKU for configurable) */
  sku: Scalars['String']['output'];
};

/** Action from an order sync promotion logic */
export type OrderSyncItemReferenceAction = {
  __typename?: 'OrderSyncItemReferenceAction';
  /** Full gift product details with image, name, price */
  action_product?: Maybe<ProductInterface>;
  /** Gift quantity */
  action_qty?: Maybe<Scalars['Int']['output']>;
  /** free_gift, discount, free_ship, etc. */
  action_type: Scalars['String']['output'];
  /** Discount/point value */
  action_value?: Maybe<Scalars['Float']['output']>;
  /** Whether the gift was actually applied to the order */
  was_applied: Scalars['Boolean']['output'];
};

/** Promotion logic applied to an order sync item */
export type OrderSyncItemReferenceLogic = {
  __typename?: 'OrderSyncItemReferenceLogic';
  /** Actions from this logic */
  actions?: Maybe<Array<OrderSyncItemReferenceAction>>;
  /** Quantity allocated to this rule */
  allocated_qty: Scalars['Int']['output'];
  /** Rule ID */
  logic_id: Scalars['Int']['output'];
  /** Rule display name */
  logic_name?: Maybe<Scalars['String']['output']>;
  /** promotion, freeship, campaign, other */
  logic_type: Scalars['String']['output'];
};

/** Order sync references output with full product data for My Order page */
export type OrderSyncReferencesOutput = {
  __typename?: 'OrderSyncReferencesOutput';
  /** All gift items grouped by source */
  gifts: Array<OrderSyncGiftDetail>;
  /** Order items with full product and promotion data */
  items: Array<OrderSyncItemReference>;
  /** Basic order information */
  order_info: OrderBasicInfo;
};

/** Configurable option selected at time of order */
export type OrderSyncSelectedOption = {
  __typename?: 'OrderSyncSelectedOption';
  /** Option label, e.g. 'Size' */
  option_label: Scalars['String']['output'];
  /** Selected value label, e.g. 'XXXL' */
  value_label: Scalars['String']['output'];
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  __typename?: 'OrderTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the order, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the order. */
  total_shipping: Money;
  /** The amount of tax applied to the order. */
  total_tax: Money;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The current page of brands. */
  current_page?: Maybe<Scalars['Int']['output']>;
  /** The page size of brands. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** The total number of items. */
  total_count?: Maybe<Scalars['Int']['output']>;
  /** The total number of pages. */
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PaginationData = {
  __typename?: 'PaginationData';
  current_page?: Maybe<Scalars['Int']['output']>;
  items_count?: Maybe<Scalars['Int']['output']>;
  items_per_page?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

/** Enum for participant types */
export enum ParticipantType {
  Fandom = 'FANDOM',
  NursingFather = 'NURSING_FATHER',
  NursingMother = 'NURSING_MOTHER',
  Other = 'OTHER',
  PregnantFather = 'PREGNANT_FATHER',
  PregnantMother = 'PREGNANT_MOTHER'
}

export type PaymentInformation = {
  __typename?: 'PaymentInformation';
  payment_url: Scalars['String']['output'];
};

export type PaymentMethodInput = {
  braintree?: InputMaybe<BraintreeInput>;
  braintree_cc_vault?: InputMaybe<BraintreeCcVaultInput>;
  /** Payment method code */
  code: Scalars['String']['input'];
  /** Purchase order number */
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodSettings = {
  __typename?: 'PaymentMethodSettings';
  payment_method_configs?: Maybe<Array<Maybe<EnabledPaymentMethod>>>;
};

export type PaymentOrderInformation = {
  __typename?: 'PaymentOrderInformation';
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
  /** Order payment token */
  token?: Maybe<Scalars['String']['output']>;
  /** Order payment Link */
  url?: Maybe<Scalars['String']['output']>;
};

export type PaymentOrderLinkResponse = {
  __typename?: 'PaymentOrderLinkResponse';
  /** Error Code */
  app_link?: Maybe<Scalars['String']['output']>;
  /** Checksum of the payment order link. This is used to verify the authenticity of the payment order link. */
  checksum: Scalars['String']['output'];
  /** Error Code */
  deeplink?: Maybe<Scalars['String']['output']>;
  /** Error Code */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Error Code */
  qr_code_url?: Maybe<Scalars['String']['output']>;
  /** Signature of the payment order link. This is used to verify the authenticity of the payment order link. */
  signature: Scalars['String']['output'];
  /** Success */
  success: Scalars['Boolean']['output'];
  /** Target of the payment order link. This is the URL where the user should be redirected to. */
  target: Scalars['String']['output'];
  /** Payment Order Link */
  url: Scalars['String']['output'];
};

export type PaymentOrderTransactionStatusResponse = {
  __typename?: 'PaymentOrderTransactionStatusResponse';
  create_time?: Maybe<Scalars['Int']['output']>;
  /** Error Code */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  reference_id: Scalars['String']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
  transaction_type?: Maybe<Scalars['Int']['output']>;
  update_time?: Maybe<Scalars['Int']['output']>;
};

export enum PaymentProvider {
  Momo = 'MOMO'
}

/** The stored payment method available to the customer */
export type PaymentToken = {
  __typename?: 'PaymentToken';
  /** Stored account details */
  details?: Maybe<Scalars['String']['output']>;
  /** The payment method code associated with the token */
  payment_method_code: Scalars['String']['output'];
  /** The public hash of the token */
  public_hash: Scalars['String']['output'];
  type: PaymentTokenTypeEnum;
};

/** The list of available payment token types */
export enum PaymentTokenTypeEnum {
  /** @deprecated  */
  Account = 'account',
  /** @deprecated  */
  Card = 'card'
}

/** PhysicalProductInterface contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PickedGiftInput = {
  /** The rule id of cart price rule. */
  rule_id: Scalars['Int']['input'];
  /** The product sku. */
  sku: Scalars['String']['input'];
};

export type PlaceOrderInput = {
  cart_id: Scalars['String']['input'];
};

export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput';
  order: Order;
};

/** popular search keyword input and response */
export type PopularSearchKeyword = {
  __typename?: 'PopularSearchKeyword';
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PopularSearchTerms = {
  __typename?: 'PopularSearchTerms';
  items?: Maybe<Array<Maybe<SearchTerm>>>;
};

/** The post information. */
export type Post = {
  __typename?: 'Post';
  /** The author of the post. */
  author?: Maybe<Scalars['String']['output']>;
  /** The comment status of the post. */
  comment_status?: Maybe<Scalars['String']['output']>;
  /** The default url of the post. */
  guid?: Maybe<Scalars['String']['output']>;
  /** The id of the post. */
  id?: Maybe<Scalars['String']['output']>;
  /** The content of the post. */
  post_content?: Maybe<Scalars['String']['output']>;
  /** The date posted the post. */
  post_date?: Maybe<Scalars['String']['output']>;
  /** The excerpt of the post. */
  post_excerpt?: Maybe<Scalars['String']['output']>;
  /** The date modified the post. */
  post_modified?: Maybe<Scalars['String']['output']>;
  /** The date modified the post by GMT. */
  post_modified_gmt?: Maybe<Scalars['String']['output']>;
  /** The post name of the post. */
  post_name?: Maybe<Scalars['String']['output']>;
  /** The status of the post. */
  post_status?: Maybe<Scalars['String']['output']>;
  /** The title of the post. */
  post_title?: Maybe<Scalars['String']['output']>;
  /** The type of the post. */
  post_type?: Maybe<Scalars['String']['output']>;
  /** The url of the post. */
  post_url?: Maybe<Scalars['String']['output']>;
  /** The thumbnail image of the post. */
  thumb_img?: Maybe<Scalars['String']['output']>;
  /** The views count of the post. */
  views_count?: Maybe<Scalars['Int']['output']>;
};

/** An array posts. */
export type Posts = {
  __typename?: 'Posts';
  /** The background color of post block. */
  background_color?: Maybe<Scalars['String']['output']>;
  /** Returns an array post. */
  items?: Maybe<Array<Maybe<Post>>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The banner of post block. */
  post_banner?: Maybe<Scalars['String']['output']>;
  /** The total count of brands. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Price is deprecated, replaced by ProductPrice. The Price object defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  __typename?: 'Price';
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Price is deprecated, use ProductPrice.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Price is deprecated, use ProductPrice.
   */
  amount?: Maybe<Money>;
};

/** PriceAdjustment is deprecated. Taxes will be included or excluded in the price. The PricedAdjustment object defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated PriceAdjustment is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated PriceAdjustment is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>;
};

/** PriceAdjustment.code is deprecated. This enumeration contains values defined in modules other than the Catalog module. */
export enum PriceAdjustmentCodesEnum {
  /** @deprecated PriceAdjustmentCodesEnum is deprecated. Tax is included or excluded in price. Tax is not shown separtely in Catalog */
  Tax = 'TAX',
  /** @deprecated WEEE code is deprecated, use fixed_product_taxes.label */
  Weee = 'WEEE',
  /** @deprecated Use fixed_product_taxes. PriceAdjustmentCodesEnum is deprecated. Tax is included or excluded in price. Tax is not shown separtely in Catalog */
  WeeeTax = 'WEEE_TAX'
}

/** PriceAdjustmentDescriptionEnum is deprecated. This enumeration states whether a price adjustment is included or excluded. */
export enum PriceAdjustmentDescriptionEnum {
  /** @deprecated  */
  Excluded = 'EXCLUDED',
  /** @deprecated  */
  Included = 'INCLUDED'
}

/** Price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  __typename?: 'PriceRange';
  /** The highest possible price for the product. */
  maximum_price?: Maybe<ProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: ProductPrice;
};

/** This enumeration the price type. */
export enum PriceTypeEnum {
  /** @deprecated  */
  Dynamic = 'DYNAMIC',
  /** @deprecated  */
  Fixed = 'FIXED',
  /** @deprecated  */
  Percent = 'PERCENT'
}

/** This enumeration defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export enum PriceViewEnum {
  /** @deprecated  */
  AsLowAs = 'AS_LOW_AS',
  /** @deprecated  */
  PriceRange = 'PRICE_RANGE'
}

export type ProductAchievement = {
  __typename?: 'ProductAchievement';
  /** The background color of product achievement. */
  background_color?: Maybe<Scalars['String']['output']>;
  /** The border color of product achievement. */
  border_color?: Maybe<Scalars['String']['output']>;
  /** The description of product achievement. */
  description?: Maybe<Scalars['String']['output']>;
  /** The end date of product achievement. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** The id of product achievement. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The image of product achievement. */
  image?: Maybe<Scalars['String']['output']>;
  /** The status of product achievement. */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** The name of product achievement. */
  name?: Maybe<Scalars['String']['output']>;
  /** The position of product achievement. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The start date of product achievement. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** The target link of product achievement. */
  target_link?: Maybe<Scalars['String']['output']>;
  /** The text color of product achievement. */
  text_color?: Maybe<Scalars['String']['output']>;
};

export type ProductAchievementContentFilter = {
  /** Entity ID of the Achievement */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Entity Type of the Achievement */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** ProductAttributeFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Attribute label: Chọn tuổi */
  age?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Best Selling */
  best_seller_sorting?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Brand */
  brand?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by category id */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Chất liệu */
  chat_lieu?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Chất liệu gỗ */
  chat_lieu_go?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Màu sắc */
  color?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Mệnh giá */
  denomination?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Dung tích */
  dungtich?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Khối lượng */
  gram?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Has Any Discount */
  has_any_discount?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Has gift */
  has_gift?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Is Discount */
  is_discount?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Kích thước (Bao bì) */
  kich_thuoc?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Xuất xứ */
  made_in?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Kích thước núm ty */
  nipple_size?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Promotion Information From */
  promotion_info_time_from?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Promotion Information To */
  promotion_info_time_to?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Product Rating */
  ratings_summary?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Giới tính */
  sex?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Kích thước */
  size?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Size bỉm */
  size_bim?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Số tầng */
  so_tang?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: URL Key */
  url_key?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Cân nặng của bé */
  weight_bim?: InputMaybe<FilterEqualTypeInput>;
};

/** ProductAttributeSortInput specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type ProductAttributeSortInput = {
  /** Attribute label: Best Selling */
  best_seller_sorting?: InputMaybe<SortEnum>;
  /** Attribute label: Hot Product */
  hot_product?: InputMaybe<SortEnum>;
  /** Attribute label: New Product */
  new_product?: InputMaybe<SortEnum>;
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>;
  /** Attribute label: Price High To Low */
  price?: InputMaybe<SortEnum>;
  /** Attribute label: Price Low To High */
  price_low_to_high?: InputMaybe<SortEnum>;
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>;
};

export type ProductBadge = {
  __typename?: 'ProductBadge';
  /** The description product badge. */
  description?: Maybe<Scalars['String']['output']>;
  /** The end date product badge. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** The id product badge. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The image product badge. */
  image?: Maybe<Scalars['String']['output']>;
  /** The status product badge. */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** The name product badge. */
  name?: Maybe<Scalars['String']['output']>;
  /** The position product badge. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The start date product badge. */
  start_date?: Maybe<Scalars['String']['output']>;
};

export type ProductBlock = {
  __typename?: 'ProductBlock';
  /** The product layout for Homepage App. */
  app_layout_type?: Maybe<LayoutData>;
  /** The block type. */
  block_type?: Maybe<Scalars['String']['output']>;
  /** The first highlight product. */
  highlight_items?: Maybe<Array<Maybe<HighlightProductItem>>>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** The is auto of product. */
  is_auto?: Maybe<Scalars['String']['output']>;
  /** The product limit for Home Page (App). */
  limit_products_for_app?: Maybe<Scalars['Int']['output']>;
  /** The product limit for Home Page (Web). */
  limit_products_for_web?: Maybe<Scalars['Int']['output']>;
  /** The limit quantity products. */
  limit_qty_products?: Maybe<Scalars['Int']['output']>;
  /** The name of block. */
  name?: Maybe<Scalars['String']['output']>;
  /** An array of products that match the specified query data */
  products?: Maybe<Products>;
};


export type ProductBlockProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCartPriceRule = {
  __typename?: 'ProductCartPriceRule';
  description?: Maybe<Scalars['String']['output']>;
  discount_step?: Maybe<Scalars['Int']['output']>;
  discounted_price?: Maybe<Money>;
  from_date?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage_discount?: Maybe<Scalars['Float']['output']>;
  rule_id?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Money>;
  to_date?: Maybe<Scalars['String']['output']>;
};

/** A discount applied to a product price. */
export type ProductDiscount = {
  __typename?: 'ProductDiscount';
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars['Float']['output']>;
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars['Float']['output']>;
};

/** An array product FAQs. */
export type ProductFaQs = {
  __typename?: 'ProductFAQs';
  /** An array of product FAQs that match the specified search criteria. */
  items?: Maybe<Array<Maybe<FaqQuestion>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<PageInfo>;
  /** The number of FAQs returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Product image information. Contains the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  __typename?: 'ProductImage';
  /** Whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
};

/** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
export type ProductInterface = {
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Return a related products array. */
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead. But in Magento 2.3.4 and higher versions __typename is not available for products. Use `... on SimpleProduct` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

/** ProductLinks contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']['output']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']['output']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']['output']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']['output']>;
};

/** Configs of catalog-products-list widget */
export type ProductListConfig = {
  __typename?: 'ProductListConfig';
  /** Number of product in initial loading */
  initial_load_count?: Maybe<Scalars['Int']['output']>;
  /** Layout type to show product list. Ex: Slide, Grid */
  layout_type?: Maybe<Scalars['Int']['output']>;
  /** Number of product for load more */
  load_more_count?: Maybe<Scalars['Int']['output']>;
};

/** ProductMediaGalleryEntriesContent contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  __typename?: 'ProductMediaGalleryEntriesContent';
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars['String']['output']>;
  /** The file name of the image. */
  name?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']['output']>;
};

/** ProductMediaGalleryEntriesVideoContent contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  __typename?: 'ProductMediaGalleryEntriesVideoContent';
  /** Must be external-video. */
  media_type?: Maybe<Scalars['String']['output']>;
  /** A description of the video. */
  video_description?: Maybe<Scalars['String']['output']>;
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars['String']['output']>;
  /** Describes the video source. */
  video_provider?: Maybe<Scalars['String']['output']>;
  /** The title of the video. */
  video_title?: Maybe<Scalars['String']['output']>;
  /** The URL to the video. */
  video_url?: Maybe<Scalars['String']['output']>;
};

export type ProductNotification = {
  __typename?: 'ProductNotification';
  content?: Maybe<Scalars['String']['output']>;
  notification_id?: Maybe<Scalars['Int']['output']>;
  notification_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Description for enumType ProductPageType. */
export enum ProductPageType {
  /**
   * The bestseller products.
   * @deprecated
   */
  Bestseller = 'BESTSELLER',
  /**
   * The highlight products.
   * @deprecated
   */
  Highlight = 'HIGHLIGHT',
  /**
   * The new arrival products.
   * @deprecated
   */
  NewArrival = 'NEW_ARRIVAL'
}

/** An array posts in product detail page. */
export type ProductPosts = {
  __typename?: 'ProductPosts';
  /** An array of posts that match the specified query data. */
  items?: Maybe<Array<Maybe<Post>>>;
};

/** Represents a product price. */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>;
  /** The final price of the product after discounts applied. */
  final_price: Money;
  /** The multiple FPTs that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: Money;
};

/** ProductPrices is deprecated, replaced by PriceRange. The ProductPrices object contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  __typename?: 'ProductPrices';
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the to value.
   * @deprecated Use PriceRange.maximum_price.
   */
  maximalPrice?: Maybe<Price>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the from value.
   * @deprecated Use PriceRange.minimum_price.
   */
  minimalPrice?: Maybe<Price>;
  /**
   * The base price of a product.
   * @deprecated Use regular_price from PriceRange.minimum_price or PriceRange.maximum_price.
   */
  regularPrice?: Maybe<Price>;
};

export type ProductReviewsAggregationResponse = {
  __typename?: 'ProductReviewsAggregationResponse';
  /** aggregation of reviews */
  aggregations?: Maybe<Array<Maybe<ReviewAggregation>>>;
  /** The rating average value returned that match the specified filter criteria */
  rating_average?: Maybe<Scalars['Float']['output']>;
};

export type ProductReviewsAggregationV2Response = {
  __typename?: 'ProductReviewsAggregationV2Response';
  /** aggregation of all reviews */
  all_reviews_aggregation?: Maybe<Array<Maybe<ReviewAggregation>>>;
  /** "The average rating value returned matches the specified filter criteria. */
  average_rating?: Maybe<Scalars['Float']['output']>;
  /** aggregation of reviews that had images */
  has_image_reviews_aggregation?: Maybe<Array<Maybe<ReviewAggregation>>>;
};

export type ProductReviewsResponse = {
  __typename?: 'ProductReviewsResponse';
  /** An array of review that match the specified filter criteria */
  items?: Maybe<Array<Maybe<Review>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  page_info?: Maybe<PageInfo>;
  /** The number of reviews returned that match specified filter criteria */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ProductSalableQuantity = {
  __typename?: 'ProductSalableQuantity';
  /** The available salable quantity of the product. */
  available_quantity?: Maybe<Scalars['Float']['output']>;
  /** An array of errors, if any occurred while checking the product. */
  errors?: Maybe<Array<Maybe<ProductSalableQuantityError>>>;
  /** Indicates whether the product is salable. True if the salable quantity > 0. */
  is_salable?: Maybe<Scalars['Boolean']['output']>;
  /** The SKU of the product. */
  sku?: Maybe<Scalars['String']['output']>;
};

export type ProductSalableQuantityError = {
  __typename?: 'ProductSalableQuantityError';
  /** The type of the error. */
  code?: Maybe<Scalars['String']['output']>;
  /** The message of the error. */
  message?: Maybe<Scalars['String']['output']>;
};

export type ProductSalableQuantityInput = {
  /** The quantity requested for this product. */
  request_qty: Scalars['Int']['input'];
  /** The SKU of the product. */
  sku: Scalars['String']['input'];
};

/** This enumeration states whether a product stock status is in stock or out of stock */
export enum ProductStockStatus {
  /** @deprecated  */
  InStock = 'IN_STOCK',
  /** @deprecated  */
  OutOfStock = 'OUT_OF_STOCK'
}

export type ProductSuggestedHashTags = {
  __typename?: 'ProductSuggestedHashTags';
  /** Tag items for category. */
  hash_tags?: Maybe<Scalars['String']['output']>;
};

export type ProductTags = {
  __typename?: 'ProductTags';
  /** An array of tags */
  items?: Maybe<Array<Maybe<Tag>>>;
};

/** ProductTierPrices is deprecated and has been replaced by TierPrice. The ProductTierPrices object defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  __typename?: 'ProductTierPrices';
  /**
   * The ID of the customer group.
   * @deprecated customer_group_id is not relevant for storefront.
   */
  customer_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage discount of the item.
   * @deprecated ProductTierPrices is deprecated. Use TierPrice.discount.
   */
  percentage_value?: Maybe<Scalars['Float']['output']>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated ProductTierPrices is deprecated, use TierPrice.quantity.
   */
  qty?: Maybe<Scalars['Float']['output']>;
  /**
   * The price of the fixed price item.
   * @deprecated ProductTierPrices is deprecated. Use TierPrice.final_price
   */
  value?: Maybe<Scalars['Float']['output']>;
  /**
   * The ID assigned to the website.
   * @deprecated website_id is not relevant for storefront.
   */
  website_id?: Maybe<Scalars['Float']['output']>;
};

export type ProductToWishlistOutput = {
  __typename?: 'ProductToWishlistOutput';
  /** Is added to wishlist. */
  is_added_to_wishlist?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the product. */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The number wishlist of product. */
  wishlist_count?: Maybe<Scalars['Int']['output']>;
};

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  __typename?: 'ProductVideo';
  /** Whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
  /** Contains a ProductMediaGalleryEntriesVideoContent object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** The Products object is the top-level object returned in a product search. */
export type Products = {
  __typename?: 'Products';
  /** Layered navigation aggregations. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use aggregations instead
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export enum ProviderEnum {
  Fptsms = 'FPTSMS',
  Vsms = 'VSMS',
  Zalooa = 'ZALOOA'
}

export type PurchaseContentInput = {
  item_price?: InputMaybe<Scalars['Int']['input']>;
  product_id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type PurchaseEventInput = {
  purchase_info?: InputMaybe<PurchaseInfoInput>;
  user: UserDataInput;
};

export type PurchaseInfoInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<PurchaseContentInput>>;
  currency: Scalars['String']['input'];
  order_id?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};

export type PurchaseTrackingEventInput = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<PurchaseEventInput>;
};

export type PurchasedProductStatus = {
  __typename?: 'PurchasedProductStatus';
  is_purchased: Scalars['Boolean']['output'];
};

export type PushAllocationResult = {
  __typename?: 'PushAllocationResult';
  success: Scalars['Boolean']['output'];
  sync_status: SyncStatus;
};

/** Query type for fetching data */
export type Query = {
  __typename?: 'Query';
  /** Get available cart-level gifts (all rules with eligibility status) */
  availableCartLevelGifts?: Maybe<CartLevelGiftsOutput>;
  /** Returns an array available rules. */
  availableCartPriceRules?: Maybe<AvailableRules>;
  /** Returns information about available coupons */
  availableCoupons?: Maybe<Array<Maybe<SalesRule>>>;
  /** Returns list gifts that can applied to cart. */
  availableGiftsCart?: Maybe<AvailableGiftsCart>;
  bannerConfig?: Maybe<BannerConfig>;
  /** Returns best seller products on homepage blocks */
  bestsellerProducts?: Maybe<BlockProducts>;
  /** Get list of brands with pagination, filter */
  brandList?: Maybe<Brands>;
  /** Returns brands for category */
  brands?: Maybe<Brands>;
  /** Returns popups for pages. */
  bssPopups?: Maybe<BssPopups>;
  cancelOrderReason?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cancellableOrderStatuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns information about shopping cart */
  cart?: Maybe<Cart>;
  /** Lightweight query returning only cart items without expensive total calculations. Optimized for fast UI updates like quantity changes. */
  cartItemsOnly?: Maybe<CartItemsOnly>;
  /** Return items which are out of stock or lack of quantity */
  cartItemsStatus: Array<Maybe<ItemStatus>>;
  /** Returns information about raw data of cart. */
  cartMeta?: Maybe<CartMeta>;
  /** Get cart sync references for audit trail */
  cartSyncReferences?: Maybe<Array<Maybe<CartItemReference>>>;
  /**
   * The category query searches for categories that match the criteria specified in the search and filter attributes.
   * @deprecated Use 'categoryList' query instead of 'category' query
   */
  category?: Maybe<CategoryTree>;
  /** Returns banners for category page. */
  categoryBanners?: Maybe<CategoryBanners>;
  /** Returns highlight products by category */
  categoryHighlightProducts?: Maybe<CategoryHighlightProducts>;
  /** Returns an array of categories based on the specified filters. */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>;
  /** Return useful posts for category. */
  categoryPosts?: Maybe<CategoryPosts>;
  /** Returns tags for category page. */
  categoryTags?: Maybe<CategoryTags>;
  /** Fetch referral code entity */
  checkEventReferralCodeExist: Scalars['Boolean']['output'];
  /** The Checkout Agreements information */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>;
  /** The CMS block query returns information about CMS blocks */
  cmsBlocks?: Maybe<CmsBlocks>;
  /** The CMS page query returns information about a CMS page */
  cmsPage?: Maybe<CmsPage>;
  /** Query return information of cms page from magento with json schema of content */
  cmsPageByIdentifier?: Maybe<GetCmsPageSchemaByIdentifierResponse>;
  cmsPageConfig?: Maybe<CmsPageConfig>;
  /** Query return information of cms page from magento with additional content_fragment field */
  cmsPageWidget?: Maybe<CmsPageResponse>;
  coreConfig?: Maybe<CoreConfig>;
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>;
  couponWidgetContent?: Maybe<Array<Maybe<CouponContentResponse>>>;
  /** The currency query returns information about store currency. */
  currency?: Maybe<Currency>;
  /** The customAttributeMetadata query returns the attribute type, given an attribute code and entity type */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  /** The customer query returns information about a customer account */
  customer?: Maybe<Customer>;
  /** Get list of customer account deletion requests */
  customerAccountDeletionRequests: CustomerAccountDeletionListResponse;
  /** Returns an array active carts for customer. */
  customerActiveCarts?: Maybe<Array<Maybe<Cart>>>;
  /** Returns information about the customer shopping cart */
  customerCart: Cart;
  customerCouponWallet?: Maybe<Array<Maybe<CouponContentResponse>>>;
  /** The query returns the contents of a customer's downloadable products */
  customerDownloadableProducts?: Maybe<CustomerDownloadableProducts>;
  /** Returns information about customer kicoin */
  customerKicoin?: Maybe<CustomerKicoin>;
  /** Customer order statistics for voucher eligibility evaluation. Requires authentication. */
  customerOrderStats?: Maybe<CustomerOrderStats>;
  /** List of customer orders */
  customerOrders?: Maybe<CustomerOrders>;
  /** List of customer orders */
  customerOrdersV2?: Maybe<CustomerOrdersV2>;
  /** Return a list of customer payment tokens */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  customerProfile?: Maybe<CustomerInformation>;
  districts?: Maybe<Array<Maybe<District>>>;
  /** Fetch activities for a specific event by event ID */
  eventActivities: Array<EventActivity>;
  /** Fetch grouped activities for a specific event by event ID */
  eventActivityGroups: Array<Maybe<EventActivityGroup>>;
  /** Fetch all event attributes */
  eventAttributes: Array<EventAttribute>;
  /** A list of FAQ articles */
  faqArticles?: Maybe<FaqArticles>;
  /** Get FAQ Category */
  faqCategories?: Maybe<FaqCategories>;
  /** Search Questions Guest By Search Term */
  faqGuest?: Maybe<FaqListBySku>;
  faqReactionByProduct?: Maybe<Array<Maybe<FaqReaction>>>;
  faqSuggestionTags: Array<FaqSuggestionTag>;
  /** Returns cart totals quickly without full price calculation */
  fastCartTotals?: Maybe<FastCartTotals>;
  /**
   * Returns flash sale information of a product
   * @deprecated Use `flashSaleProductV2` instead
   */
  flashSaleProduct?: Maybe<FlashSaleProduct>;
  /** Returns the running flash sale for the product if available, otherwise returns the upcoming flash sale for the product. */
  flashSaleProductV2?: Maybe<FlashSaleProduct>;
  /** Returns flash sale products on homepage blocks */
  flashSaleProducts?: Maybe<FlashSaleProducts>;
  /**
   * Returns flash sale products.
   * @deprecated Use the `flashSaleProductsV3` query instead.
   */
  flashSaleProductsV2?: Maybe<FlashSaleProductsV2>;
  /** Returns flash sale products. */
  flashSaleProductsV3?: Maybe<FlashSaleProductsV2>;
  /** Returns an array Flash Sale session. */
  flashSaleSessions?: Maybe<Array<Maybe<FlashSale>>>;
  formConfig?: Maybe<FormConfig>;
  formSubmission?: Maybe<FormValue>;
  /**
   * Returns information about free gifts on cart.
   * @deprecated Use freeGiftsInCart instead.
   */
  freeGiftCart?: Maybe<FreeGiftCart>;
  /** Returns free gifts content of a product */
  freeGifts?: Maybe<FreeGifts>;
  /** Returns an array free gifts for cart */
  freeGiftsForCart?: Maybe<Array<Maybe<FreeGiftsData>>>;
  /** Returns free gifts for product */
  freeGiftsForProduct?: Maybe<Array<Maybe<FreeGiftsData>>>;
  /** Returns information about free gifts in cart. */
  freeGiftsInCart?: Maybe<Array<Maybe<GiftCartItem>>>;
  /** Fetch all events */
  getAllEvents: Array<EventEntity>;
  /** Fetch event registrations by User */
  getEventRegistrationsByUser?: Maybe<Array<EventRegistration>>;
  /** Fetch user entity by id and signature */
  getEventUserById: EventUser;
  /** Get FAQ list by SKU */
  getFaqListBySku?: Maybe<GetFaqListBySkuResponse>;
  /** Get questions by product ID */
  getQuestions: Array<Maybe<Question>>;
  /** Get gift rule thresholds with progress from ElasticSearch */
  giftRuleThresholds?: Maybe<GiftRuleThresholdsOutput>;
  hasPurchasedProduct: PurchasedProductStatus;
  hasReviewedProduct: Scalars['Boolean']['output'];
  helloCatalogService?: Maybe<Scalars['String']['output']>;
  helloCheckoutService?: Maybe<Scalars['String']['output']>;
  helloCmsService?: Maybe<Scalars['String']['output']>;
  helloCoreService?: Maybe<Scalars['String']['output']>;
  helloSynchronizeService?: Maybe<Scalars['String']['output']>;
  helloUrlService?: Maybe<Scalars['String']['output']>;
  /** Returns highlight brands for homepage */
  highlightBrands?: Maybe<HighlightBrands>;
  /** Returns highlight categories for homepage */
  highlightCategories?: Maybe<HighlightCategories>;
  /** An array highlight product attributes of category */
  highlightProductAttributes?: Maybe<Array<Maybe<Aggregation>>>;
  /** Returns highlight products for best seller tab on homepage */
  highlightProductBlocks?: Maybe<HighlightProductBlocks>;
  /** Returns highlight products on homepage block */
  highlightProducts?: Maybe<HighlightProducts>;
  /** An array of products that match the specified query data. */
  highlightProductsPage?: Maybe<CategoryProducts>;
  /** Returns featured blocks data for Homepage. */
  homepageFeaturedBlock?: Maybe<Array<Maybe<HomepageFeaturedBlock>>>;
  /** Returns float banners on Homepage. */
  homepageFloatBanner?: Maybe<HomePageFloatBanner>;
  /** Popular keyword for homepage */
  homepagePopularSearchKeywords?: Maybe<HomepagePopularSearchKeywords>;
  /** Return useful posts for homepage */
  homepagePosts?: Maybe<HomepagePosts>;
  /** Ultra-fast homepage products — bestseller, new arrival, highlight hot/new — ALL from Elasticsearch. No MySQL EAV, no Product model. */
  homepageProductsLightweight?: Maybe<HomepageProductsLightweight>;
  /** Returns interested products on homepage blocks */
  interestedProducts?: Maybe<InterestedProducts>;
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>;
  lookupCustomer: LookupCustomerResponse;
  lookupCustomerByCaptcha: LookupCustomerResponse;
  /** Fetch user entity by search string */
  lookupEventUser?: Maybe<EventUser>;
  /** Check if referral code is exist */
  lookupReferralCode?: Maybe<CustomerReferralCodeSignature>;
  marketingGetAllocationDetail?: Maybe<StorefrontAllocation>;
  marketingGetAppliedCodes: AppliedCodesResponse;
  marketingGetAvailableVouchers: Array<StorefrontAllocation>;
  /** Get user coupon of current session */
  myCoupons: Array<Maybe<IssuedCoupon>>;
  /** Get customer favorite brands */
  myFavoriteBrands?: Maybe<MyFavoriteBrands>;
  myNotificationHistory?: Maybe<Notifications>;
  myNotificationMessage?: Maybe<NotificationCustomer>;
  myQuestion?: Maybe<MyQuestions>;
  /** Returns new arrival products on homepage blocks */
  newArrivalProducts?: Maybe<NewArrivalProducts>;
  /** Get order sync references with full product data. Mirrors cartSyncReferences structure for consistent UI rendering on My Order page. */
  orderSyncReferences?: Maybe<OrderSyncReferencesOutput>;
  /** Returns Kredivo payment url */
  paymentInformation?: Maybe<PaymentInformation>;
  /** Query the payment methods. */
  paymentMethodSettings?: Maybe<PaymentMethodSettings>;
  paymentOrderInformation?: Maybe<PaymentOrderInformation>;
  /** Query the payment order link for a given payment method. */
  paymentOrderLink?: Maybe<PaymentOrderLinkResponse>;
  /** Query the payment order transaction status for a given payment method. */
  paymentOrderTransactionStatus?: Maybe<PaymentOrderTransactionStatusResponse>;
  /** Get popular search keyword */
  popularSearchKeywords: Array<PopularSearchKeyword>;
  /** Returns popular search terms. */
  popularSearchTerms?: Maybe<PopularSearchTerms>;
  /** Returns product by sku. */
  productBySku?: Maybe<ProductInterface>;
  /** Returns product by product id */
  productByUuid?: Maybe<ProductInterface>;
  productCartPriceRules?: Maybe<Array<Maybe<ProductCartPriceRule>>>;
  /** Returns an array product FAQs. */
  productFAQs?: Maybe<ProductFaQs>;
  /** Lightweight product list — reads directly from ES, no EAV load. 10-50x faster than native products() query. */
  productListLightweight?: Maybe<LightweightProductList>;
  /** Return useful posts for product. */
  productPosts?: Maybe<ProductPosts>;
  /** Get product reviews by filter */
  productReviews?: Maybe<ProductReviewsResponse>;
  /** Get product review aggregation */
  productReviewsAggregation?: Maybe<ProductReviewsAggregationResponse>;
  /** Get product review aggregation */
  productReviewsAggregationV2?: Maybe<ProductReviewsAggregationV2Response>;
  /** Get all review images by product id */
  productReviewsImagesGallery?: Maybe<Array<Maybe<ReviewMedia>>>;
  /** Returns information about salable quantity of product. */
  productSalableQuantity?: Maybe<ProductSalableQuantity>;
  /** Returns hashtags suggested for product detail page. */
  productSuggestedHashTags?: Maybe<ProductSuggestedHashTags>;
  /** Returns information for tag. */
  productTag?: Maybe<Tag>;
  /** Returns tags for product detail page. */
  productTags?: Maybe<ProductTags>;
  /** The wishlist query returns the contents of a customer's wish list */
  productWishlist?: Maybe<ProductToWishlistOutput>;
  /** The products query searches for products that match the criteria specified in the search and filter attributes. */
  products?: Maybe<Products>;
  /** Returns information about salable quantity of list products. */
  productsSalableQuantity?: Maybe<Array<Maybe<ProductSalableQuantity>>>;
  /** Returns an array products have gift or discount. */
  promotionProducts?: Maybe<Products>;
  regionStore?: Maybe<RegionStore>;
  regions?: Maybe<Array<Maybe<Region>>>;
  regionsV2: Array<Maybe<Region>>;
  /** Returns custom related products. */
  relatedProducts?: Maybe<RelatedProducts>;
  reviewTags?: Maybe<Array<Maybe<ReviewTag>>>;
  /** A list of order status */
  salesOrderStatuses: Array<SalesOrderStatus>;
  /** Get currently selected cart-level gifts */
  selectedCartLevelGifts?: Maybe<SelectedCartLevelGiftsOutput>;
  settings: Settings;
  /** Returns banners base on position provided. */
  sliderBanners?: Maybe<BannerItems>;
  /** Get slider's banners V2 */
  sliderBannersV2?: Maybe<BannerItems>;
  /** The store config query */
  storeConfig?: Maybe<StoreConfig>;
  /** Returns list regions that have KidsPlaza stores. */
  storeRegions?: Maybe<StoreRegions>;
  /** Returns list store locator. */
  storesLocator?: Maybe<StoresLocator>;
  /** Get suggest search */
  suggestionSearch?: Maybe<SuggestionSearchResponse>;
  supportMenuItems: Array<SupportMenuItem>;
  termsOfService?: Maybe<Array<Maybe<TermsOfService>>>;
  /** Return the information for a specified screen. */
  universalLinkResolver?: Maybe<UniversalLinkEntity>;
  /** The urlResolver query returns the relative URL for a specified product, category or CMS page, using as input a url_key appended by the url_suffix, if one exists */
  urlResolver?: Maybe<EntityUrl>;
  /** Return the relative URL for a specified product, category or CMS page. Get from url redirects first then look up in url rewrites */
  urlResolverTwo?: Maybe<EntityUrl>;
  /** Verify update secret */
  verifyEventUserUpdateSecret: Scalars['Boolean']['output'];
  wards?: Maybe<Array<Maybe<Ward>>>;
  wardsV2: Array<Maybe<Ward>>;
  /** Returns information about current shopping cart on the web */
  webCart?: Maybe<Cart>;
  /** Returns an array banners. */
  widgetBanners?: Maybe<Array<Maybe<Banner>>>;
  /** Retrieves widget shortcut links based on a provided shortcutLinks string. */
  widgetShortcutLinks: WidgetShortcutLink;
  /** Retrieves widget shortcut links based on a provided shortcutLinks string. */
  widgetShortcutLinksV2: WidgetShortcutLinkV2;
  /** Return an array wordpress posts. */
  wpPosts?: Maybe<Posts>;
};


/** Query type for fetching data */
export type QueryAvailableCartLevelGiftsArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryAvailableGiftsCartArgs = {
  cart_id: Scalars['String']['input'];
  cart_item_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryBannerConfigArgs = {
  page_type?: InputMaybe<BannerPageType>;
};


/** Query type for fetching data */
export type QueryBrandListArgs = {
  input?: InputMaybe<BrandListInput>;
};


/** Query type for fetching data */
export type QueryBrandsArgs = {
  brand_ids: Array<InputMaybe<Scalars['Int']['input']>>;
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCartArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCartItemsOnlyArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCartItemsStatusArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCartMetaArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCartSyncReferencesArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCategoryBannersArgs = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryCategoryHighlightProductsArgs = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCategoryListArgs = {
  filters?: InputMaybe<CategoryFilterInput>;
};


/** Query type for fetching data */
export type QueryCategoryPostsArgs = {
  category_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryCategoryTagsArgs = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCheckEventReferralCodeExistArgs = {
  code: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Query type for fetching data */
export type QueryCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryCmsPageByIdentifierArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryCmsPageConfigArgs = {
  key: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCmsPageWidgetArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryCouponWidgetContentArgs = {
  filter?: InputMaybe<CouponWidgetFilterInput>;
};


/** Query type for fetching data */
export type QueryCustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>;
};


/** Query type for fetching data */
export type QueryCustomerAccountDeletionRequestsArgs = {
  request?: InputMaybe<GetCustomerAccountDeletionRequest>;
};


/** Query type for fetching data */
export type QueryCustomerOrdersV2Args = {
  filter?: InputMaybe<CustomerOrderFilterV2>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryDistrictsArgs = {
  regionCode: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryEventActivitiesArgs = {
  eventId: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryEventActivityGroupsArgs = {
  eventId: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFaqArticlesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  search_term?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOptions>;
};


/** Query type for fetching data */
export type QueryFaqCategoriesArgs = {
  current_page: Scalars['Int']['input'];
  filters?: InputMaybe<FaqCategoryFilters>;
  page_size: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryFaqGuestArgs = {
  current_page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
  search_term: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFaqReactionByProductArgs = {
  product_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryFaqSuggestionTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryFastCartTotalsArgs = {
  cart_id?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFlashSaleProductArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFlashSaleProductV2Args = {
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFlashSaleProductsV3Args = {
  flashsale_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryFormConfigArgs = {
  id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFormSubmissionArgs = {
  form_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFreeGiftCartArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFreeGiftsArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFreeGiftsForProductArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFreeGiftsInCartArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryGetAllEventsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryGetEventRegistrationsByUserArgs = {
  input: GetEventUserEntityInput;
};


/** Query type for fetching data */
export type QueryGetEventUserByIdArgs = {
  input: GetEventUserEntityInput;
};


/** Query type for fetching data */
export type QueryGetFaqListBySkuArgs = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryGetQuestionsArgs = {
  productId: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryGiftRuleThresholdsArgs = {
  grand_total: Scalars['Float']['input'];
};


/** Query type for fetching data */
export type QueryHasPurchasedProductArgs = {
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryHasReviewedProductArgs = {
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryHighlightProductAttributesArgs = {
  category_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryHighlightProductBlocksArgs = {
  block_types?: InputMaybe<Array<InputMaybe<BlockTypeEnum>>>;
};


/** Query type for fetching data */
export type QueryHighlightProductsPageArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  type: ProductPageType;
};


/** Query type for fetching data */
export type QueryIsEmailAvailableArgs = {
  email: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryLookupCustomerArgs = {
  phone_number: Scalars['String']['input'];
  sign: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryLookupCustomerByCaptchaArgs = {
  captchaResponseToken: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryLookupEventUserArgs = {
  input: LookUpEventUserInput;
};


/** Query type for fetching data */
export type QueryLookupReferralCodeArgs = {
  code: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryMarketingGetAllocationDetailArgs = {
  allocation_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryMarketingGetAppliedCodesArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryMarketingGetAvailableVouchersArgs = {
  cart_id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<DisplayLocation>;
};


/** Query type for fetching data */
export type QueryMyCouponsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryMyFavoriteBrandsArgs = {
  filter?: InputMaybe<FavoriteBrandFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryMyNotificationHistoryArgs = {
  filter: NotificationHistoryFilterInput;
  page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryMyNotificationMessageArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryMyQuestionArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryOrderSyncReferencesArgs = {
  order_number: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryPaymentInformationArgs = {
  order_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryPaymentOrderInformationArgs = {
  orderId: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryPaymentOrderLinkArgs = {
  orderNumber: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryPaymentOrderTransactionStatusArgs = {
  checksum: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductBySkuArgs = {
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductByUuidArgs = {
  uuid: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductCartPriceRulesArgs = {
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductFaQsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<FaqFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductListLightweightArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


/** Query type for fetching data */
export type QueryProductPostsArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryProductReviewsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ReviewAttributeFilterInput>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductReviewsAggregationArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductReviewsAggregationV2Args = {
  product_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryProductReviewsImagesGalleryArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductSalableQuantityArgs = {
  request_qty: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductSuggestedHashTagsArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductTagArgs = {
  identifier: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductTagsArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryProductWishlistArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


/** Query type for fetching data */
export type QueryProductsSalableQuantityArgs = {
  items?: InputMaybe<Array<ProductSalableQuantityInput>>;
};


/** Query type for fetching data */
export type QueryPromotionProductsArgs = {
  category_id: Scalars['Int']['input'];
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryRegionStoreArgs = {
  region_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryRelatedProductsArgs = {
  product_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QuerySelectedCartLevelGiftsArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QuerySettingsArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QuerySliderBannersArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QuerySliderBannersV2Args = {
  location: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QuerySuggestionSearchArgs = {
  query: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QuerySupportMenuItemsArgs = {
  location: Location;
};


/** Query type for fetching data */
export type QueryUniversalLinkResolverArgs = {
  url: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryUrlResolverArgs = {
  url: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryUrlResolverTwoArgs = {
  url: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryVerifyEventUserUpdateSecretArgs = {
  input: VerifyEventUserUpdateSecretInput;
};


/** Query type for fetching data */
export type QueryWardsArgs = {
  districtId: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryWardsV2Args = {
  region_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryWidgetBannersArgs = {
  encrypted_banner_ids?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryWidgetShortcutLinksArgs = {
  location?: InputMaybe<ShortcutLinkLocation>;
};


/** Query type for fetching data */
export type QueryWidgetShortcutLinksV2Args = {
  location?: InputMaybe<ShortcutLinkLocation>;
};


/** Query type for fetching data */
export type QueryWpPostsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  post_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type Question = {
  __typename?: 'Question';
  answers?: Maybe<Array<Maybe<Answer>>>;
  customerId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceId?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionRequest = {
  captchaResponseToken: Scalars['String']['input'];
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export enum QuotaLevelEnum {
  All = 'ALL',
  Day = 'DAY'
}

export type RecalculateCartTotalsInput = {
  cart_id: Scalars['String']['input'];
};

export type RecalculateCartTotalsOutput = {
  __typename?: 'RecalculateCartTotalsOutput';
  cart: Cart;
};

export type ReferralCodeResponse = {
  __typename?: 'ReferralCodeResponse';
  /** Referral Code */
  referral_code: Scalars['String']['output'];
};

export type Region = {
  __typename?: 'Region';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RegionStore = {
  __typename?: 'RegionStore';
  region_code: Scalars['String']['output'];
  region_id: Scalars['Int']['output'];
  region_name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  sort_order: Scalars['String']['output'];
  store_code: Scalars['String']['output'];
};

export type RegisterAccountInfo = {
  /** Email */
  email: Scalars['String']['input'];
  /** First Name */
  first_name: Scalars['String']['input'];
  /** Last Name */
  last_name: Scalars['String']['input'];
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Website ID from the device */
  website_id: Scalars['Int']['input'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  customer_token?: Maybe<CustomerToken>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RelatedProducts = {
  __typename?: 'RelatedProducts';
  /** An array of products that match the specified query data. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

export type RemoveCartLevelGiftInput = {
  /** Masked cart ID */
  cart_id: Scalars['String']['input'];
  /** Gift item ID to remove */
  gift_item_id: Scalars['Int']['input'];
};

export type RemoveCartLevelGiftOutput = {
  __typename?: 'RemoveCartLevelGiftOutput';
  /** Updated cart */
  cart: Cart;
  /** Whether removal was successful */
  success: Scalars['Boolean']['output'];
};

export type RemoveCodeResponse = {
  __typename?: 'RemoveCodeResponse';
  error_message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveCouponFromCartInput = {
  cart_id: Scalars['String']['input'];
};

export type RemoveCouponFromCartOutput = {
  __typename?: 'RemoveCouponFromCartOutput';
  cart?: Maybe<Cart>;
};

export type RemoveItemFromCartInput = {
  cart_id: Scalars['String']['input'];
  cart_item_id: Scalars['Int']['input'];
};

export type RemoveItemFromCartOutput = {
  __typename?: 'RemoveItemFromCartOutput';
  cart: Cart;
};

export type RemoveKicoinsInput = {
  cart_id: Scalars['String']['input'];
};

export type RemoveKicoinsOutput = {
  __typename?: 'RemoveKicoinsOutput';
  cart: Cart;
};

export type RemoveUniversalCodeInput = {
  cart_id: Scalars['String']['input'];
};

export type RemoveUniversalCodeOutput = {
  __typename?: 'RemoveUniversalCodeOutput';
  cart: Cart;
  user_message?: Maybe<Scalars['String']['output']>;
};

export type RequestStatus = {
  __typename?: 'RequestStatus';
  request_id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type RequestValidatePhoneResponse = {
  __typename?: 'RequestValidatePhoneResponse';
  /** Error Code if any */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Secret to verify Phone number with OTP */
  secret?: Maybe<Scalars['String']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  /** Message */
  message: Scalars['String']['output'];
  /** Success */
  success: Scalars['Boolean']['output'];
};

export type Result = {
  __typename?: 'Result';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Review = {
  __typename?: 'Review';
  /**
   * Created At
   * @deprecated use created_at instead
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Created At */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Detail */
  detail?: Maybe<Scalars['String']['output']>;
  /** Array of files */
  files?: Maybe<Array<Maybe<ReviewMedia>>>;
  /** Id */
  id?: Maybe<Scalars['String']['output']>;
  /**
   * Array of files
   * @deprecated use files instead
   */
  images?: Maybe<Array<Maybe<ReviewMedia>>>;
  /**
   * Is Liked
   * @deprecated use liked instead
   */
  is_liked?: Maybe<Scalars['Boolean']['output']>;
  /** Did Customer order the product */
  is_ordered_customer?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if the user has liked this review yet */
  liked?: Maybe<Scalars['Boolean']['output']>;
  /** Nick name */
  nickname?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  /**
   * Order number
   * @deprecated No longer supported
   */
  order_number?: Maybe<Scalars['String']['output']>;
  /** Percent */
  percent?: Maybe<Scalars['Int']['output']>;
  /** The product owns the review */
  product?: Maybe<ProductInterface>;
  /** Id of product */
  product_id?: Maybe<Scalars['String']['output']>;
  /** Rating code */
  rating_code?: Maybe<Scalars['String']['output']>;
  /** Reply */
  reply?: Maybe<Array<Maybe<ReviewOption>>>;
  /** Source */
  source?: Maybe<Scalars['String']['output']>;
  /** Status */
  status_code?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Total likes */
  total_likes?: Maybe<Scalars['Int']['output']>;
  /** Value */
  value?: Maybe<Scalars['Float']['output']>;
};

/** // TODO: duplicate from catalog service */
export type ReviewAggregation = {
  __typename?: 'ReviewAggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String']['output'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<ReviewAggregationOption>>>;
};

export type ReviewAggregationOption = {
  __typename?: 'ReviewAggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Aggregation option display label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

export type ReviewAttributeFilterInput = {
  brand_id?: InputMaybe<Scalars['Int']['input']>;
  /** review has image or not */
  has_image?: InputMaybe<Scalars['Boolean']['input']>;
  /** review has video or not */
  has_video?: InputMaybe<Scalars['Boolean']['input']>;
  /** product id of review */
  product_id?: InputMaybe<Scalars['Int']['input']>;
  /** rating summary of review */
  rating_value?: InputMaybe<Scalars['Float']['input']>;
};

export type ReviewMedia = {
  __typename?: 'ReviewMedia';
  /** alt of media */
  alt: Scalars['String']['output'];
  /**
   * Created At
   * @deprecated use created_at instead
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Created At */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** id of media */
  id: Scalars['String']['output'];
  /** key path of media */
  key: Scalars['String']['output'];
  /** Mine type of media */
  mime_type?: Maybe<Scalars['String']['output']>;
  /** review that has the media */
  review_id?: Maybe<Scalars['String']['output']>;
  /** Source of media */
  source?: Maybe<Scalars['String']['output']>;
  /** url of media */
  url?: Maybe<Scalars['String']['output']>;
};

export type ReviewOption = {
  __typename?: 'ReviewOption';
  /** Content */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * Created At
   * @deprecated use created_at instead
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Created At */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Id */
  id?: Maybe<Scalars['String']['output']>;
  /** Indicate if the user has liked this review yet */
  liked?: Maybe<Scalars['Boolean']['output']>;
  /** Post by */
  post_by?: Maybe<Scalars['String']['output']>;
  /** Status */
  status?: Maybe<Scalars['Int']['output']>;
  /** Total likes */
  total_likes?: Maybe<Scalars['Int']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ReviewReactionRequest = {
  /** like or unlike */
  reaction_type: Scalars['String']['input'];
  review_id: Scalars['String']['input'];
  /** comment or reply */
  type: Scalars['String']['input'];
};

export type ReviewReactionResponse = {
  __typename?: 'ReviewReactionResponse';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReviewTag = {
  __typename?: 'ReviewTag';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
};

export type RevokeCustomerTokenOutput = {
  __typename?: 'RevokeCustomerTokenOutput';
  result: Scalars['Boolean']['output'];
};

/** The available rule is applied for the product. */
export type Rule = {
  __typename?: 'Rule';
  /** Returns an array conditions deserialized. */
  conditions?: Maybe<Array<Maybe<Condition>>>;
  /** The description of rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** The discount amount (Get Y). */
  discount_amount?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Discount is Applied To */
  discount_qty?: Maybe<Scalars['Int']['output']>;
  /** The discount qty step (Buy X). */
  discount_step?: Maybe<Scalars['Int']['output']>;
  /** The end date of rule. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date of rule. */
  from_date?: Maybe<Scalars['String']['output']>;
  /** The label of rule. */
  label?: Maybe<Scalars['String']['output']>;
  /** Maximum discount cap (0 = no cap) */
  max_discount_amount?: Maybe<Scalars['Float']['output']>;
  /** The name of rule. */
  name?: Maybe<Scalars['String']['output']>;
  /** The ID of rule. */
  rule_id?: Maybe<Scalars['Int']['output']>;
  /** The action of rule. */
  simple_action?: Maybe<Scalars['String']['output']>;
  /** The sort order of rule. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The discard subsequent rules. */
  stop_rules_processing?: Maybe<Scalars['Int']['output']>;
  /** The url of rule. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Contains details about a comment. */
export type SalesCommentItem = {
  __typename?: 'SalesCommentItem';
  /** The text of the message. */
  message: Scalars['String']['output'];
  /** The timestamp of the comment. */
  timestamp: Scalars['String']['output'];
};

export type SalesOrderStatus = {
  __typename?: 'SalesOrderStatus';
  /** icon url */
  icon?: Maybe<Scalars['String']['output']>;
  /** label for status */
  label: Scalars['String']['output'];
  /** key for status */
  status: Scalars['String']['output'];
};

export type SalesRule = {
  __typename?: 'SalesRule';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  from_date?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_valid?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rule?: Maybe<Rule>;
  to_date?: Maybe<Scalars['String']['output']>;
};

export type Salesrule = {
  __typename?: 'Salesrule';
  code?: Maybe<Scalars['String']['output']>;
  coupon_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Int']['output']>;
  discount_qty?: Maybe<Scalars['Int']['output']>;
  discount_step?: Maybe<Scalars['Int']['output']>;
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  from_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  salesrule_id: Scalars['String']['output'];
  sort_order?: Maybe<Scalars['Int']['output']>;
  times_used?: Maybe<Scalars['Int']['output']>;
  to_date?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usage_limit?: Maybe<Scalars['Int']['output']>;
  usage_per_customer?: Maybe<Scalars['Int']['output']>;
};

/** This enumeration defines the scope type for customer orders. */
export enum ScopeTypeEnum {
  /** @deprecated  */
  Global = 'GLOBAL',
  /** @deprecated  */
  Store = 'STORE',
  /** @deprecated  */
  Website = 'WEBSITE'
}

export type ScrollDepthInternalEventInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  page_title?: InputMaybe<Scalars['String']['input']>;
  page_url?: InputMaybe<Scalars['String']['input']>;
  scroll_depth: Scalars['Int']['input'];
  scroll_percentage: Scalars['Float']['input'];
  session_id?: InputMaybe<Scalars['String']['input']>;
  time_on_page?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type ScrollDepthInternalEventRequest = {
  context?: InputMaybe<TrackingEventContextInput>;
  data?: InputMaybe<ScrollDepthInternalEventInput>;
};

export type SearchKeywordHistory = {
  __typename?: 'SearchKeywordHistory';
  /** Keyword that user have searched before */
  keyword: Scalars['String']['output'];
  /** The number of times the user searches this keyword */
  total: Scalars['Int']['output'];
};

/** SearchResultPageInfo provides navigation for the query response */
export type SearchResultPageInfo = {
  __typename?: 'SearchResultPageInfo';
  /** Specifies which page of results to return */
  current_page?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of items to return */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Total pages */
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type SearchTerm = {
  __typename?: 'SearchTerm';
  num_results?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SelectedBundleOption = {
  __typename?: 'SelectedBundleOption';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Maybe<SelectedBundleOptionValue>>;
};

export type SelectedBundleOptionValue = {
  __typename?: 'SelectedBundleOptionValue';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
};

export type SelectedCartLevelGift = {
  __typename?: 'SelectedCartLevelGift';
  /** Gift item ID */
  gift_item_id: Scalars['Int']['output'];
  /** Product image */
  image?: Maybe<Scalars['String']['output']>;
  /** Whether gift is added to Magento cart */
  is_applied_to_cart: Scalars['Boolean']['output'];
  /** Whether gift is still valid (rule still eligible) */
  is_available: Scalars['Boolean']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** Product ID */
  product_id: Scalars['Int']['output'];
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Magento quote item ID */
  quote_item_id?: Maybe<Scalars['Int']['output']>;
  /** Rule ID */
  rule_id: Scalars['Int']['output'];
  /** Rule name */
  rule_name?: Maybe<Scalars['String']['output']>;
  /** Gift SKU */
  sku: Scalars['String']['output'];
};

export type SelectedCartLevelGiftsOutput = {
  __typename?: 'SelectedCartLevelGiftsOutput';
  /** List of selected gifts */
  items: Array<SelectedCartLevelGift>;
  /** Total count */
  total_count: Scalars['Int']['output'];
};

export type SelectedConfigurableOption = {
  __typename?: 'SelectedConfigurableOption';
  id: Scalars['Int']['output'];
  option_label: Scalars['String']['output'];
  value_id: Scalars['Int']['output'];
  value_label: Scalars['String']['output'];
};

export type SelectedCustomizableOption = {
  __typename?: 'SelectedCustomizableOption';
  id: Scalars['Int']['output'];
  is_required: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  values: Array<Maybe<SelectedCustomizableOptionValue>>;
};

export type SelectedCustomizableOptionValue = {
  __typename?: 'SelectedCustomizableOptionValue';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: CartItemSelectedOptionValuePrice;
  value: Scalars['String']['output'];
};

export type SelectedGift = {
  __typename?: 'SelectedGift';
  /** Gift item ID (for removal) */
  gift_item_id: Scalars['Int']['output'];
  /** Selected quantity */
  quantity: Scalars['Int']['output'];
  /** Gift SKU */
  sku: Scalars['String']['output'];
};

export type SelectedPaymentMethod = {
  __typename?: 'SelectedPaymentMethod';
  /** The payment method code */
  code: Scalars['String']['output'];
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  /** The payment method title. */
  title: Scalars['String']['output'];
};

export type SelectedShippingMethod = {
  __typename?: 'SelectedShippingMethod';
  amount: Money;
  /** @deprecated The field should not be used on the storefront */
  base_amount?: Maybe<Money>;
  carrier_code: Scalars['String']['output'];
  carrier_title: Scalars['String']['output'];
  method_code: Scalars['String']['output'];
  method_title: Scalars['String']['output'];
};

export enum SelectionStrategy {
  Fifo = 'FIFO',
  Random = 'RANDOM'
}

export type SeoData = {
  __typename?: 'SeoData';
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  twitterCardType?: Maybe<Scalars['String']['output']>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
};

export type SetBillingAddressOnCartInput = {
  billing_address: BillingAddressInput;
  cart_id: Scalars['String']['input'];
};

export type SetBillingAddressOnCartOutput = {
  __typename?: 'SetBillingAddressOnCartOutput';
  cart: Cart;
};

export type SetGuestEmailOnCartInput = {
  cart_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type SetGuestEmailOnCartOutput = {
  __typename?: 'SetGuestEmailOnCartOutput';
  cart: Cart;
};

export type SetPaymentMethodAndPlaceOrderInput = {
  cart_id: Scalars['String']['input'];
  payment_method: PaymentMethodInput;
};

export type SetPaymentMethodOnCartInput = {
  cart_id: Scalars['String']['input'];
  payment_method: PaymentMethodInput;
};

export type SetPaymentMethodOnCartOutput = {
  __typename?: 'SetPaymentMethodOnCartOutput';
  cart: Cart;
};

export type SetShippingAddressesOnCartInput = {
  cart_id: Scalars['String']['input'];
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>;
};

export type SetShippingAddressesOnCartOutput = {
  __typename?: 'SetShippingAddressesOnCartOutput';
  cart: Cart;
};

export type SetShippingMethodsOnCartInput = {
  cart_id: Scalars['String']['input'];
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>;
};

export type SetShippingMethodsOnCartOutput = {
  __typename?: 'SetShippingMethodsOnCartOutput';
  cart: Cart;
};

export type Settings = {
  __typename?: 'Settings';
  created_at: Scalars['DateTime']['output'];
  /** id of setting */
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  /** setting data */
  options?: Maybe<SettingsOptions>;
  /** Config data get from magento */
  storeConfig?: Maybe<StoreConfiguration>;
  /** Config data get from magento */
  store_config_v2?: Maybe<StoreConfigurationV2>;
  translated_languages: Array<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  url_config?: Maybe<UrlConfigData>;
};

export type SettingsOptions = {
  __typename?: 'SettingsOptions';
  /** Contact details */
  contactDetails?: Maybe<ContactDetails>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyToWalletRatio?: Maybe<Scalars['Int']['output']>;
  /** Delivery information */
  deliveryTime?: Maybe<Array<Maybe<DeliveryTime>>>;
  freeShipping?: Maybe<Scalars['Boolean']['output']>;
  freeShippingAmount?: Maybe<Scalars['Float']['output']>;
  /** Logo of application */
  logo?: Maybe<LogoData>;
  maximumQuestionLimit?: Maybe<Scalars['Float']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Float']['output']>;
  paymentGateway?: Maybe<Scalars['String']['output']>;
  /** Default SEO data */
  seo?: Maybe<SeoData>;
  shippingClass?: Maybe<Scalars['String']['output']>;
  signupPoints?: Maybe<Scalars['Int']['output']>;
  /** Sub title of application */
  siteSubtitle?: Maybe<Scalars['String']['output']>;
  /** Title of application */
  siteTitle?: Maybe<Scalars['String']['output']>;
  taxClass?: Maybe<Scalars['String']['output']>;
  useCashOnDelivery?: Maybe<Scalars['Boolean']['output']>;
  useOtp?: Maybe<Scalars['Boolean']['output']>;
};

export type ShareChannelGroupResponse = {
  __typename?: 'ShareChannelGroupResponse';
  social_channels?: Maybe<Array<Maybe<ShareChannelItem>>>;
  utility_channels?: Maybe<Array<Maybe<ShareChannelItem>>>;
};

export type ShareChannelItem = {
  __typename?: 'ShareChannelItem';
  icon: Scalars['String']['output'];
  label: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** This enumeration defines whether bundle items must be shipped together. */
export enum ShipBundleItemsEnum {
  /** @deprecated  */
  Separately = 'SEPARATELY',
  /** @deprecated  */
  Together = 'TOGETHER'
}

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  __typename?: 'ShipmentTracking';
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String']['output'];
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']['output']>;
  /** The shipment tracking title. */
  title: Scalars['String']['output'];
};

export type ShippingAddressInput = {
  address?: InputMaybe<CartAddressInput>;
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  customer_notes?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingCartAddress = CartAddressInterface & {
  __typename?: 'ShippingCartAddress';
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** @deprecated `cart_items_v2` should be used instead */
  cart_items?: Maybe<Array<Maybe<CartItemQuantity>>>;
  cart_items_v2?: Maybe<Array<Maybe<CartItemInterface>>>;
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: CartAddressCountry;
  customer_notes?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['Int']['output']>;
  firstname: Scalars['String']['output'];
  /** @deprecated This information shoud not be exposed on frontend */
  items_weight?: Maybe<Scalars['Float']['output']>;
  lastname: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  selected_shipping_method?: Maybe<SelectedShippingMethod>;
  street: Array<Maybe<Scalars['String']['output']>>;
  telephone: Scalars['String']['output'];
  ward?: Maybe<Scalars['String']['output']>;
  ward_id?: Maybe<Scalars['Int']['output']>;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  __typename?: 'ShippingDiscount';
  /** The amount of the discount. */
  amount: Money;
};

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  __typename?: 'ShippingHandling';
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<Money>;
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<Money>;
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The total amount for shipping. */
  total_amount: Money;
};

export type ShippingMethodInput = {
  carrier_code: Scalars['String']['input'];
  method_code: Scalars['String']['input'];
};

/** Represents a shortcut link entity with its unique properties and identifiers. */
export type ShortcutLink = {
  __typename?: 'ShortcutLink';
  /** Icon associated with the shortcut link. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the shortcut link. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The status of shortcut link. */
  is_active?: Maybe<Scalars['Int']['output']>;
  /** The list of location to show shortcut link. */
  location?: Maybe<Scalars['String']['output']>;
  /** Name of the shortcut link. */
  name?: Maybe<Scalars['String']['output']>;
  /** Position of the shortcut link, used for ordering. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The store ids to show shortcut link. */
  store_ids?: Maybe<Scalars['String']['output']>;
  /** URL for the shortcut link. */
  url?: Maybe<Scalars['String']['output']>;
};

export enum ShortcutLinkLocation {
  CatalogPage = 'CATALOG_PAGE',
  CmsPage = 'CMS_PAGE',
  FlashSale = 'FLASH_SALE',
  Homepage = 'HOMEPAGE',
  MyAccount = 'MY_ACCOUNT',
  ProductPage = 'PRODUCT_PAGE'
}

/** Represents a shortcut link entity with its unique properties and identifiers. */
export type ShortcutLinkV2 = {
  __typename?: 'ShortcutLinkV2';
  /** Icon associated with the shortcut link. */
  icon: Scalars['String']['output'];
  /** Unique identifier for the shortcut link. */
  id: Scalars['ID']['output'];
  /** The status of shortcut link. */
  is_active: Scalars['Int']['output'];
  /** The list of location to show shortcut link. */
  location?: Maybe<Scalars['String']['output']>;
  /** Name of the shortcut link. */
  name: Scalars['String']['output'];
  /** Position of the shortcut link, used for ordering. */
  position: Scalars['Int']['output'];
  /** The corresponding shortcut link identifier in Magento. */
  shortcut_link_id: Scalars['Int']['output'];
  /** The store ids to show shortcut link. */
  store_ids: Scalars['String']['output'];
  /** URL for the shortcut link. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Simple Cart Item */
export type SimpleCartItem = CartItemInterface & {
  __typename?: 'SimpleCartItem';
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** Simple Local Cart Item */
export type SimpleLocalCartItem = LocalCartItemInterface & {
  __typename?: 'SimpleLocalCartItem';
  cart_item_reference_id: Scalars['String']['output'];
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  local_id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** A simple product is tangible and are usually sold as single units or in fixed quantities. */
export type SimpleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & {
  __typename?: 'SimpleProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  sold_quantity?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type SimpleProductCartItemInput = {
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
};

export type SocialChannel = {
  __typename?: 'SocialChannel';
  icon?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Defines sorting direction. */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** This enumeration indicates whether to return results in ascending or descending order */
export enum SortEnum {
  /** @deprecated  */
  Asc = 'ASC',
  /** @deprecated  */
  Desc = 'DESC'
}

export type SortField = {
  __typename?: 'SortField';
  /** Label of sort field. */
  label?: Maybe<Scalars['String']['output']>;
  /** Attribute code of sort field. */
  value?: Maybe<Scalars['String']['output']>;
};

/** SortFields contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields';
  /** Default value of sort fields. */
  default?: Maybe<Scalars['String']['output']>;
  /** Available sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>;
};

export type SortOptions = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type SortingInput = {
  sort_direction?: InputMaybe<SortDirection>;
  sort_field?: InputMaybe<Scalars['String']['input']>;
};

export type StaticWidget = ContentFragmentDataInterface & {
  __typename?: 'StaticWidget';
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type StatusMessageResponse = {
  __typename?: 'StatusMessageResponse';
  /** Describe the outcome of the delete action */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicate if the delete action was successful */
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StockStatus = {
  __typename?: 'StockStatus';
  /** error code: 102 - out of stock, 103 - lack of quantity */
  code: Scalars['Int']['output'];
  /** available product quantity */
  current_available: Scalars['Int']['output'];
  /** stock status error message */
  message: Scalars['String']['output'];
};

/** The type contains information about a store config */
export type StoreConfig = {
  __typename?: 'StoreConfig';
  /** Footer Miscellaneous HTML */
  absolute_footer?: Maybe<Scalars['String']['output']>;
  /** Base currency code */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** Base link URL for the store */
  base_link_url?: Maybe<Scalars['String']['output']>;
  /** Base media URL for the store */
  base_media_url?: Maybe<Scalars['String']['output']>;
  /** Base static URL for the store */
  base_static_url?: Maybe<Scalars['String']['output']>;
  /** Base URL for the store */
  base_url?: Maybe<Scalars['String']['output']>;
  /** Default Sort By. */
  catalog_default_sort_by?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices In Product Lists' field. It indicates how FPT information is displayed on category pages */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Category URL Suffix. */
  category_url_suffix?: Maybe<Scalars['String']['output']>;
  /** CMS Home Page */
  cms_home_page?: Maybe<Scalars['String']['output']>;
  /** CMS No Cookies Page */
  cms_no_cookies?: Maybe<Scalars['String']['output']>;
  /** CMS No Route Page */
  cms_no_route?: Maybe<Scalars['String']['output']>;
  /** A code assigned to the store to identify it */
  code?: Maybe<Scalars['String']['output']>;
  /** Copyright */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Default Meta Description */
  default_description?: Maybe<Scalars['String']['output']>;
  /** Default display currency code */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** Default Meta Keywords */
  default_keywords?: Maybe<Scalars['String']['output']>;
  /** Default Page Title */
  default_title?: Maybe<Scalars['String']['output']>;
  /** Display Demo Store Notice */
  demonotice?: Maybe<Scalars['Int']['output']>;
  /** Default Web URL */
  front?: Maybe<Scalars['String']['output']>;
  /** Products per Page on Grid Default Value. */
  grid_per_page?: Maybe<Scalars['Int']['output']>;
  /** Products per Page on Grid Allowed Values. */
  grid_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Scripts and Style Sheets */
  head_includes?: Maybe<Scalars['String']['output']>;
  /** Favicon Icon */
  head_shortcut_icon?: Maybe<Scalars['String']['output']>;
  /** Logo Image */
  header_logo_src?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the store */
  id?: Maybe<Scalars['Int']['output']>;
  /** List Mode. */
  list_mode?: Maybe<Scalars['String']['output']>;
  /** Products per Page on List Default Value. */
  list_per_page?: Maybe<Scalars['Int']['output']>;
  /** Products per Page on List Allowed Values. */
  list_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Store locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** Logo Image Alt */
  logo_alt?: Maybe<Scalars['String']['output']>;
  /** Logo Attribute Height */
  logo_height?: Maybe<Scalars['Int']['output']>;
  /** Logo Attribute Width */
  logo_width?: Maybe<Scalars['Int']['output']>;
  /** Default No-route URL */
  no_route?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices On Product View Page' field. It indicates how FPT information is displayed on product pages */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Product URL Suffix. */
  product_url_suffix?: Maybe<Scalars['String']['output']>;
  /** The ID of the root category */
  root_category_id?: Maybe<Scalars['Int']['output']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field. It indicates how FPT information is displayed on cart, checkout, and order pages */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Secure base link URL for the store */
  secure_base_link_url?: Maybe<Scalars['String']['output']>;
  /** Secure base media URL for the store */
  secure_base_media_url?: Maybe<Scalars['String']['output']>;
  /** Secure base static URL for the store */
  secure_base_static_url?: Maybe<Scalars['String']['output']>;
  /** Secure base URL for the store */
  secure_base_url?: Maybe<Scalars['String']['output']>;
  /** Show Breadcrumbs for CMS Pages */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']['output']>;
  /** Name of the store */
  store_name?: Maybe<Scalars['String']['output']>;
  /** Timezone of the store */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Page Title Prefix */
  title_prefix?: Maybe<Scalars['String']['output']>;
  /** Page Title Separator. */
  title_separator?: Maybe<Scalars['String']['output']>;
  /** Page Title Suffix */
  title_suffix?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the website store belongs */
  website_id?: Maybe<Scalars['Int']['output']>;
  /** The unit of weight */
  weight_unit?: Maybe<Scalars['String']['output']>;
  /** Welcome Text */
  welcome?: Maybe<Scalars['String']['output']>;
};

/** The type contains information about a store config */
export type StoreConfiguration = {
  __typename?: 'StoreConfiguration';
  /** Footer Miscellaneous HTML */
  absolute_footer?: Maybe<Scalars['String']['output']>;
  /** Base currency code */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** Base link URL for the store */
  base_link_url?: Maybe<Scalars['String']['output']>;
  /** Base media URL for the store */
  base_media_url?: Maybe<Scalars['String']['output']>;
  /** Base static URL for the store */
  base_static_url?: Maybe<Scalars['String']['output']>;
  /** Base URL for the store */
  base_url?: Maybe<Scalars['String']['output']>;
  /** Max quantity per item in the cart. */
  cart_max_qty_per_item?: Maybe<Scalars['Int']['output']>;
  /** Min quantity per item in the cart. */
  cart_min_qty_per_item?: Maybe<Scalars['Int']['output']>;
  /** Default Sort By. */
  catalog_default_sort_by?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices In Product Lists' field. It indicates how FPT information is displayed on category pages */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySetting>;
  /** Category URL Suffix. */
  category_url_suffix?: Maybe<Scalars['String']['output']>;
  /** CMS Home Page */
  cms_home_page?: Maybe<Scalars['String']['output']>;
  /** CMS No Cookies Page */
  cms_no_cookies?: Maybe<Scalars['String']['output']>;
  /** CMS No Route Page */
  cms_no_route?: Maybe<Scalars['String']['output']>;
  /** CMS Promotion Page */
  cms_promotion_page?: Maybe<Scalars['String']['output']>;
  /** A code assigned to the store to identify it */
  code?: Maybe<Scalars['String']['output']>;
  /** Copyright */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Default Meta Description */
  default_description?: Maybe<Scalars['String']['output']>;
  /** Default display currency code */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** Default Meta Keywords */
  default_keywords?: Maybe<Scalars['String']['output']>;
  /** Default Page Title */
  default_title?: Maybe<Scalars['String']['output']>;
  /** Display Demo Store Notice */
  demonotice?: Maybe<Scalars['Int']['output']>;
  /** Default Web URL */
  front?: Maybe<Scalars['String']['output']>;
  /** Products per Page on Grid Default Value. */
  grid_per_page?: Maybe<Scalars['Int']['output']>;
  /** Products per Page on Grid Allowed Values. */
  grid_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Scripts and Style Sheets */
  head_includes?: Maybe<Scalars['String']['output']>;
  /** Favicon Icon */
  head_shortcut_icon?: Maybe<Scalars['String']['output']>;
  /** Logo Image */
  header_logo_src?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the store */
  id?: Maybe<Scalars['Int']['output']>;
  /** List Mode. */
  list_mode?: Maybe<Scalars['String']['output']>;
  /** Products per Page on List Default Value. */
  list_per_page?: Maybe<Scalars['Int']['output']>;
  /** Products per Page on List Allowed Values. */
  list_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Store locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** Logo Image Alt */
  logo_alt?: Maybe<Scalars['String']['output']>;
  /** Logo Attribute Height */
  logo_height?: Maybe<Scalars['Int']['output']>;
  /** Logo Attribute Width */
  logo_width?: Maybe<Scalars['Int']['output']>;
  /** Default No-route URL */
  no_route?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices On Product View Page' field. It indicates how FPT information is displayed on product pages */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySetting>;
  /** Product URL Suffix. */
  product_url_suffix?: Maybe<Scalars['String']['output']>;
  /** The ID of the root category */
  root_category_id?: Maybe<Scalars['Int']['output']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field. It indicates how FPT information is displayed on cart, checkout, and order pages */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySetting>;
  /** Returns the placeholder text shown in the search input field. */
  search_placeholder?: Maybe<Scalars['String']['output']>;
  /** Secure base link URL for the store */
  secure_base_link_url?: Maybe<Scalars['String']['output']>;
  /** Secure base media URL for the store */
  secure_base_media_url?: Maybe<Scalars['String']['output']>;
  /** Secure base static URL for the store */
  secure_base_static_url?: Maybe<Scalars['String']['output']>;
  /** Secure base URL for the store */
  secure_base_url?: Maybe<Scalars['String']['output']>;
  /** Show Breadcrumbs for CMS Pages */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']['output']>;
  /** Name of the store */
  store_name?: Maybe<Scalars['String']['output']>;
  /** Timezone of the store */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Page Title Prefix */
  title_prefix?: Maybe<Scalars['String']['output']>;
  /** Page Title Separator. */
  title_separator?: Maybe<Scalars['String']['output']>;
  /** Page Title Suffix */
  title_suffix?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the website store belongs */
  website_id?: Maybe<Scalars['Int']['output']>;
  /** The unit of weight */
  weight_unit?: Maybe<Scalars['String']['output']>;
  /** Welcome Text */
  welcome?: Maybe<Scalars['String']['output']>;
};

export type StoreConfigurationV2 = {
  __typename?: 'StoreConfigurationV2';
  app_config?: Maybe<AppConfiguration>;
  magento_graphql_url?: Maybe<Scalars['String']['output']>;
  review_service_graphql_url?: Maybe<Scalars['String']['output']>;
};

export type StoreLocator = {
  __typename?: 'StoreLocator';
  /** The description of store. */
  description?: Maybe<Scalars['String']['output']>;
  /** The district id of store. */
  district_id?: Maybe<Scalars['Int']['output']>;
  /** The is coming soon of store. */
  is_coming_soon?: Maybe<Scalars['Boolean']['output']>;
  /** The is new of store. */
  is_new?: Maybe<Scalars['Boolean']['output']>;
  /** The latitude of store. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude of store. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The name of store. */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone of store. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The district id of store. */
  region_id?: Maybe<Scalars['Int']['output']>;
  /** The store image of store. */
  store_image?: Maybe<Scalars['String']['output']>;
  /** The street of store. */
  street?: Maybe<Scalars['String']['output']>;
};

export type StoreRegion = {
  __typename?: 'StoreRegion';
  /** The code of region. */
  code?: Maybe<Scalars['String']['output']>;
  /** The id of region. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of region. */
  name?: Maybe<Scalars['String']['output']>;
  /** The number of stores in region. */
  num_of_stores?: Maybe<Scalars['Int']['output']>;
};

export type StoreRegions = {
  __typename?: 'StoreRegions';
  /** The identifier for cache. */
  id?: Maybe<Scalars['String']['output']>;
  /** An array regions that have Kids Plaza stores. */
  items?: Maybe<Array<Maybe<StoreRegion>>>;
};

export type StorefrontAllocation = {
  __typename?: 'StorefrontAllocation';
  allocation_code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_locations?: Maybe<Array<Scalars['String']['output']>>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  magento_conditions?: Maybe<Scalars['JSON']['output']>;
  magento_pool_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  remaining_allocation_quota?: Maybe<Scalars['Int']['output']>;
  remaining_user_quota?: Maybe<Scalars['Int']['output']>;
  sample_amount?: Maybe<Scalars['Float']['output']>;
  start_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StoresLocator = {
  __typename?: 'StoresLocator';
  /** The identifier for cache. */
  id?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<StoreLocator>>>;
};

export type SuggestionSearchCategory = {
  __typename?: 'SuggestionSearchCategory';
  breadcrumb?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SuggestionSearchProduct = {
  __typename?: 'SuggestionSearchProduct';
  final_price?: Maybe<Money>;
  image?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** suggestSearch input and response */
export type SuggestionSearchResponse = {
  __typename?: 'SuggestionSearchResponse';
  categories: Array<SuggestionSearchCategory>;
  products: Array<SuggestionSearchProduct>;
  terms: Array<SuggestionSearchTerm>;
};

export type SuggestionSearchTerm = {
  __typename?: 'SuggestionSearchTerm';
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SupportMenuAction = {
  __typename?: 'SupportMenuAction';
  type: SupportMenuActionType;
  value?: Maybe<Scalars['String']['output']>;
};

export enum SupportMenuActionType {
  Call = 'CALL',
  Navigate = 'NAVIGATE',
  OpenBottomSheet = 'OPEN_BOTTOM_SHEET',
  RequestCancel = 'REQUEST_CANCEL'
}

export type SupportMenuItem = {
  __typename?: 'SupportMenuItem';
  id: Scalars['ID']['output'];
  left_icon?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  menu_label?: Maybe<Scalars['String']['output']>;
  right_icon?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  support_menu_action?: Maybe<SupportMenuAction>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SwatchData = {
  __typename?: 'SwatchData';
  /** Type of swatch filter item: 1 - text, 2 - image */
  type?: Maybe<Scalars['String']['output']>;
  /** Value for swatch item (text or image link) */
  value?: Maybe<Scalars['String']['output']>;
};

export type SwatchDataInterface = {
  /** Value of swatch item (HEX color code, image link or textual value) */
  value?: Maybe<Scalars['String']['output']>;
};

export type SwatchLayerFilterItem = LayerFilterItemInterface & SwatchLayerFilterItemInterface & {
  __typename?: 'SwatchLayerFilterItem';
  /**
   * Count of items by filter.
   * @deprecated Use AggregationOption.count instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Filter label.
   * @deprecated Use AggregationOption.label instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /** Data required to render swatch filter item */
  swatch_data?: Maybe<SwatchData>;
  /**
   * Value for filter request variable to be used in query.
   * @deprecated Use AggregationOption.value instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

export type SwatchLayerFilterItemInterface = {
  /** Data required to render swatch filter item */
  swatch_data?: Maybe<SwatchData>;
};

export enum SyncStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type SynchronizeCartInput = {
  /** The masked cart ID */
  cart_id: Scalars['String']['input'];
  /** Complete desired state of cart items */
  items: Array<CartSyncItemInput>;
};

export type SynchronizeCartPayload = {
  __typename?: 'SynchronizeCartPayload';
  /** The synchronized cart */
  cart: Cart;
  /** Per-item errors for client-side display at cart line level. Present when individual items fail but others succeed (partial success). */
  item_errors?: Maybe<Array<CartSyncItemError>>;
};

/** Tag information. */
export type Tag = {
  __typename?: 'Tag';
  /** The created at of tag. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The identifier of tag. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** The meta description at of tag. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** The updated at of tag. */
  modified_at?: Maybe<Scalars['String']['output']>;
  /** The number products of tag. */
  number_products?: Maybe<Scalars['Int']['output']>;
  /** The products are assigned for tag. */
  products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The status of tag. */
  status?: Maybe<Scalars['Int']['output']>;
  /** The description of tag. */
  tag_description?: Maybe<Scalars['String']['output']>;
  /** The ID of tag. */
  tag_id?: Maybe<Scalars['Int']['output']>;
  /** The title of tag. */
  tag_title?: Maybe<Scalars['String']['output']>;
  /** The url of tag. */
  tag_url?: Maybe<Scalars['String']['output']>;
};

/** Contains tax item details. */
export type TaxItem = {
  __typename?: 'TaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The rate used to calculate the tax. */
  rate: Scalars['Float']['output'];
  /** A title that describes the tax. */
  title: Scalars['String']['output'];
};

export type TermsOfService = {
  __typename?: 'TermsOfService';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TextSwatchData = SwatchDataInterface & {
  __typename?: 'TextSwatchData';
  /** Value of swatch item (HEX color code, image link or textual value) */
  value?: Maybe<Scalars['String']['output']>;
};

/** A price based on the quantity purchased. */
export type TierPrice = {
  __typename?: 'TierPrice';
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>;
  final_price?: Maybe<Money>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type TrackEventInput = {
  eventData: EventDataInput;
  /** type of event */
  eventName: EventTypeEnum;
};

export type TrackEventResult = {
  __typename?: 'TrackEventResult';
  /** Id of event tracking */
  id?: Maybe<Scalars['String']['output']>;
  /** Error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Status of request */
  success: Scalars['Boolean']['output'];
};

export type TrackingEventContextInput = {
  app_instance_id?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  screen?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum TypeNotificationEnum {
  Order = 'ORDER',
  Promotion = 'PROMOTION',
  System = 'SYSTEM'
}

export type UniversalLinkEntity = {
  __typename?: 'UniversalLinkEntity';
  params?: Maybe<UniversalLinkParamsInterface>;
  screen_name?: Maybe<Scalars['String']['output']>;
};

export type UniversalLinkEntityParams = UniversalLinkParamsInterface & {
  __typename?: 'UniversalLinkEntityParams';
  /** The canonical_url field is deprecated, use relative_url instead. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID. */
  id?: Maybe<Scalars['Int']['output']>;
  /** 301 or 302 HTTP code for url permanent or temporary redirect or 0 for the 200 no redirect */
  redirect_code?: Maybe<Scalars['Int']['output']>;
  /** The internal relative URL. If the specified  url is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  /** The ID is encoded. */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type UniversalLinkOrderParams = UniversalLinkParamsInterface & {
  __typename?: 'UniversalLinkOrderParams';
  /** The increment_id of the order. */
  increment_id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UniversalLinkParams = UniversalLinkParamsInterface & {
  __typename?: 'UniversalLinkParams';
  url?: Maybe<Scalars['String']['output']>;
};

export type UniversalLinkParamsInterface = {
  /** The URL info. */
  url?: Maybe<Scalars['String']['output']>;
};

export type UniversalLinkProductCollectionParams = UniversalLinkParamsInterface & {
  __typename?: 'UniversalLinkProductCollectionParams';
  /** The block type of the highlight block. */
  block_type?: Maybe<BlockTypeEnum>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UniversalLinkSearchParams = UniversalLinkParamsInterface & {
  __typename?: 'UniversalLinkSearchParams';
  /** The keyword search. */
  q?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UpdateAllocationInput = {
  allocation_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_end_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_locations?: InputMaybe<Array<DisplayLocation>>;
  display_start_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_status?: InputMaybe<DisplayStatus>;
  expires_at?: InputMaybe<Scalars['DateTime']['input']>;
  max_allocation_usages?: InputMaybe<Scalars['Int']['input']>;
  max_user_usages?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_at?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AllocationStatus>;
};

export type UpdateCartItemsInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<CartItemUpdateInput>>;
};

export type UpdateCartItemsOutput = {
  __typename?: 'UpdateCartItemsOutput';
  cart: Cart;
};

export type UpdateCustomerAccountDeletionStatusInput = {
  /** New status */
  status: AccountDeletionStatus;
};

export type UrlConfigData = {
  __typename?: 'UrlConfigData';
  magento_graphql_url?: Maybe<Scalars['String']['output']>;
  review_service_graphql_url?: Maybe<Scalars['String']['output']>;
};

/** The object contains URL rewrite details */
export type UrlRewrite = {
  __typename?: 'UrlRewrite';
  /** Request parameters */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>;
  /** Request URL */
  url?: Maybe<Scalars['String']['output']>;
};

/** This enumeration defines the entity type. */
export enum UrlRewriteEntityTypeEnum {
  /** @deprecated  */
  Category = 'CATEGORY',
  /** @deprecated  */
  CmsPage = 'CMS_PAGE',
  /** @deprecated  */
  CustomPage = 'CUSTOM_PAGE',
  /** @deprecated  */
  Product = 'PRODUCT'
}

export type UserDataInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type ValidateCouponsInput = {
  /** The mask id of cart. */
  cart_id: Scalars['String']['input'];
  /** An array of coupon codes. */
  coupon_code: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ValidatePhoneAndOtpResponse = {
  __typename?: 'ValidatePhoneAndOtpResponse';
  /** Message */
  message: Scalars['String']['output'];
  /** Success */
  success: Scalars['Boolean']['output'];
};

export enum ValidatePhoneType {
  /** Validate phone number for login */
  Login = 'LOGIN',
  /** Validate phone number for signup */
  Register = 'REGISTER'
}

/** Input type to get look up user */
export type VerifyEventUserUpdateSecretInput = {
  /** Event id */
  event_id: Scalars['ID']['input'];
  /** Phone number of user */
  phone_number: Scalars['String']['input'];
  /** Event id */
  secret: Scalars['String']['input'];
};

/** Virtual Cart Item */
export type VirtualCartItem = CartItemInterface & {
  __typename?: 'VirtualCartItem';
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** Virtual Local Cart Item */
export type VirtualLocalCartItem = LocalCartItemInterface & {
  __typename?: 'VirtualLocalCartItem';
  cart_item_reference_id: Scalars['String']['output'];
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  local_id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** A virtual product is non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = CustomizableProductInterface & ProductInterface & {
  __typename?: 'VirtualProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type VirtualProductCartItemInput = {
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
};

export type Voucher = {
  __typename?: 'Voucher';
  allocation?: Maybe<VoucherAllocation>;
  amount: Scalars['Float']['output'];
  applied_at?: Maybe<Scalars['DateTime']['output']>;
  campaign?: Maybe<VoucherCampaign>;
  campaign_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  customer_contact_no?: Maybe<Scalars['String']['output']>;
  erp_created_by_receipt_no?: Maybe<Scalars['String']['output']>;
  erp_created_in_store_no?: Maybe<Scalars['String']['output']>;
  erp_replication_counter?: Maybe<Scalars['Int']['output']>;
  erp_reserved_by_pos_no?: Maybe<Scalars['String']['output']>;
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initial_amount: Scalars['Float']['output'];
  start_at: Scalars['DateTime']['output'];
  status: VoucherStatus;
  updated_at: Scalars['DateTime']['output'];
  usage_logs?: Maybe<Array<VoucherUsageLog>>;
  usage_type: VoucherUsageType;
  voucher_code: Scalars['String']['output'];
};

export type VoucherAllocation = {
  __typename?: 'VoucherAllocation';
  allocation_code: Scalars['String']['output'];
  available_voucher_count?: Maybe<Scalars['Int']['output']>;
  campaign?: Maybe<VoucherCampaign>;
  campaign_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  current_usage_count: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_end_at?: Maybe<Scalars['DateTime']['output']>;
  display_locations?: Maybe<Array<Scalars['String']['output']>>;
  display_start_at?: Maybe<Scalars['DateTime']['output']>;
  display_status: DisplayStatus;
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  magento_conditions?: Maybe<Scalars['JSON']['output']>;
  magento_pool_id?: Maybe<Scalars['String']['output']>;
  max_allocation_usages?: Maybe<Scalars['Int']['output']>;
  max_user_usages?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  start_at: Scalars['DateTime']['output'];
  status: AllocationStatus;
  sync_status: SyncStatus;
  synced_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
  voucher_count?: Maybe<Scalars['Int']['output']>;
};

export type VoucherCampaign = {
  __typename?: 'VoucherCampaign';
  available_voucher_count?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unallocated_voucher?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  voucher_count?: Maybe<Scalars['Int']['output']>;
  vouchers?: Maybe<Array<Voucher>>;
};

export enum VoucherDisplayType {
  Allocation = 'ALLOCATION',
  Manual = 'MANUAL'
}

export type VoucherFilterInput = {
  allocation_id?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  applied_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  applied_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  campaign_code?: InputMaybe<Scalars['String']['input']>;
  created_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  expires_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  expires_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  initial_amount?: InputMaybe<Scalars['Int']['input']>;
  start_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<VoucherStatus>;
  updated_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  voucher_code?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherHistory = {
  __typename?: 'VoucherHistory';
  action_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  raw_payload?: Maybe<Scalars['String']['output']>;
  request_id: Scalars['String']['output'];
  status?: Maybe<MarketingRequestLogStatus>;
  updated_at: Scalars['DateTime']['output'];
  voucher_code: Scalars['String']['output'];
};

export type VoucherHistoryFilterInput = {
  created_at_from?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_to?: InputMaybe<Scalars['DateTime']['input']>;
  request_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MarketingRequestLogStatus>;
  voucher_code?: InputMaybe<Scalars['String']['input']>;
  voucher_id?: InputMaybe<Scalars['String']['input']>;
};

export enum VoucherStatus {
  Abnormal = 'ABNORMAL',
  Applied = 'APPLIED',
  Available = 'AVAILABLE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Locking = 'LOCKING',
  Reserved = 'RESERVED',
  Used = 'USED'
}

export type VoucherUsageInput = {
  applied_amount: Scalars['Float']['input'];
  order_id: Scalars['String']['input'];
  platform: VoucherUsagePlatform;
  voucher_code: Scalars['String']['input'];
};

export type VoucherUsageLog = {
  __typename?: 'VoucherUsageLog';
  applied_amount: Scalars['Float']['output'];
  applied_at: Scalars['DateTime']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  order_id: Scalars['String']['output'];
  platform?: Maybe<Scalars['String']['output']>;
  request_id: Scalars['ID']['output'];
  voucher?: Maybe<Voucher>;
  voucher_id: Scalars['ID']['output'];
};

export enum VoucherUsagePlatform {
  Erp = 'ERP',
  Magento = 'MAGENTO'
}

export enum VoucherUsageType {
  MultiUse = 'MULTI_USE',
  SingleUse = 'SINGLE_USE'
}

export type Ward = {
  __typename?: 'Ward';
  district_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region_id?: Maybe<Scalars['Int']['output']>;
};

/** Website is deprecated because it is should not be used on storefront. The type contains information about a website */
export type Website = {
  __typename?: 'Website';
  /**
   * A code assigned to the website to identify it
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * The default group ID that the website has
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the website
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /**
   * Specifies if this is the default website
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute to use for sorting websites
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** Represents a widget containing a collection of shortcut links. */
export type WidgetShortcutLink = {
  __typename?: 'WidgetShortcutLink';
  /** A list of shortcut links. */
  items?: Maybe<Array<Maybe<ShortcutLink>>>;
};

/** Represents a widget containing a collection of shortcut links. */
export type WidgetShortcutLinkV2 = {
  __typename?: 'WidgetShortcutLinkV2';
  /** A list of shortcut links. */
  items?: Maybe<Array<ShortcutLinkV2>>;
};

export type Wishlist = {
  __typename?: 'Wishlist';
  /** Wishlist unique identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** An array of items in the customer's wish list */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /** The number of items in the wish list */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** An encrypted code that Magento uses to link to the wish list */
  sharing_code?: Maybe<Scalars['String']['output']>;
  /** The time of the last modification to the wish list */
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type WishlistItem = {
  __typename?: 'WishlistItem';
  /** The time when the customer added the item to the wish list */
  added_at?: Maybe<Scalars['String']['output']>;
  /** The customer's comment about this item */
  description?: Maybe<Scalars['String']['output']>;
  /** The wish list item ID */
  id?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']['output']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;


/** Mapping of interface types */
export type ResolversInterfaceTypes<RefType extends Record<string, unknown>> = {
  AggregationOptionInterface: ( AggregationOption );
  CartAddressInterface: ( BillingCartAddress ) | ( ShippingCartAddress );
  CartItemInterface: ( BundleCartItem ) | ( ConfigurableCartItem ) | ( DownloadableCartItem ) | ( SimpleCartItem ) | ( VirtualCartItem );
  CategoryInterface: ( CategoryTree );
  ContentFragmentDataInterface: ( CatalogProductsListWidget ) | ( CompositeImageWidget ) | ( FlashSaleWidget ) | ( HtmlWidget ) | ( IframeWidget ) | ( ImageWidget ) | ( StaticWidget );
  CreditMemoItemInterface: never;
  CustomizableOptionInterface: never;
  CustomizableProductInterface: ( BundleProduct ) | ( ConfigurableProduct ) | ( DownloadableProduct ) | ( SimpleProduct ) | ( VirtualProduct );
  InvoiceItemInterface: never;
  LayerFilterItemInterface: ( SwatchLayerFilterItem );
  LocalCartItemInterface: ( ConfigurableLocalCartItem ) | ( DownloadableLocalCartItem ) | ( SimpleLocalCartItem ) | ( VirtualLocalCartItem );
  MediaGalleryInterface: ( ProductImage ) | ( ProductVideo );
  NotificationPayload: ( NotificationOrderData ) | ( NotificationPromotionData );
  OrderItemInterface: ( OrderItem );
  PhysicalProductInterface: ( BundleProduct ) | ( ConfigurableProduct ) | ( GroupedProduct ) | ( SimpleProduct );
  ProductInterface: ( BundleProduct ) | ( ConfigurableProduct ) | ( DownloadableProduct ) | ( GroupedProduct ) | ( SimpleProduct ) | ( VirtualProduct );
  ProductLinksInterface: never;
  ShipmentItemInterface: never;
  SwatchDataInterface: ( ColorSwatchData ) | ( ImageSwatchData ) | ( TextSwatchData );
  SwatchLayerFilterItemInterface: ( SwatchLayerFilterItem );
  UniversalLinkParamsInterface: ( UniversalLinkEntityParams ) | ( UniversalLinkOrderParams ) | ( UniversalLinkParams ) | ( UniversalLinkProductCollectionParams ) | ( UniversalLinkSearchParams );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AccountDeletionStatus: AccountDeletionStatus;
  Achievement: ResolverTypeWrapper<Achievement>;
  ActionType: ActionType;
  AddBundleProductsToCartInput: AddBundleProductsToCartInput;
  AddBundleProductsToCartOutput: ResolverTypeWrapper<AddBundleProductsToCartOutput>;
  AddCartLevelGiftsInput: AddCartLevelGiftsInput;
  AddCartLevelGiftsOutput: ResolverTypeWrapper<AddCartLevelGiftsOutput>;
  AddConfigurableProductsToCartInput: AddConfigurableProductsToCartInput;
  AddConfigurableProductsToCartOutput: ResolverTypeWrapper<AddConfigurableProductsToCartOutput>;
  AddDownloadableProductsToCartInput: AddDownloadableProductsToCartInput;
  AddDownloadableProductsToCartOutput: ResolverTypeWrapper<AddDownloadableProductsToCartOutput>;
  AddGiftsToCartInput: AddGiftsToCartInput;
  AddGiftsToCartOutput: ResolverTypeWrapper<AddGiftsToCartOutput>;
  AddProductToWishlistInput: AddProductToWishlistInput;
  AddSimpleProductsToCartInput: AddSimpleProductsToCartInput;
  AddSimpleProductsToCartOutput: ResolverTypeWrapper<AddSimpleProductsToCartOutput>;
  AddToCartContentInput: AddToCartContentInput;
  AddToCartErrorInternalEventInput: AddToCartErrorInternalEventInput;
  AddToCartErrorInternalEventRequest: AddToCartErrorInternalEventRequest;
  AddToCartEventInput: AddToCartEventInput;
  AddToCartTrackingEventRequest: AddToCartTrackingEventRequest;
  AddVirtualProductsToCartInput: AddVirtualProductsToCartInput;
  AddVirtualProductsToCartOutput: ResolverTypeWrapper<AddVirtualProductsToCartOutput>;
  AdditionalDataAttribute: ResolverTypeWrapper<AdditionalDataAttribute>;
  AddressTypeEnum: AddressTypeEnum;
  AdminAnswered: ResolverTypeWrapper<AdminAnswered>;
  Aggregation: ResolverTypeWrapper<Aggregation>;
  AggregationOption: ResolverTypeWrapper<AggregationOption>;
  AggregationOptionInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AggregationOptionInterface']>;
  AllocationFilterInput: AllocationFilterInput;
  AllocationStatus: AllocationStatus;
  Answer: ResolverTypeWrapper<Answer>;
  AnswerRequest: AnswerRequest;
  ApiErrorInternalEventInput: ApiErrorInternalEventInput;
  ApiErrorInternalEventRequest: ApiErrorInternalEventRequest;
  AppBannerConfig: ResolverTypeWrapper<AppBannerConfig>;
  AppConfiguration: ResolverTypeWrapper<AppConfiguration>;
  AppliedCodeData: ResolverTypeWrapper<AppliedCodeData>;
  AppliedCodeType: AppliedCodeType;
  AppliedCodesResponse: ResolverTypeWrapper<AppliedCodesResponse>;
  AppliedCoupon: ResolverTypeWrapper<AppliedCoupon>;
  AppliedUniversalCode: ResolverTypeWrapper<AppliedUniversalCode>;
  AppliedVoucher: ResolverTypeWrapper<AppliedVoucher>;
  ApplyCodeResponse: ResolverTypeWrapper<ApplyCodeResponse>;
  ApplyCouponToCartInput: ApplyCouponToCartInput;
  ApplyCouponToCartOutput: ResolverTypeWrapper<ApplyCouponToCartOutput>;
  ApplyKicoinsInput: ApplyKicoinsInput;
  ApplyKicoinsOutput: ResolverTypeWrapper<ApplyKicoinsOutput>;
  ApplyUniversalCodeInput: ApplyUniversalCodeInput;
  ApplyUniversalCodePayload: ResolverTypeWrapper<ApplyUniversalCodePayload>;
  ApplyVoucherResponse: ResolverTypeWrapper<ApplyVoucherResponse>;
  AssignVouchersInput: AssignVouchersInput;
  AssignVouchersResult: ResolverTypeWrapper<AssignVouchersResult>;
  Attribute: ResolverTypeWrapper<Attribute>;
  AttributeInput: AttributeInput;
  AttributeOption: ResolverTypeWrapper<AttributeOption>;
  AuthErrorInternalEventInput: AuthErrorInternalEventInput;
  AuthErrorInternalEventRequest: AuthErrorInternalEventRequest;
  AvailableGifts: ResolverTypeWrapper<AvailableGifts>;
  AvailableGiftsCart: ResolverTypeWrapper<AvailableGiftsCart>;
  AvailableOrderHistoryStatuses: ResolverTypeWrapper<AvailableOrderHistoryStatuses>;
  AvailablePaymentMethod: ResolverTypeWrapper<AvailablePaymentMethod>;
  AvailableRules: ResolverTypeWrapper<AvailableRules>;
  AvailableShippingMethod: ResolverTypeWrapper<AvailableShippingMethod>;
  Banner: ResolverTypeWrapper<Banner>;
  BannerConfig: ResolverTypeWrapper<BannerConfig>;
  BannerItems: ResolverTypeWrapper<BannerItems>;
  BannerLayoutData: ResolverTypeWrapper<BannerLayoutData>;
  BannerPageType: BannerPageType;
  Banners: ResolverTypeWrapper<Banners>;
  BeginAddToCartInternalEventInput: BeginAddToCartInternalEventInput;
  BeginAddToCartInternalEventRequest: BeginAddToCartInternalEventRequest;
  BigInt: ResolverTypeWrapper<Scalars['BigInt']['output']>;
  BillingAddressInput: BillingAddressInput;
  BillingCartAddress: ResolverTypeWrapper<BillingCartAddress>;
  BlockProducts: ResolverTypeWrapper<BlockProducts>;
  BlockTypeEnum: BlockTypeEnum;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BraintreeCcVaultInput: BraintreeCcVaultInput;
  BraintreeInput: BraintreeInput;
  BrandLayout: ResolverTypeWrapper<BrandLayout>;
  BrandListFilter: BrandListFilter;
  BrandListInput: BrandListInput;
  Brands: ResolverTypeWrapper<Brands>;
  Breadcrumb: ResolverTypeWrapper<Breadcrumb>;
  BssPopup: ResolverTypeWrapper<BssPopup>;
  BssPopups: ResolverTypeWrapper<BssPopups>;
  BundleCartItem: ResolverTypeWrapper<BundleCartItem>;
  BundleItem: ResolverTypeWrapper<BundleItem>;
  BundleItemOption: ResolverTypeWrapper<BundleItemOption>;
  BundleOptionInput: BundleOptionInput;
  BundleProduct: ResolverTypeWrapper<BundleProduct>;
  BundleProductCartItemInput: BundleProductCartItemInput;
  CacheControlScope: CacheControlScope;
  CampaignFilterInput: CampaignFilterInput;
  CancelOrderInput: CancelOrderInput;
  Cart: ResolverTypeWrapper<Cart>;
  CartAddressCountry: ResolverTypeWrapper<CartAddressCountry>;
  CartAddressInput: CartAddressInput;
  CartAddressInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CartAddressInterface']>;
  CartAddressRegion: ResolverTypeWrapper<CartAddressRegion>;
  CartDiscount: ResolverTypeWrapper<CartDiscount>;
  CartInfoInput: CartInfoInput;
  CartItemInput: CartItemInput;
  CartItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CartItemInterface']>;
  CartItemMeta: ResolverTypeWrapper<CartItemMeta>;
  CartItemPrices: ResolverTypeWrapper<CartItemPrices>;
  CartItemQuantity: ResolverTypeWrapper<CartItemQuantity>;
  CartItemReference: ResolverTypeWrapper<CartItemReference>;
  CartItemReferenceAction: ResolverTypeWrapper<CartItemReferenceAction>;
  CartItemReferenceLogic: ResolverTypeWrapper<CartItemReferenceLogic>;
  CartItemSelectedOptionValuePrice: ResolverTypeWrapper<CartItemSelectedOptionValuePrice>;
  CartItemUpdateInput: CartItemUpdateInput;
  CartItemsOnly: ResolverTypeWrapper<CartItemsOnly>;
  CartLevelGiftInput: CartLevelGiftInput;
  CartLevelGiftRule: ResolverTypeWrapper<CartLevelGiftRule>;
  CartLevelGiftsOutput: ResolverTypeWrapper<CartLevelGiftsOutput>;
  CartMeta: ResolverTypeWrapper<CartMeta>;
  CartPrices: ResolverTypeWrapper<CartPrices>;
  CartSyncActionInput: CartSyncActionInput;
  CartSyncActionProductInput: CartSyncActionProductInput;
  CartSyncItemError: ResolverTypeWrapper<CartSyncItemError>;
  CartSyncItemErrorCode: CartSyncItemErrorCode;
  CartSyncItemInput: CartSyncItemInput;
  CartSyncLogicInput: CartSyncLogicInput;
  CartTaxItem: ResolverTypeWrapper<CartTaxItem>;
  CatalogProductsListWidget: ResolverTypeWrapper<CatalogProductsListWidget>;
  CatalogStatusMessageResponse: ResolverTypeWrapper<CatalogStatusMessageResponse>;
  CategoryBanners: ResolverTypeWrapper<CategoryBanners>;
  CategoryFilterInput: CategoryFilterInput;
  CategoryHighlightProducts: ResolverTypeWrapper<CategoryHighlightProducts>;
  CategoryInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CategoryInterface']>;
  CategoryPosts: ResolverTypeWrapper<CategoryPosts>;
  CategoryProducts: ResolverTypeWrapper<CategoryProducts>;
  CategoryTags: ResolverTypeWrapper<CategoryTags>;
  CategoryTree: ResolverTypeWrapper<CategoryTree>;
  CheckoutAgreement: ResolverTypeWrapper<CheckoutAgreement>;
  CheckoutAgreementMode: CheckoutAgreementMode;
  CheckoutInfoInput: CheckoutInfoInput;
  ClientCredentialInput: ClientCredentialInput;
  CmsBlock: ResolverTypeWrapper<CmsBlock>;
  CmsBlocks: ResolverTypeWrapper<CmsBlocks>;
  CmsPage: ResolverTypeWrapper<CmsPage>;
  CmsPageConfig: ResolverTypeWrapper<CmsPageConfig>;
  CmsPageResponse: ResolverTypeWrapper<CmsPageResponse>;
  ColorSwatchData: ResolverTypeWrapper<ColorSwatchData>;
  CompleteRegistrationEventInput: CompleteRegistrationEventInput;
  CompleteRegistrationTrackingEventRequest: CompleteRegistrationTrackingEventRequest;
  ComplexTextValue: ResolverTypeWrapper<ComplexTextValue>;
  CompositeImageWidget: ResolverTypeWrapper<CompositeImageWidget>;
  Condition: ResolverTypeWrapper<Condition>;
  ConfigurableAttributeOption: ResolverTypeWrapper<ConfigurableAttributeOption>;
  ConfigurableCartItem: ResolverTypeWrapper<ConfigurableCartItem>;
  ConfigurableLocalCartItem: ResolverTypeWrapper<ConfigurableLocalCartItem>;
  ConfigurableProduct: ResolverTypeWrapper<ConfigurableProduct>;
  ConfigurableProductCartItemInput: ConfigurableProductCartItemInput;
  ConfigurableProductOptions: ResolverTypeWrapper<ConfigurableProductOptions>;
  ConfigurableProductOptionsValues: ResolverTypeWrapper<ConfigurableProductOptionsValues>;
  ConfigurableVariant: ResolverTypeWrapper<ConfigurableVariant>;
  ConfirmRequestedValidationPhoneResponse: ResolverTypeWrapper<ConfirmRequestedValidationPhoneResponse>;
  ContactDetails: ResolverTypeWrapper<ContactDetails>;
  ContentFragment: ResolverTypeWrapper<ContentFragment>;
  ContentFragmentDataInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ContentFragmentDataInterface']>;
  CoreConfig: ResolverTypeWrapper<CoreConfig>;
  Country: ResolverTypeWrapper<Country>;
  CountryCodeEnum: CountryCodeEnum;
  CouponContentResponse: ResolverTypeWrapper<CouponContentResponse>;
  CouponPartner: ResolverTypeWrapper<CouponPartner>;
  CouponWidgetFilterEqualTypeInput: CouponWidgetFilterEqualTypeInput;
  CouponWidgetFilterInput: CouponWidgetFilterInput;
  CreateAllocationInput: CreateAllocationInput;
  CreateAnswerRequest: CreateAnswerRequest;
  CreateAnswerResponse: ResolverTypeWrapper<CreateAnswerResponse>;
  CreateClientCredentialResult: ResolverTypeWrapper<CreateClientCredentialResult>;
  CreateEmptyCartInput: CreateEmptyCartInput;
  CreateEventRegistrationDetailsInput: CreateEventRegistrationDetailsInput;
  CreateEventRegistrationInput: CreateEventRegistrationInput;
  CreateEventUserInput: CreateEventUserInput;
  CreateNotificationMessageInput: CreateNotificationMessageInput;
  CreateQuestionRequest: CreateQuestionRequest;
  CreateQuestionResponse: ResolverTypeWrapper<CreateQuestionResponse>;
  CreateReviewRequest: CreateReviewRequest;
  CreditMemo: ResolverTypeWrapper<CreditMemo>;
  CreditMemoItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CreditMemoItemInterface']>;
  CreditMemoTotal: ResolverTypeWrapper<CreditMemoTotal>;
  Currency: ResolverTypeWrapper<Currency>;
  CurrencyEnum: CurrencyEnum;
  CustomAttributeMetadata: ResolverTypeWrapper<CustomAttributeMetadata>;
  Customer: ResolverTypeWrapper<Customer>;
  CustomerAccountDeletionFilters: CustomerAccountDeletionFilters;
  CustomerAccountDeletionListResponse: ResolverTypeWrapper<CustomerAccountDeletionListResponse>;
  CustomerAccountDeletionResponse: ResolverTypeWrapper<CustomerAccountDeletionResponse>;
  CustomerAddress: ResolverTypeWrapper<CustomerAddress>;
  CustomerAddressAttribute: ResolverTypeWrapper<CustomerAddressAttribute>;
  CustomerAddressAttributeInput: CustomerAddressAttributeInput;
  CustomerAddressInput: CustomerAddressInput;
  CustomerAddressRegion: ResolverTypeWrapper<CustomerAddressRegion>;
  CustomerAddressRegionInput: CustomerAddressRegionInput;
  CustomerDownloadableProduct: ResolverTypeWrapper<CustomerDownloadableProduct>;
  CustomerDownloadableProducts: ResolverTypeWrapper<CustomerDownloadableProducts>;
  CustomerFaq: ResolverTypeWrapper<CustomerFaq>;
  CustomerFaqData: ResolverTypeWrapper<CustomerFaqData>;
  CustomerInformation: ResolverTypeWrapper<CustomerInformation>;
  CustomerInput: CustomerInput;
  CustomerKicoin: ResolverTypeWrapper<CustomerKicoin>;
  CustomerOrder: ResolverTypeWrapper<CustomerOrder>;
  CustomerOrderFilterV2: CustomerOrderFilterV2;
  CustomerOrderSortInput: CustomerOrderSortInput;
  CustomerOrderSortableField: CustomerOrderSortableField;
  CustomerOrderStats: ResolverTypeWrapper<CustomerOrderStats>;
  CustomerOrders: ResolverTypeWrapper<CustomerOrders>;
  CustomerOrdersFilterInput: CustomerOrdersFilterInput;
  CustomerOrdersV2: ResolverTypeWrapper<CustomerOrdersV2>;
  CustomerOutput: ResolverTypeWrapper<CustomerOutput>;
  CustomerPaymentTokens: ResolverTypeWrapper<CustomerPaymentTokens>;
  CustomerProfile: ResolverTypeWrapper<CustomerProfile>;
  CustomerProfileInput: CustomerProfileInput;
  CustomerProfileSign: ResolverTypeWrapper<CustomerProfileSign>;
  CustomerQuestion: ResolverTypeWrapper<CustomerQuestion>;
  CustomerQuestions: ResolverTypeWrapper<CustomerQuestions>;
  CustomerReferralCodeInput: CustomerReferralCodeInput;
  CustomerReferralCodeSignature: ResolverTypeWrapper<CustomerReferralCodeSignature>;
  CustomerReviewFilterInput: CustomerReviewFilterInput;
  CustomerReviewsResponse: ResolverTypeWrapper<CustomerReviewsResponse>;
  CustomerToken: ResolverTypeWrapper<CustomerToken>;
  CustomizableOptionInput: CustomizableOptionInput;
  CustomizableOptionInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CustomizableOptionInterface']>;
  CustomizableProductInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CustomizableProductInterface']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DeletePaymentTokenOutput: ResolverTypeWrapper<DeletePaymentTokenOutput>;
  DeliveryTime: ResolverTypeWrapper<DeliveryTime>;
  DeviceRequestInput: DeviceRequestInput;
  Discount: ResolverTypeWrapper<Discount>;
  DiscountKicoins: ResolverTypeWrapper<DiscountKicoins>;
  DisplayInfoItem: ResolverTypeWrapper<DisplayInfoItem>;
  DisplayLocation: DisplayLocation;
  DisplayStatus: DisplayStatus;
  District: ResolverTypeWrapper<District>;
  DownloadableCartItem: ResolverTypeWrapper<DownloadableCartItem>;
  DownloadableFileTypeEnum: DownloadableFileTypeEnum;
  DownloadableLocalCartItem: ResolverTypeWrapper<DownloadableLocalCartItem>;
  DownloadableProduct: ResolverTypeWrapper<DownloadableProduct>;
  DownloadableProductCartItemInput: DownloadableProductCartItemInput;
  DownloadableProductLinks: ResolverTypeWrapper<DownloadableProductLinks>;
  DownloadableProductLinksInput: DownloadableProductLinksInput;
  DownloadableProductSamples: ResolverTypeWrapper<DownloadableProductSamples>;
  EnabledPaymentMethod: ResolverTypeWrapper<EnabledPaymentMethod>;
  EntityUrl: ResolverTypeWrapper<EntityUrl>;
  ErpVoucherSyncInput: ErpVoucherSyncInput;
  EventActivity: ResolverTypeWrapper<EventActivity>;
  EventActivityGroup: ResolverTypeWrapper<EventActivityGroup>;
  EventAttribute: ResolverTypeWrapper<EventAttribute>;
  EventDataInput: EventDataInput;
  EventEntity: ResolverTypeWrapper<EventEntity>;
  EventRegistration: ResolverTypeWrapper<EventRegistration>;
  EventRegistrationDetails: ResolverTypeWrapper<EventRegistrationDetails>;
  EventTypeEnum: EventTypeEnum;
  EventUser: ResolverTypeWrapper<EventUser>;
  ExchangeRate: ResolverTypeWrapper<ExchangeRate>;
  ExecutePaymentInput: ExecutePaymentInput;
  ExecutePaymentResult: ResolverTypeWrapper<ExecutePaymentResult>;
  FaqAnswer: ResolverTypeWrapper<FaqAnswer>;
  FaqArticle: ResolverTypeWrapper<FaqArticle>;
  FaqArticles: ResolverTypeWrapper<FaqArticles>;
  FaqCategories: ResolverTypeWrapper<FaqCategories>;
  FaqCategory: ResolverTypeWrapper<FaqCategory>;
  FaqCategoryAnswer: ResolverTypeWrapper<FaqCategoryAnswer>;
  FaqCategoryFilters: FaqCategoryFilters;
  FaqCategoryQuestion: ResolverTypeWrapper<FaqCategoryQuestion>;
  FaqCategoryQuestions: ResolverTypeWrapper<FaqCategoryQuestions>;
  FaqFilterInput: FaqFilterInput;
  FaqItem: ResolverTypeWrapper<FaqItem>;
  FaqListBySku: ResolverTypeWrapper<FaqListBySku>;
  FaqQuestion: ResolverTypeWrapper<FaqQuestion>;
  FaqReaction: ResolverTypeWrapper<FaqReaction>;
  FaqSuggestionTag: ResolverTypeWrapper<FaqSuggestionTag>;
  FastCartTotals: ResolverTypeWrapper<FastCartTotals>;
  FavoriteBrandFilter: FavoriteBrandFilter;
  FeaturedImageData: ResolverTypeWrapper<FeaturedImageData>;
  FilterEqualTypeInput: FilterEqualTypeInput;
  FilterMatchTypeInput: FilterMatchTypeInput;
  FilterRangeTypeInput: FilterRangeTypeInput;
  FilterStringTypeInput: FilterStringTypeInput;
  FilterTypeInput: FilterTypeInput;
  FixedProductTax: ResolverTypeWrapper<FixedProductTax>;
  FixedProductTaxDisplaySetting: FixedProductTaxDisplaySetting;
  FixedProductTaxDisplaySettings: FixedProductTaxDisplaySettings;
  FlashSale: ResolverTypeWrapper<FlashSale>;
  FlashSaleItems: ResolverTypeWrapper<FlashSaleItems>;
  FlashSaleProduct: ResolverTypeWrapper<FlashSaleProduct>;
  FlashSaleProductData: ResolverTypeWrapper<FlashSaleProductData>;
  FlashSaleProducts: ResolverTypeWrapper<FlashSaleProducts>;
  FlashSaleProductsV2: ResolverTypeWrapper<FlashSaleProductsV2>;
  FlashSaleWidget: ResolverTypeWrapper<FlashSaleWidget>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FollowerActionEnum: FollowerActionEnum;
  FooterConfig: ResolverTypeWrapper<FooterConfig>;
  FormAttributeValue: ResolverTypeWrapper<FormAttributeValue>;
  FormConfig: ResolverTypeWrapper<FormConfig>;
  FormDataInput: FormDataInput;
  FormSubmissionInput: FormSubmissionInput;
  FormValue: ResolverTypeWrapper<FormValue>;
  FreeGiftCart: ResolverTypeWrapper<FreeGiftCart>;
  FreeGifts: ResolverTypeWrapper<FreeGifts>;
  FreeGiftsData: ResolverTypeWrapper<FreeGiftsData>;
  GeneratedOtpTokenResponse: ResolverTypeWrapper<GeneratedOtpTokenResponse>;
  GetCmsPageSchemaByIdentifierResponse: ResolverTypeWrapper<GetCmsPageSchemaByIdentifierResponse>;
  GetCustomerAccountDeletionRequest: GetCustomerAccountDeletionRequest;
  GetEventUserEntityInput: GetEventUserEntityInput;
  GetFaqListBySkuResponse: ResolverTypeWrapper<GetFaqListBySkuResponse>;
  GiftCartItem: ResolverTypeWrapper<GiftCartItem>;
  GiftError: ResolverTypeWrapper<GiftError>;
  GiftIndexedInfo: ResolverTypeWrapper<GiftIndexedInfo>;
  GiftProduct: ResolverTypeWrapper<GiftProduct>;
  GiftRuleThreshold: ResolverTypeWrapper<GiftRuleThreshold>;
  GiftRuleThresholdsOutput: ResolverTypeWrapper<GiftRuleThresholdsOutput>;
  GroupedProduct: ResolverTypeWrapper<GroupedProduct>;
  GroupedProductItem: ResolverTypeWrapper<GroupedProductItem>;
  HighlightBrand: ResolverTypeWrapper<HighlightBrand>;
  HighlightBrands: ResolverTypeWrapper<HighlightBrands>;
  HighlightCategories: ResolverTypeWrapper<HighlightCategories>;
  HighlightCategory: ResolverTypeWrapper<HighlightCategory>;
  HighlightProductBlocks: ResolverTypeWrapper<HighlightProductBlocks>;
  HighlightProductItem: ResolverTypeWrapper<HighlightProductItem>;
  HighlightProducts: ResolverTypeWrapper<HighlightProducts>;
  HomePageFloatBanner: ResolverTypeWrapper<HomePageFloatBanner>;
  HomepageFeaturedBlock: ResolverTypeWrapper<HomepageFeaturedBlock>;
  HomepagePopularSearchKeywords: ResolverTypeWrapper<HomepagePopularSearchKeywords>;
  HomepagePosts: ResolverTypeWrapper<HomepagePosts>;
  HomepageProductsLightweight: ResolverTypeWrapper<HomepageProductsLightweight>;
  HtmlWidget: ResolverTypeWrapper<HtmlWidget>;
  HttpQueryParameter: ResolverTypeWrapper<HttpQueryParameter>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IdentityAuthResult: ResolverTypeWrapper<IdentityAuthResult>;
  IdentityMagentoToken: ResolverTypeWrapper<IdentityMagentoToken>;
  IdentityOtpChallengeResponse: ResolverTypeWrapper<IdentityOtpChallengeResponse>;
  IdentityRefreshResult: ResolverTypeWrapper<IdentityRefreshResult>;
  IdentitySignUpResult: ResolverTypeWrapper<IdentitySignUpResult>;
  IframeWidget: ResolverTypeWrapper<IframeWidget>;
  ImageItem: ResolverTypeWrapper<ImageItem>;
  ImageSwatchData: ResolverTypeWrapper<ImageSwatchData>;
  ImageWidget: ResolverTypeWrapper<ImageWidget>;
  InitiateCheckoutContentInput: InitiateCheckoutContentInput;
  InitiateCheckoutEventInput: InitiateCheckoutEventInput;
  InitiateCheckoutTrackingEventRequest: InitiateCheckoutTrackingEventRequest;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InteractiveRequestData: InteractiveRequestData;
  InterestedProducts: ResolverTypeWrapper<InterestedProducts>;
  Invoice: ResolverTypeWrapper<Invoice>;
  InvoiceItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['InvoiceItemInterface']>;
  InvoiceTotal: ResolverTypeWrapper<InvoiceTotal>;
  IsEmailAvailableOutput: ResolverTypeWrapper<IsEmailAvailableOutput>;
  IssuedCoupon: ResolverTypeWrapper<IssuedCoupon>;
  ItemStatus: ResolverTypeWrapper<ItemStatus>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  KeyValue: ResolverTypeWrapper<KeyValue>;
  Keywords: ResolverTypeWrapper<Keywords>;
  LayerFilter: ResolverTypeWrapper<LayerFilter>;
  LayerFilterItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LayerFilterItemInterface']>;
  Layout: ResolverTypeWrapper<Layout>;
  LayoutData: ResolverTypeWrapper<LayoutData>;
  LightweightPageInfo: ResolverTypeWrapper<LightweightPageInfo>;
  LightweightPrice: ResolverTypeWrapper<LightweightPrice>;
  LightweightPriceRange: ResolverTypeWrapper<LightweightPriceRange>;
  LightweightProductItem: ResolverTypeWrapper<LightweightProductItem>;
  LightweightProductList: ResolverTypeWrapper<LightweightProductList>;
  LocalCartItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LocalCartItemInterface']>;
  Location: Location;
  LogicType: LogicType;
  LoginDevice: LoginDevice;
  LoginEventInput: LoginEventInput;
  LoginSuccessResponse: ResolverTypeWrapper<LoginSuccessResponse>;
  LoginTrackingEventRequest: LoginTrackingEventRequest;
  LogoData: ResolverTypeWrapper<LogoData>;
  LogoutInternalEventInput: LogoutInternalEventInput;
  LogoutInternalEventRequest: LogoutInternalEventRequest;
  LookUpEventUserInput: LookUpEventUserInput;
  LookupCustomerResponse: ResolverTypeWrapper<LookupCustomerResponse>;
  MarketingAppliedCoupon: ResolverTypeWrapper<MarketingAppliedCoupon>;
  MarketingCodeType: MarketingCodeType;
  MarketingRequestLog: ResolverTypeWrapper<MarketingRequestLog>;
  MarketingRequestLogStatus: MarketingRequestLogStatus;
  MarketingRequestLogsFilterInput: MarketingRequestLogsFilterInput;
  MediaGalleryEntry: ResolverTypeWrapper<MediaGalleryEntry>;
  MediaGalleryInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['MediaGalleryInterface']>;
  MomoExecutePaymentInput: MomoExecutePaymentInput;
  Money: ResolverTypeWrapper<Money>;
  Mutation: ResolverTypeWrapper<{}>;
  MyFavoriteBrands: ResolverTypeWrapper<MyFavoriteBrands>;
  MyOrderReviewFilter: MyOrderReviewFilter;
  MyOrderReviews: ResolverTypeWrapper<MyOrderReviews>;
  MyQuestion: ResolverTypeWrapper<MyQuestion>;
  MyQuestions: ResolverTypeWrapper<MyQuestions>;
  NewArrivalProducts: ResolverTypeWrapper<NewArrivalProducts>;
  NotificationChannel: NotificationChannel;
  NotificationCustomer: ResolverTypeWrapper<NotificationCustomer>;
  NotificationData: ResolverTypeWrapper<NotificationData>;
  NotificationHistoryFilterInput: NotificationHistoryFilterInput;
  NotificationMessage: ResolverTypeWrapper<NotificationMessage>;
  NotificationOrderData: ResolverTypeWrapper<NotificationOrderData>;
  NotificationPagination: ResolverTypeWrapper<NotificationPagination>;
  NotificationPayload: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['NotificationPayload']>;
  NotificationPromotionData: ResolverTypeWrapper<NotificationPromotionData>;
  Notifications: ResolverTypeWrapper<Notifications>;
  NotificationsData: ResolverTypeWrapper<NotificationsData>;
  Order: ResolverTypeWrapper<Order>;
  OrderAddress: ResolverTypeWrapper<OrderAddress>;
  OrderBasicInfo: ResolverTypeWrapper<OrderBasicInfo>;
  OrderItem: ResolverTypeWrapper<OrderItem>;
  OrderItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderItemInterface']>;
  OrderItemOption: ResolverTypeWrapper<OrderItemOption>;
  OrderPaymentMethod: ResolverTypeWrapper<OrderPaymentMethod>;
  OrderReviewInformation: OrderReviewInformation;
  OrderShipment: ResolverTypeWrapper<OrderShipment>;
  OrderStatus: ResolverTypeWrapper<OrderStatus>;
  OrderStatusHistory: ResolverTypeWrapper<OrderStatusHistory>;
  OrderStatusHistoryItem: ResolverTypeWrapper<OrderStatusHistoryItem>;
  OrderSyncGiftDetail: ResolverTypeWrapper<OrderSyncGiftDetail>;
  OrderSyncItemPrice: ResolverTypeWrapper<OrderSyncItemPrice>;
  OrderSyncItemReference: ResolverTypeWrapper<OrderSyncItemReference>;
  OrderSyncItemReferenceAction: ResolverTypeWrapper<OrderSyncItemReferenceAction>;
  OrderSyncItemReferenceLogic: ResolverTypeWrapper<OrderSyncItemReferenceLogic>;
  OrderSyncReferencesOutput: ResolverTypeWrapper<OrderSyncReferencesOutput>;
  OrderSyncSelectedOption: ResolverTypeWrapper<OrderSyncSelectedOption>;
  OrderTotal: ResolverTypeWrapper<OrderTotal>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PaginationData: ResolverTypeWrapper<PaginationData>;
  ParticipantType: ParticipantType;
  PaymentInformation: ResolverTypeWrapper<PaymentInformation>;
  PaymentMethodInput: PaymentMethodInput;
  PaymentMethodSettings: ResolverTypeWrapper<PaymentMethodSettings>;
  PaymentOrderInformation: ResolverTypeWrapper<PaymentOrderInformation>;
  PaymentOrderLinkResponse: ResolverTypeWrapper<PaymentOrderLinkResponse>;
  PaymentOrderTransactionStatusResponse: ResolverTypeWrapper<PaymentOrderTransactionStatusResponse>;
  PaymentProvider: PaymentProvider;
  PaymentToken: ResolverTypeWrapper<PaymentToken>;
  PaymentTokenTypeEnum: PaymentTokenTypeEnum;
  PhysicalProductInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PhysicalProductInterface']>;
  PickedGiftInput: PickedGiftInput;
  PlaceOrderInput: PlaceOrderInput;
  PlaceOrderOutput: ResolverTypeWrapper<PlaceOrderOutput>;
  PopularSearchKeyword: ResolverTypeWrapper<PopularSearchKeyword>;
  PopularSearchTerms: ResolverTypeWrapper<PopularSearchTerms>;
  Post: ResolverTypeWrapper<Post>;
  Posts: ResolverTypeWrapper<Posts>;
  Price: ResolverTypeWrapper<Price>;
  PriceAdjustment: ResolverTypeWrapper<PriceAdjustment>;
  PriceAdjustmentCodesEnum: PriceAdjustmentCodesEnum;
  PriceAdjustmentDescriptionEnum: PriceAdjustmentDescriptionEnum;
  PriceRange: ResolverTypeWrapper<PriceRange>;
  PriceTypeEnum: PriceTypeEnum;
  PriceViewEnum: PriceViewEnum;
  ProductAchievement: ResolverTypeWrapper<ProductAchievement>;
  ProductAchievementContentFilter: ProductAchievementContentFilter;
  ProductAttributeFilterInput: ProductAttributeFilterInput;
  ProductAttributeSortInput: ProductAttributeSortInput;
  ProductBadge: ResolverTypeWrapper<ProductBadge>;
  ProductBlock: ResolverTypeWrapper<ProductBlock>;
  ProductCartPriceRule: ResolverTypeWrapper<ProductCartPriceRule>;
  ProductDiscount: ResolverTypeWrapper<ProductDiscount>;
  ProductFAQs: ResolverTypeWrapper<ProductFaQs>;
  ProductImage: ResolverTypeWrapper<ProductImage>;
  ProductInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ProductInterface']>;
  ProductLinksInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ProductLinksInterface']>;
  ProductListConfig: ResolverTypeWrapper<ProductListConfig>;
  ProductMediaGalleryEntriesContent: ResolverTypeWrapper<ProductMediaGalleryEntriesContent>;
  ProductMediaGalleryEntriesVideoContent: ResolverTypeWrapper<ProductMediaGalleryEntriesVideoContent>;
  ProductNotification: ResolverTypeWrapper<ProductNotification>;
  ProductPageType: ProductPageType;
  ProductPosts: ResolverTypeWrapper<ProductPosts>;
  ProductPrice: ResolverTypeWrapper<ProductPrice>;
  ProductPrices: ResolverTypeWrapper<ProductPrices>;
  ProductReviewsAggregationResponse: ResolverTypeWrapper<ProductReviewsAggregationResponse>;
  ProductReviewsAggregationV2Response: ResolverTypeWrapper<ProductReviewsAggregationV2Response>;
  ProductReviewsResponse: ResolverTypeWrapper<ProductReviewsResponse>;
  ProductSalableQuantity: ResolverTypeWrapper<ProductSalableQuantity>;
  ProductSalableQuantityError: ResolverTypeWrapper<ProductSalableQuantityError>;
  ProductSalableQuantityInput: ProductSalableQuantityInput;
  ProductStockStatus: ProductStockStatus;
  ProductSuggestedHashTags: ResolverTypeWrapper<ProductSuggestedHashTags>;
  ProductTags: ResolverTypeWrapper<ProductTags>;
  ProductTierPrices: ResolverTypeWrapper<ProductTierPrices>;
  ProductToWishlistOutput: ResolverTypeWrapper<ProductToWishlistOutput>;
  ProductVideo: ResolverTypeWrapper<ProductVideo>;
  Products: ResolverTypeWrapper<Products>;
  ProviderEnum: ProviderEnum;
  PurchaseContentInput: PurchaseContentInput;
  PurchaseEventInput: PurchaseEventInput;
  PurchaseInfoInput: PurchaseInfoInput;
  PurchaseTrackingEventInput: PurchaseTrackingEventInput;
  PurchasedProductStatus: ResolverTypeWrapper<PurchasedProductStatus>;
  PushAllocationResult: ResolverTypeWrapper<PushAllocationResult>;
  Query: ResolverTypeWrapper<{}>;
  Question: ResolverTypeWrapper<Question>;
  QuestionRequest: QuestionRequest;
  QuotaLevelEnum: QuotaLevelEnum;
  RecalculateCartTotalsInput: RecalculateCartTotalsInput;
  RecalculateCartTotalsOutput: ResolverTypeWrapper<RecalculateCartTotalsOutput>;
  ReferralCodeResponse: ResolverTypeWrapper<ReferralCodeResponse>;
  Region: ResolverTypeWrapper<Region>;
  RegionStore: ResolverTypeWrapper<RegionStore>;
  RegisterAccountInfo: RegisterAccountInfo;
  RegisterResponse: ResolverTypeWrapper<RegisterResponse>;
  RelatedProducts: ResolverTypeWrapper<RelatedProducts>;
  RemoveCartLevelGiftInput: RemoveCartLevelGiftInput;
  RemoveCartLevelGiftOutput: ResolverTypeWrapper<RemoveCartLevelGiftOutput>;
  RemoveCodeResponse: ResolverTypeWrapper<RemoveCodeResponse>;
  RemoveCouponFromCartInput: RemoveCouponFromCartInput;
  RemoveCouponFromCartOutput: ResolverTypeWrapper<RemoveCouponFromCartOutput>;
  RemoveItemFromCartInput: RemoveItemFromCartInput;
  RemoveItemFromCartOutput: ResolverTypeWrapper<RemoveItemFromCartOutput>;
  RemoveKicoinsInput: RemoveKicoinsInput;
  RemoveKicoinsOutput: ResolverTypeWrapper<RemoveKicoinsOutput>;
  RemoveUniversalCodeInput: RemoveUniversalCodeInput;
  RemoveUniversalCodeOutput: ResolverTypeWrapper<RemoveUniversalCodeOutput>;
  RequestStatus: ResolverTypeWrapper<RequestStatus>;
  RequestValidatePhoneResponse: ResolverTypeWrapper<RequestValidatePhoneResponse>;
  ResetPasswordResponse: ResolverTypeWrapper<ResetPasswordResponse>;
  Result: ResolverTypeWrapper<Result>;
  Review: ResolverTypeWrapper<Review>;
  ReviewAggregation: ResolverTypeWrapper<ReviewAggregation>;
  ReviewAggregationOption: ResolverTypeWrapper<ReviewAggregationOption>;
  ReviewAttributeFilterInput: ReviewAttributeFilterInput;
  ReviewMedia: ResolverTypeWrapper<ReviewMedia>;
  ReviewOption: ResolverTypeWrapper<ReviewOption>;
  ReviewReactionRequest: ReviewReactionRequest;
  ReviewReactionResponse: ResolverTypeWrapper<ReviewReactionResponse>;
  ReviewTag: ResolverTypeWrapper<ReviewTag>;
  RevokeCustomerTokenOutput: ResolverTypeWrapper<RevokeCustomerTokenOutput>;
  Rule: ResolverTypeWrapper<Rule>;
  SalesCommentItem: ResolverTypeWrapper<SalesCommentItem>;
  SalesOrderStatus: ResolverTypeWrapper<SalesOrderStatus>;
  SalesRule: ResolverTypeWrapper<SalesRule>;
  Salesrule: ResolverTypeWrapper<Salesrule>;
  ScopeTypeEnum: ScopeTypeEnum;
  ScrollDepthInternalEventInput: ScrollDepthInternalEventInput;
  ScrollDepthInternalEventRequest: ScrollDepthInternalEventRequest;
  SearchKeywordHistory: ResolverTypeWrapper<SearchKeywordHistory>;
  SearchResultPageInfo: ResolverTypeWrapper<SearchResultPageInfo>;
  SearchTerm: ResolverTypeWrapper<SearchTerm>;
  SelectedBundleOption: ResolverTypeWrapper<SelectedBundleOption>;
  SelectedBundleOptionValue: ResolverTypeWrapper<SelectedBundleOptionValue>;
  SelectedCartLevelGift: ResolverTypeWrapper<SelectedCartLevelGift>;
  SelectedCartLevelGiftsOutput: ResolverTypeWrapper<SelectedCartLevelGiftsOutput>;
  SelectedConfigurableOption: ResolverTypeWrapper<SelectedConfigurableOption>;
  SelectedCustomizableOption: ResolverTypeWrapper<SelectedCustomizableOption>;
  SelectedCustomizableOptionValue: ResolverTypeWrapper<SelectedCustomizableOptionValue>;
  SelectedGift: ResolverTypeWrapper<SelectedGift>;
  SelectedPaymentMethod: ResolverTypeWrapper<SelectedPaymentMethod>;
  SelectedShippingMethod: ResolverTypeWrapper<SelectedShippingMethod>;
  SelectionStrategy: SelectionStrategy;
  SeoData: ResolverTypeWrapper<SeoData>;
  SetBillingAddressOnCartInput: SetBillingAddressOnCartInput;
  SetBillingAddressOnCartOutput: ResolverTypeWrapper<SetBillingAddressOnCartOutput>;
  SetGuestEmailOnCartInput: SetGuestEmailOnCartInput;
  SetGuestEmailOnCartOutput: ResolverTypeWrapper<SetGuestEmailOnCartOutput>;
  SetPaymentMethodAndPlaceOrderInput: SetPaymentMethodAndPlaceOrderInput;
  SetPaymentMethodOnCartInput: SetPaymentMethodOnCartInput;
  SetPaymentMethodOnCartOutput: ResolverTypeWrapper<SetPaymentMethodOnCartOutput>;
  SetShippingAddressesOnCartInput: SetShippingAddressesOnCartInput;
  SetShippingAddressesOnCartOutput: ResolverTypeWrapper<SetShippingAddressesOnCartOutput>;
  SetShippingMethodsOnCartInput: SetShippingMethodsOnCartInput;
  SetShippingMethodsOnCartOutput: ResolverTypeWrapper<SetShippingMethodsOnCartOutput>;
  Settings: ResolverTypeWrapper<Settings>;
  SettingsOptions: ResolverTypeWrapper<SettingsOptions>;
  ShareChannelGroupResponse: ResolverTypeWrapper<ShareChannelGroupResponse>;
  ShareChannelItem: ResolverTypeWrapper<ShareChannelItem>;
  ShipBundleItemsEnum: ShipBundleItemsEnum;
  ShipmentItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ShipmentItemInterface']>;
  ShipmentTracking: ResolverTypeWrapper<ShipmentTracking>;
  ShippingAddressInput: ShippingAddressInput;
  ShippingCartAddress: ResolverTypeWrapper<ShippingCartAddress>;
  ShippingDiscount: ResolverTypeWrapper<ShippingDiscount>;
  ShippingHandling: ResolverTypeWrapper<ShippingHandling>;
  ShippingMethodInput: ShippingMethodInput;
  ShortcutLink: ResolverTypeWrapper<ShortcutLink>;
  ShortcutLinkLocation: ShortcutLinkLocation;
  ShortcutLinkV2: ResolverTypeWrapper<ShortcutLinkV2>;
  SimpleCartItem: ResolverTypeWrapper<SimpleCartItem>;
  SimpleLocalCartItem: ResolverTypeWrapper<SimpleLocalCartItem>;
  SimpleProduct: ResolverTypeWrapper<SimpleProduct>;
  SimpleProductCartItemInput: SimpleProductCartItemInput;
  SocialChannel: ResolverTypeWrapper<SocialChannel>;
  SortDirection: SortDirection;
  SortEnum: SortEnum;
  SortField: ResolverTypeWrapper<SortField>;
  SortFields: ResolverTypeWrapper<SortFields>;
  SortOptions: SortOptions;
  SortingInput: SortingInput;
  StaticWidget: ResolverTypeWrapper<StaticWidget>;
  StatusMessageResponse: ResolverTypeWrapper<StatusMessageResponse>;
  StockStatus: ResolverTypeWrapper<StockStatus>;
  StoreConfig: ResolverTypeWrapper<StoreConfig>;
  StoreConfiguration: ResolverTypeWrapper<StoreConfiguration>;
  StoreConfigurationV2: ResolverTypeWrapper<StoreConfigurationV2>;
  StoreLocator: ResolverTypeWrapper<StoreLocator>;
  StoreRegion: ResolverTypeWrapper<StoreRegion>;
  StoreRegions: ResolverTypeWrapper<StoreRegions>;
  StorefrontAllocation: ResolverTypeWrapper<StorefrontAllocation>;
  StoresLocator: ResolverTypeWrapper<StoresLocator>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SuggestionSearchCategory: ResolverTypeWrapper<SuggestionSearchCategory>;
  SuggestionSearchProduct: ResolverTypeWrapper<SuggestionSearchProduct>;
  SuggestionSearchResponse: ResolverTypeWrapper<SuggestionSearchResponse>;
  SuggestionSearchTerm: ResolverTypeWrapper<SuggestionSearchTerm>;
  SupportMenuAction: ResolverTypeWrapper<SupportMenuAction>;
  SupportMenuActionType: SupportMenuActionType;
  SupportMenuItem: ResolverTypeWrapper<SupportMenuItem>;
  SwatchData: ResolverTypeWrapper<SwatchData>;
  SwatchDataInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SwatchDataInterface']>;
  SwatchLayerFilterItem: ResolverTypeWrapper<SwatchLayerFilterItem>;
  SwatchLayerFilterItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SwatchLayerFilterItemInterface']>;
  SyncStatus: SyncStatus;
  SynchronizeCartInput: SynchronizeCartInput;
  SynchronizeCartPayload: ResolverTypeWrapper<SynchronizeCartPayload>;
  Tag: ResolverTypeWrapper<Tag>;
  TaxItem: ResolverTypeWrapper<TaxItem>;
  TermsOfService: ResolverTypeWrapper<TermsOfService>;
  TextSwatchData: ResolverTypeWrapper<TextSwatchData>;
  TierPrice: ResolverTypeWrapper<TierPrice>;
  TrackEventInput: TrackEventInput;
  TrackEventResult: ResolverTypeWrapper<TrackEventResult>;
  TrackingEventContextInput: TrackingEventContextInput;
  TypeNotificationEnum: TypeNotificationEnum;
  UniversalLinkEntity: ResolverTypeWrapper<UniversalLinkEntity>;
  UniversalLinkEntityParams: ResolverTypeWrapper<UniversalLinkEntityParams>;
  UniversalLinkOrderParams: ResolverTypeWrapper<UniversalLinkOrderParams>;
  UniversalLinkParams: ResolverTypeWrapper<UniversalLinkParams>;
  UniversalLinkParamsInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['UniversalLinkParamsInterface']>;
  UniversalLinkProductCollectionParams: ResolverTypeWrapper<UniversalLinkProductCollectionParams>;
  UniversalLinkSearchParams: ResolverTypeWrapper<UniversalLinkSearchParams>;
  UpdateAllocationInput: UpdateAllocationInput;
  UpdateCartItemsInput: UpdateCartItemsInput;
  UpdateCartItemsOutput: ResolverTypeWrapper<UpdateCartItemsOutput>;
  UpdateCustomerAccountDeletionStatusInput: UpdateCustomerAccountDeletionStatusInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  UrlConfigData: ResolverTypeWrapper<UrlConfigData>;
  UrlRewrite: ResolverTypeWrapper<UrlRewrite>;
  UrlRewriteEntityTypeEnum: UrlRewriteEntityTypeEnum;
  UserDataInput: UserDataInput;
  ValidateCouponsInput: ValidateCouponsInput;
  ValidatePhoneAndOtpResponse: ResolverTypeWrapper<ValidatePhoneAndOtpResponse>;
  ValidatePhoneType: ValidatePhoneType;
  VerifyEventUserUpdateSecretInput: VerifyEventUserUpdateSecretInput;
  VirtualCartItem: ResolverTypeWrapper<VirtualCartItem>;
  VirtualLocalCartItem: ResolverTypeWrapper<VirtualLocalCartItem>;
  VirtualProduct: ResolverTypeWrapper<VirtualProduct>;
  VirtualProductCartItemInput: VirtualProductCartItemInput;
  Voucher: ResolverTypeWrapper<Voucher>;
  VoucherAllocation: ResolverTypeWrapper<VoucherAllocation>;
  VoucherCampaign: ResolverTypeWrapper<VoucherCampaign>;
  VoucherDisplayType: VoucherDisplayType;
  VoucherFilterInput: VoucherFilterInput;
  VoucherHistory: ResolverTypeWrapper<VoucherHistory>;
  VoucherHistoryFilterInput: VoucherHistoryFilterInput;
  VoucherStatus: VoucherStatus;
  VoucherUsageInput: VoucherUsageInput;
  VoucherUsageLog: ResolverTypeWrapper<VoucherUsageLog>;
  VoucherUsagePlatform: VoucherUsagePlatform;
  VoucherUsageType: VoucherUsageType;
  Ward: ResolverTypeWrapper<Ward>;
  Website: ResolverTypeWrapper<Website>;
  WidgetShortcutLink: ResolverTypeWrapper<WidgetShortcutLink>;
  WidgetShortcutLinkV2: ResolverTypeWrapper<WidgetShortcutLinkV2>;
  Wishlist: ResolverTypeWrapper<Wishlist>;
  WishlistItem: ResolverTypeWrapper<WishlistItem>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Achievement: Achievement;
  AddBundleProductsToCartInput: AddBundleProductsToCartInput;
  AddBundleProductsToCartOutput: AddBundleProductsToCartOutput;
  AddCartLevelGiftsInput: AddCartLevelGiftsInput;
  AddCartLevelGiftsOutput: AddCartLevelGiftsOutput;
  AddConfigurableProductsToCartInput: AddConfigurableProductsToCartInput;
  AddConfigurableProductsToCartOutput: AddConfigurableProductsToCartOutput;
  AddDownloadableProductsToCartInput: AddDownloadableProductsToCartInput;
  AddDownloadableProductsToCartOutput: AddDownloadableProductsToCartOutput;
  AddGiftsToCartInput: AddGiftsToCartInput;
  AddGiftsToCartOutput: AddGiftsToCartOutput;
  AddProductToWishlistInput: AddProductToWishlistInput;
  AddSimpleProductsToCartInput: AddSimpleProductsToCartInput;
  AddSimpleProductsToCartOutput: AddSimpleProductsToCartOutput;
  AddToCartContentInput: AddToCartContentInput;
  AddToCartErrorInternalEventInput: AddToCartErrorInternalEventInput;
  AddToCartErrorInternalEventRequest: AddToCartErrorInternalEventRequest;
  AddToCartEventInput: AddToCartEventInput;
  AddToCartTrackingEventRequest: AddToCartTrackingEventRequest;
  AddVirtualProductsToCartInput: AddVirtualProductsToCartInput;
  AddVirtualProductsToCartOutput: AddVirtualProductsToCartOutput;
  AdditionalDataAttribute: AdditionalDataAttribute;
  AdminAnswered: AdminAnswered;
  Aggregation: Aggregation;
  AggregationOption: AggregationOption;
  AggregationOptionInterface: ResolversInterfaceTypes<ResolversParentTypes>['AggregationOptionInterface'];
  AllocationFilterInput: AllocationFilterInput;
  Answer: Answer;
  AnswerRequest: AnswerRequest;
  ApiErrorInternalEventInput: ApiErrorInternalEventInput;
  ApiErrorInternalEventRequest: ApiErrorInternalEventRequest;
  AppBannerConfig: AppBannerConfig;
  AppConfiguration: AppConfiguration;
  AppliedCodeData: AppliedCodeData;
  AppliedCodesResponse: AppliedCodesResponse;
  AppliedCoupon: AppliedCoupon;
  AppliedUniversalCode: AppliedUniversalCode;
  AppliedVoucher: AppliedVoucher;
  ApplyCodeResponse: ApplyCodeResponse;
  ApplyCouponToCartInput: ApplyCouponToCartInput;
  ApplyCouponToCartOutput: ApplyCouponToCartOutput;
  ApplyKicoinsInput: ApplyKicoinsInput;
  ApplyKicoinsOutput: ApplyKicoinsOutput;
  ApplyUniversalCodeInput: ApplyUniversalCodeInput;
  ApplyUniversalCodePayload: ApplyUniversalCodePayload;
  ApplyVoucherResponse: ApplyVoucherResponse;
  AssignVouchersInput: AssignVouchersInput;
  AssignVouchersResult: AssignVouchersResult;
  Attribute: Attribute;
  AttributeInput: AttributeInput;
  AttributeOption: AttributeOption;
  AuthErrorInternalEventInput: AuthErrorInternalEventInput;
  AuthErrorInternalEventRequest: AuthErrorInternalEventRequest;
  AvailableGifts: AvailableGifts;
  AvailableGiftsCart: AvailableGiftsCart;
  AvailableOrderHistoryStatuses: AvailableOrderHistoryStatuses;
  AvailablePaymentMethod: AvailablePaymentMethod;
  AvailableRules: AvailableRules;
  AvailableShippingMethod: AvailableShippingMethod;
  Banner: Banner;
  BannerConfig: BannerConfig;
  BannerItems: BannerItems;
  BannerLayoutData: BannerLayoutData;
  Banners: Banners;
  BeginAddToCartInternalEventInput: BeginAddToCartInternalEventInput;
  BeginAddToCartInternalEventRequest: BeginAddToCartInternalEventRequest;
  BigInt: Scalars['BigInt']['output'];
  BillingAddressInput: BillingAddressInput;
  BillingCartAddress: BillingCartAddress;
  BlockProducts: BlockProducts;
  Boolean: Scalars['Boolean']['output'];
  BraintreeCcVaultInput: BraintreeCcVaultInput;
  BraintreeInput: BraintreeInput;
  BrandLayout: BrandLayout;
  BrandListFilter: BrandListFilter;
  BrandListInput: BrandListInput;
  Brands: Brands;
  Breadcrumb: Breadcrumb;
  BssPopup: BssPopup;
  BssPopups: BssPopups;
  BundleCartItem: BundleCartItem;
  BundleItem: BundleItem;
  BundleItemOption: BundleItemOption;
  BundleOptionInput: BundleOptionInput;
  BundleProduct: BundleProduct;
  BundleProductCartItemInput: BundleProductCartItemInput;
  CampaignFilterInput: CampaignFilterInput;
  CancelOrderInput: CancelOrderInput;
  Cart: Cart;
  CartAddressCountry: CartAddressCountry;
  CartAddressInput: CartAddressInput;
  CartAddressInterface: ResolversInterfaceTypes<ResolversParentTypes>['CartAddressInterface'];
  CartAddressRegion: CartAddressRegion;
  CartDiscount: CartDiscount;
  CartInfoInput: CartInfoInput;
  CartItemInput: CartItemInput;
  CartItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['CartItemInterface'];
  CartItemMeta: CartItemMeta;
  CartItemPrices: CartItemPrices;
  CartItemQuantity: CartItemQuantity;
  CartItemReference: CartItemReference;
  CartItemReferenceAction: CartItemReferenceAction;
  CartItemReferenceLogic: CartItemReferenceLogic;
  CartItemSelectedOptionValuePrice: CartItemSelectedOptionValuePrice;
  CartItemUpdateInput: CartItemUpdateInput;
  CartItemsOnly: CartItemsOnly;
  CartLevelGiftInput: CartLevelGiftInput;
  CartLevelGiftRule: CartLevelGiftRule;
  CartLevelGiftsOutput: CartLevelGiftsOutput;
  CartMeta: CartMeta;
  CartPrices: CartPrices;
  CartSyncActionInput: CartSyncActionInput;
  CartSyncActionProductInput: CartSyncActionProductInput;
  CartSyncItemError: CartSyncItemError;
  CartSyncItemInput: CartSyncItemInput;
  CartSyncLogicInput: CartSyncLogicInput;
  CartTaxItem: CartTaxItem;
  CatalogProductsListWidget: CatalogProductsListWidget;
  CatalogStatusMessageResponse: CatalogStatusMessageResponse;
  CategoryBanners: CategoryBanners;
  CategoryFilterInput: CategoryFilterInput;
  CategoryHighlightProducts: CategoryHighlightProducts;
  CategoryInterface: ResolversInterfaceTypes<ResolversParentTypes>['CategoryInterface'];
  CategoryPosts: CategoryPosts;
  CategoryProducts: CategoryProducts;
  CategoryTags: CategoryTags;
  CategoryTree: CategoryTree;
  CheckoutAgreement: CheckoutAgreement;
  CheckoutInfoInput: CheckoutInfoInput;
  ClientCredentialInput: ClientCredentialInput;
  CmsBlock: CmsBlock;
  CmsBlocks: CmsBlocks;
  CmsPage: CmsPage;
  CmsPageConfig: CmsPageConfig;
  CmsPageResponse: CmsPageResponse;
  ColorSwatchData: ColorSwatchData;
  CompleteRegistrationEventInput: CompleteRegistrationEventInput;
  CompleteRegistrationTrackingEventRequest: CompleteRegistrationTrackingEventRequest;
  ComplexTextValue: ComplexTextValue;
  CompositeImageWidget: CompositeImageWidget;
  Condition: Condition;
  ConfigurableAttributeOption: ConfigurableAttributeOption;
  ConfigurableCartItem: ConfigurableCartItem;
  ConfigurableLocalCartItem: ConfigurableLocalCartItem;
  ConfigurableProduct: ConfigurableProduct;
  ConfigurableProductCartItemInput: ConfigurableProductCartItemInput;
  ConfigurableProductOptions: ConfigurableProductOptions;
  ConfigurableProductOptionsValues: ConfigurableProductOptionsValues;
  ConfigurableVariant: ConfigurableVariant;
  ConfirmRequestedValidationPhoneResponse: ConfirmRequestedValidationPhoneResponse;
  ContactDetails: ContactDetails;
  ContentFragment: ContentFragment;
  ContentFragmentDataInterface: ResolversInterfaceTypes<ResolversParentTypes>['ContentFragmentDataInterface'];
  CoreConfig: CoreConfig;
  Country: Country;
  CouponContentResponse: CouponContentResponse;
  CouponPartner: CouponPartner;
  CouponWidgetFilterEqualTypeInput: CouponWidgetFilterEqualTypeInput;
  CouponWidgetFilterInput: CouponWidgetFilterInput;
  CreateAllocationInput: CreateAllocationInput;
  CreateAnswerRequest: CreateAnswerRequest;
  CreateAnswerResponse: CreateAnswerResponse;
  CreateClientCredentialResult: CreateClientCredentialResult;
  CreateEmptyCartInput: CreateEmptyCartInput;
  CreateEventRegistrationDetailsInput: CreateEventRegistrationDetailsInput;
  CreateEventRegistrationInput: CreateEventRegistrationInput;
  CreateEventUserInput: CreateEventUserInput;
  CreateNotificationMessageInput: CreateNotificationMessageInput;
  CreateQuestionRequest: CreateQuestionRequest;
  CreateQuestionResponse: CreateQuestionResponse;
  CreateReviewRequest: CreateReviewRequest;
  CreditMemo: CreditMemo;
  CreditMemoItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['CreditMemoItemInterface'];
  CreditMemoTotal: CreditMemoTotal;
  Currency: Currency;
  CustomAttributeMetadata: CustomAttributeMetadata;
  Customer: Customer;
  CustomerAccountDeletionFilters: CustomerAccountDeletionFilters;
  CustomerAccountDeletionListResponse: CustomerAccountDeletionListResponse;
  CustomerAccountDeletionResponse: CustomerAccountDeletionResponse;
  CustomerAddress: CustomerAddress;
  CustomerAddressAttribute: CustomerAddressAttribute;
  CustomerAddressAttributeInput: CustomerAddressAttributeInput;
  CustomerAddressInput: CustomerAddressInput;
  CustomerAddressRegion: CustomerAddressRegion;
  CustomerAddressRegionInput: CustomerAddressRegionInput;
  CustomerDownloadableProduct: CustomerDownloadableProduct;
  CustomerDownloadableProducts: CustomerDownloadableProducts;
  CustomerFaq: CustomerFaq;
  CustomerFaqData: CustomerFaqData;
  CustomerInformation: CustomerInformation;
  CustomerInput: CustomerInput;
  CustomerKicoin: CustomerKicoin;
  CustomerOrder: CustomerOrder;
  CustomerOrderFilterV2: CustomerOrderFilterV2;
  CustomerOrderSortInput: CustomerOrderSortInput;
  CustomerOrderStats: CustomerOrderStats;
  CustomerOrders: CustomerOrders;
  CustomerOrdersFilterInput: CustomerOrdersFilterInput;
  CustomerOrdersV2: CustomerOrdersV2;
  CustomerOutput: CustomerOutput;
  CustomerPaymentTokens: CustomerPaymentTokens;
  CustomerProfile: CustomerProfile;
  CustomerProfileInput: CustomerProfileInput;
  CustomerProfileSign: CustomerProfileSign;
  CustomerQuestion: CustomerQuestion;
  CustomerQuestions: CustomerQuestions;
  CustomerReferralCodeInput: CustomerReferralCodeInput;
  CustomerReferralCodeSignature: CustomerReferralCodeSignature;
  CustomerReviewFilterInput: CustomerReviewFilterInput;
  CustomerReviewsResponse: CustomerReviewsResponse;
  CustomerToken: CustomerToken;
  CustomizableOptionInput: CustomizableOptionInput;
  CustomizableOptionInterface: ResolversInterfaceTypes<ResolversParentTypes>['CustomizableOptionInterface'];
  CustomizableProductInterface: ResolversInterfaceTypes<ResolversParentTypes>['CustomizableProductInterface'];
  DateTime: Scalars['DateTime']['output'];
  DeletePaymentTokenOutput: DeletePaymentTokenOutput;
  DeliveryTime: DeliveryTime;
  DeviceRequestInput: DeviceRequestInput;
  Discount: Discount;
  DiscountKicoins: DiscountKicoins;
  DisplayInfoItem: DisplayInfoItem;
  District: District;
  DownloadableCartItem: DownloadableCartItem;
  DownloadableLocalCartItem: DownloadableLocalCartItem;
  DownloadableProduct: DownloadableProduct;
  DownloadableProductCartItemInput: DownloadableProductCartItemInput;
  DownloadableProductLinks: DownloadableProductLinks;
  DownloadableProductLinksInput: DownloadableProductLinksInput;
  DownloadableProductSamples: DownloadableProductSamples;
  EnabledPaymentMethod: EnabledPaymentMethod;
  EntityUrl: EntityUrl;
  ErpVoucherSyncInput: ErpVoucherSyncInput;
  EventActivity: EventActivity;
  EventActivityGroup: EventActivityGroup;
  EventAttribute: EventAttribute;
  EventDataInput: EventDataInput;
  EventEntity: EventEntity;
  EventRegistration: EventRegistration;
  EventRegistrationDetails: EventRegistrationDetails;
  EventUser: EventUser;
  ExchangeRate: ExchangeRate;
  ExecutePaymentInput: ExecutePaymentInput;
  ExecutePaymentResult: ExecutePaymentResult;
  FaqAnswer: FaqAnswer;
  FaqArticle: FaqArticle;
  FaqArticles: FaqArticles;
  FaqCategories: FaqCategories;
  FaqCategory: FaqCategory;
  FaqCategoryAnswer: FaqCategoryAnswer;
  FaqCategoryFilters: FaqCategoryFilters;
  FaqCategoryQuestion: FaqCategoryQuestion;
  FaqCategoryQuestions: FaqCategoryQuestions;
  FaqFilterInput: FaqFilterInput;
  FaqItem: FaqItem;
  FaqListBySku: FaqListBySku;
  FaqQuestion: FaqQuestion;
  FaqReaction: FaqReaction;
  FaqSuggestionTag: FaqSuggestionTag;
  FastCartTotals: FastCartTotals;
  FavoriteBrandFilter: FavoriteBrandFilter;
  FeaturedImageData: FeaturedImageData;
  FilterEqualTypeInput: FilterEqualTypeInput;
  FilterMatchTypeInput: FilterMatchTypeInput;
  FilterRangeTypeInput: FilterRangeTypeInput;
  FilterStringTypeInput: FilterStringTypeInput;
  FilterTypeInput: FilterTypeInput;
  FixedProductTax: FixedProductTax;
  FlashSale: FlashSale;
  FlashSaleItems: FlashSaleItems;
  FlashSaleProduct: FlashSaleProduct;
  FlashSaleProductData: FlashSaleProductData;
  FlashSaleProducts: FlashSaleProducts;
  FlashSaleProductsV2: FlashSaleProductsV2;
  FlashSaleWidget: FlashSaleWidget;
  Float: Scalars['Float']['output'];
  FooterConfig: FooterConfig;
  FormAttributeValue: FormAttributeValue;
  FormConfig: FormConfig;
  FormDataInput: FormDataInput;
  FormSubmissionInput: FormSubmissionInput;
  FormValue: FormValue;
  FreeGiftCart: FreeGiftCart;
  FreeGifts: FreeGifts;
  FreeGiftsData: FreeGiftsData;
  GeneratedOtpTokenResponse: GeneratedOtpTokenResponse;
  GetCmsPageSchemaByIdentifierResponse: GetCmsPageSchemaByIdentifierResponse;
  GetCustomerAccountDeletionRequest: GetCustomerAccountDeletionRequest;
  GetEventUserEntityInput: GetEventUserEntityInput;
  GetFaqListBySkuResponse: GetFaqListBySkuResponse;
  GiftCartItem: GiftCartItem;
  GiftError: GiftError;
  GiftIndexedInfo: GiftIndexedInfo;
  GiftProduct: GiftProduct;
  GiftRuleThreshold: GiftRuleThreshold;
  GiftRuleThresholdsOutput: GiftRuleThresholdsOutput;
  GroupedProduct: GroupedProduct;
  GroupedProductItem: GroupedProductItem;
  HighlightBrand: HighlightBrand;
  HighlightBrands: HighlightBrands;
  HighlightCategories: HighlightCategories;
  HighlightCategory: HighlightCategory;
  HighlightProductBlocks: HighlightProductBlocks;
  HighlightProductItem: HighlightProductItem;
  HighlightProducts: HighlightProducts;
  HomePageFloatBanner: HomePageFloatBanner;
  HomepageFeaturedBlock: HomepageFeaturedBlock;
  HomepagePopularSearchKeywords: HomepagePopularSearchKeywords;
  HomepagePosts: HomepagePosts;
  HomepageProductsLightweight: HomepageProductsLightweight;
  HtmlWidget: HtmlWidget;
  HttpQueryParameter: HttpQueryParameter;
  ID: Scalars['ID']['output'];
  IdentityAuthResult: IdentityAuthResult;
  IdentityMagentoToken: IdentityMagentoToken;
  IdentityOtpChallengeResponse: IdentityOtpChallengeResponse;
  IdentityRefreshResult: IdentityRefreshResult;
  IdentitySignUpResult: IdentitySignUpResult;
  IframeWidget: IframeWidget;
  ImageItem: ImageItem;
  ImageSwatchData: ImageSwatchData;
  ImageWidget: ImageWidget;
  InitiateCheckoutContentInput: InitiateCheckoutContentInput;
  InitiateCheckoutEventInput: InitiateCheckoutEventInput;
  InitiateCheckoutTrackingEventRequest: InitiateCheckoutTrackingEventRequest;
  Int: Scalars['Int']['output'];
  InteractiveRequestData: InteractiveRequestData;
  InterestedProducts: InterestedProducts;
  Invoice: Invoice;
  InvoiceItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['InvoiceItemInterface'];
  InvoiceTotal: InvoiceTotal;
  IsEmailAvailableOutput: IsEmailAvailableOutput;
  IssuedCoupon: IssuedCoupon;
  ItemStatus: ItemStatus;
  JSON: Scalars['JSON']['output'];
  KeyValue: KeyValue;
  Keywords: Keywords;
  LayerFilter: LayerFilter;
  LayerFilterItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['LayerFilterItemInterface'];
  Layout: Layout;
  LayoutData: LayoutData;
  LightweightPageInfo: LightweightPageInfo;
  LightweightPrice: LightweightPrice;
  LightweightPriceRange: LightweightPriceRange;
  LightweightProductItem: LightweightProductItem;
  LightweightProductList: LightweightProductList;
  LocalCartItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['LocalCartItemInterface'];
  LoginDevice: LoginDevice;
  LoginEventInput: LoginEventInput;
  LoginSuccessResponse: LoginSuccessResponse;
  LoginTrackingEventRequest: LoginTrackingEventRequest;
  LogoData: LogoData;
  LogoutInternalEventInput: LogoutInternalEventInput;
  LogoutInternalEventRequest: LogoutInternalEventRequest;
  LookUpEventUserInput: LookUpEventUserInput;
  LookupCustomerResponse: LookupCustomerResponse;
  MarketingAppliedCoupon: MarketingAppliedCoupon;
  MarketingRequestLog: MarketingRequestLog;
  MarketingRequestLogsFilterInput: MarketingRequestLogsFilterInput;
  MediaGalleryEntry: MediaGalleryEntry;
  MediaGalleryInterface: ResolversInterfaceTypes<ResolversParentTypes>['MediaGalleryInterface'];
  MomoExecutePaymentInput: MomoExecutePaymentInput;
  Money: Money;
  Mutation: {};
  MyFavoriteBrands: MyFavoriteBrands;
  MyOrderReviewFilter: MyOrderReviewFilter;
  MyOrderReviews: MyOrderReviews;
  MyQuestion: MyQuestion;
  MyQuestions: MyQuestions;
  NewArrivalProducts: NewArrivalProducts;
  NotificationCustomer: NotificationCustomer;
  NotificationData: NotificationData;
  NotificationHistoryFilterInput: NotificationHistoryFilterInput;
  NotificationMessage: NotificationMessage;
  NotificationOrderData: NotificationOrderData;
  NotificationPagination: NotificationPagination;
  NotificationPayload: ResolversInterfaceTypes<ResolversParentTypes>['NotificationPayload'];
  NotificationPromotionData: NotificationPromotionData;
  Notifications: Notifications;
  NotificationsData: NotificationsData;
  Order: Order;
  OrderAddress: OrderAddress;
  OrderBasicInfo: OrderBasicInfo;
  OrderItem: OrderItem;
  OrderItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['OrderItemInterface'];
  OrderItemOption: OrderItemOption;
  OrderPaymentMethod: OrderPaymentMethod;
  OrderReviewInformation: OrderReviewInformation;
  OrderShipment: OrderShipment;
  OrderStatus: OrderStatus;
  OrderStatusHistory: OrderStatusHistory;
  OrderStatusHistoryItem: OrderStatusHistoryItem;
  OrderSyncGiftDetail: OrderSyncGiftDetail;
  OrderSyncItemPrice: OrderSyncItemPrice;
  OrderSyncItemReference: OrderSyncItemReference;
  OrderSyncItemReferenceAction: OrderSyncItemReferenceAction;
  OrderSyncItemReferenceLogic: OrderSyncItemReferenceLogic;
  OrderSyncReferencesOutput: OrderSyncReferencesOutput;
  OrderSyncSelectedOption: OrderSyncSelectedOption;
  OrderTotal: OrderTotal;
  PageInfo: PageInfo;
  PaginationData: PaginationData;
  PaymentInformation: PaymentInformation;
  PaymentMethodInput: PaymentMethodInput;
  PaymentMethodSettings: PaymentMethodSettings;
  PaymentOrderInformation: PaymentOrderInformation;
  PaymentOrderLinkResponse: PaymentOrderLinkResponse;
  PaymentOrderTransactionStatusResponse: PaymentOrderTransactionStatusResponse;
  PaymentToken: PaymentToken;
  PhysicalProductInterface: ResolversInterfaceTypes<ResolversParentTypes>['PhysicalProductInterface'];
  PickedGiftInput: PickedGiftInput;
  PlaceOrderInput: PlaceOrderInput;
  PlaceOrderOutput: PlaceOrderOutput;
  PopularSearchKeyword: PopularSearchKeyword;
  PopularSearchTerms: PopularSearchTerms;
  Post: Post;
  Posts: Posts;
  Price: Price;
  PriceAdjustment: PriceAdjustment;
  PriceRange: PriceRange;
  ProductAchievement: ProductAchievement;
  ProductAchievementContentFilter: ProductAchievementContentFilter;
  ProductAttributeFilterInput: ProductAttributeFilterInput;
  ProductAttributeSortInput: ProductAttributeSortInput;
  ProductBadge: ProductBadge;
  ProductBlock: ProductBlock;
  ProductCartPriceRule: ProductCartPriceRule;
  ProductDiscount: ProductDiscount;
  ProductFAQs: ProductFaQs;
  ProductImage: ProductImage;
  ProductInterface: ResolversInterfaceTypes<ResolversParentTypes>['ProductInterface'];
  ProductLinksInterface: ResolversInterfaceTypes<ResolversParentTypes>['ProductLinksInterface'];
  ProductListConfig: ProductListConfig;
  ProductMediaGalleryEntriesContent: ProductMediaGalleryEntriesContent;
  ProductMediaGalleryEntriesVideoContent: ProductMediaGalleryEntriesVideoContent;
  ProductNotification: ProductNotification;
  ProductPosts: ProductPosts;
  ProductPrice: ProductPrice;
  ProductPrices: ProductPrices;
  ProductReviewsAggregationResponse: ProductReviewsAggregationResponse;
  ProductReviewsAggregationV2Response: ProductReviewsAggregationV2Response;
  ProductReviewsResponse: ProductReviewsResponse;
  ProductSalableQuantity: ProductSalableQuantity;
  ProductSalableQuantityError: ProductSalableQuantityError;
  ProductSalableQuantityInput: ProductSalableQuantityInput;
  ProductSuggestedHashTags: ProductSuggestedHashTags;
  ProductTags: ProductTags;
  ProductTierPrices: ProductTierPrices;
  ProductToWishlistOutput: ProductToWishlistOutput;
  ProductVideo: ProductVideo;
  Products: Products;
  PurchaseContentInput: PurchaseContentInput;
  PurchaseEventInput: PurchaseEventInput;
  PurchaseInfoInput: PurchaseInfoInput;
  PurchaseTrackingEventInput: PurchaseTrackingEventInput;
  PurchasedProductStatus: PurchasedProductStatus;
  PushAllocationResult: PushAllocationResult;
  Query: {};
  Question: Question;
  QuestionRequest: QuestionRequest;
  RecalculateCartTotalsInput: RecalculateCartTotalsInput;
  RecalculateCartTotalsOutput: RecalculateCartTotalsOutput;
  ReferralCodeResponse: ReferralCodeResponse;
  Region: Region;
  RegionStore: RegionStore;
  RegisterAccountInfo: RegisterAccountInfo;
  RegisterResponse: RegisterResponse;
  RelatedProducts: RelatedProducts;
  RemoveCartLevelGiftInput: RemoveCartLevelGiftInput;
  RemoveCartLevelGiftOutput: RemoveCartLevelGiftOutput;
  RemoveCodeResponse: RemoveCodeResponse;
  RemoveCouponFromCartInput: RemoveCouponFromCartInput;
  RemoveCouponFromCartOutput: RemoveCouponFromCartOutput;
  RemoveItemFromCartInput: RemoveItemFromCartInput;
  RemoveItemFromCartOutput: RemoveItemFromCartOutput;
  RemoveKicoinsInput: RemoveKicoinsInput;
  RemoveKicoinsOutput: RemoveKicoinsOutput;
  RemoveUniversalCodeInput: RemoveUniversalCodeInput;
  RemoveUniversalCodeOutput: RemoveUniversalCodeOutput;
  RequestStatus: RequestStatus;
  RequestValidatePhoneResponse: RequestValidatePhoneResponse;
  ResetPasswordResponse: ResetPasswordResponse;
  Result: Result;
  Review: Review;
  ReviewAggregation: ReviewAggregation;
  ReviewAggregationOption: ReviewAggregationOption;
  ReviewAttributeFilterInput: ReviewAttributeFilterInput;
  ReviewMedia: ReviewMedia;
  ReviewOption: ReviewOption;
  ReviewReactionRequest: ReviewReactionRequest;
  ReviewReactionResponse: ReviewReactionResponse;
  ReviewTag: ReviewTag;
  RevokeCustomerTokenOutput: RevokeCustomerTokenOutput;
  Rule: Rule;
  SalesCommentItem: SalesCommentItem;
  SalesOrderStatus: SalesOrderStatus;
  SalesRule: SalesRule;
  Salesrule: Salesrule;
  ScrollDepthInternalEventInput: ScrollDepthInternalEventInput;
  ScrollDepthInternalEventRequest: ScrollDepthInternalEventRequest;
  SearchKeywordHistory: SearchKeywordHistory;
  SearchResultPageInfo: SearchResultPageInfo;
  SearchTerm: SearchTerm;
  SelectedBundleOption: SelectedBundleOption;
  SelectedBundleOptionValue: SelectedBundleOptionValue;
  SelectedCartLevelGift: SelectedCartLevelGift;
  SelectedCartLevelGiftsOutput: SelectedCartLevelGiftsOutput;
  SelectedConfigurableOption: SelectedConfigurableOption;
  SelectedCustomizableOption: SelectedCustomizableOption;
  SelectedCustomizableOptionValue: SelectedCustomizableOptionValue;
  SelectedGift: SelectedGift;
  SelectedPaymentMethod: SelectedPaymentMethod;
  SelectedShippingMethod: SelectedShippingMethod;
  SeoData: SeoData;
  SetBillingAddressOnCartInput: SetBillingAddressOnCartInput;
  SetBillingAddressOnCartOutput: SetBillingAddressOnCartOutput;
  SetGuestEmailOnCartInput: SetGuestEmailOnCartInput;
  SetGuestEmailOnCartOutput: SetGuestEmailOnCartOutput;
  SetPaymentMethodAndPlaceOrderInput: SetPaymentMethodAndPlaceOrderInput;
  SetPaymentMethodOnCartInput: SetPaymentMethodOnCartInput;
  SetPaymentMethodOnCartOutput: SetPaymentMethodOnCartOutput;
  SetShippingAddressesOnCartInput: SetShippingAddressesOnCartInput;
  SetShippingAddressesOnCartOutput: SetShippingAddressesOnCartOutput;
  SetShippingMethodsOnCartInput: SetShippingMethodsOnCartInput;
  SetShippingMethodsOnCartOutput: SetShippingMethodsOnCartOutput;
  Settings: Settings;
  SettingsOptions: SettingsOptions;
  ShareChannelGroupResponse: ShareChannelGroupResponse;
  ShareChannelItem: ShareChannelItem;
  ShipmentItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['ShipmentItemInterface'];
  ShipmentTracking: ShipmentTracking;
  ShippingAddressInput: ShippingAddressInput;
  ShippingCartAddress: ShippingCartAddress;
  ShippingDiscount: ShippingDiscount;
  ShippingHandling: ShippingHandling;
  ShippingMethodInput: ShippingMethodInput;
  ShortcutLink: ShortcutLink;
  ShortcutLinkV2: ShortcutLinkV2;
  SimpleCartItem: SimpleCartItem;
  SimpleLocalCartItem: SimpleLocalCartItem;
  SimpleProduct: SimpleProduct;
  SimpleProductCartItemInput: SimpleProductCartItemInput;
  SocialChannel: SocialChannel;
  SortField: SortField;
  SortFields: SortFields;
  SortOptions: SortOptions;
  SortingInput: SortingInput;
  StaticWidget: StaticWidget;
  StatusMessageResponse: StatusMessageResponse;
  StockStatus: StockStatus;
  StoreConfig: StoreConfig;
  StoreConfiguration: StoreConfiguration;
  StoreConfigurationV2: StoreConfigurationV2;
  StoreLocator: StoreLocator;
  StoreRegion: StoreRegion;
  StoreRegions: StoreRegions;
  StorefrontAllocation: StorefrontAllocation;
  StoresLocator: StoresLocator;
  String: Scalars['String']['output'];
  SuggestionSearchCategory: SuggestionSearchCategory;
  SuggestionSearchProduct: SuggestionSearchProduct;
  SuggestionSearchResponse: SuggestionSearchResponse;
  SuggestionSearchTerm: SuggestionSearchTerm;
  SupportMenuAction: SupportMenuAction;
  SupportMenuItem: SupportMenuItem;
  SwatchData: SwatchData;
  SwatchDataInterface: ResolversInterfaceTypes<ResolversParentTypes>['SwatchDataInterface'];
  SwatchLayerFilterItem: SwatchLayerFilterItem;
  SwatchLayerFilterItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['SwatchLayerFilterItemInterface'];
  SynchronizeCartInput: SynchronizeCartInput;
  SynchronizeCartPayload: SynchronizeCartPayload;
  Tag: Tag;
  TaxItem: TaxItem;
  TermsOfService: TermsOfService;
  TextSwatchData: TextSwatchData;
  TierPrice: TierPrice;
  TrackEventInput: TrackEventInput;
  TrackEventResult: TrackEventResult;
  TrackingEventContextInput: TrackingEventContextInput;
  UniversalLinkEntity: UniversalLinkEntity;
  UniversalLinkEntityParams: UniversalLinkEntityParams;
  UniversalLinkOrderParams: UniversalLinkOrderParams;
  UniversalLinkParams: UniversalLinkParams;
  UniversalLinkParamsInterface: ResolversInterfaceTypes<ResolversParentTypes>['UniversalLinkParamsInterface'];
  UniversalLinkProductCollectionParams: UniversalLinkProductCollectionParams;
  UniversalLinkSearchParams: UniversalLinkSearchParams;
  UpdateAllocationInput: UpdateAllocationInput;
  UpdateCartItemsInput: UpdateCartItemsInput;
  UpdateCartItemsOutput: UpdateCartItemsOutput;
  UpdateCustomerAccountDeletionStatusInput: UpdateCustomerAccountDeletionStatusInput;
  Upload: Scalars['Upload']['output'];
  UrlConfigData: UrlConfigData;
  UrlRewrite: UrlRewrite;
  UserDataInput: UserDataInput;
  ValidateCouponsInput: ValidateCouponsInput;
  ValidatePhoneAndOtpResponse: ValidatePhoneAndOtpResponse;
  VerifyEventUserUpdateSecretInput: VerifyEventUserUpdateSecretInput;
  VirtualCartItem: VirtualCartItem;
  VirtualLocalCartItem: VirtualLocalCartItem;
  VirtualProduct: VirtualProduct;
  VirtualProductCartItemInput: VirtualProductCartItemInput;
  Voucher: Voucher;
  VoucherAllocation: VoucherAllocation;
  VoucherCampaign: VoucherCampaign;
  VoucherFilterInput: VoucherFilterInput;
  VoucherHistory: VoucherHistory;
  VoucherHistoryFilterInput: VoucherHistoryFilterInput;
  VoucherUsageInput: VoucherUsageInput;
  VoucherUsageLog: VoucherUsageLog;
  Ward: Ward;
  Website: Website;
  WidgetShortcutLink: WidgetShortcutLink;
  WidgetShortcutLinkV2: WidgetShortcutLinkV2;
  Wishlist: Wishlist;
  WishlistItem: WishlistItem;
};

export type AchievementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Achievement'] = ResolversParentTypes['Achievement']> = {
  background_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  border_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  target_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddBundleProductsToCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddBundleProductsToCartOutput'] = ResolversParentTypes['AddBundleProductsToCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddCartLevelGiftsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddCartLevelGiftsOutput'] = ResolversParentTypes['AddCartLevelGiftsOutput']> = {
  cart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType>;
  errors?: Resolver<Array<ResolversTypes['GiftError']>, ParentType, ContextType>;
  selected_gifts?: Resolver<Array<ResolversTypes['SelectedCartLevelGift']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddConfigurableProductsToCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddConfigurableProductsToCartOutput'] = ResolversParentTypes['AddConfigurableProductsToCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddDownloadableProductsToCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddDownloadableProductsToCartOutput'] = ResolversParentTypes['AddDownloadableProductsToCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddGiftsToCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddGiftsToCartOutput'] = ResolversParentTypes['AddGiftsToCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddSimpleProductsToCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSimpleProductsToCartOutput'] = ResolversParentTypes['AddSimpleProductsToCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddVirtualProductsToCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddVirtualProductsToCartOutput'] = ResolversParentTypes['AddVirtualProductsToCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalDataAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdditionalDataAttribute'] = ResolversParentTypes['AdditionalDataAttribute']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminAnsweredResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAnswered'] = ResolversParentTypes['AdminAnswered']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_admin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  like_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  liked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parent_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_satisfied?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Aggregation'] = ResolversParentTypes['Aggregation']> = {
  attribute_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['AggregationOption']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AggregationOption'] = ResolversParentTypes['AggregationOption']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregationOptionInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['AggregationOptionInterface'] = ResolversParentTypes['AggregationOptionInterface']> = {
  __resolveType: TypeResolveFn<'AggregationOption', ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Answer'] = ResolversParentTypes['Answer']> = {
  adminId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  adminName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppBannerConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppBannerConfig'] = ResolversParentTypes['AppBannerConfig']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  image_url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppConfiguration'] = ResolversParentTypes['AppConfiguration']> = {
  banner_config?: Resolver<Maybe<ResolversTypes['AppBannerConfig']>, ParentType, ContextType>;
  footer_config?: Resolver<Maybe<ResolversTypes['FooterConfig']>, ParentType, ContextType>;
  share_channel_configs?: Resolver<Maybe<ResolversTypes['ShareChannelGroupResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppliedCodeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedCodeData'] = ResolversParentTypes['AppliedCodeData']> = {
  allocation_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applied_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coupon_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  masked_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MarketingCodeType'], ParentType, ContextType>;
  voucher_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppliedCodesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedCodesResponse'] = ResolversParentTypes['AppliedCodesResponse']> = {
  coupons?: Resolver<Array<ResolversTypes['MarketingAppliedCoupon']>, ParentType, ContextType>;
  vouchers?: Resolver<Array<ResolversTypes['AppliedVoucher']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppliedCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedCoupon'] = ResolversParentTypes['AppliedCoupon']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppliedUniversalCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedUniversalCode'] = ResolversParentTypes['AppliedUniversalCode']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppliedVoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedVoucher'] = ResolversParentTypes['AppliedVoucher']> = {
  allocation?: Resolver<Maybe<ResolversTypes['StorefrontAllocation']>, ParentType, ContextType>;
  allocation_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applied_amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  display_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  display_type?: Resolver<ResolversTypes['VoucherDisplayType'], ParentType, ContextType>;
  voucher_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplyCodeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyCodeResponse'] = ResolversParentTypes['ApplyCodeResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['AppliedCodeData']>, ParentType, ContextType>;
  error_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplyCouponToCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyCouponToCartOutput'] = ResolversParentTypes['ApplyCouponToCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplyKicoinsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyKicoinsOutput'] = ResolversParentTypes['ApplyKicoinsOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplyUniversalCodePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyUniversalCodePayload'] = ResolversParentTypes['ApplyUniversalCodePayload']> = {
  applied_code_type?: Resolver<Maybe<ResolversTypes['AppliedCodeType']>, ParentType, ContextType>;
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  user_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplyVoucherResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyVoucherResponse'] = ResolversParentTypes['ApplyVoucherResponse']> = {
  error_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  voucher_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssignVouchersResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssignVouchersResult'] = ResolversParentTypes['AssignVouchersResult']> = {
  allocation?: Resolver<ResolversTypes['VoucherAllocation'], ParentType, ContextType>;
  assigned_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attribute'] = ResolversParentTypes['Attribute']> = {
  attribute_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['AttributeOption']>>>, ParentType, ContextType>;
  attribute_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entity_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  input_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttributeOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttributeOption'] = ResolversParentTypes['AttributeOption']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  swatch_data?: Resolver<Maybe<ResolversTypes['SwatchDataInterface']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableGiftsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableGifts'] = ResolversParentTypes['AvailableGifts']> = {
  cart_item_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  rule?: Resolver<Maybe<ResolversTypes['Rule']>, ParentType, ContextType>;
  rule_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableGiftsCartResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableGiftsCart'] = ResolversParentTypes['AvailableGiftsCart']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvailableGifts']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableOrderHistoryStatusesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableOrderHistoryStatuses'] = ResolversParentTypes['AvailableOrderHistoryStatuses']> = {
  direction?: Resolver<ResolversTypes['SortDirection'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailablePaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailablePaymentMethod'] = ResolversParentTypes['AvailablePaymentMethod']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableRulesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableRules'] = ResolversParentTypes['AvailableRules']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Rule']>>>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableShippingMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableShippingMethod'] = ResolversParentTypes['AvailableShippingMethod']> = {
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  available?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  base_amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  carrier_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrier_title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price_excl_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  price_incl_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Banner'] = ResolversParentTypes['Banner']> = {
  app_image_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  background_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_app?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newtab?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_banner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerConfig'] = ResolversParentTypes['BannerConfig']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerItemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerItems'] = ResolversParentTypes['BannerItems']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Banner']>>>, ParentType, ContextType>;
  layout?: Resolver<Maybe<ResolversTypes['BannerLayoutData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerLayoutDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerLayoutData'] = ResolversParentTypes['BannerLayoutData']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannersResolvers<ContextType = any, ParentType extends ResolversParentTypes['Banners'] = ResolversParentTypes['Banners']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Banner']>>>, ParentType, ContextType>;
  layout?: Resolver<Maybe<ResolversTypes['LayoutData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BigIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigInt'], any> {
  name: 'BigInt';
}

export type BillingCartAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingCartAddress'] = ResolversParentTypes['BillingCartAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['CartAddressCountry'], ParentType, ContextType>;
  customer_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoice_company_address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['CartAddressRegion']>, ParentType, ContextType>;
  street?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  telephone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockProducts'] = ResolversParentTypes['BlockProducts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandLayout'] = ResolversParentTypes['BrandLayout']> = {
  banner_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  border_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layout?: Resolver<Maybe<ResolversTypes['LayoutData']>, ParentType, ContextType>;
  limit_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  row_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Brands'] = ResolversParentTypes['Brands']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['HighlightBrand']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BreadcrumbResolvers<ContextType = any, ParentType extends ResolversParentTypes['Breadcrumb'] = ResolversParentTypes['Breadcrumb']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  category_level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  category_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BssPopupResolvers<ContextType = any, ParentType extends ResolversParentTypes['BssPopup'] = ResolversParentTypes['BssPopup']> = {
  after_load?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  after_scroll?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  close_outside?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cookie_expires?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customer_group?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effect_display?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  event_display?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  exclude_category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exclude_product?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequently?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hide_after?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  layouts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Layout']>>>, ParentType, ContextType>;
  page_display?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  page_view?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  popup_content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popup_css?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popup_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popup_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  storeview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BssPopupsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BssPopups'] = ResolversParentTypes['BssPopups']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['BssPopup']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleCartItem'] = ResolversParentTypes['BundleCartItem']> = {
  bundle_options?: Resolver<Array<Maybe<ResolversTypes['SelectedBundleOption']>>, ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleItem'] = ResolversParentTypes['BundleItem']> = {
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['BundleItemOption']>>>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleItemOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleItemOption'] = ResolversParentTypes['BundleItemOption']> = {
  can_change_quantity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BundleProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['BundleProduct'] = ResolversParentTypes['BundleProduct']> = {
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  additional_data_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditionalDataAttribute']>>>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  am_offer_item_condition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appboxo_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  avatars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bao_hanh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  chat_lieu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chat_lieu_go?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chat_lieu_vai?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chon_so?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combo_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  denomination?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  dungtich?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dynamic_price?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dynamic_sku?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dynamic_weight?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSaleProductData']>, ParentType, ContextType>;
  gift_indexed_info?: Resolver<Maybe<Array<Maybe<ResolversTypes['GiftIndexedInfo']>>>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gram?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_bought?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupon_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gtin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_gift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hot_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  is_discount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_kids_gift?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_online_only?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['BundleItem']>>>, ParentType, ContextType>;
  kich_thuoc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  made_in?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  market_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  muivi?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nipple_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductNotification']>>>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  price_view?: Resolver<Maybe<ResolversTypes['PriceViewEnum']>, ParentType, ContextType>;
  product_achievements?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductAchievement']>>>, ParentType, ContextType>;
  product_badges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductBadge']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products_combo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratings_summary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  related_products_two?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ship_bundle_items?: Resolver<Maybe<ResolversTypes['ShipBundleItemsEnum']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  so_tang?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soluong?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  upsell_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_cc?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_custom_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_guide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weight_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartResolvers<ContextType = any, ParentType extends ResolversParentTypes['Cart'] = ResolversParentTypes['Cart']> = {
  applied_coupon?: Resolver<Maybe<ResolversTypes['AppliedCoupon']>, ParentType, ContextType>;
  applied_coupons?: Resolver<Maybe<Array<Maybe<ResolversTypes['AppliedCoupon']>>>, ParentType, ContextType>;
  applied_universal_codes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AppliedUniversalCode']>>>, ParentType, ContextType>;
  available_payment_methods?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvailablePaymentMethod']>>>, ParentType, ContextType>;
  billing_address?: Resolver<Maybe<ResolversTypes['BillingCartAddress']>, ParentType, ContextType>;
  discount_kicoins?: Resolver<Maybe<ResolversTypes['DiscountKicoins']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  is_virtual?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemInterface']>>>, ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartPrices']>, ParentType, ContextType>;
  selected_payment_method?: Resolver<Maybe<ResolversTypes['SelectedPaymentMethod']>, ParentType, ContextType>;
  shipping_addresses?: Resolver<Array<Maybe<ResolversTypes['ShippingCartAddress']>>, ParentType, ContextType>;
  total_quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartAddressCountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartAddressCountry'] = ResolversParentTypes['CartAddressCountry']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartAddressInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartAddressInterface'] = ResolversParentTypes['CartAddressInterface']> = {
  __resolveType: TypeResolveFn<'BillingCartAddress' | 'ShippingCartAddress', ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['CartAddressCountry'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['CartAddressRegion']>, ParentType, ContextType>;
  street?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  telephone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CartAddressRegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartAddressRegion'] = ResolversParentTypes['CartAddressRegion']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartDiscount'] = ResolversParentTypes['CartDiscount']> = {
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  label?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemInterface'] = ResolversParentTypes['CartItemInterface']> = {
  __resolveType: TypeResolveFn<'BundleCartItem' | 'ConfigurableCartItem' | 'DownloadableCartItem' | 'SimpleCartItem' | 'VirtualCartItem', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type CartItemMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemMeta'] = ResolversParentTypes['CartItemMeta']> = {
  additional_data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applied_rule_ids?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_discount_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  base_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  base_price_incl_tax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  base_row_total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  base_row_total_incl_tax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  custom_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_percent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_qty_decimal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_virtual?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  no_discount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  original_custom_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parent_item_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_incl_tax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  row_total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  row_total_incl_tax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  row_total_with_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  row_weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartItemPricesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemPrices'] = ResolversParentTypes['CartItemPrices']> = {
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  row_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  row_total_including_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total_item_discount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartItemQuantityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemQuantity'] = ResolversParentTypes['CartItemQuantity']> = {
  cart_item_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartItemReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemReference'] = ResolversParentTypes['CartItemReference']> = {
  cart_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cart_item_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cart_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cart_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['LocalCartItemInterface']>>>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_selected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  local_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logics?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemReferenceLogic']>>>, ParentType, ContextType>;
  parent_product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartItemReferenceActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemReferenceAction'] = ResolversParentTypes['CartItemReferenceAction']> = {
  action_note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  action_product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  action_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  action_type?: Resolver<Maybe<ResolversTypes['ActionType']>, ParentType, ContextType>;
  action_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cart_item_reference_logic_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result_quote_item_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartItemReferenceLogicResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemReferenceLogic'] = ResolversParentTypes['CartItemReferenceLogic']> = {
  actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemReferenceAction']>>>, ParentType, ContextType>;
  allocated_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cart_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logic_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logic_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logic_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  session_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartItemSelectedOptionValuePriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemSelectedOptionValuePrice'] = ResolversParentTypes['CartItemSelectedOptionValuePrice']> = {
  type?: Resolver<ResolversTypes['PriceTypeEnum'], ParentType, ContextType>;
  units?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartItemsOnlyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartItemsOnly'] = ResolversParentTypes['CartItemsOnly']> = {
  cart_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemInterface']>>>, ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items_qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartLevelGiftRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartLevelGiftRule'] = ResolversParentTypes['CartLevelGiftRule']> = {
  available_gifts?: Resolver<Array<ResolversTypes['GiftProduct']>, ParentType, ContextType>;
  conditions_text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gift_selection_type?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  is_effective?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_eligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  max_selections?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rule_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rule_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rule_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selected_gifts?: Resolver<Array<ResolversTypes['SelectedGift']>, ParentType, ContextType>;
  sort_order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stop_rules_processing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  threshold_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartLevelGiftsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartLevelGiftsOutput'] = ResolversParentTypes['CartLevelGiftsOutput']> = {
  active_rule_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  active_rule_ids?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  effective_rules?: Resolver<Array<ResolversTypes['CartLevelGiftRule']>, ParentType, ContextType>;
  has_exclusive_conflict?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CartLevelGiftRule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartMeta'] = ResolversParentTypes['CartMeta']> = {
  applied_rule_ids?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_grand_total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  base_subtotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  base_subtotal_with_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  confirm_by_phone?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  coupon_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_dob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_middlename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_note_notify?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customer_prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_taxvat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grand_total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  is_changed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemMeta']>>>, ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quote_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shipping_note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  store_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  store_to_base_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  store_to_quote_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subtotal_with_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartPricesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartPrices'] = ResolversParentTypes['CartPrices']> = {
  applied_taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartTaxItem']>>>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['CartDiscount']>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  grand_total?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  subtotal_excluding_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  subtotal_including_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  subtotal_with_discount_excluding_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartSyncItemErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartSyncItemError'] = ResolversParentTypes['CartSyncItemError']> = {
  cart_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error_code?: Resolver<ResolversTypes['CartSyncItemErrorCode'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartTaxItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartTaxItem'] = ResolversParentTypes['CartTaxItem']> = {
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogProductsListWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogProductsListWidget'] = ResolversParentTypes['CatalogProductsListWidget']> = {
  cache_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  config?: Resolver<Maybe<ResolversTypes['ProductListConfig']>, ParentType, ContextType>;
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_lazy_loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  skus?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogStatusMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogStatusMessageResponse'] = ResolversParentTypes['CatalogStatusMessageResponse']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryBannersResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryBanners'] = ResolversParentTypes['CategoryBanners']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Banner']>>>, ParentType, ContextType>;
  layout?: Resolver<Maybe<ResolversTypes['BannerLayoutData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryHighlightProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryHighlightProducts'] = ResolversParentTypes['CategoryHighlightProducts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryInterface'] = ResolversParentTypes['CategoryInterface']> = {
  __resolveType: TypeResolveFn<'CategoryTree', ParentType, ContextType>;
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  amtoolkit_robots?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  author_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  available_sort_by?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  background_app_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_active_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_active_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_head?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_menu_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_mobile_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_image_for_app?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_tags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  child_tags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  children_count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_block?: Resolver<Maybe<ResolversTypes['CmsBlock']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custom_layout_update_file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_sort_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featured_app_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featured_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filter_price_range?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  first_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourth_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_product_app_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_product_app_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_product_app_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_desktop_active_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_desktop_active_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_mobile_active_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_mobile_active_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  include_in_menu?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_anchor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_featured?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_virtual_category?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  landing_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  menu_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  menu_icon_over?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path_in_store?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularSearchKeywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_deal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_deal_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['CategoryProducts']>, ParentType, ContextType, RequireFields<CategoryInterfaceProductsArgs, 'currentPage' | 'pageSize'>>;
  searchindex_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  second_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  short_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slider_params?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  third_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_name_in_product_search?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_store_positions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  virtual_category_root?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  virtual_rule?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CategoryPostsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryPosts'] = ResolversParentTypes['CategoryPosts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Post']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryProducts'] = ResolversParentTypes['CategoryProducts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryTagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryTags'] = ResolversParentTypes['CategoryTags']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tag']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryTreeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryTree'] = ResolversParentTypes['CategoryTree']> = {
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  amtoolkit_robots?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  author_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  available_sort_by?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  background_app_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_active_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_active_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_head?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_menu_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_mobile_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_image_for_app?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_tags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  child_tags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  children?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryTree']>>>, ParentType, ContextType>;
  children_count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_block?: Resolver<Maybe<ResolversTypes['CmsBlock']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custom_layout_update_file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_sort_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featured_app_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featured_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filter_price_range?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  first_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourth_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_product_app_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_product_app_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_product_app_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_product_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attribute']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_desktop_active_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_desktop_active_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_mobile_active_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_mobile_active_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  include_in_menu?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_anchor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_featured?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_virtual_category?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  landing_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  menu_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  menu_icon_over?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path_in_store?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularSearchKeywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_deal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_deal_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['CategoryProducts']>, ParentType, ContextType, RequireFields<CategoryTreeProductsArgs, 'currentPage' | 'pageSize'>>;
  searchindex_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  second_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  short_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slider_params?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  third_post?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_name_in_product_search?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_store_positions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  virtual_category_root?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  virtual_rule?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutAgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutAgreement'] = ResolversParentTypes['CheckoutAgreement']> = {
  agreement_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  checkbox_text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_html?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['CheckoutAgreementMode'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CmsBlockResolvers<ContextType = any, ParentType extends ResolversParentTypes['CmsBlock'] = ResolversParentTypes['CmsBlock']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CmsBlocksResolvers<ContextType = any, ParentType extends ResolversParentTypes['CmsBlocks'] = ResolversParentTypes['CmsBlocks']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CmsBlock']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CmsPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CmsPage'] = ResolversParentTypes['CmsPage']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  page_layout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CmsPageConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['CmsPageConfig'] = ResolversParentTypes['CmsPageConfig']> = {
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CmsPageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CmsPageResponse'] = ResolversParentTypes['CmsPageResponse']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_fragment?: Resolver<Array<ResolversTypes['ContentFragment']>, ParentType, ContextType>;
  content_heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  page_layout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  social_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ColorSwatchDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ColorSwatchData'] = ResolversParentTypes['ColorSwatchData']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComplexTextValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComplexTextValue'] = ResolversParentTypes['ComplexTextValue']> = {
  html?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompositeImageWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompositeImageWidget'] = ResolversParentTypes['CompositeImageWidget']> = {
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['ImageItem']>>>, ParentType, ContextType>;
  is_lazy_loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Condition'] = ResolversParentTypes['Condition']> = {
  aggregator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Condition']>>>, ParentType, ContextType>;
  is_value_processed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigurableAttributeOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurableAttributeOption'] = ResolversParentTypes['ConfigurableAttributeOption']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value_index?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigurableCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurableCartItem'] = ResolversParentTypes['ConfigurableCartItem']> = {
  configurable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedConfigurableOption']>>, ParentType, ContextType>;
  configured_variant?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigurableLocalCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurableLocalCartItem'] = ResolversParentTypes['ConfigurableLocalCartItem']> = {
  cart_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  configurable_options?: Resolver<Array<ResolversTypes['SelectedConfigurableOption']>, ParentType, ContextType>;
  configured_variant?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  local_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigurableProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurableProduct'] = ResolversParentTypes['ConfigurableProduct']> = {
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  additional_data_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditionalDataAttribute']>>>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  am_offer_item_condition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appboxo_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  avatars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bao_hanh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  chat_lieu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chat_lieu_go?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chat_lieu_vai?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chon_so?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combo_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  configurable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableProductOptions']>>>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  denomination?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  dungtich?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSaleProductData']>, ParentType, ContextType>;
  gift_indexed_info?: Resolver<Maybe<Array<Maybe<ResolversTypes['GiftIndexedInfo']>>>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gram?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_bought?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupon_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gtin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_gift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hot_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  is_discount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_kids_gift?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_online_only?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kich_thuoc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  made_in?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  market_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  muivi?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nipple_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductNotification']>>>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_achievements?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductAchievement']>>>, ParentType, ContextType>;
  product_badges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductBadge']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products_combo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratings_summary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  related_products_two?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  so_tang?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold_quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soluong?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  upsell_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_cc?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_custom_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_guide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variants?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableVariant']>>>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weight_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigurableProductOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurableProductOptions'] = ResolversParentTypes['ConfigurableProductOptions']> = {
  attribute_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableProductOptionsValues']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigurableProductOptionsValuesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurableProductOptionsValues'] = ResolversParentTypes['ConfigurableProductOptionsValues']> = {
  default_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  store_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  swatch_data?: Resolver<Maybe<ResolversTypes['SwatchDataInterface']>, ParentType, ContextType>;
  use_default_value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  value_index?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigurableVariantResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurableVariant'] = ResolversParentTypes['ConfigurableVariant']> = {
  attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableAttributeOption']>>>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['SimpleProduct']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfirmRequestedValidationPhoneResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmRequestedValidationPhoneResponse'] = ResolversParentTypes['ConfirmRequestedValidationPhoneResponse']> = {
  error_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactDetails'] = ResolversParentTypes['ContactDetails']> = {
  contact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  socials?: Resolver<Maybe<Array<Maybe<ResolversTypes['SocialChannel']>>>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentFragmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentFragment'] = ResolversParentTypes['ContentFragment']> = {
  data?: Resolver<Maybe<ResolversTypes['ContentFragmentDataInterface']>, ParentType, ContextType>;
  html?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  widget_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentFragmentDataInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentFragmentDataInterface'] = ResolversParentTypes['ContentFragmentDataInterface']> = {
  __resolveType: TypeResolveFn<'CatalogProductsListWidget' | 'CompositeImageWidget' | 'FlashSaleWidget' | 'HtmlWidget' | 'IframeWidget' | 'ImageWidget' | 'StaticWidget', ParentType, ContextType>;
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_lazy_loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CoreConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoreConfig'] = ResolversParentTypes['CoreConfig']> = {
  image_upload_quantity_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image_upload_size_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  video_upload_quantity_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  video_upload_size_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Country'] = ResolversParentTypes['Country']> = {
  available_regions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType>;
  full_name_english?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  full_name_locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  three_letter_abbreviation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  two_letter_abbreviation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponContentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponContentResponse'] = ResolversParentTypes['CouponContentResponse']> = {
  background_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  border_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  condition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon_config_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instruction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_in_wallet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partner?: Resolver<Maybe<Array<Maybe<ResolversTypes['CouponPartner']>>>, ParentType, ContextType>;
  payment_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payment_method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payment_method_text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restriction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesrule?: Resolver<Maybe<ResolversTypes['Salesrule']>, ParentType, ContextType>;
  shipping_method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPartnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPartner'] = ResolversParentTypes['CouponPartner']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partner_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partner_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAnswerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAnswerResponse'] = ResolversParentTypes['CreateAnswerResponse']> = {
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateClientCredentialResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateClientCredentialResult'] = ResolversParentTypes['CreateClientCredentialResult']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateQuestionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateQuestionResponse'] = ResolversParentTypes['CreateQuestionResponse']> = {
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditMemoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditMemo'] = ResolversParentTypes['CreditMemo']> = {
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesCommentItem']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreditMemoItemInterface']>>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['CreditMemoTotal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditMemoItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditMemoItemInterface'] = ResolversParentTypes['CreditMemoItemInterface']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type CreditMemoTotalResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditMemoTotal'] = ResolversParentTypes['CreditMemoTotal']> = {
  adjustment?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  base_grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  shipping_handling?: Resolver<Maybe<ResolversTypes['ShippingHandling']>, ParentType, ContextType>;
  subtotal?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxItem']>>>, ParentType, ContextType>;
  total_shipping?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Currency'] = ResolversParentTypes['Currency']> = {
  available_currency_codes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  base_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_currency_symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currecy_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currecy_symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currency_symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exchange_rates?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExchangeRate']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomAttributeMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAttributeMetadata'] = ResolversParentTypes['CustomAttributeMetadata']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attribute']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = {
  addresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerAddress']>>>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_of_birth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_billing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_shipping?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faq?: Resolver<Maybe<ResolversTypes['CustomerFaq']>, ParentType, ContextType, RequireFields<CustomerFaqArgs, 'currentPage' | 'pageSize'>>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  group_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_subscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middlename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order_reviews?: Resolver<Maybe<ResolversTypes['MyOrderReviews']>, ParentType, ContextType, RequireFields<CustomerOrder_ReviewsArgs, 'page' | 'page_size'>>;
  orders?: Resolver<Maybe<ResolversTypes['CustomerOrders']>, ParentType, ContextType, RequireFields<CustomerOrdersArgs, 'currentPage' | 'pageSize'>>;
  phone_number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questions?: Resolver<Maybe<ResolversTypes['CustomerQuestions']>, ParentType, ContextType, RequireFields<CustomerQuestionsArgs, 'current_page' | 'page_size'>>;
  rank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referral_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviews?: Resolver<Maybe<ResolversTypes['CustomerReviewsResponse']>, ParentType, ContextType, RequireFields<CustomerReviewsArgs, 'filter'>>;
  search_keywords_history?: Resolver<Maybe<Array<ResolversTypes['SearchKeywordHistory']>>, ParentType, ContextType>;
  suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxvat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wishlist?: Resolver<ResolversTypes['Wishlist'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAccountDeletionListResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAccountDeletionListResponse'] = ResolversParentTypes['CustomerAccountDeletionListResponse']> = {
  items?: Resolver<Array<ResolversTypes['CustomerAccountDeletionResponse']>, ParentType, ContextType>;
  page_info?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAccountDeletionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAccountDeletionResponse'] = ResolversParentTypes['CustomerAccountDeletionResponse']> = {
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone_number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AccountDeletionStatus'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAddress'] = ResolversParentTypes['CustomerAddress']> = {
  address_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_code?: Resolver<Maybe<ResolversTypes['CountryCodeEnum']>, ParentType, ContextType>;
  country_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custom_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerAddressAttribute']>>>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  default_billing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  default_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  extension_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerAddressAttribute']>>>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  invoice_company_address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middlename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['CustomerAddressRegion']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ward?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ward_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAddressAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAddressAttribute'] = ResolversParentTypes['CustomerAddressAttribute']> = {
  attribute_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAddressRegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAddressRegion'] = ResolversParentTypes['CustomerAddressRegion']> = {
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerDownloadableProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerDownloadableProduct'] = ResolversParentTypes['CustomerDownloadableProduct']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  download_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order_increment_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remaining_downloads?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerDownloadableProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerDownloadableProducts'] = ResolversParentTypes['CustomerDownloadableProducts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerDownloadableProduct']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerFaqResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerFaq'] = ResolversParentTypes['CustomerFaq']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerFaqData']>>>, ParentType, ContextType>;
  pagination_metadata?: Resolver<Maybe<ResolversTypes['PaginationData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerFaqDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerFaqData'] = ResolversParentTypes['CustomerFaqData']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  create_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  item?: Resolver<Maybe<ResolversTypes['FaqItem']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  visibility?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerInformation'] = ResolversParentTypes['CustomerInformation']> = {
  profile?: Resolver<Maybe<ResolversTypes['CustomerProfile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerKicoinResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerKicoin'] = ResolversParentTypes['CustomerKicoin']> = {
  available?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerOrder'] = ResolversParentTypes['CustomerOrder']> = {
  billing_address?: Resolver<Maybe<ResolversTypes['OrderAddress']>, ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesCommentItem']>>>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  credit_memos?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreditMemo']>>>, ParentType, ContextType>;
  grand_total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  increment_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoices?: Resolver<Array<Maybe<ResolversTypes['Invoice']>>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemInterface']>>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order_date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order_number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payment_methods?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderPaymentMethod']>>>, ParentType, ContextType>;
  shipments?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderShipment']>>>, ParentType, ContextType>;
  shipping_address?: Resolver<Maybe<ResolversTypes['OrderAddress']>, ParentType, ContextType>;
  shipping_method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status_history?: Resolver<Maybe<ResolversTypes['OrderStatusHistory']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['OrderTotal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerOrderStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerOrderStats'] = ResolversParentTypes['CustomerOrderStats']> = {
  app_order_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completed_order_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last_order_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_sales_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  web_order_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerOrdersResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerOrders'] = ResolversParentTypes['CustomerOrders']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['CustomerOrder']>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerOrdersV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerOrdersV2'] = ResolversParentTypes['CustomerOrdersV2']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['CustomerOrder']>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerOutput'] = ResolversParentTypes['CustomerOutput']> = {
  customer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerPaymentTokensResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerPaymentTokens'] = ResolversParentTypes['CustomerPaymentTokens']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['PaymentToken']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerProfile'] = ResolversParentTypes['CustomerProfile']> = {
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerProfileSignResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerProfileSign'] = ResolversParentTypes['CustomerProfileSign']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sign?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerQuestion'] = ResolversParentTypes['CustomerQuestion']> = {
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  question?: Resolver<ResolversTypes['FaqQuestion'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerQuestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerQuestions'] = ResolversParentTypes['CustomerQuestions']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['CustomerQuestion']>>, ParentType, ContextType>;
  page_info?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerReferralCodeSignatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerReferralCodeSignature'] = ResolversParentTypes['CustomerReferralCodeSignature']> = {
  salt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sign?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerReviewsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerReviewsResponse'] = ResolversParentTypes['CustomerReviewsResponse']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Review']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerToken'] = ResolversParentTypes['CustomerToken']> = {
  access_token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires_in?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id_token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refresh_token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomizableOptionInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomizableOptionInterface'] = ResolversParentTypes['CustomizableOptionInterface']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CustomizableProductInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomizableProductInterface'] = ResolversParentTypes['CustomizableProductInterface']> = {
  __resolveType: TypeResolveFn<'BundleProduct' | 'ConfigurableProduct' | 'DownloadableProduct' | 'SimpleProduct' | 'VirtualProduct', ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeletePaymentTokenOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePaymentTokenOutput'] = ResolversParentTypes['DeletePaymentTokenOutput']> = {
  customerPaymentTokens?: Resolver<Maybe<ResolversTypes['CustomerPaymentTokens']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryTimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryTime'] = ResolversParentTypes['DeliveryTime']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Discount'] = ResolversParentTypes['Discount']> = {
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscountKicoinsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscountKicoins'] = ResolversParentTypes['DiscountKicoins']> = {
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayInfoItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayInfoItem'] = ResolversParentTypes['DisplayInfoItem']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistrictResolvers<ContextType = any, ParentType extends ResolversParentTypes['District'] = ResolversParentTypes['District']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DownloadableCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadableCartItem'] = ResolversParentTypes['DownloadableCartItem']> = {
  customizable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  links?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductLinks']>>>, ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  samples?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductSamples']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DownloadableLocalCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadableLocalCartItem'] = ResolversParentTypes['DownloadableLocalCartItem']> = {
  cart_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customizable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  links?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductLinks']>>>, ParentType, ContextType>;
  local_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  samples?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductSamples']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DownloadableProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadableProduct'] = ResolversParentTypes['DownloadableProduct']> = {
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  additional_data_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditionalDataAttribute']>>>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  am_offer_item_condition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appboxo_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  avatars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bao_hanh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  chat_lieu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chat_lieu_go?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chat_lieu_vai?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chon_so?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combo_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  denomination?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  downloadable_product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductLinks']>>>, ParentType, ContextType>;
  downloadable_product_samples?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductSamples']>>>, ParentType, ContextType>;
  dungtich?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSaleProductData']>, ParentType, ContextType>;
  gift_indexed_info?: Resolver<Maybe<Array<Maybe<ResolversTypes['GiftIndexedInfo']>>>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gram?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_bought?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupon_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gtin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_gift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hot_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  is_discount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_kids_gift?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_online_only?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kich_thuoc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  links_purchased_separately?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  links_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  made_in?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  market_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  muivi?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nipple_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductNotification']>>>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_achievements?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductAchievement']>>>, ParentType, ContextType>;
  product_badges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductBadge']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products_combo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratings_summary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  related_products_two?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  so_tang?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soluong?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  upsell_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_cc?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_custom_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_guide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DownloadableProductLinksResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadableProductLinks'] = ResolversParentTypes['DownloadableProductLinks']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_shareable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  link_type?: Resolver<Maybe<ResolversTypes['DownloadableFileTypeEnum']>, ParentType, ContextType>;
  number_of_downloads?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sample_file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sample_type?: Resolver<Maybe<ResolversTypes['DownloadableFileTypeEnum']>, ParentType, ContextType>;
  sample_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DownloadableProductSamplesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadableProductSamples'] = ResolversParentTypes['DownloadableProductSamples']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sample_file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sample_type?: Resolver<Maybe<ResolversTypes['DownloadableFileTypeEnum']>, ParentType, ContextType>;
  sample_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnabledPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnabledPaymentMethod'] = ResolversParentTypes['EnabledPaymentMethod']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instruction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntityUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntityUrl'] = ResolversParentTypes['EntityUrl']> = {
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  redirectCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventActivity'] = ResolversParentTypes['EventActivity']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_time?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  is_open_for_register?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start_time?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventActivityGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventActivityGroup'] = ResolversParentTypes['EventActivityGroup']> = {
  activities?: Resolver<Maybe<Array<Maybe<ResolversTypes['EventActivity']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventAttribute'] = ResolversParentTypes['EventAttribute']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventEntity'] = ResolversParentTypes['EventEntity']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_time?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  start_time?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  users_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventRegistrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventRegistration'] = ResolversParentTypes['EventRegistration']> = {
  activity?: Resolver<ResolversTypes['EventActivity'], ParentType, ContextType>;
  agreed_terms?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['EventEntity'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  registration_details?: Resolver<Maybe<Array<ResolversTypes['EventRegistrationDetails']>>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['EventUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventRegistrationDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventRegistrationDetails'] = ResolversParentTypes['EventRegistrationDetails']> = {
  birth_certificate_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birth_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  district_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  due_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  full_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  guardian_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guardian_phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phone_number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prenatal_checkup_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  region_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<ResolversTypes['EventRegistration'], ParentType, ContextType>;
  specific_address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ticket_exchange_store_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticket_exchange_store_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ward_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ward_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventUser'] = ResolversParentTypes['EventUser']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  birth_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contacted_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  district_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  district_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  full_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  participant_type?: Resolver<ResolversTypes['ParticipantType'], ParentType, ContextType>;
  phone_number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referral_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  region_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specific_address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user_temporary_id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ward_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ward_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExchangeRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExchangeRate'] = ResolversParentTypes['ExchangeRate']> = {
  currency_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecutePaymentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutePaymentResult'] = ResolversParentTypes['ExecutePaymentResult']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transaction_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqAnswer'] = ResolversParentTypes['FaqAnswer']> = {
  admin_answered?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdminAnswered']>>>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqArticleResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqArticle'] = ResolversParentTypes['FaqArticle']> = {
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqArticlesResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqArticles'] = ResolversParentTypes['FaqArticles']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqArticle']>>>, ParentType, ContextType>;
  pagination?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqCategoriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqCategories'] = ResolversParentTypes['FaqCategories']> = {
  faq_categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqCategory']>>>, ParentType, ContextType>;
  pagination?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqCategory'] = ResolversParentTypes['FaqCategory']> = {
  articles?: Resolver<Maybe<ResolversTypes['FaqArticles']>, ParentType, ContextType, RequireFields<FaqCategoryArticlesArgs, 'current_page' | 'page_size'>>;
  category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questions?: Resolver<Maybe<ResolversTypes['FaqCategoryQuestions']>, ParentType, ContextType, RequireFields<FaqCategoryQuestionsArgs, 'current_page' | 'page_size'>>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url_key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqCategoryAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqCategoryAnswer'] = ResolversParentTypes['FaqCategoryAnswer']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interactive_action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_admin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_satisfied?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_unsatisfied?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqCategoryQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqCategoryQuestion'] = ResolversParentTypes['FaqCategoryQuestion']> = {
  answers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqCategoryAnswer']>>>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url_key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqCategoryQuestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqCategoryQuestions'] = ResolversParentTypes['FaqCategoryQuestions']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqCategoryQuestion']>>>, ParentType, ContextType>;
  pagination?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqItem'] = ResolversParentTypes['FaqItem']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqListBySkuResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqListBySku'] = ResolversParentTypes['FaqListBySku']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqAnswer']>>>, ParentType, ContextType>;
  pagination?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqQuestion'] = ResolversParentTypes['FaqQuestion']> = {
  admin_answered?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdminAnswered']>>>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_purchased?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  like_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  liked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_satisfied?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqReactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqReaction'] = ResolversParentTypes['FaqReaction']> = {
  entity_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  entity_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqSuggestionTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqSuggestionTag'] = ResolversParentTypes['FaqSuggestionTag']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FastCartTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FastCartTotals'] = ResolversParentTypes['FastCartTotals']> = {
  cart_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  grand_total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  is_virtual?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items_qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shipping_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subtotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subtotal_with_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tax_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeaturedImageDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedImageData'] = ResolversParentTypes['FeaturedImageData']> = {
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FixedProductTaxResolvers<ContextType = any, ParentType extends ResolversParentTypes['FixedProductTax'] = ResolversParentTypes['FixedProductTax']> = {
  amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlashSaleResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlashSale'] = ResolversParentTypes['FlashSale']> = {
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deal_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deal_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flashsale_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flashsale_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_featured?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  out_of_stock?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold_out?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_ids?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlashSaleItemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlashSaleItems'] = ResolversParentTypes['FlashSaleItems']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FlashSaleProduct']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlashSaleProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlashSaleProduct'] = ResolversParentTypes['FlashSaleProduct']> = {
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  sales_data?: Resolver<Maybe<ResolversTypes['FlashSaleProductData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlashSaleProductDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlashSaleProductData'] = ResolversParentTypes['FlashSaleProductData']> = {
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deal_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deal_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deal_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deal_value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flashsale_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  limit_per_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrice']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sale_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_ids?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlashSaleProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlashSaleProducts'] = ResolversParentTypes['FlashSaleProducts']> = {
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSale']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FlashSaleProduct']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlashSaleProductsV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['FlashSaleProductsV2'] = ResolversParentTypes['FlashSaleProductsV2']> = {
  banner_items?: Resolver<Maybe<ResolversTypes['BannerItems']>, ParentType, ContextType>;
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSale']>, ParentType, ContextType>;
  flash_sale_items?: Resolver<Maybe<ResolversTypes['FlashSaleItems']>, ParentType, ContextType, RequireFields<FlashSaleProductsV2Flash_Sale_ItemsArgs, 'current_page' | 'page_size'>>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlashSaleWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlashSaleWidget'] = ResolversParentTypes['FlashSaleWidget']> = {
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_lazy_loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FooterConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['FooterConfig'] = ResolversParentTypes['FooterConfig']> = {
  html_content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  image_url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormAttributeValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormAttributeValue'] = ResolversParentTypes['FormAttributeValue']> = {
  attribute_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormConfig'] = ResolversParentTypes['FormConfig']> = {
  configs?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormValue'] = ResolversParentTypes['FormValue']> = {
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormAttributeValue']>>>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FreeGiftCartResolvers<ContextType = any, ParentType extends ResolversParentTypes['FreeGiftCart'] = ResolversParentTypes['FreeGiftCart']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemInterface']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FreeGiftsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FreeGifts'] = ResolversParentTypes['FreeGifts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FreeGiftsData']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FreeGiftsDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FreeGiftsData'] = ResolversParentTypes['FreeGiftsData']> = {
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  rule?: Resolver<Maybe<ResolversTypes['Rule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeneratedOtpTokenResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneratedOtpTokenResponse'] = ResolversParentTypes['GeneratedOtpTokenResponse']> = {
  secret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCmsPageSchemaByIdentifierResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCmsPageSchemaByIdentifierResponse'] = ResolversParentTypes['GetCmsPageSchemaByIdentifierResponse']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetFaqListBySkuResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetFaqListBySkuResponse'] = ResolversParentTypes['GetFaqListBySkuResponse']> = {
  current_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqAnswer']>>>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_pages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['GiftCartItem'] = ResolversParentTypes['GiftCartItem']> = {
  gift_item?: Resolver<Maybe<ResolversTypes['CartItemInterface']>, ParentType, ContextType>;
  rule?: Resolver<Maybe<ResolversTypes['Rule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['GiftError'] = ResolversParentTypes['GiftError']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftIndexedInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GiftIndexedInfo'] = ResolversParentTypes['GiftIndexedInfo']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image_urls?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  rule_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['GiftProduct'] = ResolversParentTypes['GiftProduct']> = {
  max_qty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftRuleThresholdResolvers<ContextType = any, ParentType extends ResolversParentTypes['GiftRuleThreshold'] = ResolversParentTypes['GiftRuleThreshold']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_unlocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  max_selections?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progress_percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  remaining_amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rule_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rule_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rule_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  threshold_amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftRuleThresholdsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['GiftRuleThresholdsOutput'] = ResolversParentTypes['GiftRuleThresholdsOutput']> = {
  current_subtotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['GiftRuleThreshold']>, ParentType, ContextType>;
  next_milestone?: Resolver<Maybe<ResolversTypes['GiftRuleThreshold']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupedProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupedProduct'] = ResolversParentTypes['GroupedProduct']> = {
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  additional_data_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditionalDataAttribute']>>>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  am_offer_item_condition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appboxo_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  avatars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bao_hanh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  chat_lieu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chat_lieu_go?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chat_lieu_vai?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chon_so?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combo_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  denomination?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  dungtich?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSaleProductData']>, ParentType, ContextType>;
  gift_indexed_info?: Resolver<Maybe<Array<Maybe<ResolversTypes['GiftIndexedInfo']>>>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gram?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_bought?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupon_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gtin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_gift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hot_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  is_discount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_kids_gift?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_online_only?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['GroupedProductItem']>>>, ParentType, ContextType>;
  kich_thuoc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  made_in?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  market_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  muivi?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nipple_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductNotification']>>>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_achievements?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductAchievement']>>>, ParentType, ContextType>;
  product_badges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductBadge']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products_combo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratings_summary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  related_products_two?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  so_tang?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soluong?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  upsell_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_cc?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_custom_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_guide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weight_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupedProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupedProductItem'] = ResolversParentTypes['GroupedProductItem']> = {
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightBrandResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighlightBrand'] = ResolversParentTypes['HighlightBrand']> = {
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banner_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_products?: Resolver<Maybe<ResolversTypes['Products']>, ParentType, ContextType, Partial<HighlightBrandHighlight_ProductsArgs>>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  like_count?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  review_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold_count?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  title_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wp_posts?: Resolver<Maybe<ResolversTypes['Posts']>, ParentType, ContextType, Partial<HighlightBrandWp_PostsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightBrandsResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighlightBrands'] = ResolversParentTypes['HighlightBrands']> = {
  category_layout?: Resolver<Maybe<ResolversTypes['BrandLayout']>, ParentType, ContextType>;
  homepage_layout?: Resolver<Maybe<ResolversTypes['BrandLayout']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['HighlightBrand']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightCategoriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighlightCategories'] = ResolversParentTypes['HighlightCategories']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['HighlightCategory']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighlightCategory'] = ResolversParentTypes['HighlightCategory']> = {
  background_app_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featured_app_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featured_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featured_icon_solid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightProductBlocksResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighlightProductBlocks'] = ResolversParentTypes['HighlightProductBlocks']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductBlock']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighlightProductItem'] = ResolversParentTypes['HighlightProductItem']> = {
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighlightProducts'] = ResolversParentTypes['HighlightProducts']> = {
  highlight_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['HighlightProductItem']>>>, ParentType, ContextType>;
  hot_new_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomePageFloatBannerResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomePageFloatBanner'] = ResolversParentTypes['HomePageFloatBanner']> = {
  left_banner_img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  left_banner_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  right_banner_img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  right_banner_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomepageFeaturedBlockResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomepageFeaturedBlock'] = ResolversParentTypes['HomepageFeaturedBlock']> = {
  app_banner_images?: Resolver<Maybe<ResolversTypes['BannerItems']>, ParentType, ContextType>;
  category_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryTree']>>>, ParentType, ContextType>;
  featured_images?: Resolver<Maybe<Array<Maybe<ResolversTypes['FeaturedImageData']>>>, ParentType, ContextType>;
  highlight_attribute?: Resolver<Maybe<ResolversTypes['Aggregation']>, ParentType, ContextType>;
  highlight_item?: Resolver<Maybe<ResolversTypes['HighlightProductItem']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layout_product_app?: Resolver<Maybe<ResolversTypes['LayoutData']>, ParentType, ContextType>;
  limit_product_block?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  limit_product_homepage_app?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  limit_product_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mobile_banner_images?: Resolver<Maybe<Array<Maybe<ResolversTypes['Banner']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_app_items?: Resolver<Maybe<ResolversTypes['Products']>, ParentType, ContextType, Partial<HomepageFeaturedBlockProduct_App_ItemsArgs>>;
  product_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Aggregation']>>>, ParentType, ContextType>;
  product_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomepagePopularSearchKeywordsResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomepagePopularSearchKeywords'] = ResolversParentTypes['HomepagePopularSearchKeywords']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomepagePostsResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomepagePosts'] = ResolversParentTypes['HomepagePosts']> = {
  background_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Post']>>>, ParentType, ContextType>;
  post_banner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomepageProductsLightweightResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomepageProductsLightweight'] = ResolversParentTypes['HomepageProductsLightweight']> = {
  bestseller_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['LightweightProductItem']>>>, ParentType, ContextType>;
  hot_new_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['LightweightProductItem']>>>, ParentType, ContextType>;
  new_arrival_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['LightweightProductItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HtmlWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['HtmlWidget'] = ResolversParentTypes['HtmlWidget']> = {
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_lazy_loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HttpQueryParameterResolvers<ContextType = any, ParentType extends ResolversParentTypes['HttpQueryParameter'] = ResolversParentTypes['HttpQueryParameter']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityAuthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityAuthResult'] = ResolversParentTypes['IdentityAuthResult']> = {
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresIn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  idpAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  idpIdToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  idpRefreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  session?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tokenType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityMagentoTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityMagentoToken'] = ResolversParentTypes['IdentityMagentoToken']> = {
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresIn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityOtpChallengeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityOtpChallengeResponse'] = ResolversParentTypes['IdentityOtpChallengeResponse']> = {
  challengeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isNewUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  session?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityRefreshResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityRefreshResult'] = ResolversParentTypes['IdentityRefreshResult']> = {
  accessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresIn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  idToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentitySignUpResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentitySignUpResult'] = ResolversParentTypes['IdentitySignUpResult']> = {
  cognitoSub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commerceAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commerceExpiresIn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commerceRefreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IframeWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['IframeWidget'] = ResolversParentTypes['IframeWidget']> = {
  class_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iframe_url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  is_lazy_loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageItem'] = ResolversParentTypes['ImageItem']> = {
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  html_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageSwatchDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageSwatchData'] = ResolversParentTypes['ImageSwatchData']> = {
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageWidget'] = ResolversParentTypes['ImageWidget']> = {
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  html_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  is_lazy_loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestedProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterestedProducts'] = ResolversParentTypes['InterestedProducts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesCommentItem']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['InvoiceItemInterface']>>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['InvoiceTotal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceItemInterface'] = ResolversParentTypes['InvoiceItemInterface']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type InvoiceTotalResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceTotal'] = ResolversParentTypes['InvoiceTotal']> = {
  base_grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  shipping_handling?: Resolver<Maybe<ResolversTypes['ShippingHandling']>, ParentType, ContextType>;
  subtotal?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxItem']>>>, ParentType, ContextType>;
  total_shipping?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IsEmailAvailableOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['IsEmailAvailableOutput'] = ResolversParentTypes['IsEmailAvailableOutput']> = {
  is_email_available?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IssuedCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['IssuedCoupon'] = ResolversParentTypes['IssuedCoupon']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  masked_phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  uses_per_customer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ItemStatus'] = ResolversParentTypes['ItemStatus']> = {
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stock_status?: Resolver<ResolversTypes['StockStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type KeyValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeyValue'] = ResolversParentTypes['KeyValue']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeywordsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Keywords'] = ResolversParentTypes['Keywords']> = {
  tag_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayerFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayerFilter'] = ResolversParentTypes['LayerFilter']> = {
  filter_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['LayerFilterItemInterface']>>>, ParentType, ContextType>;
  filter_items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  request_var?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayerFilterItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayerFilterItemInterface'] = ResolversParentTypes['LayerFilterItemInterface']> = {
  __resolveType: TypeResolveFn<'SwatchLayerFilterItem', ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value_string?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['Layout'] = ResolversParentTypes['Layout']> = {
  entities?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layout_handle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layout_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  page_for?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  page_group?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutData'] = ResolversParentTypes['LayoutData']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LightweightPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LightweightPageInfo'] = ResolversParentTypes['LightweightPageInfo']> = {
  current_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  page_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_pages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LightweightPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['LightweightPrice'] = ResolversParentTypes['LightweightPrice']> = {
  discount?: Resolver<Maybe<ResolversTypes['ProductDiscount']>, ParentType, ContextType>;
  final_price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  regular_price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LightweightPriceRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LightweightPriceRange'] = ResolversParentTypes['LightweightPriceRange']> = {
  maximum_price?: Resolver<Maybe<ResolversTypes['LightweightPrice']>, ParentType, ContextType>;
  minimum_price?: Resolver<Maybe<ResolversTypes['LightweightPrice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LightweightProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LightweightProductItem'] = ResolversParentTypes['LightweightProductItem']> = {
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_gift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hot_product?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_product?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price_range?: Resolver<Maybe<ResolversTypes['LightweightPriceRange']>, ParentType, ContextType>;
  product_badge_ids?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratings_summary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LightweightProductListResolvers<ContextType = any, ParentType extends ResolversParentTypes['LightweightProductList'] = ResolversParentTypes['LightweightProductList']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['LightweightProductItem']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['LightweightPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocalCartItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalCartItemInterface'] = ResolversParentTypes['LocalCartItemInterface']> = {
  __resolveType: TypeResolveFn<'ConfigurableLocalCartItem' | 'DownloadableLocalCartItem' | 'SimpleLocalCartItem' | 'VirtualLocalCartItem', ParentType, ContextType>;
  cart_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  local_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type LoginSuccessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginSuccessResponse'] = ResolversParentTypes['LoginSuccessResponse']> = {
  cookies?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoData'] = ResolversParentTypes['LogoData']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  original?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupCustomerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LookupCustomerResponse'] = ResolversParentTypes['LookupCustomerResponse']> = {
  is_existed_phone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketingAppliedCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingAppliedCoupon'] = ResolversParentTypes['MarketingAppliedCoupon']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketingRequestLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingRequestLog'] = ResolversParentTypes['MarketingRequestLog']> = {
  action_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  operation_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  raw_payload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  request_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['MarketingRequestLogStatus']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaGalleryEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaGalleryEntry'] = ResolversParentTypes['MediaGalleryEntry']> = {
  content?: Resolver<Maybe<ResolversTypes['ProductMediaGalleryEntriesContent']>, ParentType, ContextType>;
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  media_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  types?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  video_content?: Resolver<Maybe<ResolversTypes['ProductMediaGalleryEntriesVideoContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaGalleryInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaGalleryInterface'] = ResolversParentTypes['MediaGalleryInterface']> = {
  __resolveType: TypeResolveFn<'ProductImage' | 'ProductVideo', ParentType, ContextType>;
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type MoneyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Money'] = ResolversParentTypes['Money']> = {
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addBundleProductsToCart?: Resolver<Maybe<ResolversTypes['AddBundleProductsToCartOutput']>, ParentType, ContextType, Partial<MutationAddBundleProductsToCartArgs>>;
  addCartLevelGiftsToCart?: Resolver<Maybe<ResolversTypes['AddCartLevelGiftsOutput']>, ParentType, ContextType, RequireFields<MutationAddCartLevelGiftsToCartArgs, 'input'>>;
  addConfigurableProductsToCart?: Resolver<Maybe<ResolversTypes['AddConfigurableProductsToCartOutput']>, ParentType, ContextType, Partial<MutationAddConfigurableProductsToCartArgs>>;
  addCouponToMyList?: Resolver<Maybe<ResolversTypes['StatusMessageResponse']>, ParentType, ContextType, RequireFields<MutationAddCouponToMyListArgs, 'coupon_code'>>;
  addDeviceToUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddDeviceToUserArgs, 'push_id' | 'push_token' | 'type_device'>>;
  addDownloadableProductsToCart?: Resolver<Maybe<ResolversTypes['AddDownloadableProductsToCartOutput']>, ParentType, ContextType, Partial<MutationAddDownloadableProductsToCartArgs>>;
  addGiftsToCart?: Resolver<Maybe<ResolversTypes['AddGiftsToCartOutput']>, ParentType, ContextType, Partial<MutationAddGiftsToCartArgs>>;
  addNewIp?: Resolver<ResolversTypes['Result'], ParentType, ContextType, RequireFields<MutationAddNewIpArgs, 'ip'>>;
  addProductToWishlist?: Resolver<Maybe<ResolversTypes['ProductToWishlistOutput']>, ParentType, ContextType, Partial<MutationAddProductToWishlistArgs>>;
  addSimpleProductsToCart?: Resolver<Maybe<ResolversTypes['AddSimpleProductsToCartOutput']>, ParentType, ContextType, Partial<MutationAddSimpleProductsToCartArgs>>;
  addVirtualProductsToCart?: Resolver<Maybe<ResolversTypes['AddVirtualProductsToCartOutput']>, ParentType, ContextType, Partial<MutationAddVirtualProductsToCartArgs>>;
  applyCouponToCart?: Resolver<Maybe<ResolversTypes['ApplyCouponToCartOutput']>, ParentType, ContextType, Partial<MutationApplyCouponToCartArgs>>;
  applyKicoins?: Resolver<Maybe<ResolversTypes['ApplyKicoinsOutput']>, ParentType, ContextType, Partial<MutationApplyKicoinsArgs>>;
  applyUniversalCode?: Resolver<Maybe<ResolversTypes['ApplyUniversalCodePayload']>, ParentType, ContextType, Partial<MutationApplyUniversalCodeArgs>>;
  assignCustomerToGuestCart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType, RequireFields<MutationAssignCustomerToGuestCartArgs, 'cart_id'>>;
  assignProviderToClient?: Resolver<ResolversTypes['Result'], ParentType, ContextType, RequireFields<MutationAssignProviderToClientArgs, 'clientId' | 'credentialProviderId'>>;
  cancelCustomerOrder?: Resolver<Maybe<ResolversTypes['StatusMessageResponse']>, ParentType, ContextType, RequireFields<MutationCancelCustomerOrderArgs, 'input'>>;
  changeCustomerPassword?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType, RequireFields<MutationChangeCustomerPasswordArgs, 'currentPassword' | 'newPassword'>>;
  configureSmsServiceProvider?: Resolver<ResolversTypes['Result'], ParentType, ContextType, RequireFields<MutationConfigureSmsServiceProviderArgs, 'provider' | 'providerId' | 'providerSecret' | 'serviceProviderName'>>;
  confirmRequestedValidationPhone?: Resolver<ResolversTypes['ConfirmRequestedValidationPhoneResponse'], ParentType, ContextType, RequireFields<MutationConfirmRequestedValidationPhoneArgs, 'otp' | 'phone_number' | 'secret'>>;
  createAnswer?: Resolver<Maybe<ResolversTypes['CreateAnswerResponse']>, ParentType, ContextType, Partial<MutationCreateAnswerArgs>>;
  createBraintreeClientToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createClient?: Resolver<ResolversTypes['CreateClientCredentialResult'], ParentType, ContextType, RequireFields<MutationCreateClientArgs, 'clientName'>>;
  createClientQuota?: Resolver<ResolversTypes['Result'], ParentType, ContextType, RequireFields<MutationCreateClientQuotaArgs, 'clientId' | 'quotaAmount' | 'quotaLevel'>>;
  createCustomerAddress?: Resolver<Maybe<ResolversTypes['CustomerAddress']>, ParentType, ContextType, RequireFields<MutationCreateCustomerAddressArgs, 'input'>>;
  createEmptyCart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MutationCreateEmptyCartArgs>>;
  createEmptyWebCart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType>;
  createEventRegistration?: Resolver<Maybe<Array<ResolversTypes['EventRegistration']>>, ParentType, ContextType, Partial<MutationCreateEventRegistrationArgs>>;
  createQuestion?: Resolver<Maybe<ResolversTypes['CreateQuestionResponse']>, ParentType, ContextType, Partial<MutationCreateQuestionArgs>>;
  deleteAllIps?: Resolver<ResolversTypes['Result'], ParentType, ContextType>;
  deleteCustomerAddress?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteCustomerAddressArgs, 'id'>>;
  deletePaymentToken?: Resolver<Maybe<ResolversTypes['DeletePaymentTokenOutput']>, ParentType, ContextType, RequireFields<MutationDeletePaymentTokenArgs, 'public_hash'>>;
  deleteSearchKeyword?: Resolver<ResolversTypes['StatusMessageResponse'], ParentType, ContextType, RequireFields<MutationDeleteSearchKeywordArgs, 'query'>>;
  exchangeIdentityToken?: Resolver<ResolversTypes['IdentityMagentoToken'], ParentType, ContextType, RequireFields<MutationExchangeIdentityTokenArgs, 'idpAccessToken' | 'idpIdToken'>>;
  executePayment?: Resolver<ResolversTypes['ExecutePaymentResult'], ParentType, ContextType, RequireFields<MutationExecutePaymentArgs, 'input'>>;
  generateCustomerProfileSign?: Resolver<Maybe<ResolversTypes['CustomerProfileSign']>, ParentType, ContextType>;
  generateCustomerToken?: Resolver<Maybe<ResolversTypes['CustomerToken']>, ParentType, ContextType, RequireFields<MutationGenerateCustomerTokenArgs, 'email' | 'password'>>;
  generateReferralCode?: Resolver<ResolversTypes['ReferralCodeResponse'], ParentType, ContextType>;
  identitySignUp?: Resolver<ResolversTypes['IdentitySignUpResult'], ParentType, ContextType, RequireFields<MutationIdentitySignUpArgs, 'email' | 'firstName' | 'lastName' | 'phoneNumber'>>;
  initiateIdentityOtpChallenge?: Resolver<ResolversTypes['IdentityOtpChallengeResponse'], ParentType, ContextType, RequireFields<MutationInitiateIdentityOtpChallengeArgs, 'phoneNumber'>>;
  initiatePasswordResetByPhone?: Resolver<ResolversTypes['GeneratedOtpTokenResponse'], ParentType, ContextType, RequireFields<MutationInitiatePasswordResetByPhoneArgs, 'phone_number'>>;
  likeBrand?: Resolver<ResolversTypes['CatalogStatusMessageResponse'], ParentType, ContextType, RequireFields<MutationLikeBrandArgs, 'action' | 'brand_id'>>;
  loginCustomerByUsernameAndPassword?: Resolver<ResolversTypes['CustomerToken'], ParentType, ContextType, RequireFields<MutationLoginCustomerByUsernameAndPasswordArgs, 'password' | 'phone_number'>>;
  loginWithPhoneAndOtp?: Resolver<ResolversTypes['CustomerToken'], ParentType, ContextType, RequireFields<MutationLoginWithPhoneAndOtpArgs, 'device' | 'otp' | 'phone_number' | 'secret' | 'sign'>>;
  markAllNotificationAsRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  markNotificationAsRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationMarkNotificationAsReadArgs, 'notification_id'>>;
  marketingApplyCode?: Resolver<ResolversTypes['ApplyCodeResponse'], ParentType, ContextType, RequireFields<MutationMarketingApplyCodeArgs, 'cart_id' | 'code'>>;
  marketingApplyVoucherFromAllocation?: Resolver<ResolversTypes['ApplyVoucherResponse'], ParentType, ContextType, RequireFields<MutationMarketingApplyVoucherFromAllocationArgs, 'allocation_id' | 'cart_id'>>;
  marketingRemoveAppliedVoucher?: Resolver<ResolversTypes['ApplyVoucherResponse'], ParentType, ContextType, RequireFields<MutationMarketingRemoveAppliedVoucherArgs, 'cart_id' | 'voucher_id'>>;
  marketingRemoveCode?: Resolver<ResolversTypes['RemoveCodeResponse'], ParentType, ContextType, RequireFields<MutationMarketingRemoveCodeArgs, 'cart_id' | 'code_id' | 'type'>>;
  mergeCarts?: Resolver<ResolversTypes['Cart'], ParentType, ContextType, RequireFields<MutationMergeCartsArgs, 'destination_cart_id' | 'source_cart_id'>>;
  placeOrder?: Resolver<Maybe<ResolversTypes['PlaceOrderOutput']>, ParentType, ContextType, Partial<MutationPlaceOrderArgs>>;
  pushAddToCartErrorInternalEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushAddToCartErrorInternalEventArgs>>;
  pushAddToCartTrackingEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushAddToCartTrackingEventArgs>>;
  pushApiErrorInternalEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushApiErrorInternalEventArgs>>;
  pushAuthErrorInternalEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushAuthErrorInternalEventArgs>>;
  pushBeginAddToCartInternalEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushBeginAddToCartInternalEventArgs>>;
  pushCompleteRegistrationTrackingEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushCompleteRegistrationTrackingEventArgs>>;
  pushInitiateCheckoutTrackingEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushInitiateCheckoutTrackingEventArgs>>;
  pushLoginTrackingEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushLoginTrackingEventArgs>>;
  pushLogoutInternalEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushLogoutInternalEventArgs>>;
  pushPurchaseTrackingEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushPurchaseTrackingEventArgs>>;
  pushScrollDepthInternalEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationPushScrollDepthInternalEventArgs>>;
  recalculateCartTotals?: Resolver<Maybe<ResolversTypes['RecalculateCartTotalsOutput']>, ParentType, ContextType, RequireFields<MutationRecalculateCartTotalsArgs, 'input'>>;
  refreshIdentitySession?: Resolver<ResolversTypes['IdentityRefreshResult'], ParentType, ContextType, RequireFields<MutationRefreshIdentitySessionArgs, 'refreshToken'>>;
  refreshToken?: Resolver<ResolversTypes['CustomerToken'], ParentType, ContextType, RequireFields<MutationRefreshTokenArgs, 'refresh_token'>>;
  registerNewAccountByOtp?: Resolver<ResolversTypes['RegisterResponse'], ParentType, ContextType, RequireFields<MutationRegisterNewAccountByOtpArgs, 'accountInfo' | 'otp' | 'phone_number' | 'secret'>>;
  registerUserToEvent?: Resolver<ResolversTypes['EventUser'], ParentType, ContextType, RequireFields<MutationRegisterUserToEventArgs, 'input'>>;
  removeCartLevelGiftFromCart?: Resolver<Maybe<ResolversTypes['RemoveCartLevelGiftOutput']>, ParentType, ContextType, RequireFields<MutationRemoveCartLevelGiftFromCartArgs, 'input'>>;
  removeCouponFromCart?: Resolver<Maybe<ResolversTypes['RemoveCouponFromCartOutput']>, ParentType, ContextType, Partial<MutationRemoveCouponFromCartArgs>>;
  removeIp?: Resolver<ResolversTypes['Result'], ParentType, ContextType, RequireFields<MutationRemoveIpArgs, 'ip'>>;
  removeItemFromCart?: Resolver<Maybe<ResolversTypes['RemoveItemFromCartOutput']>, ParentType, ContextType, Partial<MutationRemoveItemFromCartArgs>>;
  removeKicoins?: Resolver<Maybe<ResolversTypes['RemoveKicoinsOutput']>, ParentType, ContextType, Partial<MutationRemoveKicoinsArgs>>;
  removeUniversalCode?: Resolver<Maybe<ResolversTypes['RemoveUniversalCodeOutput']>, ParentType, ContextType, Partial<MutationRemoveUniversalCodeArgs>>;
  requestCustomerAccountDeletion?: Resolver<ResolversTypes['StatusMessageResponse'], ParentType, ContextType>;
  requestValidatePhone?: Resolver<ResolversTypes['RequestValidatePhoneResponse'], ParentType, ContextType, RequireFields<MutationRequestValidatePhoneArgs, 'notificationChannel' | 'phone_number' | 'validateType'>>;
  resetPasswordByOtp?: Resolver<ResolversTypes['ResetPasswordResponse'], ParentType, ContextType, RequireFields<MutationResetPasswordByOtpArgs, 'new_password' | 'otp' | 'phone_number' | 'secret'>>;
  revokeCustomerToken?: Resolver<Maybe<ResolversTypes['RevokeCustomerTokenOutput']>, ParentType, ContextType>;
  saveFaqAnswer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationSaveFaqAnswerArgs>>;
  saveFaqInteractive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationSaveFaqInteractiveArgs>>;
  saveFaqQuestion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationSaveFaqQuestionArgs>>;
  saveFaqReaction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSaveFaqReactionArgs, 'entity_id' | 'entity_type' | 'reaction_type'>>;
  saveReviewReaction?: Resolver<Maybe<ResolversTypes['ReviewReactionResponse']>, ParentType, ContextType, RequireFields<MutationSaveReviewReactionArgs, 'input'>>;
  sendOrderReview?: Resolver<Maybe<ResolversTypes['StatusMessageResponse']>, ParentType, ContextType, RequireFields<MutationSendOrderReviewArgs, 'captchaResponseToken' | 'order' | 'reviewRequest'>>;
  sendReview?: Resolver<Maybe<ResolversTypes['Review']>, ParentType, ContextType, RequireFields<MutationSendReviewArgs, 'captchaResponseToken' | 'reviewRequest'>>;
  setBillingAddressOnCart?: Resolver<Maybe<ResolversTypes['SetBillingAddressOnCartOutput']>, ParentType, ContextType, Partial<MutationSetBillingAddressOnCartArgs>>;
  setGuestEmailOnCart?: Resolver<Maybe<ResolversTypes['SetGuestEmailOnCartOutput']>, ParentType, ContextType, Partial<MutationSetGuestEmailOnCartArgs>>;
  setPaymentMethodAndPlaceOrder?: Resolver<Maybe<ResolversTypes['PlaceOrderOutput']>, ParentType, ContextType, Partial<MutationSetPaymentMethodAndPlaceOrderArgs>>;
  setPaymentMethodOnCart?: Resolver<Maybe<ResolversTypes['SetPaymentMethodOnCartOutput']>, ParentType, ContextType, Partial<MutationSetPaymentMethodOnCartArgs>>;
  setShippingAddressesOnCart?: Resolver<Maybe<ResolversTypes['SetShippingAddressesOnCartOutput']>, ParentType, ContextType, Partial<MutationSetShippingAddressesOnCartArgs>>;
  setShippingMethodsOnCart?: Resolver<Maybe<ResolversTypes['SetShippingMethodsOnCartOutput']>, ParentType, ContextType, Partial<MutationSetShippingMethodsOnCartArgs>>;
  submitForm?: Resolver<Maybe<ResolversTypes['FormValue']>, ParentType, ContextType, RequireFields<MutationSubmitFormArgs, 'input'>>;
  synchronizeCart?: Resolver<Maybe<ResolversTypes['SynchronizeCartPayload']>, ParentType, ContextType, RequireFields<MutationSynchronizeCartArgs, 'input'>>;
  trackEvent?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationTrackEventArgs>>;
  trackEventSession?: Resolver<Maybe<ResolversTypes['TrackEventResult']>, ParentType, ContextType, Partial<MutationTrackEventSessionArgs>>;
  updateCartItems?: Resolver<Maybe<ResolversTypes['UpdateCartItemsOutput']>, ParentType, ContextType, Partial<MutationUpdateCartItemsArgs>>;
  updateCustomer?: Resolver<Maybe<ResolversTypes['CustomerOutput']>, ParentType, ContextType, RequireFields<MutationUpdateCustomerArgs, 'input'>>;
  updateCustomerAccountDeletionStatus?: Resolver<ResolversTypes['CustomerAccountDeletionResponse'], ParentType, ContextType, RequireFields<MutationUpdateCustomerAccountDeletionStatusArgs, 'id' | 'input'>>;
  updateCustomerAddress?: Resolver<Maybe<ResolversTypes['CustomerAddress']>, ParentType, ContextType, RequireFields<MutationUpdateCustomerAddressArgs, 'id'>>;
  updateCustomerProfile?: Resolver<Maybe<ResolversTypes['StatusMessageResponse']>, ParentType, ContextType, RequireFields<MutationUpdateCustomerProfileArgs, 'input'>>;
  updateQuotaAmount?: Resolver<ResolversTypes['Result'], ParentType, ContextType, RequireFields<MutationUpdateQuotaAmountArgs, 'clientId' | 'quotaAmount' | 'quotaLevel'>>;
  validateCoupons?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesRule']>>>, ParentType, ContextType, Partial<MutationValidateCouponsArgs>>;
  validateResetPasswordToken?: Resolver<ResolversTypes['ResetPasswordResponse'], ParentType, ContextType, RequireFields<MutationValidateResetPasswordTokenArgs, 'otp' | 'phone_number' | 'secret'>>;
  verifyIdentityOtpChallenge?: Resolver<ResolversTypes['IdentityAuthResult'], ParentType, ContextType, RequireFields<MutationVerifyIdentityOtpChallengeArgs, 'otp' | 'phoneNumber' | 'session'>>;
};

export type MyFavoriteBrandsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyFavoriteBrands'] = ResolversParentTypes['MyFavoriteBrands']> = {
  brands?: Resolver<Maybe<Array<Maybe<ResolversTypes['HighlightBrand']>>>, ParentType, ContextType>;
  pagination?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyOrderReviewsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyOrderReviews'] = ResolversParentTypes['MyOrderReviews']> = {
  page_info?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  reviews?: Resolver<Maybe<Array<Maybe<ResolversTypes['Review']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyQuestion'] = ResolversParentTypes['MyQuestion']> = {
  answers?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdminAnswered']>>>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyQuestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyQuestions'] = ResolversParentTypes['MyQuestions']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['MyQuestion']>>>, ParentType, ContextType>;
  pagination?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewArrivalProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewArrivalProducts'] = ResolversParentTypes['NewArrivalProducts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  limit_product_for_app?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  limit_product_for_web?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationCustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationCustomer'] = ResolversParentTypes['NotificationCustomer']> = {
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['NotificationMessage']>>>, ParentType, ContextType>;
  paginationMetadata?: Resolver<Maybe<ResolversTypes['NotificationPagination']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationData'] = ResolversParentTypes['NotificationData']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  displayInfo?: Resolver<Maybe<Array<ResolversTypes['DisplayInfoItem']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['NotificationPayload']>, ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  route?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationMessage'] = ResolversParentTypes['NotificationMessage']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  read?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeNotification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationOrderDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationOrderData'] = ResolversParentTypes['NotificationOrderData']> = {
  currentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationPagination'] = ResolversParentTypes['NotificationPagination']> = {
  currentPage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationPayload'] = ResolversParentTypes['NotificationPayload']> = {
  __resolveType: TypeResolveFn<'NotificationOrderData' | 'NotificationPromotionData', ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type NotificationPromotionDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationPromotionData'] = ResolversParentTypes['NotificationPromotionData']> = {
  discountCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  validUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notifications'] = ResolversParentTypes['Notifications']> = {
  data?: Resolver<Maybe<ResolversTypes['NotificationsData']>, ParentType, ContextType>;
  pagination?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationsData'] = ResolversParentTypes['NotificationsData']> = {
  notification?: Resolver<Maybe<Array<Maybe<ResolversTypes['NotificationData']>>>, ParentType, ContextType>;
  total_unread?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']> = {
  order_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order_number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAddress'] = ResolversParentTypes['OrderAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_code?: Resolver<Maybe<ResolversTypes['CountryCodeEnum']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  middlename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  street?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ward?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ward_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderBasicInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderBasicInfo'] = ResolversParentTypes['OrderBasicInfo']> = {
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  grand_total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  increment_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderItem'] = ResolversParentTypes['OrderItem']> = {
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  entered_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_original_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity_canceled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_ordered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_returned?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_shipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reviewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  selected_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderItemInterface'] = ResolversParentTypes['OrderItemInterface']> = {
  __resolveType: TypeResolveFn<'OrderItem', ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  entered_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_original_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity_canceled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_ordered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_returned?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_shipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  selected_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type OrderItemOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderItemOption'] = ResolversParentTypes['OrderItemOption']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentMethod'] = ResolversParentTypes['OrderPaymentMethod']> = {
  additional_data?: Resolver<Maybe<Array<Maybe<ResolversTypes['KeyValue']>>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderShipmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderShipment'] = ResolversParentTypes['OrderShipment']> = {
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesCommentItem']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShipmentItemInterface']>>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tracking?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShipmentTracking']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderStatus'] = ResolversParentTypes['OrderStatus']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sort_order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderStatusHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderStatusHistory'] = ResolversParentTypes['OrderStatusHistory']> = {
  available_statuses?: Resolver<ResolversTypes['AvailableOrderHistoryStatuses'], ParentType, ContextType>;
  history?: Resolver<Array<ResolversTypes['OrderStatusHistoryItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderStatusHistoryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderStatusHistoryItem'] = ResolversParentTypes['OrderStatusHistoryItem']> = {
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSyncGiftDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSyncGiftDetail'] = ResolversParentTypes['OrderSyncGiftDetail']> = {
  gift_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gift_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gift_product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  gift_qty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  gift_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rule_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rule_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source_product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source_product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  was_applied?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSyncItemPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSyncItemPrice'] = ResolversParentTypes['OrderSyncItemPrice']> = {
  discount_percent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  original_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  row_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSyncItemReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSyncItemReference'] = ResolversParentTypes['OrderSyncItemReference']> = {
  configurable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderSyncSelectedOption']>>>, ParentType, ContextType>;
  configured_variant?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  is_selected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logics?: Resolver<Maybe<Array<ResolversTypes['OrderSyncItemReferenceLogic']>>, ParentType, ContextType>;
  order_item_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  order_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order_price?: Resolver<ResolversTypes['OrderSyncItemPrice'], ParentType, ContextType>;
  parent_product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  parent_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSyncItemReferenceActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSyncItemReferenceAction'] = ResolversParentTypes['OrderSyncItemReferenceAction']> = {
  action_product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  action_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  action_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  action_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  was_applied?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSyncItemReferenceLogicResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSyncItemReferenceLogic'] = ResolversParentTypes['OrderSyncItemReferenceLogic']> = {
  actions?: Resolver<Maybe<Array<ResolversTypes['OrderSyncItemReferenceAction']>>, ParentType, ContextType>;
  allocated_qty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  logic_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  logic_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logic_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSyncReferencesOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSyncReferencesOutput'] = ResolversParentTypes['OrderSyncReferencesOutput']> = {
  gifts?: Resolver<Array<ResolversTypes['OrderSyncGiftDetail']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderSyncItemReference']>, ParentType, ContextType>;
  order_info?: Resolver<ResolversTypes['OrderBasicInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderSyncSelectedOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderSyncSelectedOption'] = ResolversParentTypes['OrderSyncSelectedOption']> = {
  option_label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value_label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderTotalResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderTotal'] = ResolversParentTypes['OrderTotal']> = {
  base_grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  shipping_handling?: Resolver<Maybe<ResolversTypes['ShippingHandling']>, ParentType, ContextType>;
  subtotal?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxItem']>>>, ParentType, ContextType>;
  total_shipping?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  current_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  page_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_pages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginationData'] = ResolversParentTypes['PaginationData']> = {
  current_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items_per_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_items?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_pages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentInformation'] = ResolversParentTypes['PaymentInformation']> = {
  payment_url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentMethodSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMethodSettings'] = ResolversParentTypes['PaymentMethodSettings']> = {
  payment_method_configs?: Resolver<Maybe<Array<Maybe<ResolversTypes['EnabledPaymentMethod']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentOrderInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentOrderInformation'] = ResolversParentTypes['PaymentOrderInformation']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentOrderLinkResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentOrderLinkResponse'] = ResolversParentTypes['PaymentOrderLinkResponse']> = {
  app_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checksum?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deeplink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  qr_code_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentOrderTransactionStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentOrderTransactionStatusResponse'] = ResolversParentTypes['PaymentOrderTransactionStatusResponse']> = {
  create_time?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  error_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  transaction_type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  update_time?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentToken'] = ResolversParentTypes['PaymentToken']> = {
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payment_method_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  public_hash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentTokenTypeEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhysicalProductInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhysicalProductInterface'] = ResolversParentTypes['PhysicalProductInterface']> = {
  __resolveType: TypeResolveFn<'BundleProduct' | 'ConfigurableProduct' | 'GroupedProduct' | 'SimpleProduct', ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type PlaceOrderOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaceOrderOutput'] = ResolversParentTypes['PlaceOrderOutput']> = {
  order?: Resolver<ResolversTypes['Order'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopularSearchKeywordResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopularSearchKeyword'] = ResolversParentTypes['PopularSearchKeyword']> = {
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopularSearchTermsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopularSearchTerms'] = ResolversParentTypes['PopularSearchTerms']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchTerm']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostResolvers<ContextType = any, ParentType extends ResolversParentTypes['Post'] = ResolversParentTypes['Post']> = {
  author?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_excerpt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_modified?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_modified_gmt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb_img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  views_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Posts'] = ResolversParentTypes['Posts']> = {
  background_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Post']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  post_banner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Price'] = ResolversParentTypes['Price']> = {
  adjustments?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceAdjustment']>>>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceAdjustmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceAdjustment'] = ResolversParentTypes['PriceAdjustment']> = {
  amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['PriceAdjustmentCodesEnum']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['PriceAdjustmentDescriptionEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceRange'] = ResolversParentTypes['PriceRange']> = {
  maximum_price?: Resolver<Maybe<ResolversTypes['ProductPrice']>, ParentType, ContextType>;
  minimum_price?: Resolver<ResolversTypes['ProductPrice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductAchievementResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductAchievement'] = ResolversParentTypes['ProductAchievement']> = {
  background_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  border_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  target_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBadgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBadge'] = ResolversParentTypes['ProductBadge']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlockResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlock'] = ResolversParentTypes['ProductBlock']> = {
  app_layout_type?: Resolver<Maybe<ResolversTypes['LayoutData']>, ParentType, ContextType>;
  block_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlight_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['HighlightProductItem']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_auto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limit_products_for_app?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  limit_products_for_web?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  limit_qty_products?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['Products']>, ParentType, ContextType, RequireFields<ProductBlockProductsArgs, 'currentPage' | 'pageSize'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCartPriceRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCartPriceRule'] = ResolversParentTypes['ProductCartPriceRule']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_step?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discounted_price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentage_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rule_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  savings?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductDiscount'] = ResolversParentTypes['ProductDiscount']> = {
  amount_off?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  percent_off?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductFaQsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductFAQs'] = ResolversParentTypes['ProductFAQs']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqQuestion']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductImage'] = ResolversParentTypes['ProductImage']> = {
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductInterface'] = ResolversParentTypes['ProductInterface']> = {
  __resolveType: TypeResolveFn<'BundleProduct' | 'ConfigurableProduct' | 'DownloadableProduct' | 'GroupedProduct' | 'SimpleProduct' | 'VirtualProduct', ParentType, ContextType>;
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  additional_data_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditionalDataAttribute']>>>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  am_offer_item_condition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appboxo_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  avatars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bao_hanh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  chat_lieu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chat_lieu_go?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chat_lieu_vai?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chon_so?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combo_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  denomination?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  dungtich?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSaleProductData']>, ParentType, ContextType>;
  gift_indexed_info?: Resolver<Maybe<Array<Maybe<ResolversTypes['GiftIndexedInfo']>>>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gram?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_bought?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupon_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gtin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_gift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hot_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  is_discount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_kids_gift?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_online_only?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kich_thuoc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  made_in?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  market_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  muivi?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nipple_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductNotification']>>>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_achievements?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductAchievement']>>>, ParentType, ContextType>;
  product_badges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductBadge']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products_combo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratings_summary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  related_products_two?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  so_tang?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soluong?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  upsell_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_cc?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_custom_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_guide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type ProductLinksInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductLinksInterface'] = ResolversParentTypes['ProductLinksInterface']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  link_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked_product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked_product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ProductListConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductListConfig'] = ResolversParentTypes['ProductListConfig']> = {
  initial_load_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  layout_type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  load_more_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductMediaGalleryEntriesContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductMediaGalleryEntriesContent'] = ResolversParentTypes['ProductMediaGalleryEntriesContent']> = {
  base64_encoded_data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductMediaGalleryEntriesVideoContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductMediaGalleryEntriesVideoContent'] = ResolversParentTypes['ProductMediaGalleryEntriesVideoContent']> = {
  media_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_metadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductNotification'] = ResolversParentTypes['ProductNotification']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notification_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notification_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductPostsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductPosts'] = ResolversParentTypes['ProductPosts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Post']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductPrice'] = ResolversParentTypes['ProductPrice']> = {
  discount?: Resolver<Maybe<ResolversTypes['ProductDiscount']>, ParentType, ContextType>;
  final_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  fixed_product_taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FixedProductTax']>>>, ParentType, ContextType>;
  regular_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductPricesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductPrices'] = ResolversParentTypes['ProductPrices']> = {
  maximalPrice?: Resolver<Maybe<ResolversTypes['Price']>, ParentType, ContextType>;
  minimalPrice?: Resolver<Maybe<ResolversTypes['Price']>, ParentType, ContextType>;
  regularPrice?: Resolver<Maybe<ResolversTypes['Price']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductReviewsAggregationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductReviewsAggregationResponse'] = ResolversParentTypes['ProductReviewsAggregationResponse']> = {
  aggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewAggregation']>>>, ParentType, ContextType>;
  rating_average?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductReviewsAggregationV2ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductReviewsAggregationV2Response'] = ResolversParentTypes['ProductReviewsAggregationV2Response']> = {
  all_reviews_aggregation?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewAggregation']>>>, ParentType, ContextType>;
  average_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  has_image_reviews_aggregation?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewAggregation']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductReviewsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductReviewsResponse'] = ResolversParentTypes['ProductReviewsResponse']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Review']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductSalableQuantityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSalableQuantity'] = ResolversParentTypes['ProductSalableQuantity']> = {
  available_quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductSalableQuantityError']>>>, ParentType, ContextType>;
  is_salable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductSalableQuantityErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSalableQuantityError'] = ResolversParentTypes['ProductSalableQuantityError']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductSuggestedHashTagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSuggestedHashTags'] = ResolversParentTypes['ProductSuggestedHashTags']> = {
  hash_tags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductTagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductTags'] = ResolversParentTypes['ProductTags']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tag']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductTierPricesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductTierPrices'] = ResolversParentTypes['ProductTierPrices']> = {
  customer_group_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentage_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  website_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductToWishlistOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductToWishlistOutput'] = ResolversParentTypes['ProductToWishlistOutput']> = {
  is_added_to_wishlist?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  wishlist_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVideo'] = ResolversParentTypes['ProductVideo']> = {
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_content?: Resolver<Maybe<ResolversTypes['ProductMediaGalleryEntriesVideoContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Products'] = ResolversParentTypes['Products']> = {
  aggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Aggregation']>>>, ParentType, ContextType>;
  filters?: Resolver<Maybe<Array<Maybe<ResolversTypes['LayerFilter']>>>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  sort_fields?: Resolver<Maybe<ResolversTypes['SortFields']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchasedProductStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchasedProductStatus'] = ResolversParentTypes['PurchasedProductStatus']> = {
  is_purchased?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PushAllocationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PushAllocationResult'] = ResolversParentTypes['PushAllocationResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sync_status?: Resolver<ResolversTypes['SyncStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  availableCartLevelGifts?: Resolver<Maybe<ResolversTypes['CartLevelGiftsOutput']>, ParentType, ContextType, RequireFields<QueryAvailableCartLevelGiftsArgs, 'cart_id'>>;
  availableCartPriceRules?: Resolver<Maybe<ResolversTypes['AvailableRules']>, ParentType, ContextType>;
  availableCoupons?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesRule']>>>, ParentType, ContextType>;
  availableGiftsCart?: Resolver<Maybe<ResolversTypes['AvailableGiftsCart']>, ParentType, ContextType, RequireFields<QueryAvailableGiftsCartArgs, 'cart_id'>>;
  bannerConfig?: Resolver<Maybe<ResolversTypes['BannerConfig']>, ParentType, ContextType, Partial<QueryBannerConfigArgs>>;
  bestsellerProducts?: Resolver<Maybe<ResolversTypes['BlockProducts']>, ParentType, ContextType>;
  brandList?: Resolver<Maybe<ResolversTypes['Brands']>, ParentType, ContextType, Partial<QueryBrandListArgs>>;
  brands?: Resolver<Maybe<ResolversTypes['Brands']>, ParentType, ContextType, RequireFields<QueryBrandsArgs, 'brand_ids' | 'current_page' | 'page_size'>>;
  bssPopups?: Resolver<Maybe<ResolversTypes['BssPopups']>, ParentType, ContextType>;
  cancelOrderReason?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  cancellableOrderStatuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  cart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType, RequireFields<QueryCartArgs, 'cart_id'>>;
  cartItemsOnly?: Resolver<Maybe<ResolversTypes['CartItemsOnly']>, ParentType, ContextType, RequireFields<QueryCartItemsOnlyArgs, 'cart_id'>>;
  cartItemsStatus?: Resolver<Array<Maybe<ResolversTypes['ItemStatus']>>, ParentType, ContextType, RequireFields<QueryCartItemsStatusArgs, 'cart_id'>>;
  cartMeta?: Resolver<Maybe<ResolversTypes['CartMeta']>, ParentType, ContextType, RequireFields<QueryCartMetaArgs, 'cart_id'>>;
  cartSyncReferences?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemReference']>>>, ParentType, ContextType, RequireFields<QueryCartSyncReferencesArgs, 'cart_id'>>;
  category?: Resolver<Maybe<ResolversTypes['CategoryTree']>, ParentType, ContextType, Partial<QueryCategoryArgs>>;
  categoryBanners?: Resolver<Maybe<ResolversTypes['CategoryBanners']>, ParentType, ContextType, Partial<QueryCategoryBannersArgs>>;
  categoryHighlightProducts?: Resolver<Maybe<ResolversTypes['CategoryHighlightProducts']>, ParentType, ContextType, Partial<QueryCategoryHighlightProductsArgs>>;
  categoryList?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryTree']>>>, ParentType, ContextType, Partial<QueryCategoryListArgs>>;
  categoryPosts?: Resolver<Maybe<ResolversTypes['CategoryPosts']>, ParentType, ContextType, RequireFields<QueryCategoryPostsArgs, 'category_id'>>;
  categoryTags?: Resolver<Maybe<ResolversTypes['CategoryTags']>, ParentType, ContextType, Partial<QueryCategoryTagsArgs>>;
  checkEventReferralCodeExist?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCheckEventReferralCodeExistArgs, 'code'>>;
  checkoutAgreements?: Resolver<Maybe<Array<Maybe<ResolversTypes['CheckoutAgreement']>>>, ParentType, ContextType>;
  cmsBlocks?: Resolver<Maybe<ResolversTypes['CmsBlocks']>, ParentType, ContextType, Partial<QueryCmsBlocksArgs>>;
  cmsPage?: Resolver<Maybe<ResolversTypes['CmsPage']>, ParentType, ContextType, Partial<QueryCmsPageArgs>>;
  cmsPageByIdentifier?: Resolver<Maybe<ResolversTypes['GetCmsPageSchemaByIdentifierResponse']>, ParentType, ContextType, Partial<QueryCmsPageByIdentifierArgs>>;
  cmsPageConfig?: Resolver<Maybe<ResolversTypes['CmsPageConfig']>, ParentType, ContextType, RequireFields<QueryCmsPageConfigArgs, 'key'>>;
  cmsPageWidget?: Resolver<Maybe<ResolversTypes['CmsPageResponse']>, ParentType, ContextType, Partial<QueryCmsPageWidgetArgs>>;
  coreConfig?: Resolver<Maybe<ResolversTypes['CoreConfig']>, ParentType, ContextType>;
  countries?: Resolver<Maybe<Array<Maybe<ResolversTypes['Country']>>>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['Country']>, ParentType, ContextType, Partial<QueryCountryArgs>>;
  couponWidgetContent?: Resolver<Maybe<Array<Maybe<ResolversTypes['CouponContentResponse']>>>, ParentType, ContextType, Partial<QueryCouponWidgetContentArgs>>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  customAttributeMetadata?: Resolver<Maybe<ResolversTypes['CustomAttributeMetadata']>, ParentType, ContextType, RequireFields<QueryCustomAttributeMetadataArgs, 'attributes'>>;
  customer?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  customerAccountDeletionRequests?: Resolver<ResolversTypes['CustomerAccountDeletionListResponse'], ParentType, ContextType, Partial<QueryCustomerAccountDeletionRequestsArgs>>;
  customerActiveCarts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Cart']>>>, ParentType, ContextType>;
  customerCart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  customerCouponWallet?: Resolver<Maybe<Array<Maybe<ResolversTypes['CouponContentResponse']>>>, ParentType, ContextType>;
  customerDownloadableProducts?: Resolver<Maybe<ResolversTypes['CustomerDownloadableProducts']>, ParentType, ContextType>;
  customerKicoin?: Resolver<Maybe<ResolversTypes['CustomerKicoin']>, ParentType, ContextType>;
  customerOrderStats?: Resolver<Maybe<ResolversTypes['CustomerOrderStats']>, ParentType, ContextType>;
  customerOrders?: Resolver<Maybe<ResolversTypes['CustomerOrders']>, ParentType, ContextType>;
  customerOrdersV2?: Resolver<Maybe<ResolversTypes['CustomerOrdersV2']>, ParentType, ContextType, RequireFields<QueryCustomerOrdersV2Args, 'page' | 'page_size'>>;
  customerPaymentTokens?: Resolver<Maybe<ResolversTypes['CustomerPaymentTokens']>, ParentType, ContextType>;
  customerProfile?: Resolver<Maybe<ResolversTypes['CustomerInformation']>, ParentType, ContextType>;
  districts?: Resolver<Maybe<Array<Maybe<ResolversTypes['District']>>>, ParentType, ContextType, RequireFields<QueryDistrictsArgs, 'regionCode'>>;
  eventActivities?: Resolver<Array<ResolversTypes['EventActivity']>, ParentType, ContextType, RequireFields<QueryEventActivitiesArgs, 'eventId'>>;
  eventActivityGroups?: Resolver<Array<Maybe<ResolversTypes['EventActivityGroup']>>, ParentType, ContextType, RequireFields<QueryEventActivityGroupsArgs, 'eventId'>>;
  eventAttributes?: Resolver<Array<ResolversTypes['EventAttribute']>, ParentType, ContextType>;
  faqArticles?: Resolver<Maybe<ResolversTypes['FaqArticles']>, ParentType, ContextType, RequireFields<QueryFaqArticlesArgs, 'page' | 'page_size'>>;
  faqCategories?: Resolver<Maybe<ResolversTypes['FaqCategories']>, ParentType, ContextType, RequireFields<QueryFaqCategoriesArgs, 'current_page' | 'page_size'>>;
  faqGuest?: Resolver<Maybe<ResolversTypes['FaqListBySku']>, ParentType, ContextType, RequireFields<QueryFaqGuestArgs, 'current_page' | 'page_size' | 'search_term'>>;
  faqReactionByProduct?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqReaction']>>>, ParentType, ContextType, RequireFields<QueryFaqReactionByProductArgs, 'product_id'>>;
  faqSuggestionTags?: Resolver<Array<ResolversTypes['FaqSuggestionTag']>, ParentType, ContextType, RequireFields<QueryFaqSuggestionTagsArgs, 'limit'>>;
  fastCartTotals?: Resolver<Maybe<ResolversTypes['FastCartTotals']>, ParentType, ContextType, Partial<QueryFastCartTotalsArgs>>;
  flashSaleProduct?: Resolver<Maybe<ResolversTypes['FlashSaleProduct']>, ParentType, ContextType, Partial<QueryFlashSaleProductArgs>>;
  flashSaleProductV2?: Resolver<Maybe<ResolversTypes['FlashSaleProduct']>, ParentType, ContextType, Partial<QueryFlashSaleProductV2Args>>;
  flashSaleProducts?: Resolver<Maybe<ResolversTypes['FlashSaleProducts']>, ParentType, ContextType>;
  flashSaleProductsV2?: Resolver<Maybe<ResolversTypes['FlashSaleProductsV2']>, ParentType, ContextType>;
  flashSaleProductsV3?: Resolver<Maybe<ResolversTypes['FlashSaleProductsV2']>, ParentType, ContextType, Partial<QueryFlashSaleProductsV3Args>>;
  flashSaleSessions?: Resolver<Maybe<Array<Maybe<ResolversTypes['FlashSale']>>>, ParentType, ContextType>;
  formConfig?: Resolver<Maybe<ResolversTypes['FormConfig']>, ParentType, ContextType, RequireFields<QueryFormConfigArgs, 'id'>>;
  formSubmission?: Resolver<Maybe<ResolversTypes['FormValue']>, ParentType, ContextType, RequireFields<QueryFormSubmissionArgs, 'form_id'>>;
  freeGiftCart?: Resolver<Maybe<ResolversTypes['FreeGiftCart']>, ParentType, ContextType, RequireFields<QueryFreeGiftCartArgs, 'cart_id'>>;
  freeGifts?: Resolver<Maybe<ResolversTypes['FreeGifts']>, ParentType, ContextType, Partial<QueryFreeGiftsArgs>>;
  freeGiftsForCart?: Resolver<Maybe<Array<Maybe<ResolversTypes['FreeGiftsData']>>>, ParentType, ContextType>;
  freeGiftsForProduct?: Resolver<Maybe<Array<Maybe<ResolversTypes['FreeGiftsData']>>>, ParentType, ContextType, Partial<QueryFreeGiftsForProductArgs>>;
  freeGiftsInCart?: Resolver<Maybe<Array<Maybe<ResolversTypes['GiftCartItem']>>>, ParentType, ContextType, RequireFields<QueryFreeGiftsInCartArgs, 'cart_id'>>;
  getAllEvents?: Resolver<Array<ResolversTypes['EventEntity']>, ParentType, ContextType, Partial<QueryGetAllEventsArgs>>;
  getEventRegistrationsByUser?: Resolver<Maybe<Array<ResolversTypes['EventRegistration']>>, ParentType, ContextType, RequireFields<QueryGetEventRegistrationsByUserArgs, 'input'>>;
  getEventUserById?: Resolver<ResolversTypes['EventUser'], ParentType, ContextType, RequireFields<QueryGetEventUserByIdArgs, 'input'>>;
  getFaqListBySku?: Resolver<Maybe<ResolversTypes['GetFaqListBySkuResponse']>, ParentType, ContextType, RequireFields<QueryGetFaqListBySkuArgs, 'currentPage' | 'pageSize' | 'sku'>>;
  getQuestions?: Resolver<Array<Maybe<ResolversTypes['Question']>>, ParentType, ContextType, RequireFields<QueryGetQuestionsArgs, 'productId'>>;
  giftRuleThresholds?: Resolver<Maybe<ResolversTypes['GiftRuleThresholdsOutput']>, ParentType, ContextType, RequireFields<QueryGiftRuleThresholdsArgs, 'grand_total'>>;
  hasPurchasedProduct?: Resolver<ResolversTypes['PurchasedProductStatus'], ParentType, ContextType, RequireFields<QueryHasPurchasedProductArgs, 'sku'>>;
  hasReviewedProduct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryHasReviewedProductArgs, 'sku'>>;
  helloCatalogService?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helloCheckoutService?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helloCmsService?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helloCoreService?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helloSynchronizeService?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helloUrlService?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlightBrands?: Resolver<Maybe<ResolversTypes['HighlightBrands']>, ParentType, ContextType>;
  highlightCategories?: Resolver<Maybe<ResolversTypes['HighlightCategories']>, ParentType, ContextType>;
  highlightProductAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Aggregation']>>>, ParentType, ContextType, RequireFields<QueryHighlightProductAttributesArgs, 'category_id'>>;
  highlightProductBlocks?: Resolver<Maybe<ResolversTypes['HighlightProductBlocks']>, ParentType, ContextType, Partial<QueryHighlightProductBlocksArgs>>;
  highlightProducts?: Resolver<Maybe<ResolversTypes['HighlightProducts']>, ParentType, ContextType>;
  highlightProductsPage?: Resolver<Maybe<ResolversTypes['CategoryProducts']>, ParentType, ContextType, RequireFields<QueryHighlightProductsPageArgs, 'type'>>;
  homepageFeaturedBlock?: Resolver<Maybe<Array<Maybe<ResolversTypes['HomepageFeaturedBlock']>>>, ParentType, ContextType>;
  homepageFloatBanner?: Resolver<Maybe<ResolversTypes['HomePageFloatBanner']>, ParentType, ContextType>;
  homepagePopularSearchKeywords?: Resolver<Maybe<ResolversTypes['HomepagePopularSearchKeywords']>, ParentType, ContextType>;
  homepagePosts?: Resolver<Maybe<ResolversTypes['HomepagePosts']>, ParentType, ContextType>;
  homepageProductsLightweight?: Resolver<Maybe<ResolversTypes['HomepageProductsLightweight']>, ParentType, ContextType>;
  interestedProducts?: Resolver<Maybe<ResolversTypes['InterestedProducts']>, ParentType, ContextType>;
  isEmailAvailable?: Resolver<Maybe<ResolversTypes['IsEmailAvailableOutput']>, ParentType, ContextType, RequireFields<QueryIsEmailAvailableArgs, 'email'>>;
  lookupCustomer?: Resolver<ResolversTypes['LookupCustomerResponse'], ParentType, ContextType, RequireFields<QueryLookupCustomerArgs, 'phone_number' | 'sign'>>;
  lookupCustomerByCaptcha?: Resolver<ResolversTypes['LookupCustomerResponse'], ParentType, ContextType, RequireFields<QueryLookupCustomerByCaptchaArgs, 'captchaResponseToken' | 'phone_number'>>;
  lookupEventUser?: Resolver<Maybe<ResolversTypes['EventUser']>, ParentType, ContextType, RequireFields<QueryLookupEventUserArgs, 'input'>>;
  lookupReferralCode?: Resolver<Maybe<ResolversTypes['CustomerReferralCodeSignature']>, ParentType, ContextType, RequireFields<QueryLookupReferralCodeArgs, 'code'>>;
  marketingGetAllocationDetail?: Resolver<Maybe<ResolversTypes['StorefrontAllocation']>, ParentType, ContextType, RequireFields<QueryMarketingGetAllocationDetailArgs, 'allocation_id'>>;
  marketingGetAppliedCodes?: Resolver<ResolversTypes['AppliedCodesResponse'], ParentType, ContextType, RequireFields<QueryMarketingGetAppliedCodesArgs, 'cart_id'>>;
  marketingGetAvailableVouchers?: Resolver<Array<ResolversTypes['StorefrontAllocation']>, ParentType, ContextType, Partial<QueryMarketingGetAvailableVouchersArgs>>;
  myCoupons?: Resolver<Array<Maybe<ResolversTypes['IssuedCoupon']>>, ParentType, ContextType, RequireFields<QueryMyCouponsArgs, 'page' | 'pageSize'>>;
  myFavoriteBrands?: Resolver<Maybe<ResolversTypes['MyFavoriteBrands']>, ParentType, ContextType, RequireFields<QueryMyFavoriteBrandsArgs, 'page' | 'page_size'>>;
  myNotificationHistory?: Resolver<Maybe<ResolversTypes['Notifications']>, ParentType, ContextType, RequireFields<QueryMyNotificationHistoryArgs, 'filter' | 'page' | 'page_size'>>;
  myNotificationMessage?: Resolver<Maybe<ResolversTypes['NotificationCustomer']>, ParentType, ContextType, RequireFields<QueryMyNotificationMessageArgs, 'page' | 'pageSize'>>;
  myQuestion?: Resolver<Maybe<ResolversTypes['MyQuestions']>, ParentType, ContextType, RequireFields<QueryMyQuestionArgs, 'page' | 'page_size'>>;
  newArrivalProducts?: Resolver<Maybe<ResolversTypes['NewArrivalProducts']>, ParentType, ContextType>;
  orderSyncReferences?: Resolver<Maybe<ResolversTypes['OrderSyncReferencesOutput']>, ParentType, ContextType, RequireFields<QueryOrderSyncReferencesArgs, 'order_number'>>;
  paymentInformation?: Resolver<Maybe<ResolversTypes['PaymentInformation']>, ParentType, ContextType, RequireFields<QueryPaymentInformationArgs, 'order_id'>>;
  paymentMethodSettings?: Resolver<Maybe<ResolversTypes['PaymentMethodSettings']>, ParentType, ContextType>;
  paymentOrderInformation?: Resolver<Maybe<ResolversTypes['PaymentOrderInformation']>, ParentType, ContextType, RequireFields<QueryPaymentOrderInformationArgs, 'orderId'>>;
  paymentOrderLink?: Resolver<Maybe<ResolversTypes['PaymentOrderLinkResponse']>, ParentType, ContextType, RequireFields<QueryPaymentOrderLinkArgs, 'orderNumber' | 'paymentMethod'>>;
  paymentOrderTransactionStatus?: Resolver<Maybe<ResolversTypes['PaymentOrderTransactionStatusResponse']>, ParentType, ContextType, RequireFields<QueryPaymentOrderTransactionStatusArgs, 'checksum' | 'orderNumber' | 'paymentMethod' | 'signature'>>;
  popularSearchKeywords?: Resolver<Array<ResolversTypes['PopularSearchKeyword']>, ParentType, ContextType>;
  popularSearchTerms?: Resolver<Maybe<ResolversTypes['PopularSearchTerms']>, ParentType, ContextType>;
  productBySku?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType, RequireFields<QueryProductBySkuArgs, 'sku'>>;
  productByUuid?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType, RequireFields<QueryProductByUuidArgs, 'uuid'>>;
  productCartPriceRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductCartPriceRule']>>>, ParentType, ContextType, RequireFields<QueryProductCartPriceRulesArgs, 'sku'>>;
  productFAQs?: Resolver<Maybe<ResolversTypes['ProductFAQs']>, ParentType, ContextType, RequireFields<QueryProductFaQsArgs, 'currentPage' | 'pageSize'>>;
  productListLightweight?: Resolver<Maybe<ResolversTypes['LightweightProductList']>, ParentType, ContextType, RequireFields<QueryProductListLightweightArgs, 'currentPage' | 'pageSize'>>;
  productPosts?: Resolver<Maybe<ResolversTypes['ProductPosts']>, ParentType, ContextType, Partial<QueryProductPostsArgs>>;
  productReviews?: Resolver<Maybe<ResolversTypes['ProductReviewsResponse']>, ParentType, ContextType, RequireFields<QueryProductReviewsArgs, 'current_page' | 'page_size'>>;
  productReviewsAggregation?: Resolver<Maybe<ResolversTypes['ProductReviewsAggregationResponse']>, ParentType, ContextType, Partial<QueryProductReviewsAggregationArgs>>;
  productReviewsAggregationV2?: Resolver<Maybe<ResolversTypes['ProductReviewsAggregationV2Response']>, ParentType, ContextType, RequireFields<QueryProductReviewsAggregationV2Args, 'product_id'>>;
  productReviewsImagesGallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewMedia']>>>, ParentType, ContextType, Partial<QueryProductReviewsImagesGalleryArgs>>;
  productSalableQuantity?: Resolver<Maybe<ResolversTypes['ProductSalableQuantity']>, ParentType, ContextType, RequireFields<QueryProductSalableQuantityArgs, 'request_qty' | 'sku'>>;
  productSuggestedHashTags?: Resolver<Maybe<ResolversTypes['ProductSuggestedHashTags']>, ParentType, ContextType, Partial<QueryProductSuggestedHashTagsArgs>>;
  productTag?: Resolver<Maybe<ResolversTypes['Tag']>, ParentType, ContextType, RequireFields<QueryProductTagArgs, 'identifier'>>;
  productTags?: Resolver<Maybe<ResolversTypes['ProductTags']>, ParentType, ContextType, Partial<QueryProductTagsArgs>>;
  productWishlist?: Resolver<Maybe<ResolversTypes['ProductToWishlistOutput']>, ParentType, ContextType, Partial<QueryProductWishlistArgs>>;
  products?: Resolver<Maybe<ResolversTypes['Products']>, ParentType, ContextType, RequireFields<QueryProductsArgs, 'currentPage' | 'pageSize'>>;
  productsSalableQuantity?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductSalableQuantity']>>>, ParentType, ContextType, Partial<QueryProductsSalableQuantityArgs>>;
  promotionProducts?: Resolver<Maybe<ResolversTypes['Products']>, ParentType, ContextType, RequireFields<QueryPromotionProductsArgs, 'category_id'>>;
  regionStore?: Resolver<Maybe<ResolversTypes['RegionStore']>, ParentType, ContextType, RequireFields<QueryRegionStoreArgs, 'region_id'>>;
  regions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType>;
  regionsV2?: Resolver<Array<Maybe<ResolversTypes['Region']>>, ParentType, ContextType>;
  relatedProducts?: Resolver<Maybe<ResolversTypes['RelatedProducts']>, ParentType, ContextType, RequireFields<QueryRelatedProductsArgs, 'product_id'>>;
  reviewTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewTag']>>>, ParentType, ContextType>;
  salesOrderStatuses?: Resolver<Array<ResolversTypes['SalesOrderStatus']>, ParentType, ContextType>;
  selectedCartLevelGifts?: Resolver<Maybe<ResolversTypes['SelectedCartLevelGiftsOutput']>, ParentType, ContextType, RequireFields<QuerySelectedCartLevelGiftsArgs, 'cart_id'>>;
  settings?: Resolver<ResolversTypes['Settings'], ParentType, ContextType, Partial<QuerySettingsArgs>>;
  sliderBanners?: Resolver<Maybe<ResolversTypes['BannerItems']>, ParentType, ContextType, Partial<QuerySliderBannersArgs>>;
  sliderBannersV2?: Resolver<Maybe<ResolversTypes['BannerItems']>, ParentType, ContextType, RequireFields<QuerySliderBannersV2Args, 'location'>>;
  storeConfig?: Resolver<Maybe<ResolversTypes['StoreConfig']>, ParentType, ContextType>;
  storeRegions?: Resolver<Maybe<ResolversTypes['StoreRegions']>, ParentType, ContextType>;
  storesLocator?: Resolver<Maybe<ResolversTypes['StoresLocator']>, ParentType, ContextType>;
  suggestionSearch?: Resolver<Maybe<ResolversTypes['SuggestionSearchResponse']>, ParentType, ContextType, RequireFields<QuerySuggestionSearchArgs, 'query'>>;
  supportMenuItems?: Resolver<Array<ResolversTypes['SupportMenuItem']>, ParentType, ContextType, RequireFields<QuerySupportMenuItemsArgs, 'location'>>;
  termsOfService?: Resolver<Maybe<Array<Maybe<ResolversTypes['TermsOfService']>>>, ParentType, ContextType>;
  universalLinkResolver?: Resolver<Maybe<ResolversTypes['UniversalLinkEntity']>, ParentType, ContextType, RequireFields<QueryUniversalLinkResolverArgs, 'url'>>;
  urlResolver?: Resolver<Maybe<ResolversTypes['EntityUrl']>, ParentType, ContextType, RequireFields<QueryUrlResolverArgs, 'url'>>;
  urlResolverTwo?: Resolver<Maybe<ResolversTypes['EntityUrl']>, ParentType, ContextType, RequireFields<QueryUrlResolverTwoArgs, 'url'>>;
  verifyEventUserUpdateSecret?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryVerifyEventUserUpdateSecretArgs, 'input'>>;
  wards?: Resolver<Maybe<Array<Maybe<ResolversTypes['Ward']>>>, ParentType, ContextType, RequireFields<QueryWardsArgs, 'districtId'>>;
  wardsV2?: Resolver<Array<Maybe<ResolversTypes['Ward']>>, ParentType, ContextType, RequireFields<QueryWardsV2Args, 'region_id'>>;
  webCart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType>;
  widgetBanners?: Resolver<Maybe<Array<Maybe<ResolversTypes['Banner']>>>, ParentType, ContextType, Partial<QueryWidgetBannersArgs>>;
  widgetShortcutLinks?: Resolver<ResolversTypes['WidgetShortcutLink'], ParentType, ContextType, Partial<QueryWidgetShortcutLinksArgs>>;
  widgetShortcutLinksV2?: Resolver<ResolversTypes['WidgetShortcutLinkV2'], ParentType, ContextType, Partial<QueryWidgetShortcutLinksV2Args>>;
  wpPosts?: Resolver<Maybe<ResolversTypes['Posts']>, ParentType, ContextType, RequireFields<QueryWpPostsArgs, 'post_ids'>>;
};

export type QuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Question'] = ResolversParentTypes['Question']> = {
  answers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Answer']>>>, ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  visibility?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecalculateCartTotalsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecalculateCartTotalsOutput'] = ResolversParentTypes['RecalculateCartTotalsOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralCodeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralCodeResponse'] = ResolversParentTypes['ReferralCodeResponse']> = {
  referral_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Region'] = ResolversParentTypes['Region']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionStoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegionStore'] = ResolversParentTypes['RegionStore']> = {
  region_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  region_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sort_order?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  store_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegisterResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterResponse'] = ResolversParentTypes['RegisterResponse']> = {
  customer_token?: Resolver<Maybe<ResolversTypes['CustomerToken']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelatedProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelatedProducts'] = ResolversParentTypes['RelatedProducts']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveCartLevelGiftOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCartLevelGiftOutput'] = ResolversParentTypes['RemoveCartLevelGiftOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveCodeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCodeResponse'] = ResolversParentTypes['RemoveCodeResponse']> = {
  error_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveCouponFromCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCouponFromCartOutput'] = ResolversParentTypes['RemoveCouponFromCartOutput']> = {
  cart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveItemFromCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveItemFromCartOutput'] = ResolversParentTypes['RemoveItemFromCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveKicoinsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveKicoinsOutput'] = ResolversParentTypes['RemoveKicoinsOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveUniversalCodeOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveUniversalCodeOutput'] = ResolversParentTypes['RemoveUniversalCodeOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  user_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestStatus'] = ResolversParentTypes['RequestStatus']> = {
  request_id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestValidatePhoneResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestValidatePhoneResponse'] = ResolversParentTypes['RequestValidatePhoneResponse']> = {
  error_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPasswordResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordResponse'] = ResolversParentTypes['ResetPasswordResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['Result'] = ResolversParentTypes['Result']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['Review'] = ResolversParentTypes['Review']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewMedia']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewMedia']>>>, ParentType, ContextType>;
  is_liked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_ordered_customer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  liked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  order_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reply?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewOption']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_likes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewAggregationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewAggregation'] = ResolversParentTypes['ReviewAggregation']> = {
  attribute_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewAggregationOption']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewAggregationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewAggregationOption'] = ResolversParentTypes['ReviewAggregationOption']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewMediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewMedia'] = ResolversParentTypes['ReviewMedia']> = {
  alt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mime_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewOption'] = ResolversParentTypes['ReviewOption']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  post_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_likes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewReactionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewReactionResponse'] = ResolversParentTypes['ReviewReactionResponse']> = {
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewTag'] = ResolversParentTypes['ReviewTag']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RevokeCustomerTokenOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevokeCustomerTokenOutput'] = ResolversParentTypes['RevokeCustomerTokenOutput']> = {
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Rule'] = ResolversParentTypes['Rule']> = {
  conditions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Condition']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_step?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_discount_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rule_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  simple_action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stop_rules_processing?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesCommentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesCommentItem'] = ResolversParentTypes['SalesCommentItem']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesOrderStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesOrderStatus'] = ResolversParentTypes['SalesOrderStatus']> = {
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesRule'] = ResolversParentTypes['SalesRule']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rule?: Resolver<Maybe<ResolversTypes['Rule']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesruleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Salesrule'] = ResolversParentTypes['Salesrule']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_step?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expiration_date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesrule_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  times_used?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usage_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usage_per_customer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchKeywordHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchKeywordHistory'] = ResolversParentTypes['SearchKeywordHistory']> = {
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchResultPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResultPageInfo'] = ResolversParentTypes['SearchResultPageInfo']> = {
  current_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  page_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_pages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchTermResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchTerm'] = ResolversParentTypes['SearchTerm']> = {
  num_results?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedBundleOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedBundleOption'] = ResolversParentTypes['SelectedBundleOption']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<Maybe<ResolversTypes['SelectedBundleOptionValue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedBundleOptionValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedBundleOptionValue'] = ResolversParentTypes['SelectedBundleOptionValue']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedCartLevelGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedCartLevelGift'] = ResolversParentTypes['SelectedCartLevelGift']> = {
  gift_item_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_applied_to_cart?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_available?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quote_item_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rule_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rule_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedCartLevelGiftsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedCartLevelGiftsOutput'] = ResolversParentTypes['SelectedCartLevelGiftsOutput']> = {
  items?: Resolver<Array<ResolversTypes['SelectedCartLevelGift']>, ParentType, ContextType>;
  total_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedConfigurableOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedConfigurableOption'] = ResolversParentTypes['SelectedConfigurableOption']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  option_label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value_label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedCustomizableOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedCustomizableOption'] = ResolversParentTypes['SelectedCustomizableOption']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  is_required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sort_order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  values?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOptionValue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedCustomizableOptionValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedCustomizableOptionValue'] = ResolversParentTypes['SelectedCustomizableOptionValue']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['CartItemSelectedOptionValuePrice'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedGift'] = ResolversParentTypes['SelectedGift']> = {
  gift_item_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedPaymentMethod'] = ResolversParentTypes['SelectedPaymentMethod']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchase_order_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectedShippingMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectedShippingMethod'] = ResolversParentTypes['SelectedShippingMethod']> = {
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  base_amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  carrier_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrier_title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method_title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeoDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeoData'] = ResolversParentTypes['SeoData']> = {
  canonicalUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metaDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metaTags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metaTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ogDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ogImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ogTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twitterCardType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twitterHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetBillingAddressOnCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetBillingAddressOnCartOutput'] = ResolversParentTypes['SetBillingAddressOnCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetGuestEmailOnCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetGuestEmailOnCartOutput'] = ResolversParentTypes['SetGuestEmailOnCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetPaymentMethodOnCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetPaymentMethodOnCartOutput'] = ResolversParentTypes['SetPaymentMethodOnCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetShippingAddressesOnCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetShippingAddressesOnCartOutput'] = ResolversParentTypes['SetShippingAddressesOnCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetShippingMethodsOnCartOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetShippingMethodsOnCartOutput'] = ResolversParentTypes['SetShippingMethodsOnCartOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Settings'] = ResolversParentTypes['Settings']> = {
  created_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  language?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['SettingsOptions']>, ParentType, ContextType>;
  storeConfig?: Resolver<Maybe<ResolversTypes['StoreConfiguration']>, ParentType, ContextType>;
  store_config_v2?: Resolver<Maybe<ResolversTypes['StoreConfigurationV2']>, ParentType, ContextType>;
  translated_languages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  url_config?: Resolver<Maybe<ResolversTypes['UrlConfigData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SettingsOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SettingsOptions'] = ResolversParentTypes['SettingsOptions']> = {
  contactDetails?: Resolver<Maybe<ResolversTypes['ContactDetails']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyToWalletRatio?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deliveryTime?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeliveryTime']>>>, ParentType, ContextType>;
  freeShipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  freeShippingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['LogoData']>, ParentType, ContextType>;
  maximumQuestionLimit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minimumOrderAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  paymentGateway?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seo?: Resolver<Maybe<ResolversTypes['SeoData']>, ParentType, ContextType>;
  shippingClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signupPoints?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  siteSubtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  siteTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  useCashOnDelivery?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  useOtp?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShareChannelGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShareChannelGroupResponse'] = ResolversParentTypes['ShareChannelGroupResponse']> = {
  social_channels?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShareChannelItem']>>>, ParentType, ContextType>;
  utility_channels?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShareChannelItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShareChannelItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShareChannelItem'] = ResolversParentTypes['ShareChannelItem']> = {
  icon?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShipmentItemInterface'] = ResolversParentTypes['ShipmentItemInterface']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_shipped?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type ShipmentTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShipmentTracking'] = ResolversParentTypes['ShipmentTracking']> = {
  carrier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingCartAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingCartAddress'] = ResolversParentTypes['ShippingCartAddress']> = {
  available_shipping_methods?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvailableShippingMethod']>>>, ParentType, ContextType>;
  cart_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemQuantity']>>>, ParentType, ContextType>;
  cart_items_v2?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemInterface']>>>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['CartAddressCountry'], ParentType, ContextType>;
  customer_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items_weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['CartAddressRegion']>, ParentType, ContextType>;
  selected_shipping_method?: Resolver<Maybe<ResolversTypes['SelectedShippingMethod']>, ParentType, ContextType>;
  street?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  telephone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ward?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ward_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingDiscount'] = ResolversParentTypes['ShippingDiscount']> = {
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingHandlingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingHandling'] = ResolversParentTypes['ShippingHandling']> = {
  amount_excluding_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  amount_including_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShippingDiscount']>>>, ParentType, ContextType>;
  taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxItem']>>>, ParentType, ContextType>;
  total_amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShortcutLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShortcutLink'] = ResolversParentTypes['ShortcutLink']> = {
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_active?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_ids?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShortcutLinkV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ShortcutLinkV2'] = ResolversParentTypes['ShortcutLinkV2']> = {
  icon?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  is_active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shortcut_link_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  store_ids?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimpleCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleCartItem'] = ResolversParentTypes['SimpleCartItem']> = {
  customizable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimpleLocalCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleLocalCartItem'] = ResolversParentTypes['SimpleLocalCartItem']> = {
  cart_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customizable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  local_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimpleProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleProduct'] = ResolversParentTypes['SimpleProduct']> = {
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  additional_data_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditionalDataAttribute']>>>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  am_offer_item_condition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appboxo_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  avatars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bao_hanh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  chat_lieu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chat_lieu_go?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chat_lieu_vai?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chon_so?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combo_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  denomination?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  dungtich?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSaleProductData']>, ParentType, ContextType>;
  gift_indexed_info?: Resolver<Maybe<Array<Maybe<ResolversTypes['GiftIndexedInfo']>>>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gram?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_bought?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupon_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gtin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_gift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hot_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  is_discount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_kids_gift?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_online_only?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kich_thuoc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  made_in?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  market_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  muivi?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nipple_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductNotification']>>>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_achievements?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductAchievement']>>>, ParentType, ContextType>;
  product_badges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductBadge']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products_combo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratings_summary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  related_products_two?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  so_tang?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold_quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soluong?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  upsell_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_cc?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_custom_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_guide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weight_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SocialChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['SocialChannel'] = ResolversParentTypes['SocialChannel']> = {
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SortFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SortField'] = ResolversParentTypes['SortField']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SortFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SortFields'] = ResolversParentTypes['SortFields']> = {
  default?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SortField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticWidgetResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticWidget'] = ResolversParentTypes['StaticWidget']> = {
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_lazy_loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatusMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatusMessageResponse'] = ResolversParentTypes['StatusMessageResponse']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockStatus'] = ResolversParentTypes['StockStatus']> = {
  code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  current_available?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreConfig'] = ResolversParentTypes['StoreConfig']> = {
  absolute_footer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_link_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_media_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_static_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  catalog_default_sort_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySettings']>, ParentType, ContextType>;
  category_url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_home_page?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_no_cookies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_no_route?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  demonotice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  front?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grid_per_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  grid_per_page_values?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  head_includes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  head_shortcut_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  header_logo_src?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list_mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  list_per_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list_per_page_values?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo_alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo_height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  logo_width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  no_route?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySettings']>, ParentType, ContextType>;
  product_url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  root_category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sales_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySettings']>, ParentType, ContextType>;
  secure_base_link_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_media_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_static_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_cms_breadcrumbs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_separator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  weight_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  welcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreConfiguration'] = ResolversParentTypes['StoreConfiguration']> = {
  absolute_footer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_link_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_media_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_static_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cart_max_qty_per_item?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cart_min_qty_per_item?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  catalog_default_sort_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySetting']>, ParentType, ContextType>;
  category_url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_home_page?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_no_cookies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_no_route?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_promotion_page?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  demonotice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  front?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grid_per_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  grid_per_page_values?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  head_includes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  head_shortcut_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  header_logo_src?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list_mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  list_per_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list_per_page_values?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo_alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo_height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  logo_width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  no_route?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySetting']>, ParentType, ContextType>;
  product_url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  root_category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sales_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySetting']>, ParentType, ContextType>;
  search_placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_link_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_media_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_static_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_cms_breadcrumbs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_separator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  weight_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  welcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreConfigurationV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreConfigurationV2'] = ResolversParentTypes['StoreConfigurationV2']> = {
  app_config?: Resolver<Maybe<ResolversTypes['AppConfiguration']>, ParentType, ContextType>;
  magento_graphql_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_service_graphql_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreLocatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreLocator'] = ResolversParentTypes['StoreLocator']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_coming_soon?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_new?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreRegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreRegion'] = ResolversParentTypes['StoreRegion']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  num_of_stores?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreRegionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreRegions'] = ResolversParentTypes['StoreRegions']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['StoreRegion']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StorefrontAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['StorefrontAllocation'] = ResolversParentTypes['StorefrontAllocation']> = {
  allocation_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_locations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  expires_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  magento_conditions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  magento_pool_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  remaining_allocation_quota?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  remaining_user_quota?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sample_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  start_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoresLocatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoresLocator'] = ResolversParentTypes['StoresLocator']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['StoreLocator']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestionSearchCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestionSearchCategory'] = ResolversParentTypes['SuggestionSearchCategory']> = {
  breadcrumb?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestionSearchProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestionSearchProduct'] = ResolversParentTypes['SuggestionSearchProduct']> = {
  final_price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestionSearchResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestionSearchResponse'] = ResolversParentTypes['SuggestionSearchResponse']> = {
  categories?: Resolver<Array<ResolversTypes['SuggestionSearchCategory']>, ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['SuggestionSearchProduct']>, ParentType, ContextType>;
  terms?: Resolver<Array<ResolversTypes['SuggestionSearchTerm']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestionSearchTermResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestionSearchTerm'] = ResolversParentTypes['SuggestionSearchTerm']> = {
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportMenuActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportMenuAction'] = ResolversParentTypes['SupportMenuAction']> = {
  type?: Resolver<ResolversTypes['SupportMenuActionType'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportMenuItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportMenuItem'] = ResolversParentTypes['SupportMenuItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  left_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  menu_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  right_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  support_menu_action?: Resolver<Maybe<ResolversTypes['SupportMenuAction']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwatchDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwatchData'] = ResolversParentTypes['SwatchData']> = {
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwatchDataInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwatchDataInterface'] = ResolversParentTypes['SwatchDataInterface']> = {
  __resolveType: TypeResolveFn<'ColorSwatchData' | 'ImageSwatchData' | 'TextSwatchData', ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SwatchLayerFilterItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwatchLayerFilterItem'] = ResolversParentTypes['SwatchLayerFilterItem']> = {
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  swatch_data?: Resolver<Maybe<ResolversTypes['SwatchData']>, ParentType, ContextType>;
  value_string?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwatchLayerFilterItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwatchLayerFilterItemInterface'] = ResolversParentTypes['SwatchLayerFilterItemInterface']> = {
  __resolveType: TypeResolveFn<'SwatchLayerFilterItem', ParentType, ContextType>;
  swatch_data?: Resolver<Maybe<ResolversTypes['SwatchData']>, ParentType, ContextType>;
};

export type SynchronizeCartPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SynchronizeCartPayload'] = ResolversParentTypes['SynchronizeCartPayload']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  item_errors?: Resolver<Maybe<Array<ResolversTypes['CartSyncItemError']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tag'] = ResolversParentTypes['Tag']> = {
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modified_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number_products?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tag_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tag_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxItem'] = ResolversParentTypes['TaxItem']> = {
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TermsOfServiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TermsOfService'] = ResolversParentTypes['TermsOfService']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextSwatchDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextSwatchData'] = ResolversParentTypes['TextSwatchData']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TierPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TierPrice'] = ResolversParentTypes['TierPrice']> = {
  discount?: Resolver<Maybe<ResolversTypes['ProductDiscount']>, ParentType, ContextType>;
  final_price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrackEventResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrackEventResult'] = ResolversParentTypes['TrackEventResult']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversalLinkEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalLinkEntity'] = ResolversParentTypes['UniversalLinkEntity']> = {
  params?: Resolver<Maybe<ResolversTypes['UniversalLinkParamsInterface']>, ParentType, ContextType>;
  screen_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversalLinkEntityParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalLinkEntityParams'] = ResolversParentTypes['UniversalLinkEntityParams']> = {
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  redirect_code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversalLinkOrderParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalLinkOrderParams'] = ResolversParentTypes['UniversalLinkOrderParams']> = {
  increment_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversalLinkParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalLinkParams'] = ResolversParentTypes['UniversalLinkParams']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversalLinkParamsInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalLinkParamsInterface'] = ResolversParentTypes['UniversalLinkParamsInterface']> = {
  __resolveType: TypeResolveFn<'UniversalLinkEntityParams' | 'UniversalLinkOrderParams' | 'UniversalLinkParams' | 'UniversalLinkProductCollectionParams' | 'UniversalLinkSearchParams', ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type UniversalLinkProductCollectionParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalLinkProductCollectionParams'] = ResolversParentTypes['UniversalLinkProductCollectionParams']> = {
  block_type?: Resolver<Maybe<ResolversTypes['BlockTypeEnum']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversalLinkSearchParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalLinkSearchParams'] = ResolversParentTypes['UniversalLinkSearchParams']> = {
  q?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCartItemsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCartItemsOutput'] = ResolversParentTypes['UpdateCartItemsOutput']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UrlConfigDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UrlConfigData'] = ResolversParentTypes['UrlConfigData']> = {
  magento_graphql_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_service_graphql_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UrlRewriteResolvers<ContextType = any, ParentType extends ResolversParentTypes['UrlRewrite'] = ResolversParentTypes['UrlRewrite']> = {
  parameters?: Resolver<Maybe<Array<Maybe<ResolversTypes['HttpQueryParameter']>>>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidatePhoneAndOtpResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidatePhoneAndOtpResponse'] = ResolversParentTypes['ValidatePhoneAndOtpResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VirtualCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualCartItem'] = ResolversParentTypes['VirtualCartItem']> = {
  customizable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VirtualLocalCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualLocalCartItem'] = ResolversParentTypes['VirtualLocalCartItem']> = {
  cart_item_reference_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customizable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  local_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VirtualProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualProduct'] = ResolversParentTypes['VirtualProduct']> = {
  achievement?: Resolver<Maybe<ResolversTypes['Achievement']>, ParentType, ContextType>;
  additional_data_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditionalDataAttribute']>>>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  am_offer_item_condition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appboxo_qty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  avatars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bao_hanh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  chat_lieu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chat_lieu_go?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chat_lieu_vai?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chon_so?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combo_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  denomination?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  dungtich?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flash_sale?: Resolver<Maybe<ResolversTypes['FlashSaleProductData']>, ParentType, ContextType>;
  gift_indexed_info?: Resolver<Maybe<Array<Maybe<ResolversTypes['GiftIndexedInfo']>>>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gram?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_bought?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_enable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupon_qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupon_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gtin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_gift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hot_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  is_discount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_kids_gift?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_online_only?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kich_thuoc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kids_gift_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  made_in?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  market_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  muivi?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_product?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  news_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nipple_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductNotification']>>>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popular_search_keywords?: Resolver<Maybe<Array<Maybe<ResolversTypes['Keywords']>>>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_achievements?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductAchievement']>>>, ParentType, ContextType>;
  product_badges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductBadge']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products_combo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotion_info_time_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratings_summary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  related_products_two?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  so_tang?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soluong?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  upsell_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_cc?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_custom_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_guide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight_bim?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['Voucher'] = ResolversParentTypes['Voucher']> = {
  allocation?: Resolver<Maybe<ResolversTypes['VoucherAllocation']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  applied_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['VoucherCampaign']>, ParentType, ContextType>;
  campaign_id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  customer_contact_no?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erp_created_by_receipt_no?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erp_created_in_store_no?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erp_replication_counter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  erp_reserved_by_pos_no?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initial_amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  start_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['VoucherStatus'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  usage_logs?: Resolver<Maybe<Array<ResolversTypes['VoucherUsageLog']>>, ParentType, ContextType>;
  usage_type?: Resolver<ResolversTypes['VoucherUsageType'], ParentType, ContextType>;
  voucher_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoucherAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoucherAllocation'] = ResolversParentTypes['VoucherAllocation']> = {
  allocation_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  available_voucher_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  campaign?: Resolver<Maybe<ResolversTypes['VoucherCampaign']>, ParentType, ContextType>;
  campaign_id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  current_usage_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_end_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  display_locations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  display_start_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  display_status?: Resolver<ResolversTypes['DisplayStatus'], ParentType, ContextType>;
  expires_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  magento_conditions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  magento_pool_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_allocation_usages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_user_usages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  start_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AllocationStatus'], ParentType, ContextType>;
  sync_status?: Resolver<ResolversTypes['SyncStatus'], ParentType, ContextType>;
  synced_at?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  voucher_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoucherCampaignResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoucherCampaign'] = ResolversParentTypes['VoucherCampaign']> = {
  available_voucher_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unallocated_voucher?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  voucher_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vouchers?: Resolver<Maybe<Array<ResolversTypes['Voucher']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoucherHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoucherHistory'] = ResolversParentTypes['VoucherHistory']> = {
  action_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  error_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  raw_payload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  request_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['MarketingRequestLogStatus']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  voucher_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoucherUsageLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoucherUsageLog'] = ResolversParentTypes['VoucherUsageLog']> = {
  applied_amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  applied_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  request_id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  voucher?: Resolver<Maybe<ResolversTypes['Voucher']>, ParentType, ContextType>;
  voucher_id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WardResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ward'] = ResolversParentTypes['Ward']> = {
  district_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebsiteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Website'] = ResolversParentTypes['Website']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_group_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WidgetShortcutLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['WidgetShortcutLink'] = ResolversParentTypes['WidgetShortcutLink']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShortcutLink']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WidgetShortcutLinkV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['WidgetShortcutLinkV2'] = ResolversParentTypes['WidgetShortcutLinkV2']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ShortcutLinkV2']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WishlistResolvers<ContextType = any, ParentType extends ResolversParentTypes['Wishlist'] = ResolversParentTypes['Wishlist']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['WishlistItem']>>>, ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sharing_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WishlistItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['WishlistItem'] = ResolversParentTypes['WishlistItem']> = {
  added_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Achievement?: AchievementResolvers<ContextType>;
  AddBundleProductsToCartOutput?: AddBundleProductsToCartOutputResolvers<ContextType>;
  AddCartLevelGiftsOutput?: AddCartLevelGiftsOutputResolvers<ContextType>;
  AddConfigurableProductsToCartOutput?: AddConfigurableProductsToCartOutputResolvers<ContextType>;
  AddDownloadableProductsToCartOutput?: AddDownloadableProductsToCartOutputResolvers<ContextType>;
  AddGiftsToCartOutput?: AddGiftsToCartOutputResolvers<ContextType>;
  AddSimpleProductsToCartOutput?: AddSimpleProductsToCartOutputResolvers<ContextType>;
  AddVirtualProductsToCartOutput?: AddVirtualProductsToCartOutputResolvers<ContextType>;
  AdditionalDataAttribute?: AdditionalDataAttributeResolvers<ContextType>;
  AdminAnswered?: AdminAnsweredResolvers<ContextType>;
  Aggregation?: AggregationResolvers<ContextType>;
  AggregationOption?: AggregationOptionResolvers<ContextType>;
  AggregationOptionInterface?: AggregationOptionInterfaceResolvers<ContextType>;
  Answer?: AnswerResolvers<ContextType>;
  AppBannerConfig?: AppBannerConfigResolvers<ContextType>;
  AppConfiguration?: AppConfigurationResolvers<ContextType>;
  AppliedCodeData?: AppliedCodeDataResolvers<ContextType>;
  AppliedCodesResponse?: AppliedCodesResponseResolvers<ContextType>;
  AppliedCoupon?: AppliedCouponResolvers<ContextType>;
  AppliedUniversalCode?: AppliedUniversalCodeResolvers<ContextType>;
  AppliedVoucher?: AppliedVoucherResolvers<ContextType>;
  ApplyCodeResponse?: ApplyCodeResponseResolvers<ContextType>;
  ApplyCouponToCartOutput?: ApplyCouponToCartOutputResolvers<ContextType>;
  ApplyKicoinsOutput?: ApplyKicoinsOutputResolvers<ContextType>;
  ApplyUniversalCodePayload?: ApplyUniversalCodePayloadResolvers<ContextType>;
  ApplyVoucherResponse?: ApplyVoucherResponseResolvers<ContextType>;
  AssignVouchersResult?: AssignVouchersResultResolvers<ContextType>;
  Attribute?: AttributeResolvers<ContextType>;
  AttributeOption?: AttributeOptionResolvers<ContextType>;
  AvailableGifts?: AvailableGiftsResolvers<ContextType>;
  AvailableGiftsCart?: AvailableGiftsCartResolvers<ContextType>;
  AvailableOrderHistoryStatuses?: AvailableOrderHistoryStatusesResolvers<ContextType>;
  AvailablePaymentMethod?: AvailablePaymentMethodResolvers<ContextType>;
  AvailableRules?: AvailableRulesResolvers<ContextType>;
  AvailableShippingMethod?: AvailableShippingMethodResolvers<ContextType>;
  Banner?: BannerResolvers<ContextType>;
  BannerConfig?: BannerConfigResolvers<ContextType>;
  BannerItems?: BannerItemsResolvers<ContextType>;
  BannerLayoutData?: BannerLayoutDataResolvers<ContextType>;
  Banners?: BannersResolvers<ContextType>;
  BigInt?: GraphQLScalarType;
  BillingCartAddress?: BillingCartAddressResolvers<ContextType>;
  BlockProducts?: BlockProductsResolvers<ContextType>;
  BrandLayout?: BrandLayoutResolvers<ContextType>;
  Brands?: BrandsResolvers<ContextType>;
  Breadcrumb?: BreadcrumbResolvers<ContextType>;
  BssPopup?: BssPopupResolvers<ContextType>;
  BssPopups?: BssPopupsResolvers<ContextType>;
  BundleCartItem?: BundleCartItemResolvers<ContextType>;
  BundleItem?: BundleItemResolvers<ContextType>;
  BundleItemOption?: BundleItemOptionResolvers<ContextType>;
  BundleProduct?: BundleProductResolvers<ContextType>;
  Cart?: CartResolvers<ContextType>;
  CartAddressCountry?: CartAddressCountryResolvers<ContextType>;
  CartAddressInterface?: CartAddressInterfaceResolvers<ContextType>;
  CartAddressRegion?: CartAddressRegionResolvers<ContextType>;
  CartDiscount?: CartDiscountResolvers<ContextType>;
  CartItemInterface?: CartItemInterfaceResolvers<ContextType>;
  CartItemMeta?: CartItemMetaResolvers<ContextType>;
  CartItemPrices?: CartItemPricesResolvers<ContextType>;
  CartItemQuantity?: CartItemQuantityResolvers<ContextType>;
  CartItemReference?: CartItemReferenceResolvers<ContextType>;
  CartItemReferenceAction?: CartItemReferenceActionResolvers<ContextType>;
  CartItemReferenceLogic?: CartItemReferenceLogicResolvers<ContextType>;
  CartItemSelectedOptionValuePrice?: CartItemSelectedOptionValuePriceResolvers<ContextType>;
  CartItemsOnly?: CartItemsOnlyResolvers<ContextType>;
  CartLevelGiftRule?: CartLevelGiftRuleResolvers<ContextType>;
  CartLevelGiftsOutput?: CartLevelGiftsOutputResolvers<ContextType>;
  CartMeta?: CartMetaResolvers<ContextType>;
  CartPrices?: CartPricesResolvers<ContextType>;
  CartSyncItemError?: CartSyncItemErrorResolvers<ContextType>;
  CartTaxItem?: CartTaxItemResolvers<ContextType>;
  CatalogProductsListWidget?: CatalogProductsListWidgetResolvers<ContextType>;
  CatalogStatusMessageResponse?: CatalogStatusMessageResponseResolvers<ContextType>;
  CategoryBanners?: CategoryBannersResolvers<ContextType>;
  CategoryHighlightProducts?: CategoryHighlightProductsResolvers<ContextType>;
  CategoryInterface?: CategoryInterfaceResolvers<ContextType>;
  CategoryPosts?: CategoryPostsResolvers<ContextType>;
  CategoryProducts?: CategoryProductsResolvers<ContextType>;
  CategoryTags?: CategoryTagsResolvers<ContextType>;
  CategoryTree?: CategoryTreeResolvers<ContextType>;
  CheckoutAgreement?: CheckoutAgreementResolvers<ContextType>;
  CmsBlock?: CmsBlockResolvers<ContextType>;
  CmsBlocks?: CmsBlocksResolvers<ContextType>;
  CmsPage?: CmsPageResolvers<ContextType>;
  CmsPageConfig?: CmsPageConfigResolvers<ContextType>;
  CmsPageResponse?: CmsPageResponseResolvers<ContextType>;
  ColorSwatchData?: ColorSwatchDataResolvers<ContextType>;
  ComplexTextValue?: ComplexTextValueResolvers<ContextType>;
  CompositeImageWidget?: CompositeImageWidgetResolvers<ContextType>;
  Condition?: ConditionResolvers<ContextType>;
  ConfigurableAttributeOption?: ConfigurableAttributeOptionResolvers<ContextType>;
  ConfigurableCartItem?: ConfigurableCartItemResolvers<ContextType>;
  ConfigurableLocalCartItem?: ConfigurableLocalCartItemResolvers<ContextType>;
  ConfigurableProduct?: ConfigurableProductResolvers<ContextType>;
  ConfigurableProductOptions?: ConfigurableProductOptionsResolvers<ContextType>;
  ConfigurableProductOptionsValues?: ConfigurableProductOptionsValuesResolvers<ContextType>;
  ConfigurableVariant?: ConfigurableVariantResolvers<ContextType>;
  ConfirmRequestedValidationPhoneResponse?: ConfirmRequestedValidationPhoneResponseResolvers<ContextType>;
  ContactDetails?: ContactDetailsResolvers<ContextType>;
  ContentFragment?: ContentFragmentResolvers<ContextType>;
  ContentFragmentDataInterface?: ContentFragmentDataInterfaceResolvers<ContextType>;
  CoreConfig?: CoreConfigResolvers<ContextType>;
  Country?: CountryResolvers<ContextType>;
  CouponContentResponse?: CouponContentResponseResolvers<ContextType>;
  CouponPartner?: CouponPartnerResolvers<ContextType>;
  CreateAnswerResponse?: CreateAnswerResponseResolvers<ContextType>;
  CreateClientCredentialResult?: CreateClientCredentialResultResolvers<ContextType>;
  CreateQuestionResponse?: CreateQuestionResponseResolvers<ContextType>;
  CreditMemo?: CreditMemoResolvers<ContextType>;
  CreditMemoItemInterface?: CreditMemoItemInterfaceResolvers<ContextType>;
  CreditMemoTotal?: CreditMemoTotalResolvers<ContextType>;
  Currency?: CurrencyResolvers<ContextType>;
  CustomAttributeMetadata?: CustomAttributeMetadataResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  CustomerAccountDeletionListResponse?: CustomerAccountDeletionListResponseResolvers<ContextType>;
  CustomerAccountDeletionResponse?: CustomerAccountDeletionResponseResolvers<ContextType>;
  CustomerAddress?: CustomerAddressResolvers<ContextType>;
  CustomerAddressAttribute?: CustomerAddressAttributeResolvers<ContextType>;
  CustomerAddressRegion?: CustomerAddressRegionResolvers<ContextType>;
  CustomerDownloadableProduct?: CustomerDownloadableProductResolvers<ContextType>;
  CustomerDownloadableProducts?: CustomerDownloadableProductsResolvers<ContextType>;
  CustomerFaq?: CustomerFaqResolvers<ContextType>;
  CustomerFaqData?: CustomerFaqDataResolvers<ContextType>;
  CustomerInformation?: CustomerInformationResolvers<ContextType>;
  CustomerKicoin?: CustomerKicoinResolvers<ContextType>;
  CustomerOrder?: CustomerOrderResolvers<ContextType>;
  CustomerOrderStats?: CustomerOrderStatsResolvers<ContextType>;
  CustomerOrders?: CustomerOrdersResolvers<ContextType>;
  CustomerOrdersV2?: CustomerOrdersV2Resolvers<ContextType>;
  CustomerOutput?: CustomerOutputResolvers<ContextType>;
  CustomerPaymentTokens?: CustomerPaymentTokensResolvers<ContextType>;
  CustomerProfile?: CustomerProfileResolvers<ContextType>;
  CustomerProfileSign?: CustomerProfileSignResolvers<ContextType>;
  CustomerQuestion?: CustomerQuestionResolvers<ContextType>;
  CustomerQuestions?: CustomerQuestionsResolvers<ContextType>;
  CustomerReferralCodeSignature?: CustomerReferralCodeSignatureResolvers<ContextType>;
  CustomerReviewsResponse?: CustomerReviewsResponseResolvers<ContextType>;
  CustomerToken?: CustomerTokenResolvers<ContextType>;
  CustomizableOptionInterface?: CustomizableOptionInterfaceResolvers<ContextType>;
  CustomizableProductInterface?: CustomizableProductInterfaceResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DeletePaymentTokenOutput?: DeletePaymentTokenOutputResolvers<ContextType>;
  DeliveryTime?: DeliveryTimeResolvers<ContextType>;
  Discount?: DiscountResolvers<ContextType>;
  DiscountKicoins?: DiscountKicoinsResolvers<ContextType>;
  DisplayInfoItem?: DisplayInfoItemResolvers<ContextType>;
  District?: DistrictResolvers<ContextType>;
  DownloadableCartItem?: DownloadableCartItemResolvers<ContextType>;
  DownloadableLocalCartItem?: DownloadableLocalCartItemResolvers<ContextType>;
  DownloadableProduct?: DownloadableProductResolvers<ContextType>;
  DownloadableProductLinks?: DownloadableProductLinksResolvers<ContextType>;
  DownloadableProductSamples?: DownloadableProductSamplesResolvers<ContextType>;
  EnabledPaymentMethod?: EnabledPaymentMethodResolvers<ContextType>;
  EntityUrl?: EntityUrlResolvers<ContextType>;
  EventActivity?: EventActivityResolvers<ContextType>;
  EventActivityGroup?: EventActivityGroupResolvers<ContextType>;
  EventAttribute?: EventAttributeResolvers<ContextType>;
  EventEntity?: EventEntityResolvers<ContextType>;
  EventRegistration?: EventRegistrationResolvers<ContextType>;
  EventRegistrationDetails?: EventRegistrationDetailsResolvers<ContextType>;
  EventUser?: EventUserResolvers<ContextType>;
  ExchangeRate?: ExchangeRateResolvers<ContextType>;
  ExecutePaymentResult?: ExecutePaymentResultResolvers<ContextType>;
  FaqAnswer?: FaqAnswerResolvers<ContextType>;
  FaqArticle?: FaqArticleResolvers<ContextType>;
  FaqArticles?: FaqArticlesResolvers<ContextType>;
  FaqCategories?: FaqCategoriesResolvers<ContextType>;
  FaqCategory?: FaqCategoryResolvers<ContextType>;
  FaqCategoryAnswer?: FaqCategoryAnswerResolvers<ContextType>;
  FaqCategoryQuestion?: FaqCategoryQuestionResolvers<ContextType>;
  FaqCategoryQuestions?: FaqCategoryQuestionsResolvers<ContextType>;
  FaqItem?: FaqItemResolvers<ContextType>;
  FaqListBySku?: FaqListBySkuResolvers<ContextType>;
  FaqQuestion?: FaqQuestionResolvers<ContextType>;
  FaqReaction?: FaqReactionResolvers<ContextType>;
  FaqSuggestionTag?: FaqSuggestionTagResolvers<ContextType>;
  FastCartTotals?: FastCartTotalsResolvers<ContextType>;
  FeaturedImageData?: FeaturedImageDataResolvers<ContextType>;
  FixedProductTax?: FixedProductTaxResolvers<ContextType>;
  FlashSale?: FlashSaleResolvers<ContextType>;
  FlashSaleItems?: FlashSaleItemsResolvers<ContextType>;
  FlashSaleProduct?: FlashSaleProductResolvers<ContextType>;
  FlashSaleProductData?: FlashSaleProductDataResolvers<ContextType>;
  FlashSaleProducts?: FlashSaleProductsResolvers<ContextType>;
  FlashSaleProductsV2?: FlashSaleProductsV2Resolvers<ContextType>;
  FlashSaleWidget?: FlashSaleWidgetResolvers<ContextType>;
  FooterConfig?: FooterConfigResolvers<ContextType>;
  FormAttributeValue?: FormAttributeValueResolvers<ContextType>;
  FormConfig?: FormConfigResolvers<ContextType>;
  FormValue?: FormValueResolvers<ContextType>;
  FreeGiftCart?: FreeGiftCartResolvers<ContextType>;
  FreeGifts?: FreeGiftsResolvers<ContextType>;
  FreeGiftsData?: FreeGiftsDataResolvers<ContextType>;
  GeneratedOtpTokenResponse?: GeneratedOtpTokenResponseResolvers<ContextType>;
  GetCmsPageSchemaByIdentifierResponse?: GetCmsPageSchemaByIdentifierResponseResolvers<ContextType>;
  GetFaqListBySkuResponse?: GetFaqListBySkuResponseResolvers<ContextType>;
  GiftCartItem?: GiftCartItemResolvers<ContextType>;
  GiftError?: GiftErrorResolvers<ContextType>;
  GiftIndexedInfo?: GiftIndexedInfoResolvers<ContextType>;
  GiftProduct?: GiftProductResolvers<ContextType>;
  GiftRuleThreshold?: GiftRuleThresholdResolvers<ContextType>;
  GiftRuleThresholdsOutput?: GiftRuleThresholdsOutputResolvers<ContextType>;
  GroupedProduct?: GroupedProductResolvers<ContextType>;
  GroupedProductItem?: GroupedProductItemResolvers<ContextType>;
  HighlightBrand?: HighlightBrandResolvers<ContextType>;
  HighlightBrands?: HighlightBrandsResolvers<ContextType>;
  HighlightCategories?: HighlightCategoriesResolvers<ContextType>;
  HighlightCategory?: HighlightCategoryResolvers<ContextType>;
  HighlightProductBlocks?: HighlightProductBlocksResolvers<ContextType>;
  HighlightProductItem?: HighlightProductItemResolvers<ContextType>;
  HighlightProducts?: HighlightProductsResolvers<ContextType>;
  HomePageFloatBanner?: HomePageFloatBannerResolvers<ContextType>;
  HomepageFeaturedBlock?: HomepageFeaturedBlockResolvers<ContextType>;
  HomepagePopularSearchKeywords?: HomepagePopularSearchKeywordsResolvers<ContextType>;
  HomepagePosts?: HomepagePostsResolvers<ContextType>;
  HomepageProductsLightweight?: HomepageProductsLightweightResolvers<ContextType>;
  HtmlWidget?: HtmlWidgetResolvers<ContextType>;
  HttpQueryParameter?: HttpQueryParameterResolvers<ContextType>;
  IdentityAuthResult?: IdentityAuthResultResolvers<ContextType>;
  IdentityMagentoToken?: IdentityMagentoTokenResolvers<ContextType>;
  IdentityOtpChallengeResponse?: IdentityOtpChallengeResponseResolvers<ContextType>;
  IdentityRefreshResult?: IdentityRefreshResultResolvers<ContextType>;
  IdentitySignUpResult?: IdentitySignUpResultResolvers<ContextType>;
  IframeWidget?: IframeWidgetResolvers<ContextType>;
  ImageItem?: ImageItemResolvers<ContextType>;
  ImageSwatchData?: ImageSwatchDataResolvers<ContextType>;
  ImageWidget?: ImageWidgetResolvers<ContextType>;
  InterestedProducts?: InterestedProductsResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  InvoiceItemInterface?: InvoiceItemInterfaceResolvers<ContextType>;
  InvoiceTotal?: InvoiceTotalResolvers<ContextType>;
  IsEmailAvailableOutput?: IsEmailAvailableOutputResolvers<ContextType>;
  IssuedCoupon?: IssuedCouponResolvers<ContextType>;
  ItemStatus?: ItemStatusResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  KeyValue?: KeyValueResolvers<ContextType>;
  Keywords?: KeywordsResolvers<ContextType>;
  LayerFilter?: LayerFilterResolvers<ContextType>;
  LayerFilterItemInterface?: LayerFilterItemInterfaceResolvers<ContextType>;
  Layout?: LayoutResolvers<ContextType>;
  LayoutData?: LayoutDataResolvers<ContextType>;
  LightweightPageInfo?: LightweightPageInfoResolvers<ContextType>;
  LightweightPrice?: LightweightPriceResolvers<ContextType>;
  LightweightPriceRange?: LightweightPriceRangeResolvers<ContextType>;
  LightweightProductItem?: LightweightProductItemResolvers<ContextType>;
  LightweightProductList?: LightweightProductListResolvers<ContextType>;
  LocalCartItemInterface?: LocalCartItemInterfaceResolvers<ContextType>;
  LoginSuccessResponse?: LoginSuccessResponseResolvers<ContextType>;
  LogoData?: LogoDataResolvers<ContextType>;
  LookupCustomerResponse?: LookupCustomerResponseResolvers<ContextType>;
  MarketingAppliedCoupon?: MarketingAppliedCouponResolvers<ContextType>;
  MarketingRequestLog?: MarketingRequestLogResolvers<ContextType>;
  MediaGalleryEntry?: MediaGalleryEntryResolvers<ContextType>;
  MediaGalleryInterface?: MediaGalleryInterfaceResolvers<ContextType>;
  Money?: MoneyResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  MyFavoriteBrands?: MyFavoriteBrandsResolvers<ContextType>;
  MyOrderReviews?: MyOrderReviewsResolvers<ContextType>;
  MyQuestion?: MyQuestionResolvers<ContextType>;
  MyQuestions?: MyQuestionsResolvers<ContextType>;
  NewArrivalProducts?: NewArrivalProductsResolvers<ContextType>;
  NotificationCustomer?: NotificationCustomerResolvers<ContextType>;
  NotificationData?: NotificationDataResolvers<ContextType>;
  NotificationMessage?: NotificationMessageResolvers<ContextType>;
  NotificationOrderData?: NotificationOrderDataResolvers<ContextType>;
  NotificationPagination?: NotificationPaginationResolvers<ContextType>;
  NotificationPayload?: NotificationPayloadResolvers<ContextType>;
  NotificationPromotionData?: NotificationPromotionDataResolvers<ContextType>;
  Notifications?: NotificationsResolvers<ContextType>;
  NotificationsData?: NotificationsDataResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  OrderAddress?: OrderAddressResolvers<ContextType>;
  OrderBasicInfo?: OrderBasicInfoResolvers<ContextType>;
  OrderItem?: OrderItemResolvers<ContextType>;
  OrderItemInterface?: OrderItemInterfaceResolvers<ContextType>;
  OrderItemOption?: OrderItemOptionResolvers<ContextType>;
  OrderPaymentMethod?: OrderPaymentMethodResolvers<ContextType>;
  OrderShipment?: OrderShipmentResolvers<ContextType>;
  OrderStatus?: OrderStatusResolvers<ContextType>;
  OrderStatusHistory?: OrderStatusHistoryResolvers<ContextType>;
  OrderStatusHistoryItem?: OrderStatusHistoryItemResolvers<ContextType>;
  OrderSyncGiftDetail?: OrderSyncGiftDetailResolvers<ContextType>;
  OrderSyncItemPrice?: OrderSyncItemPriceResolvers<ContextType>;
  OrderSyncItemReference?: OrderSyncItemReferenceResolvers<ContextType>;
  OrderSyncItemReferenceAction?: OrderSyncItemReferenceActionResolvers<ContextType>;
  OrderSyncItemReferenceLogic?: OrderSyncItemReferenceLogicResolvers<ContextType>;
  OrderSyncReferencesOutput?: OrderSyncReferencesOutputResolvers<ContextType>;
  OrderSyncSelectedOption?: OrderSyncSelectedOptionResolvers<ContextType>;
  OrderTotal?: OrderTotalResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PaginationData?: PaginationDataResolvers<ContextType>;
  PaymentInformation?: PaymentInformationResolvers<ContextType>;
  PaymentMethodSettings?: PaymentMethodSettingsResolvers<ContextType>;
  PaymentOrderInformation?: PaymentOrderInformationResolvers<ContextType>;
  PaymentOrderLinkResponse?: PaymentOrderLinkResponseResolvers<ContextType>;
  PaymentOrderTransactionStatusResponse?: PaymentOrderTransactionStatusResponseResolvers<ContextType>;
  PaymentToken?: PaymentTokenResolvers<ContextType>;
  PhysicalProductInterface?: PhysicalProductInterfaceResolvers<ContextType>;
  PlaceOrderOutput?: PlaceOrderOutputResolvers<ContextType>;
  PopularSearchKeyword?: PopularSearchKeywordResolvers<ContextType>;
  PopularSearchTerms?: PopularSearchTermsResolvers<ContextType>;
  Post?: PostResolvers<ContextType>;
  Posts?: PostsResolvers<ContextType>;
  Price?: PriceResolvers<ContextType>;
  PriceAdjustment?: PriceAdjustmentResolvers<ContextType>;
  PriceRange?: PriceRangeResolvers<ContextType>;
  ProductAchievement?: ProductAchievementResolvers<ContextType>;
  ProductBadge?: ProductBadgeResolvers<ContextType>;
  ProductBlock?: ProductBlockResolvers<ContextType>;
  ProductCartPriceRule?: ProductCartPriceRuleResolvers<ContextType>;
  ProductDiscount?: ProductDiscountResolvers<ContextType>;
  ProductFAQs?: ProductFaQsResolvers<ContextType>;
  ProductImage?: ProductImageResolvers<ContextType>;
  ProductInterface?: ProductInterfaceResolvers<ContextType>;
  ProductLinksInterface?: ProductLinksInterfaceResolvers<ContextType>;
  ProductListConfig?: ProductListConfigResolvers<ContextType>;
  ProductMediaGalleryEntriesContent?: ProductMediaGalleryEntriesContentResolvers<ContextType>;
  ProductMediaGalleryEntriesVideoContent?: ProductMediaGalleryEntriesVideoContentResolvers<ContextType>;
  ProductNotification?: ProductNotificationResolvers<ContextType>;
  ProductPosts?: ProductPostsResolvers<ContextType>;
  ProductPrice?: ProductPriceResolvers<ContextType>;
  ProductPrices?: ProductPricesResolvers<ContextType>;
  ProductReviewsAggregationResponse?: ProductReviewsAggregationResponseResolvers<ContextType>;
  ProductReviewsAggregationV2Response?: ProductReviewsAggregationV2ResponseResolvers<ContextType>;
  ProductReviewsResponse?: ProductReviewsResponseResolvers<ContextType>;
  ProductSalableQuantity?: ProductSalableQuantityResolvers<ContextType>;
  ProductSalableQuantityError?: ProductSalableQuantityErrorResolvers<ContextType>;
  ProductSuggestedHashTags?: ProductSuggestedHashTagsResolvers<ContextType>;
  ProductTags?: ProductTagsResolvers<ContextType>;
  ProductTierPrices?: ProductTierPricesResolvers<ContextType>;
  ProductToWishlistOutput?: ProductToWishlistOutputResolvers<ContextType>;
  ProductVideo?: ProductVideoResolvers<ContextType>;
  Products?: ProductsResolvers<ContextType>;
  PurchasedProductStatus?: PurchasedProductStatusResolvers<ContextType>;
  PushAllocationResult?: PushAllocationResultResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Question?: QuestionResolvers<ContextType>;
  RecalculateCartTotalsOutput?: RecalculateCartTotalsOutputResolvers<ContextType>;
  ReferralCodeResponse?: ReferralCodeResponseResolvers<ContextType>;
  Region?: RegionResolvers<ContextType>;
  RegionStore?: RegionStoreResolvers<ContextType>;
  RegisterResponse?: RegisterResponseResolvers<ContextType>;
  RelatedProducts?: RelatedProductsResolvers<ContextType>;
  RemoveCartLevelGiftOutput?: RemoveCartLevelGiftOutputResolvers<ContextType>;
  RemoveCodeResponse?: RemoveCodeResponseResolvers<ContextType>;
  RemoveCouponFromCartOutput?: RemoveCouponFromCartOutputResolvers<ContextType>;
  RemoveItemFromCartOutput?: RemoveItemFromCartOutputResolvers<ContextType>;
  RemoveKicoinsOutput?: RemoveKicoinsOutputResolvers<ContextType>;
  RemoveUniversalCodeOutput?: RemoveUniversalCodeOutputResolvers<ContextType>;
  RequestStatus?: RequestStatusResolvers<ContextType>;
  RequestValidatePhoneResponse?: RequestValidatePhoneResponseResolvers<ContextType>;
  ResetPasswordResponse?: ResetPasswordResponseResolvers<ContextType>;
  Result?: ResultResolvers<ContextType>;
  Review?: ReviewResolvers<ContextType>;
  ReviewAggregation?: ReviewAggregationResolvers<ContextType>;
  ReviewAggregationOption?: ReviewAggregationOptionResolvers<ContextType>;
  ReviewMedia?: ReviewMediaResolvers<ContextType>;
  ReviewOption?: ReviewOptionResolvers<ContextType>;
  ReviewReactionResponse?: ReviewReactionResponseResolvers<ContextType>;
  ReviewTag?: ReviewTagResolvers<ContextType>;
  RevokeCustomerTokenOutput?: RevokeCustomerTokenOutputResolvers<ContextType>;
  Rule?: RuleResolvers<ContextType>;
  SalesCommentItem?: SalesCommentItemResolvers<ContextType>;
  SalesOrderStatus?: SalesOrderStatusResolvers<ContextType>;
  SalesRule?: SalesRuleResolvers<ContextType>;
  Salesrule?: SalesruleResolvers<ContextType>;
  SearchKeywordHistory?: SearchKeywordHistoryResolvers<ContextType>;
  SearchResultPageInfo?: SearchResultPageInfoResolvers<ContextType>;
  SearchTerm?: SearchTermResolvers<ContextType>;
  SelectedBundleOption?: SelectedBundleOptionResolvers<ContextType>;
  SelectedBundleOptionValue?: SelectedBundleOptionValueResolvers<ContextType>;
  SelectedCartLevelGift?: SelectedCartLevelGiftResolvers<ContextType>;
  SelectedCartLevelGiftsOutput?: SelectedCartLevelGiftsOutputResolvers<ContextType>;
  SelectedConfigurableOption?: SelectedConfigurableOptionResolvers<ContextType>;
  SelectedCustomizableOption?: SelectedCustomizableOptionResolvers<ContextType>;
  SelectedCustomizableOptionValue?: SelectedCustomizableOptionValueResolvers<ContextType>;
  SelectedGift?: SelectedGiftResolvers<ContextType>;
  SelectedPaymentMethod?: SelectedPaymentMethodResolvers<ContextType>;
  SelectedShippingMethod?: SelectedShippingMethodResolvers<ContextType>;
  SeoData?: SeoDataResolvers<ContextType>;
  SetBillingAddressOnCartOutput?: SetBillingAddressOnCartOutputResolvers<ContextType>;
  SetGuestEmailOnCartOutput?: SetGuestEmailOnCartOutputResolvers<ContextType>;
  SetPaymentMethodOnCartOutput?: SetPaymentMethodOnCartOutputResolvers<ContextType>;
  SetShippingAddressesOnCartOutput?: SetShippingAddressesOnCartOutputResolvers<ContextType>;
  SetShippingMethodsOnCartOutput?: SetShippingMethodsOnCartOutputResolvers<ContextType>;
  Settings?: SettingsResolvers<ContextType>;
  SettingsOptions?: SettingsOptionsResolvers<ContextType>;
  ShareChannelGroupResponse?: ShareChannelGroupResponseResolvers<ContextType>;
  ShareChannelItem?: ShareChannelItemResolvers<ContextType>;
  ShipmentItemInterface?: ShipmentItemInterfaceResolvers<ContextType>;
  ShipmentTracking?: ShipmentTrackingResolvers<ContextType>;
  ShippingCartAddress?: ShippingCartAddressResolvers<ContextType>;
  ShippingDiscount?: ShippingDiscountResolvers<ContextType>;
  ShippingHandling?: ShippingHandlingResolvers<ContextType>;
  ShortcutLink?: ShortcutLinkResolvers<ContextType>;
  ShortcutLinkV2?: ShortcutLinkV2Resolvers<ContextType>;
  SimpleCartItem?: SimpleCartItemResolvers<ContextType>;
  SimpleLocalCartItem?: SimpleLocalCartItemResolvers<ContextType>;
  SimpleProduct?: SimpleProductResolvers<ContextType>;
  SocialChannel?: SocialChannelResolvers<ContextType>;
  SortField?: SortFieldResolvers<ContextType>;
  SortFields?: SortFieldsResolvers<ContextType>;
  StaticWidget?: StaticWidgetResolvers<ContextType>;
  StatusMessageResponse?: StatusMessageResponseResolvers<ContextType>;
  StockStatus?: StockStatusResolvers<ContextType>;
  StoreConfig?: StoreConfigResolvers<ContextType>;
  StoreConfiguration?: StoreConfigurationResolvers<ContextType>;
  StoreConfigurationV2?: StoreConfigurationV2Resolvers<ContextType>;
  StoreLocator?: StoreLocatorResolvers<ContextType>;
  StoreRegion?: StoreRegionResolvers<ContextType>;
  StoreRegions?: StoreRegionsResolvers<ContextType>;
  StorefrontAllocation?: StorefrontAllocationResolvers<ContextType>;
  StoresLocator?: StoresLocatorResolvers<ContextType>;
  SuggestionSearchCategory?: SuggestionSearchCategoryResolvers<ContextType>;
  SuggestionSearchProduct?: SuggestionSearchProductResolvers<ContextType>;
  SuggestionSearchResponse?: SuggestionSearchResponseResolvers<ContextType>;
  SuggestionSearchTerm?: SuggestionSearchTermResolvers<ContextType>;
  SupportMenuAction?: SupportMenuActionResolvers<ContextType>;
  SupportMenuItem?: SupportMenuItemResolvers<ContextType>;
  SwatchData?: SwatchDataResolvers<ContextType>;
  SwatchDataInterface?: SwatchDataInterfaceResolvers<ContextType>;
  SwatchLayerFilterItem?: SwatchLayerFilterItemResolvers<ContextType>;
  SwatchLayerFilterItemInterface?: SwatchLayerFilterItemInterfaceResolvers<ContextType>;
  SynchronizeCartPayload?: SynchronizeCartPayloadResolvers<ContextType>;
  Tag?: TagResolvers<ContextType>;
  TaxItem?: TaxItemResolvers<ContextType>;
  TermsOfService?: TermsOfServiceResolvers<ContextType>;
  TextSwatchData?: TextSwatchDataResolvers<ContextType>;
  TierPrice?: TierPriceResolvers<ContextType>;
  TrackEventResult?: TrackEventResultResolvers<ContextType>;
  UniversalLinkEntity?: UniversalLinkEntityResolvers<ContextType>;
  UniversalLinkEntityParams?: UniversalLinkEntityParamsResolvers<ContextType>;
  UniversalLinkOrderParams?: UniversalLinkOrderParamsResolvers<ContextType>;
  UniversalLinkParams?: UniversalLinkParamsResolvers<ContextType>;
  UniversalLinkParamsInterface?: UniversalLinkParamsInterfaceResolvers<ContextType>;
  UniversalLinkProductCollectionParams?: UniversalLinkProductCollectionParamsResolvers<ContextType>;
  UniversalLinkSearchParams?: UniversalLinkSearchParamsResolvers<ContextType>;
  UpdateCartItemsOutput?: UpdateCartItemsOutputResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  UrlConfigData?: UrlConfigDataResolvers<ContextType>;
  UrlRewrite?: UrlRewriteResolvers<ContextType>;
  ValidatePhoneAndOtpResponse?: ValidatePhoneAndOtpResponseResolvers<ContextType>;
  VirtualCartItem?: VirtualCartItemResolvers<ContextType>;
  VirtualLocalCartItem?: VirtualLocalCartItemResolvers<ContextType>;
  VirtualProduct?: VirtualProductResolvers<ContextType>;
  Voucher?: VoucherResolvers<ContextType>;
  VoucherAllocation?: VoucherAllocationResolvers<ContextType>;
  VoucherCampaign?: VoucherCampaignResolvers<ContextType>;
  VoucherHistory?: VoucherHistoryResolvers<ContextType>;
  VoucherUsageLog?: VoucherUsageLogResolvers<ContextType>;
  Ward?: WardResolvers<ContextType>;
  Website?: WebsiteResolvers<ContextType>;
  WidgetShortcutLink?: WidgetShortcutLinkResolvers<ContextType>;
  WidgetShortcutLinkV2?: WidgetShortcutLinkV2Resolvers<ContextType>;
  Wishlist?: WishlistResolvers<ContextType>;
  WishlistItem?: WishlistItemResolvers<ContextType>;
};

